const messages = {
  '50000210': {
    id: '50000210',
    defaultmessages: 'Application not found ',
  },
  '500002581': {
    id: '500002581',
    defaultmessages: 'Company name is mandatory',
  },
  '500002616': {
    id: '500002616',
    defaultmessages: 'Mobile number is mandatory',
  },
  '500002617': {
    id: '500002617',
    defaultmessages: 'Email is mandatory',
  },
  '500002848': {
    id: '500002848',
    defaultmessages: 'Full name is mandatory',
  },
  '500002849': {
    id: '500002849',
    defaultmessages: 'Category is mandatory',
  },
  '500002850': {
    id: '500002850',
    defaultmessages: 'Subject is mandatory',
  },
  '500002851': {
    id: '500002851',
    defaultmessages: 'Content is mandatory',
  },
  '500002852': {
    id: '500002852',
    defaultmessages: 'Email has invalid format',
  },
  '500002853': {
    id: '500002853',
    defaultmessages: 'Phone number has invalid format, the accepted format is (+971XXXXXXXXX)',
  },
  ' "Mortgage_Modification_application_has_been_forwarded_to_the_bank_maker_for_approval': {
    id: ' "Mortgage_Modification_application_has_been_forwarded_to_the_bank_maker_for_approval',
    defaultmessages: 'Mortgage Variation application sent to the bank maker for approval.',
  },
  ' no_map_available': {
    id: ' no_map_available',
    defaultmessages: 'No Map available',
  },
  '1200003_content': {
    id: '1200003_content',
    defaultmessages:
      'The selected property is currently blocked and not eligible for the requested service. Please review the property status and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200003_title': {
    id: '1200003_title',
    defaultmessages: 'Property has a block',
  },
  '1200004_content': {
    id: '1200004_content',
    defaultmessages:
      'The selected property is not eligible for rental services. Please review the property status and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200004_title': {
    id: '1200004_title',
    defaultmessages: 'Property is not rentable',
  },
  '1200005_content': {
    id: '1200005_content',
    defaultmessages:
      'The selected property already has an active exclusive permit {p} issued to another broker. Please review the permit details before proceeding, or contact customer support for assistance.',
  },
  '1200005_title': {
    id: '1200005_title',
    defaultmessages: 'Property already has an active exclusive permit issued to another broker',
  },
  '1200006_content': {
    id: '1200006_content',
    defaultmessages:
      'The selected property already has an active non-exclusive permit {p} issued. Please review the permit details before proceeding, or contact customer support for assistance.',
  },
  '1200006_title': {
    id: '1200006_title',
    defaultmessages: 'Property already has an active non-exclusive permit issued',
  },
  '1200007_content': {
    id: '1200007_content',
    defaultmessages:
      'The selected property has an active or in-progress permit application. Please review the permit status before proceeding, or contact customer support for assistance.',
  },
  '1200007_title': {
    id: '1200007_title',
    defaultmessages: 'Property has active or in progress permit',
  },
  '1200008_content': {
    id: '1200008_content',
    defaultmessages:
      'The selected property is not managed under the same PMC. Please review the property management details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200008_title': {
    id: '1200008_title',
    defaultmessages: 'Property is not under same PMC',
  },
  '1200009_content': {
    id: '1200009_content',
    defaultmessages:
      'The selected land type is only allowed in sell permits. Please review the permit type and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200009_title': {
    id: '1200009_title',
    defaultmessages: 'Land selection only allowed in sell permits',
  },
  '1200010_content': {
    id: '1200010_content',
    defaultmessages:
      'The selected owner does not have an ownership share in the specified unit. Please review the ownership details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200010_title': {
    id: '1200010_title',
    defaultmessages: "Owner doesn't have ownership share on the selected unit",
  },
  '1200011_content': {
    id: '1200011_content',
    defaultmessages:
      'The selected PMC is currently blocked and not eligible for the requested service. Please review the PMC status and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200011_title': {
    id: '1200011_title',
    defaultmessages: 'PMC have block',
  },
  '1200012_content': {
    id: '1200012_content',
    defaultmessages:
      'The selected PMC is only eligible to request rent permits. Please review the permit type and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200012_title': {
    id: '1200012_title',
    defaultmessages: 'PMC can only select rent permit',
  },
  '1200013_content': {
    id: '1200013_content',
    defaultmessages:
      'The selected owner is currently blocked and not eligible for the requested service. Please review the owner status and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200013_title': {
    id: '1200013_title',
    defaultmessages: 'Owner have blocks',
  },
  '1200020_content': {
    id: '1200020_content',
    defaultmessages:
      'The selected property has an active permit {p} and is not eligible to be selected for an exclusive permit. Please review the permit details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200020_title': {
    id: '1200020_title',
    defaultmessages: 'Property has an active permit',
  },
  '1200023_content': {
    id: '1200023_content',
    defaultmessages:
      'The selected unit has an active lease agreement and cannot be used for this request. Please review the lease details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200023_title': {
    id: '1200023_title',
    defaultmessages: 'Unit has an active lease agreement',
  },
  '1200026_content': {
    id: '1200026_content',
    defaultmessages:
      'The selected property is already associated with another active application {p} and cannot be used for this request. Please review the existing application details and ensure it is completed or withdrawn before proceeding, or contact customer support for assistance.',
  },
  '1200026_title': {
    id: '1200026_title',
    defaultmessages: 'Concurrent application found',
  },
  '1200027_content': {
    id: '1200027_content',
    defaultmessages:
      'The selected property is not registered under your ownership, and therefore you cannot proceed with this request. Please review the ownership details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200027_title': {
    id: '1200027_title',
    defaultmessages: 'Property not belong to the initiator',
  },
  '1200032_content': {
    id: '1200032_content',
    defaultmessages:
      'The selected property does not have a valid off-plan agreement and cannot proceed with this request. Please review the agreement details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200032_title': {
    id: '1200032_title',
    defaultmessages: "Property doesn't have valid off-plan agreement",
  },
  '1200033_content': {
    id: '1200033_content',
    defaultmessages:
      'The selected off-plan agreement includes buyers that are invalid and cannot proceed with this request. Please review the buyer details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200033_title': {
    id: '1200033_title',
    defaultmessages: 'Off-plan agreements buyers are invalid',
  },
  '1200034_content': {
    id: '1200034_content',
    defaultmessages:
      'The selected property is registered as off-plan and is not eligible for a rent permit. Please review the property details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200034_title': {
    id: '1200034_title',
    defaultmessages: 'Rent permit is not allowed on off-plan properties',
  },
  '1200035_content': {
    id: '1200035_content',
    defaultmessages:
      'The selected property is registered under a different developer and cannot be used for this request. Please review the developer details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '1200035_title': {
    id: '1200035_title',
    defaultmessages: 'Property under a different developer',
  },
  '200001_content': {
    id: '200001_content',
    defaultmessages:
      'The selected PMC does not have a valid PMA. Please ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  '200001_title': {
    id: '200001_title',
    defaultmessages: "PMC doesn't have valid PMA",
  },
  '2_of_property_value': {
    id: '2_of_property_value',
    defaultmessages: '2% of the property value',
  },
  '470_AED_5_percent_vat': {
    id: '470_AED_5_percent_vat',
    defaultmessages: '470 AED + 5% vat',
  },
  '5_percent_adgm_authority_fees': {
    id: '5_percent_adgm_authority_fees',
    defaultmessages: 'ADGM Authority Fees 5%',
  },
  '75_100_percent': {
    id: '75_100_percent',
    defaultmessages: '75% - 99%',
  },
  '900005_content': {
    id: '900005_content',
    defaultmessages: 'Sorry, but we are unable to find any details about the company activity.',
  },
  '900005_title': {
    id: '900005_title',
    defaultmessages: 'Company activity not found',
  },
  ABU_DHABI: {
    id: 'ABU_DHABI',
    defaultmessages: 'Abu Dhabi',
  },
  ACE_ONLINE_APPROVAL: {
    id: 'ACE_ONLINE_APPROVAL',
    defaultmessages: 'Municipality Approval',
  },
  ACTION_TYPE_ADD_BUYER: {
    id: 'ACTION_TYPE_ADD_BUYER',
    defaultmessages: '',
  },
  AC_OFFLINE: {
    id: 'AC_OFFLINE',
    defaultmessages: 'Offline',
  },
  AC_ONLINE_APPROVAL: {
    id: 'AC_ONLINE_APPROVAL',
    defaultmessages: 'Municipality approval',
  },
  AC_ONLINE_CREATE_APPLICATION: {
    id: 'AC_ONLINE_CREATE_APPLICATION',
    defaultmessages: 'Create application',
  },
  AC_ONLINE_DETAILS: {
    id: 'AC_ONLINE_DETAILS',
    defaultmessages: 'Company details',
  },
  AC_ONLINE_DOCUMENTS: {
    id: 'AC_ONLINE_DOCUMENTS',
    defaultmessages: 'Upload documents',
  },
  AC_ONLINE_REVIEW: {
    id: 'AC_ONLINE_REVIEW',
    defaultmessages: 'Review',
  },
  ADD_COMPANY: {
    id: 'ADD_COMPANY',
    defaultmessages: 'Add Company',
  },
  ADD_COMPANY_EMPLOYEE: {
    id: 'ADD_COMPANY_EMPLOYEE',
    defaultmessages: 'Add company employee',
  },
  ADD_OWNER: {
    id: 'ADD_OWNER',
    defaultmessages: 'Add Owner',
  },
  ADD_PARTIES: {
    id: 'ADD_PARTIES',
    defaultmessages: 'Parties details',
  },
  ADD_POA: {
    id: 'ADD_POA',
    defaultmessages: 'Register Power of Attorney',
  },
  ADD_REPORT: {
    id: 'ADD_REPORT',
    defaultmessages: 'Insert report term',
  },
  ADD_REPRESENTATIVE: {
    id: 'ADD_REPRESENTATIVE',
    defaultmessages: 'Add POA',
  },
  ADGM_APPROVAL: {
    id: 'ADGM_APPROVAL',
    defaultmessages: 'ADGM Review',
  },
  ADGM_APPROVALS: {
    id: 'ADGM_APPROVALS',
    defaultmessages: 'ADGM APPROVAL',
  },
  ADGM_Feedback: {
    id: 'ADGM_Feedback',
    defaultmessages: 'ADGM Feedback',
  },
  ADGM_PAYMENT_RECEIPT: {
    id: 'ADGM_PAYMENT_RECEIPT',
    defaultmessages: 'Download ADGM Payment Receipt',
  },
  ADGM_RETURN: {
    id: 'ADGM_RETURN',
    defaultmessages: 'Returned from ADGM Admin',
  },
  ADGM_REVIEW: {
    id: 'ADGM_REVIEW',
    defaultmessages: 'Pending for ADGM Review',
  },
  ADGM_fees: {
    id: 'ADGM_fees',
    defaultmessages: 'ADGM fees',
  },
  ADMIN: {
    id: 'ADMIN',
    defaultmessages: 'Admin',
  },
  ADRES_PAYMENT_RECEIPT: {
    id: 'ADRES_PAYMENT_RECEIPT',
    defaultmessages: 'Download Your Electronic Service Fees Receipt',
  },
  ADRES_REGISTRATION_FEE: {
    id: 'ADRES_REGISTRATION_FEE',
    defaultmessages: 'Electronic Service Fees',
  },
  ADRES_fee: {
    id: 'ADRES_fee',
    defaultmessages: 'Electronic Service Fees',
  },
  ADRES_fees: {
    id: 'ADRES_fees',
    defaultmessages: 'Electronic Service Fees',
  },
  ADVERTISING_MATERIAL: {
    id: 'ADVERTISING_MATERIAL',
    defaultmessages: 'Advertising Material',
  },
  ADVERTISING_PERMIT_REQUEST: {
    id: 'ADVERTISING_PERMIT_REQUEST',
    defaultmessages: 'Request for Permit to Undertake Advertising',
  },
  AED: {
    id: 'AED',
    defaultmessages: 'AED',
  },
  AED_Sft: {
    id: 'AED_Sft',
    defaultmessages: 'AED/Sft',
  },
  AED_amount: {
    id: 'AED_amount',
    defaultmessages: 'AED {num}',
  },
  AED_amount_VAT: {
    id: 'AED_amount_VAT',
    defaultmessages: 'AED {num} + {per}% VAT',
  },
  AED_successfully_added: {
    id: 'AED_successfully_added',
    defaultmessages: 'AED {s} successfully added',
  },
  AGENCY: {
    id: 'AGENCY',
    defaultmessages: 'Agency',
  },
  AGREEMENT_DETAILS: {
    id: 'AGREEMENT_DETAILS',
    defaultmessages: 'Agreement details',
  },
  AJMAN: {
    id: 'AJMAN',
    defaultmessages: 'Ajman',
  },
  ALL_SECTION_SHOULD_BE_CHECKED_CODE: {
    id: 'ALL_SECTION_SHOULD_BE_CHECKED_CODE',
    defaultmessages: '940022',
  },
  ALL_SECTION_SHOULD_BE_CHECKED_MSG: {
    id: 'ALL_SECTION_SHOULD_BE_CHECKED_MSG',
    defaultmessages: 'All sections must be checked by the dispatcher',
  },
  ALSHEIKH: {
    id: 'ALSHEIKH',
    defaultmessages: 'AlSheikh',
  },
  ALSHEIKHA: {
    id: 'ALSHEIKHA',
    defaultmessages: 'AlSheikha',
  },
  AMENDMENT_SUPPLEMENTS: {
    id: 'AMENDMENT_SUPPLEMENTS',
    defaultmessages: 'Amendment supplements',
  },
  APARTMENT: {
    id: 'APARTMENT',
    defaultmessages: 'Apartment',
  },
  APPENDICES_AMEND_MEMORANDUM: {
    id: 'APPENDICES_AMEND_MEMORANDUM',
    defaultmessages: 'Appendices to amend the Memorandum of Association',
  },
  APPENDIX_AND_DOCUMENTS: {
    id: 'APPENDIX_AND_DOCUMENTS',
    defaultmessages: 'Appendix & Docs',
  },
  APPLICANT_EID: {
    id: 'APPLICANT_EID',
    defaultmessages: 'Applicant EID',
  },
  APPLICATION_COMPLETION: {
    id: 'APPLICATION_COMPLETION',
    defaultmessages: 'Application Completed',
  },
  APPLICATION_FORM: {
    id: 'APPLICATION_FORM',
    defaultmessages: 'Application Form',
  },
  APPLICATION_OTHER: {
    id: 'APPLICATION_OTHER',
    defaultmessages: 'Other',
  },
  APPOINTMENT: {
    id: 'APPOINTMENT',
    defaultmessages: 'Appointment',
  },
  APPOINTMENT_CONFIRMED: {
    id: 'APPOINTMENT_CONFIRMED',
    defaultmessages: 'Appointment confirmed',
  },
  APPROVAL: {
    id: 'APPROVAL',
    defaultmessages: 'Approval',
  },
  APPROVAL_ACTION_TYPE_REQUIRED_CODE: {
    id: 'APPROVAL_ACTION_TYPE_REQUIRED_CODE',
    defaultmessages: '940021',
  },
  APPROVAL_ACTION_TYPE_REQUIRED_MSG: {
    id: 'APPROVAL_ACTION_TYPE_REQUIRED_MSG',
    defaultmessages: 'Approval action type is required',
  },
  APPROVE: {
    id: 'APPROVE',
    defaultmessages: 'Approve',
  },
  APPROVED: {
    id: 'APPROVED',
    defaultmessages: 'Approved',
  },
  APPROVED_CAVEAT_INSTRUMENT: {
    id: 'APPROVED_CAVEAT_INSTRUMENT',
    defaultmessages: 'Approved Caveat Instrument',
  },
  AP_OFFLINE: {
    id: 'AP_OFFLINE',
    defaultmessages: 'Offline',
  },
  AP_ONLINE_APPROVAL: {
    id: 'AP_ONLINE_APPROVAL',
    defaultmessages: 'Approval',
  },
  AP_ONLINE_CREATE_APPLICATION: {
    id: 'AP_ONLINE_CREATE_APPLICATION',
    defaultmessages: 'Create application',
  },
  AP_ONLINE_OWNER_DETAILS: {
    id: 'AP_ONLINE_OWNER_DETAILS',
    defaultmessages: 'Owner details',
  },
  AP_ONLINE_POA_DETAILS: {
    id: 'AP_ONLINE_POA_DETAILS',
    defaultmessages: 'POA details',
  },
  AP_ONLINE_REP_DETAILS: {
    id: 'AP_ONLINE_REP_DETAILS',
    defaultmessages: 'Representative details',
  },
  AP_ONLINE_REVIEW: {
    id: 'AP_ONLINE_REVIEW',
    defaultmessages: 'Review',
  },
  ARCHITECT: {
    id: 'ARCHITECT',
    defaultmessages: 'Architect',
  },
  ARTICLES_ASSOCIATION: {
    id: 'ARTICLES_ASSOCIATION',
    defaultmessages: 'Article of Association',
  },
  ARTICLES_OF_ASSOCIATION: {
    id: 'ARTICLES_OF_ASSOCIATION',
    defaultmessages: 'Articles of association',
  },
  ATTESTED_POA: {
    id: 'ATTESTED_POA',
    defaultmessages: 'Attested POA',
  },
  AUDITED: {
    id: 'AUDITED',
    defaultmessages: 'Audited',
  },
  Abu_Dhabi_Court: {
    id: 'Abu_Dhabi_Court',
    defaultmessages: 'Abu Dhabi courts',
  },
  Active: {
    id: 'Active',
    defaultmessages: 'Active',
  },
  Add_as_seller: {
    id: 'Add_as_seller',
    defaultmessages: 'Add as seller',
  },
  Add_buyer: {
    id: 'Add_buyer',
    defaultmessages: 'Add buyer',
  },
  Add_occupants: {
    id: 'Add_occupants',
    defaultmessages: 'Add Occupants',
  },
  Address: {
    id: 'Address',
    defaultmessages: 'Address',
  },
  Adwea: {
    id: 'Adwea',
    defaultmessages: 'ADWEA',
  },
  Agency: {
    id: 'Agency',
    defaultmessages: 'Agency',
  },
  Agent: {
    id: 'Agent',
    defaultmessages: 'Agent',
  },
  All: {
    id: 'All',
    defaultmessages: 'All',
  },
  Allocation_type: {
    id: 'Allocation_type',
    defaultmessages: 'Allocation type',
  },
  Annual: {
    id: 'Annual',
    defaultmessages: 'Annual',
  },
  Applicant: {
    id: 'Applicant',
    defaultmessages: 'Applicant',
  },
  Application: {
    id: 'Application',
    defaultmessages: 'Application',
  },
  Application_ID: {
    id: 'Application_ID',
    defaultmessages: 'Application ID',
  },
  Applications: {
    id: 'Applications',
    defaultmessages: 'Applications',
  },
  Appointment_Details: {
    id: 'Appointment_Details',
    defaultmessages: 'Appointment Details',
  },
  Appointment_at: {
    id: 'Appointment_at',
    defaultmessages: 'Appointment at',
  },
  Appointment_type: {
    id: 'Appointment_type',
    defaultmessages: 'Appointment type',
  },
  Area: {
    id: 'Area',
    defaultmessages: 'Area',
  },
  Attestation: {
    id: 'Attestation',
    defaultmessages: 'Attestation',
  },
  Available: {
    id: 'Available',
    defaultmessages: 'Available',
  },
  BAD_REQUEST: {
    id: 'BAD_REQUEST',
    defaultmessages: 'Bad request',
  },
  BANK: {
    id: 'BANK',
    defaultmessages: 'Bank transfer',
  },
  BANKING_LICENSE: {
    id: 'BANKING_LICENSE',
    defaultmessages: 'Banking License',
  },
  BANK_APPROVAL: {
    id: 'BANK_APPROVAL',
    defaultmessages: 'Bank approval',
  },
  BANK_APPROVALS: {
    id: 'BANK_APPROVALS',
    defaultmessages: 'Bank Approval',
  },
  BANK_NOC: {
    id: 'BANK_NOC',
    defaultmessages: 'NOC from the mortgage banks',
  },
  BANK_OTHERS: {
    id: 'BANK_OTHERS',
    defaultmessages: 'Bank other',
  },
  BANK_PROCESSING: {
    id: 'BANK_PROCESSING',
    defaultmessages: 'Bank processing',
  },
  BANK_REGISTER_PROOF: {
    id: 'BANK_REGISTER_PROOF',
    defaultmessages: 'Proof that the bank was previously registered as the Project Account',
  },
  BANK_RETURN: {
    id: 'BANK_RETURN',
    defaultmessages: 'The bank returned the application',
  },
  BANK_REVIEW: {
    id: 'BANK_REVIEW',
    defaultmessages: 'Bank review',
  },
  BANK_SIGNATORY_APPROVAL: {
    id: 'BANK_SIGNATORY_APPROVAL',
    defaultmessages: 'Bank signatory',
  },
  BANK_TRANSFER: {
    id: 'BANK_TRANSFER',
    defaultmessages: 'Bank transfer',
  },
  BASIC_DETAIL: {
    id: 'BASIC_DETAIL',
    defaultmessages: 'Basic Details',
  },
  BOARD_DECISION: {
    id: 'BOARD_DECISION',
    defaultmessages: 'Board Decision',
  },
  BOTH: {
    id: 'BOTH',
    defaultmessages: 'Both',
  },
  BOTH_EXEMPT: {
    id: 'BOTH_EXEMPT',
    defaultmessages: 'Exempt both',
  },
  BROKER: {
    id: 'BROKER',
    defaultmessages: 'Broker',
  },
  BROKER_APPROVAL: {
    id: 'BROKER_APPROVAL',
    defaultmessages: 'Broker Approval',
  },
  BROKER_RETURN: {
    id: 'BROKER_RETURN',
    defaultmessages: 'Broker Return',
  },
  BROKER_REVIEW: {
    id: 'BROKER_REVIEW',
    defaultmessages: 'Broker Review',
  },
  BUILDING: {
    id: 'BUILDING',
    defaultmessages: 'Building',
  },
  BUILDING_TOWNHOUSE: {
    id: 'BUILDING_TOWNHOUSE',
    defaultmessages: 'Townhouse/Building',
  },
  BUILDING_VILLA: {
    id: 'BUILDING_VILLA',
    defaultmessages: 'Villa/Building',
  },
  BUYER_APPROVAL: {
    id: 'BUYER_APPROVAL',
    defaultmessages: 'Buyer approval',
  },
  BUYER_EXEMPT: {
    id: 'BUYER_EXEMPT',
    defaultmessages: 'Exempt buyer (1%)',
  },
  BUYER_ONLY: {
    id: 'BUYER_ONLY',
    defaultmessages: 'Buyer only 2%',
  },
  BUYER_ONLY_MUSATAHA: {
    id: 'BUYER_ONLY_MUSATAHA',
    defaultmessages: 'Buyer only 1%',
  },
  BUYER_PAYMENT: {
    id: 'BUYER_PAYMENT',
    defaultmessages: 'Buyer Payment',
  },
  BUYER_REJECT: {
    id: 'BUYER_REJECT',
    defaultmessages: 'Buyer rejection',
  },
  BUYER_RETURN: {
    id: 'BUYER_RETURN',
    defaultmessages: 'Returned by buyer',
  },
  BUYER_REVIEW: {
    id: 'BUYER_REVIEW',
    defaultmessages: 'Buyer Review',
  },
  BUY_AND_SELL_AGREEMENT: {
    id: 'BUY_AND_SELL_AGREEMENT',
    defaultmessages: 'Buy & Sell Agreement',
  },
  Basic_info: {
    id: 'Basic_info',
    defaultmessages: 'Basic information',
  },
  Bedroom: {
    id: 'Bedroom',
    defaultmessages: 'Bedroom',
  },
  Brokers: {
    id: 'Brokers',
    defaultmessages: 'Brokers',
  },
  Building: {
    id: 'Building',
    defaultmessages: 'Buildings',
  },
  Building_villa: {
    id: 'Building_villa',
    defaultmessages: 'Building / Villa',
  },
  Buy_and_sell_registration_fee: {
    id: 'Buy_and_sell_registration_fee',
    defaultmessages: 'Buy and sell registration fee',
  },
  Buyer_documents: {
    id: 'Buyer_documents',
    defaultmessages: 'Buyer documents',
  },
  Buyer_num_document_name: {
    id: 'Buyer_num_document_name',
    defaultmessages: 'Buyer #{num} documents ({name})',
  },
  Buyer_only: {
    id: 'Buyer_only',
    defaultmessages: 'Buyer only',
  },
  Buyer_paying_via_cash: {
    id: 'Buyer_paying_via_cash',
    defaultmessages: 'Buyer paying via cash',
  },
  Buyer_paying_via_mortgage: {
    id: 'Buyer_paying_via_mortgage',
    defaultmessages: 'Buyer paying via mortgage',
  },
  Buyer_type: {
    id: 'Buyer_type',
    defaultmessages: 'Buyer type',
  },
  Buyers_Broker: {
    id: 'Buyers_Broker',
    defaultmessages: 'Buyer’s Broker',
  },
  CANCELLED: {
    id: 'CANCELLED',
    defaultmessages: 'Cancelled',
  },
  CANCEL_REQUEST_ERROR: {
    id: 'CANCEL_REQUEST_ERROR',
    defaultmessages: 'User cannot cancel the request when the status is',
  },
  CARD: {
    id: 'CARD',
    defaultmessages: 'Debit/Credit Card',
  },
  CASE_REJECTED: {
    id: 'CASE_REJECTED',
    defaultmessages: 'Dispute rejected',
  },
  CASH: {
    id: 'CASH',
    defaultmessages: 'Cash',
  },
  CASH_DELIVERY_AGREEMENT: {
    id: 'CASH_DELIVERY_AGREEMENT',
    defaultmessages: 'Cash',
  },
  CERTIFICATE_OF_ASSUMING_POSITION: {
    id: 'CERTIFICATE_OF_ASSUMING_POSITION',
    defaultmessages: 'Certificate of assuming a position',
  },
  CERT_PROP_OWNERSHIP: {
    id: 'CERT_PROP_OWNERSHIP',
    defaultmessages: 'Ownership Certificate Issuance',
  },
  CERT_SITE_PLAN: {
    id: 'CERT_SITE_PLAN',
    defaultmessages: 'Site plan',
  },
  CERT_SITE_PLAN_PLOT: {
    id: 'CERT_SITE_PLAN_PLOT',
    defaultmessages: 'Site Plan Certificate Issuance',
  },
  CERT_SITE_PLAN_UNIT: {
    id: 'CERT_SITE_PLAN_UNIT',
    defaultmessages: 'Unit Site Plan',
  },
  CERT_TITLE_DEED: {
    id: 'CERT_TITLE_DEED',
    defaultmessages: 'Title deed',
  },
  CERT_TITLE_DEED_PLOT: {
    id: 'CERT_TITLE_DEED_PLOT',
    defaultmessages: 'Land Title Deed Certificate Issuance',
  },
  CERT_TITLE_DEED_UNIT: {
    id: 'CERT_TITLE_DEED_UNIT',
    defaultmessages: 'Unit Title Deed Certificate Issuance',
  },
  CERT_VERIFICATION: {
    id: 'CERT_VERIFICATION',
    defaultmessages: 'Search Certificate',
  },
  CERT_VERIFICATION_PLOT: {
    id: 'CERT_VERIFICATION_PLOT',
    defaultmessages: 'Land Search Certificate Issuance',
  },
  CERT_VERIFICATION_UNIT: {
    id: 'CERT_VERIFICATION_UNIT',
    defaultmessages: 'Unit Search Certificate Issuance',
  },
  CHECKER_APPROVAL: {
    id: 'CHECKER_APPROVAL',
    defaultmessages: 'Checker approval',
  },
  CHECKER_APPROVAL_RELEASE: {
    id: 'CHECKER_APPROVAL_RELEASE',
    defaultmessages: 'Checker approval release',
  },
  CHECKER_RETURN: {
    id: 'CHECKER_RETURN',
    defaultmessages: 'Returned by Bank checker',
  },
  CHECKER_RETURN_RELEASE: {
    id: 'CHECKER_RETURN_RELEASE',
    defaultmessages: 'Checker return release',
  },
  CHECKER_RETURN_TO_INSPECTION: {
    id: 'CHECKER_RETURN_TO_INSPECTION',
    defaultmessages: 'Returned by Bank checker',
  },
  CHECKER_RETURN_TO_MAKER: {
    id: 'CHECKER_RETURN_TO_MAKER',
    defaultmessages: 'Returned by Bank checker',
  },
  CHECKER_REVIEW: {
    id: 'CHECKER_REVIEW',
    defaultmessages: 'Bank Checker review',
  },
  CHECKER_REVIEW_RELEASE: {
    id: 'CHECKER_REVIEW_RELEASE',
    defaultmessages: 'Checker review release',
  },
  CHECK_RETURN_TO_MAKER: {
    id: 'CHECK_RETURN_TO_MAKER',
    defaultmessages: 'Retuned by Bank checker',
  },
  CHEQUE: {
    id: 'CHEQUE',
    defaultmessages: 'Cheque',
  },
  CIVIL_ENGINEER: {
    id: 'CIVIL_ENGINEER',
    defaultmessages: 'Civil Engineer',
  },
  COMMERCIAL: {
    id: 'COMMERCIAL',
    defaultmessages: 'Commercial',
  },
  COMMERCIAL_ACTIVITY_PERMIT: {
    id: 'COMMERCIAL_ACTIVITY_PERMIT',
    defaultmessages: 'Commercial activity permit on residential or investment land',
  },
  COMMUNICATIONS: {
    id: 'COMMUNICATIONS',
    defaultmessages: 'Communications',
  },
  COMMUNICATIONS_AND_RECEIPTS: {
    id: 'COMMUNICATIONS_AND_RECEIPTS',
    defaultmessages: 'Invoices and receipts',
  },
  COMPANY: {
    id: 'COMPANY',
    defaultmessages: 'Company',
  },
  COMPANY_ACKNOWLEDGE_LETTER: {
    id: 'COMPANY_ACKNOWLEDGE_LETTER',
    defaultmessages: 'Company Acknowledgment Letter',
  },
  COMPANY_ADMIN_APPROVAL: {
    id: 'COMPANY_ADMIN_APPROVAL',
    defaultmessages: 'Company Admin Approval',
  },
  COMPANY_ADMIN_RETURN: {
    id: 'COMPANY_ADMIN_RETURN',
    defaultmessages: 'Company admin return',
  },
  COMPANY_ADMIN_REVIEW: {
    id: 'COMPANY_ADMIN_REVIEW',
    defaultmessages: 'Company Admin Review',
  },
  COMPANY_APPROVAL: {
    id: 'COMPANY_APPROVAL',
    defaultmessages: 'Company Approval',
  },
  COMPANY_INCORPORATION_AGREEMENT: {
    id: 'COMPANY_INCORPORATION_AGREEMENT',
    defaultmessages: 'Company incorporation agreement',
  },
  COMPANY_SIGNATORY: {
    id: 'COMPANY_SIGNATORY',
    defaultmessages: 'Company signatory',
  },
  COMPLETE: {
    id: 'COMPLETE',
    defaultmessages: 'Completed',
  },
  COMPLETED: {
    id: 'COMPLETED',
    defaultmessages: 'Completed',
  },
  COMPLIANCE_DECLARATION: {
    id: 'COMPLIANCE_DECLARATION',
    defaultmessages: 'Compliance Declaration',
  },
  CONCEDED_CASE_LETTER: {
    id: 'CONCEDED_CASE_LETTER',
    defaultmessages: 'Conceded dispute letter',
  },
  CONCESSION_APPROVAL: {
    id: 'CONCESSION_APPROVAL',
    defaultmessages: 'Concession approval',
  },
  CONCESSION_CASE: {
    id: 'CONCESSION_CASE',
    defaultmessages: 'Dispute concession',
  },
  CONSTITUTIONAL_DOCUMENT: {
    id: 'CONSTITUTIONAL_DOCUMENT',
    defaultmessages: 'Constitutional Document',
  },
  CONTRACT: {
    id: 'CONTRACT',
    defaultmessages: 'Agreement',
  },
  COURT_LETTER: {
    id: 'COURT_LETTER',
    defaultmessages: 'Court letter',
  },
  COURT_LETTER_WITHOUT_REFUND: {
    id: 'COURT_LETTER_WITHOUT_REFUND',
    defaultmessages: 'Court letter (Without refund)',
  },
  COURT_LETTER_WITH_REFUND: {
    id: 'COURT_LETTER_WITH_REFUND',
    defaultmessages: 'Court letter (With refund)',
  },
  COURT_ORDER: {
    id: 'COURT_ORDER',
    defaultmessages: 'Court Order',
  },
  CREATE_APPLICATION: {
    id: 'CREATE_APPLICATION',
    defaultmessages: 'Application Submitted',
  },
  CREATE_COMPANY: {
    id: 'CREATE_COMPANY',
    defaultmessages: 'Company details',
  },
  CREATE_EMPLOYEE: {
    id: 'CREATE_EMPLOYEE',
    defaultmessages: 'Create employee file',
  },
  CREATE_OWNER: {
    id: 'CREATE_OWNER',
    defaultmessages: 'Create owner file',
  },
  CRIMINAL_CLEARANCE: {
    id: 'CRIMINAL_CLEARANCE',
    defaultmessages: 'Criminal Clearance',
  },
  'Cancelled by user on UAE PASS app.': {
    id: 'Cancelled by user on UAE PASS app.',
    defaultmessages: 'User cancelled the login',
  },
  'Cancelled by user on UAE PASS web.': {
    id: 'Cancelled by user on UAE PASS web.',
    defaultmessages: 'User cancelled the login',
  },
  Card: {
    id: 'Card',
    defaultmessages: 'Card',
  },
  ChangeAdd: {
    id: 'ChangeAdd',
    defaultmessages: 'Change/Add',
  },
  'Choose_your_preferred_location_to_schedule_the_appointment.': {
    id: 'Choose_your_preferred_location_to_schedule_the_appointment.',
    defaultmessages: 'Choose your preferred location to schedule the appointment.',
  },
  City: {
    id: 'City',
    defaultmessages: 'City',
  },
  Clear: {
    id: 'Clear',
    defaultmessages: 'Clear',
  },
  Click_here_to_know_more_about_the_Dari_Office: {
    id: 'Click_here_to_know_more_about_the_Dari_Office',
    defaultmessages: 'Click here to know more about the Dari Office',
  },
  Click_here_to_know_more_about_the_Dari_at_your_place: {
    id: 'Click_here_to_know_more_about_the_Dari_at_your_place',
    defaultmessages: 'Click here to know more about the Dari at your place',
  },
  Commercial: {
    id: 'Commercial',
    defaultmessages: 'Commercial',
  },
  Common_Download_Contract_release: {
    id: 'Common_Download_Contract_release',
    defaultmessages: 'Download Discharge Certificate',
  },
  Common_Success_Toast_Title: {
    id: 'Common_Success_Toast_Title',
    defaultmessages: 'Application Discarded Successfully',
  },
  Companies: {
    id: 'Companies',
    defaultmessages: 'Companies',
  },
  Company: {
    id: 'Company',
    defaultmessages: 'Company',
  },
  Company_ddress_ar: {
    id: 'Company_ddress_ar',
    defaultmessages: 'Company Address (Arabic)',
  },
  Company_ddress_en: {
    id: 'Company_ddress_en',
    defaultmessages: 'Company Address (English)',
  },
  Company_signatory: {
    id: 'Company_signatory',
    defaultmessages: 'Company signatory',
  },
  Completed: {
    id: 'Completed',
    defaultmessages: 'Completed',
  },
  ConstructorPayment: {
    id: 'ConstructorPayment',
    defaultmessages: 'agreementor Payment',
  },
  ConsultantPayment: {
    id: 'ConsultantPayment',
    defaultmessages: 'Consultant Payment',
  },
  Consultant_company: {
    id: 'Consultant_company',
    defaultmessages: 'Consultant',
  },
  Contact_us: {
    id: 'Contact_us',
    defaultmessages: 'Contact us',
  },
  Contract_details: {
    id: 'Contract_details',
    defaultmessages: 'Agreement details',
  },
  Controller: {
    id: 'Controller',
    defaultmessages: 'Controller',
  },
  Custom: {
    id: 'Custom',
    defaultmessages: 'Custom',
  },
  Customer_Service: {
    id: 'Customer_Service',
    defaultmessages: 'Customer Service',
  },
  DAD_APPROVED: {
    id: 'DAD_APPROVED',
    defaultmessages: 'Developer affairs Dept. Approved',
  },
  DARI_AT_YOUR_PLACE: {
    id: 'DARI_AT_YOUR_PLACE',
    defaultmessages: '',
  },
  DARI_OFFICE: {
    id: 'DARI_OFFICE',
    defaultmessages: '',
  },
  DARI_PENDING_BUYER_PAYMENT: {
    id: 'DARI_PENDING_BUYER_PAYMENT',
    defaultmessages: 'Pending Buyer Payment',
  },
  DARI_PENDING_PAYMENT: {
    id: 'DARI_PENDING_PAYMENT',
    defaultmessages: 'Registration Payment',
  },
  DARI_PENDING_SELLER_PAYMENT: {
    id: 'DARI_PENDING_SELLER_PAYMENT',
    defaultmessages: 'Pending Seller Payment',
  },
  DARI_VALUE_RETURN: {
    id: 'DARI_VALUE_RETURN',
    defaultmessages: 'Returned by DARI Value',
  },
  DD_MM_YY: {
    id: 'DD_MM_YY',
    defaultmessages: 'DD/MM/YYYY',
  },
  DD_MM_YYYY: {
    id: 'DD_MM_YYYY',
    defaultmessages: 'DD/MM/YYYY',
  },
  DECREE_OF_ISTRIBUTION: {
    id: 'DECREE_OF_ISTRIBUTION',
    defaultmessages: 'Decree of distribution',
  },
  DEFENDANT: {
    id: 'DEFENDANT',
    defaultmessages: 'Defendant',
  },
  DEFENTANT_INFO: {
    id: 'DEFENTANT_INFO',
    defaultmessages: 'Defendant information',
  },
  DETERMINATION_OF_HEIRS: {
    id: 'DETERMINATION_OF_HEIRS',
    defaultmessages: 'Determination of heirs',
  },
  DETERMINATION_OF_HIRE_DOCUMENT: {
    id: 'DETERMINATION_OF_HIRE_DOCUMENT',
    defaultmessages: 'Determination of hire',
  },
  DEVELOPER: {
    id: 'DEVELOPER',
    defaultmessages: 'Developer',
  },
  DEVELOPERS_APPROVAL: {
    id: 'DEVELOPERS_APPROVAL',
    defaultmessages: 'Developer approval',
  },
  DEVELOPER_APPROVAL: {
    id: 'DEVELOPER_APPROVAL',
    defaultmessages: 'Developer approver',
  },
  DEVELOPER_LICENSE: {
    id: 'DEVELOPER_LICENSE',
    defaultmessages: 'Developer License',
  },
  DEVELOPER_REGISTRATION_CERT: {
    id: 'DEVELOPER_REGISTRATION_CERT',
    defaultmessages: 'Developer Registration Certificate',
  },
  DEVELOPER_RETURN: {
    id: 'DEVELOPER_RETURN',
    defaultmessages: 'Returned by Developer approver',
  },
  DEVELOPER_SELL_CONTRACT: {
    id: 'DEVELOPER_SELL_CONTRACT',
    defaultmessages: 'Developer Sale Agreement',
  },
  DEVELOPER_SIGNATORY_APPROVAL: {
    id: 'DEVELOPER_SIGNATORY_APPROVAL',
    defaultmessages: 'Developer signatory',
  },
  DEVELOPMENT_EVIDENCE: {
    id: 'DEVELOPMENT_EVIDENCE',
    defaultmessages: 'Development Evidence',
  },
  DIGITAL_TRANSFER_OF_INTEREST_LAND: {
    id: 'DIGITAL_TRANSFER_OF_INTEREST_LAND',
    defaultmessages: 'Digital Transfer of Interest — Land',
  },
  DIGITAL_TRANSFER_OF_INTEREST_UNIT: {
    id: 'DIGITAL_TRANSFER_OF_INTEREST_UNIT',
    defaultmessages: 'Digital Transfer of Interest  — Unit',
  },
  DIPLOMAT_DOCUMENT: {
    id: 'DIPLOMAT_DOCUMENT',
    defaultmessages: 'Diplomat documents',
  },
  DISCARDED: {
    id: 'DISCARDED',
    defaultmessages: 'Discarded',
  },
  DISCHARGED: {
    id: 'DISCHARGED',
    defaultmessages: 'Discharged',
  },
  DISCHARGE_LETTER: {
    id: 'DISCHARGE_LETTER',
    defaultmessages: 'Discharge Letter from the Bank',
  },
  DISPATCHER_APPROVAL: {
    id: 'DISPATCHER_APPROVAL',
    defaultmessages: 'Dispatcher approval',
  },
  DIVISION_PROPOSAL_DOCUMENT: {
    id: 'DIVISION_PROPOSAL_DOCUMENT',
    defaultmessages: 'Division proposal',
  },
  DIVORCE_CASE_PROOF: {
    id: 'DIVORCE_CASE_PROOF',
    defaultmessages: 'Divorce case proof',
  },
  DMT_ADMIN_MORTGAGE_FEE: {
    id: 'DMT_ADMIN_MORTGAGE_FEE',
    defaultmessages: 'Other charges of mortgage registration',
  },
  DMT_APPROVAL: {
    id: 'DMT_APPROVAL',
    defaultmessages: 'Municipality approval',
  },
  DMT_FEES_PAYMENT: {
    id: 'DMT_FEES_PAYMENT',
    defaultmessages: 'DMT fees payment',
  },
  DMT_LATE_FINE_FEE: {
    id: 'DMT_LATE_FINE_FEE',
    defaultmessages: 'Late Registration Fine',
  },
  DMT_MORTGAGE_FEE: {
    id: 'DMT_MORTGAGE_FEE',
    defaultmessages: 'Mortgage registration fee',
  },
  DMT_REGISTRATION: {
    id: 'DMT_REGISTRATION',
    defaultmessages: 'DMT registration',
  },
  DMT_REG_ADMIN_TRANS_FEE: {
    id: 'DMT_REG_ADMIN_TRANS_FEE',
    defaultmessages: 'Other charges of registration',
  },
  DMT_REG_FEE: {
    id: 'DMT_REG_FEE',
    defaultmessages: 'Municipality Registration Fee',
  },
  DMT_REJECT: {
    id: 'DMT_REJECT',
    defaultmessages: 'Returned by DMT',
  },
  DMT_RENEWAL: {
    id: 'DMT_RENEWAL',
    defaultmessages: 'DMT renewal of Agreement',
  },
  DMT_RENTAL_FEE: {
    id: 'DMT_RENTAL_FEE',
    defaultmessages: 'Registration Fee',
  },
  DMT_RETURN_TO_INSPECTION: {
    id: 'DMT_RETURN_TO_INSPECTION',
    defaultmessages: 'Returned by DMT',
  },
  DMT_RETURN_TO_MAKER: {
    id: 'DMT_RETURN_TO_MAKER',
    defaultmessages: 'Returned by DMT',
  },
  DMT_REVIEW: {
    id: 'DMT_REVIEW',
    defaultmessages: 'Municipality review',
  },
  DMT_SERVICE_FEE: {
    id: 'DMT_SERVICE_FEE',
    defaultmessages: 'Municipality fees',
  },
  DMT_SURVEYOR_RETURN: {
    id: 'DMT_SURVEYOR_RETURN',
    defaultmessages: 'Municipality return to surveyor',
  },
  DMT_TAWTHEEQ_FEE: {
    id: 'DMT_TAWTHEEQ_FEE',
    defaultmessages: 'Tawqtheeq registration fee',
  },
  DOCUMENTS: {
    id: 'DOCUMENTS',
    defaultmessages: 'Documents',
  },
  DOC_NOT_FOUND_CODE: {
    id: 'DOC_NOT_FOUND_CODE',
    defaultmessages: '940031',
  },
  DOC_NOT_FOUND_MSG: {
    id: 'DOC_NOT_FOUND_MSG',
    defaultmessages: 'Document not found',
  },
  DOWNLOAD_CONTRACT: {
    id: 'DOWNLOAD_CONTRACT',
    defaultmessages: 'Download Agreement',
  },
  DOWN_INSTALMENT: {
    id: 'DOWN_INSTALMENT',
    defaultmessages: 'Down Installment',
  },
  DOWN_PAYMENT: {
    id: 'DOWN_PAYMENT',
    defaultmessages: 'Down Payment',
  },
  DRAFT: {
    id: 'DRAFT',
    defaultmessages: 'Draft',
  },
  DRC_EXECUTION_STAMP: {
    id: 'DRC_EXECUTION_STAMP',
    defaultmessages: 'Request execution stamp',
  },
  DRC_EXPERT_OPINION: {
    id: 'DRC_EXPERT_OPINION',
    defaultmessages: 'Request for expert opinion',
  },
  DRC_EXPERT_OPINION_CREATION: {
    id: 'DRC_EXPERT_OPINION_CREATION',
    defaultmessages: 'Expert opinion creation',
  },
  DRC_EXPERT_PAYMENT: {
    id: 'DRC_EXPERT_PAYMENT',
    defaultmessages: 'Expert payment',
  },
  DRC_EXPERT_REVIEW: {
    id: 'DRC_EXPERT_REVIEW',
    defaultmessages: 'Expert review',
  },
  DRC_FAQ: {
    id: 'DRC_FAQ',
    defaultmessages: 'Register a dispute FAQs',
  },
  DRC_MEDIATOR_APPROVAL: {
    id: 'DRC_MEDIATOR_APPROVAL',
    defaultmessages: 'Mediator approval',
  },
  DRC_REGISTRATION: {
    id: 'DRC_REGISTRATION',
    defaultmessages: 'Dispute registration',
  },
  DROPPED: {
    id: 'DROPPED',
    defaultmessages: 'Dropped',
  },
  DROPPED_APPROVAL: {
    id: 'DROPPED_APPROVAL',
    defaultmessages: 'Dropped approval',
  },
  DROPPED_CASE: {
    id: 'DROPPED_CASE',
    defaultmessages: 'Dispute dropped',
  },
  DROPPED_CASE_LETTER: {
    id: 'DROPPED_CASE_LETTER',
    defaultmessages: 'Dropped dispute letter',
  },
  DR_APPROVED: {
    id: 'DR_APPROVED',
    defaultmessages: 'Registration Dept. Approved',
  },
  DUBAI: {
    id: 'DUBAI',
    defaultmessages: 'Dubai',
  },
  DUPLICATE_REQUEST_PLOT_ERROR: {
    id: 'DUPLICATE_REQUEST_PLOT_ERROR',
    defaultmessages: "There's an existing request active for this plot. Please refer Request ID",
  },
  DUPLICATE_REQUEST_UNIT_ERROR: {
    id: 'DUPLICATE_REQUEST_UNIT_ERROR',
    defaultmessages: "There's an existing request active for this unit. Please refer Request ID",
  },
  Dari_Service_Fee: {
    id: 'Dari_Service_Fee',
    defaultmessages: 'Electronic Service Fees',
  },
  Date_of_birth: {
    id: 'Date_of_birth',
    defaultmessages: 'Date of birth',
  },
  Date_of_birth_DD_MM_YYYY: {
    id: 'Date_of_birth_DD_MM_YYYY',
    defaultmessages: 'Date of birth (DD/MM/YYYY)',
  },
  Diplomat: {
    id: 'Diplomat',
    defaultmessages: 'Diplomat',
  },
  DiplomaticOffices: {
    id: 'DiplomaticOffices',
    defaultmessages: 'Diplomat',
  },
  Directory: {
    id: 'Directory',
    defaultmessages: 'Directory',
  },
  Dmt_Service_Fee: {
    id: 'Dmt_Service_Fee',
    defaultmessages: 'Municipality Service Fees',
  },
  Download_contract: {
    id: 'Download_contract',
    defaultmessages: 'Download agreement',
  },
  Download_title_deed: {
    id: 'Download_title_deed',
    defaultmessages: 'Download title deed',
  },
  Draft: {
    id: 'Draft',
    defaultmessages: 'Draft',
  },
  EASEMENT_RELEASE: {
    id: 'EASEMENT_RELEASE',
    defaultmessages: 'Easement Cancellation / Release',
  },
  ED: {
    id: 'ED',
    defaultmessages: 'Trade license no.',
  },
  EDUCATION: {
    id: 'EDUCATION',
    defaultmessages: 'Education',
  },
  EID: {
    id: 'EID',
    defaultmessages: 'EID',
  },
  EID_MOI: {
    id: 'EID_MOI',
    defaultmessages: 'EID/MOI',
  },
  EID_Number: {
    id: 'EID_Number',
    defaultmessages: 'EID number',
  },
  EID_expiry_date: {
    id: 'EID_expiry_date',
    defaultmessages: 'EID expiry date',
  },
  EID_hint: {
    id: 'EID_hint',
    defaultmessages: '784–1234–5678901–2',
  },
  EID_info: {
    id: 'EID_info',
    defaultmessages: 'EID information',
  },
  EID_issue_date: {
    id: 'EID_issue_date',
    defaultmessages: 'EID issue date',
  },
  EID_number: {
    id: 'EID_number',
    defaultmessages: 'EID number',
  },
  EID_verification: {
    id: 'EID_verification',
    defaultmessages: 'EID verification',
  },
  EIGHT: {
    id: 'EIGHT',
    defaultmessages: '8 Installments',
  },
  ELEVEN: {
    id: 'ELEVEN',
    defaultmessages: '11 Installments',
  },
  EMPLOYEE: {
    id: 'EMPLOYEE',
    defaultmessages: 'Employee',
  },
  EMPLOYEE_DETAILS: {
    id: 'EMPLOYEE_DETAILS',
    defaultmessages: 'Employee details',
  },
  ENTERTAINING: {
    id: 'ENTERTAINING',
    defaultmessages: 'Entertainment',
  },
  'EQUEST-VALUATION-CERTIFICATE-LAND': {
    id: 'EQUEST-VALUATION-CERTIFICATE-LAND',
    defaultmessages: 'Land Evaluation Certificate Issuance',
  },
  ERROR_1000000: {
    id: 'ERROR_1000000',
    defaultmessages: 'Profession Id must not be empty',
  },
  ERROR_1000001: {
    id: 'ERROR_1000001',
    defaultmessages: 'Profession Id must not be empty',
  },
  ERROR_10000010: {
    id: 'ERROR_10000010',
    defaultmessages: 'Document Type is invalid',
  },
  ERROR_10000011: {
    id: 'ERROR_10000011',
    defaultmessages: 'File not be empty',
  },
  ERROR_10000012: {
    id: 'ERROR_10000012',
    defaultmessages: 'Something went wrong from elms side',
  },
  ERROR_10000013: {
    id: 'ERROR_10000013',
    defaultmessages: 'Document is not found',
  },
  ERROR_10000014: {
    id: 'ERROR_10000014',
    defaultmessages: 'Company Id is invalid',
  },
  ERROR_10000017: {
    id: 'ERROR_10000017',
    defaultmessages: 'Company can not initiate this service.',
  },
  ERROR_10000018: {
    id: 'ERROR_10000018',
    defaultmessages: 'Invalid Date format',
  },
  ERROR_10000019: {
    id: 'ERROR_10000019',
    defaultmessages: 'Document ID is Required',
  },
  ERROR_1000002: {
    id: 'ERROR_1000002',
    defaultmessages: 'Invalid user access level',
  },
  ERROR_1000003: {
    id: 'ERROR_1000003',
    defaultmessages: 'Profession Classification Id must not be empty',
  },
  ERROR_1000004: {
    id: 'ERROR_1000004',
    defaultmessages: 'Profession Classification is invalid',
  },
  ERROR_1000005: {
    id: 'ERROR_1000005',
    defaultmessages: 'Municipality Id must not be empty',
  },
  ERROR_1000006: {
    id: 'ERROR_1000006',
    defaultmessages: 'Company name must not be empty',
  },
  ERROR_1000007: {
    id: 'ERROR_1000007',
    defaultmessages: 'Reference number not be empty',
  },
  ERROR_1000008: {
    id: 'ERROR_1000008',
    defaultmessages: 'Registration date not be empty',
  },
  ERROR_1000009: {
    id: 'ERROR_1000009',
    defaultmessages: 'Expiry date not be empty',
  },
  ERR_EXISTING_APPS_IN_PROGRESS: {
    id: 'ERR_EXISTING_APPS_IN_PROGRESS',
    defaultmessages: 'Existing application in progress.',
  },
  ESCROW_BANK_CHECKER_APPROVAL: {
    id: 'ESCROW_BANK_CHECKER_APPROVAL',
    defaultmessages: 'Bank checker',
  },
  ESCROW_BANK_MAKER_REVIEW: {
    id: 'ESCROW_BANK_MAKER_REVIEW',
    defaultmessages: 'Bank maker',
  },
  ESCROW_SWAP: {
    id: 'ESCROW_SWAP',
    defaultmessages: 'Escrow Sweep',
  },
  ESCROW_SWEEP: {
    id: 'ESCROW_SWEEP',
    defaultmessages: 'Escrow Sweep',
  },
  ESTABLISHMENT_CONTRACT: {
    id: 'ESTABLISHMENT_CONTRACT',
    defaultmessages: 'Establishment Agreement',
  },
  EVALUATION: {
    id: 'EVALUATION',
    defaultmessages: 'Evaluation',
  },
  EVALUATION_CERTIFICATE: {
    id: 'EVALUATION_CERTIFICATE',
    defaultmessages: 'Evaluation Certificate',
  },
  EVIDENCES_DOCUMENT: {
    id: 'EVIDENCES_DOCUMENT',
    defaultmessages: 'Evidences',
  },
  EXCEPTIONAL_ADDING_OCCUPANT: {
    id: 'EXCEPTIONAL_ADDING_OCCUPANT',
    defaultmessages: 'Exemption letter from adding the occupant',
  },
  EXPAT_ALLOWED_PERCENTAGE: {
    id: 'EXPAT_ALLOWED_PERCENTAGE',
    defaultmessages: '',
  },
  EXPERT_APPROVAL: {
    id: 'EXPERT_APPROVAL',
    defaultmessages: 'Expert approval',
  },
  EXPERT_COURT_LETTER: {
    id: 'EXPERT_COURT_LETTER',
    defaultmessages: 'Expert Court Letter',
  },
  EXPERT_OPINION: {
    id: 'EXPERT_OPINION',
    defaultmessages: 'Expert opinion',
  },
  EXPERT_REPORT: {
    id: 'EXPERT_REPORT',
    defaultmessages: 'Expert report',
  },
  EXPERT_REQUESTED: {
    id: 'EXPERT_REQUESTED',
    defaultmessages: 'Expert requested',
  },
  EXPERT_REVIEW_REPORT: {
    id: 'EXPERT_REVIEW_REPORT',
    defaultmessages: 'Expert review report',
  },
  EXTEND_APPROVAL: {
    id: 'EXTEND_APPROVAL',
    defaultmessages: 'Extend approval',
  },
  EXTEND_MEDIATION_APPROVAL: {
    id: 'EXTEND_MEDIATION_APPROVAL',
    defaultmessages: 'Extend mediation period',
  },
  Edit: {
    id: 'Edit',
    defaultmessages: 'Edit',
  },
  Edit_buyer: {
    id: 'Edit_buyer',
    defaultmessages: 'Edit buyer',
  },
  Email: {
    id: 'Email',
    defaultmessages: 'Email',
  },
  Embassy: {
    id: 'Embassy',
    defaultmessages: 'Embassy',
  },
  Enter_EID_number_fetch_person_details: {
    id: 'Enter_EID_number_fetch_person_details',
    defaultmessages: "Enter EID number to fetch person's details",
  },
  Enter_UN_EID_number_fetch_person_details: {
    id: 'Enter_UN_EID_number_fetch_person_details',
    defaultmessages: "Enter UN/EID number to fetch person's details",
  },
  Enter_UN_EID_number_fetch_person_details_web: {
    id: 'Enter_UN_EID_number_fetch_person_details_web',
    defaultmessages:
      'Enter the premise ID to retrieve the lease unit details, Please make sure to click on the Fetch button once you enter the premise ID',
  },
  Error: {
    id: 'Error',
    defaultmessages: 'Error',
  },
  Error_VAL103_message: {
    id: 'Error_VAL103_message',
    defaultmessages: 'The selected properties are not on the same land',
  },
  Error_VAL500013_message: {
    id: 'Error_VAL500013_message',
    defaultmessages:
      'The selected property acquisition type (allotment) is not eligible for sale. Please review the acquisition details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  Extra_charge_for_Dari_at_your_place_service_is_AED_3000_for_this_application: {
    id: 'Extra_charge_for_Dari_at_your_place_service_is_AED_3000_for_this_application',
    defaultmessages: 'Extra charge for Dari at your place service is AED 3000 for this application',
  },
  FAMILY_NO: {
    id: 'FAMILY_NO',
    defaultmessages: 'Family book',
  },
  FEMALE: {
    id: 'FEMALE',
    defaultmessages: 'Female',
  },
  FILE_UPLOAD_ERROR: {
    id: 'FILE_UPLOAD_ERROR',
    defaultmessages: 'File upload failed',
  },
  FINAL_APPROVAL: {
    id: 'FINAL_APPROVAL',
    defaultmessages: 'Final approval',
  },
  FINAL_INSTALMENT: {
    id: 'FINAL_INSTALMENT',
    defaultmessages: 'Final Installment',
  },
  FINAL_PAYMENT: {
    id: 'FINAL_PAYMENT',
    defaultmessages: 'Final Payment',
  },
  FINANCE: {
    id: 'FINANCE',
    defaultmessages: 'Finance',
  },
  FIRST_PARTY_APPROVAL: {
    id: 'FIRST_PARTY_APPROVAL',
    defaultmessages: '',
  },
  FIRST_PARTY_RETURN: {
    id: 'FIRST_PARTY_RETURN',
    defaultmessages: '',
  },
  FIRST_SESSION_SCHEDULED: {
    id: 'FIRST_SESSION_SCHEDULED',
    defaultmessages: 'First session scheduled',
  },
  FIVE: {
    id: 'FIVE',
    defaultmessages: '5 Installments',
  },
  FIXED: {
    id: 'FIXED',
    defaultmessages: 'Fixed',
  },
  FOUR: {
    id: 'FOUR',
    defaultmessages: '4 installments',
  },
  FRI: {
    id: 'FRI',
    defaultmessages: 'FRI',
  },
  FUJAIRAH: {
    id: 'FUJAIRAH',
    defaultmessages: 'Fujairah',
  },
  FULL_PAYMENT: {
    id: 'FULL_PAYMENT',
    defaultmessages: 'Full payment',
  },
  False: {
    id: 'False',
    defaultmessages: 'No',
  },
  Family_book: {
    id: 'Family_book',
    defaultmessages: 'Family book',
  },
  Feedback: {
    id: 'Feedback',
    defaultmessages: 'Feedback',
  },
  Filters: {
    id: 'Filters',
    defaultmessages: 'Filters',
  },
  Floor: {
    id: 'Floor',
    defaultmessages: 'Floor',
  },
  FreeholdPropertyManagementAgreement: {
    id: 'FreeholdPropertyManagementAgreement',
    defaultmessages: 'Freehold property management agreement',
  },
  FullProject: {
    id: 'FullProject',
    defaultmessages: 'Sell Permit (Full Project)',
  },
  Full_Project_fee: {
    id: 'Full_Project_fee',
    defaultmessages: 'Full Project fees',
  },
  GENERATE_AGREEMENT: {
    id: 'GENERATE_AGREEMENT',
    defaultmessages: 'Agreement Generation',
  },
  GENERATE_CERTIFICATE: {
    id: 'GENERATE_CERTIFICATE',
    defaultmessages: 'Your certificate is being generated',
  },
  GENERATE_CONTRACT: {
    id: 'GENERATE_CONTRACT',
    defaultmessages: 'Issue Agreement',
  },
  GENERATE_DOCUMENT: {
    id: 'GENERATE_DOCUMENT',
    defaultmessages: 'Generate Document',
  },
  GET_CERTIFICATE: {
    id: 'GET_CERTIFICATE',
    defaultmessages: 'Get certificate',
  },
  GOVERNMENT: {
    id: 'GOVERNMENT',
    defaultmessages: 'Government',
  },
  GOVERNMENT_ENTITY: {
    id: 'GOVERNMENT_ENTITY',
    defaultmessages: 'Government entity',
  },
  GOVERNMENT_FEE: {
    id: 'GOVERNMENT_FEE',
    defaultmessages: 'Lease agreement of Unit Registration Fees ( On Government Land)',
  },
  GUARDIAN: {
    id: 'GUARDIAN',
    defaultmessages: 'Guardian',
  },
  GUARDIAN_COURT_LETTER: {
    id: 'GUARDIAN_COURT_LETTER',
    defaultmessages: 'Guardian Court Letter',
  },
  GUARDIAN_COURT_LETTER_SUPERVISOR: {
    id: 'GUARDIAN_COURT_LETTER_SUPERVISOR',
    defaultmessages: 'Guardian court letter',
  },
  Gender: {
    id: 'Gender',
    defaultmessages: 'Gender',
  },
  GeneralCompanyAuth: {
    id: 'GeneralCompanyAuth',
    defaultmessages: 'General company auth',
  },
  GeneralPOA: {
    id: 'GeneralPOA',
    defaultmessages: 'General POA',
  },
  Generate_Agreement: {
    id: 'Generate_Agreement',
    defaultmessages: 'The agreement has been generated successfully',
  },
  Government: {
    id: 'Government',
    defaultmessages: 'Government',
  },
  GuardianPOA: {
    id: 'GuardianPOA',
    defaultmessages: 'Guardian POA',
  },
  HEALTH: {
    id: 'HEALTH',
    defaultmessages: 'Health',
  },
  HEIRS_COURT_LETTER: {
    id: 'HEIRS_COURT_LETTER',
    defaultmessages: 'Heirs Court Letter',
  },
  HER_HIGHNESS: {
    id: 'HER_HIGHNESS',
    defaultmessages: 'Her Highness',
  },
  HER_SHEIKH_HIGHNESS: {
    id: 'HER_SHEIKH_HIGHNESS',
    defaultmessages: 'Her Sheikh Highness',
  },
  HIRES_COURT_LETTER: {
    id: 'HIRES_COURT_LETTER',
    defaultmessages: 'Heirs Court Letter',
  },
  HIS_HIGHNESS_SHEIKH: {
    id: 'HIS_HIGHNESS_SHEIKH',
    defaultmessages: 'His Highness Sheikh',
  },
  HIS_ROYAL_HIGHNESS_PRINCE: {
    id: 'HIS_ROYAL_HIGHNESS_PRINCE',
    defaultmessages: 'His Royal Highness Prince',
  },
  HONOR: {
    id: 'HONOR',
    defaultmessages: 'Excellency',
  },
  Hide: {
    id: 'Hide',
    defaultmessages: 'Hide',
  },
  How_is_buyer_paying: {
    id: 'How_is_buyer_paying',
    defaultmessages: 'How is the buyer paying?',
  },
  IBAN: {
    id: 'IBAN',
    defaultmessages: 'IBAN',
  },
  ID: {
    id: 'ID',
    defaultmessages: 'ID',
  },
  INCLUDED: {
    id: 'INCLUDED',
    defaultmessages: 'Included',
  },
  INCORPORATION_OF_LICENSE: {
    id: 'INCORPORATION_OF_LICENSE',
    defaultmessages: 'Incorporation license/certificate',
  },
  INDUSTRIAL: {
    id: 'INDUSTRIAL',
    defaultmessages: 'Industrial',
  },
  INITIATE: {
    id: 'INITIATE',
    defaultmessages: 'Initiate Application',
  },
  INITIATOR: {
    id: 'INITIATOR',
    defaultmessages: 'Initiator',
  },
  INSPECTION_APPROVAL: {
    id: 'INSPECTION_APPROVAL',
    defaultmessages: 'Inspection Company Approval',
  },
  INSPECTION_AUDITOR: {
    id: 'INSPECTION_AUDITOR',
    defaultmessages: 'Inspection Company Auditor',
  },
  INSPECTION_AUDITOR_REVIEW: {
    id: 'INSPECTION_AUDITOR_REVIEW',
    defaultmessages: 'Inspection Auditor Review',
  },
  INSPECTION_RETURN: {
    id: 'INSPECTION_RETURN',
    defaultmessages: 'Returned by Inspection company',
  },
  INSPECTION_RETURN_TO_AUDITOR: {
    id: 'INSPECTION_RETURN_TO_AUDITOR',
    defaultmessages: 'Returned by Inspection company approver',
  },
  INSTALMENT: {
    id: 'INSTALMENT',
    defaultmessages: 'Installment',
  },
  INSTRUMENT_CONTAINING_THE_COVENANT: {
    id: 'INSTRUMENT_CONTAINING_THE_COVENANT',
    defaultmessages: 'Instrument Containing the Covenant',
  },
  INSURANCE_CERTIFICATE: {
    id: 'INSURANCE_CERTIFICATE',
    defaultmessages: 'Insurance certificate',
  },
  INTERNAL_TRANSFER: {
    id: 'INTERNAL_TRANSFER',
    defaultmessages: 'Internal Transfer',
  },
  INTERPERSONAL_MUSATAHA_CONTRACT: {
    id: 'INTERPERSONAL_MUSATAHA_CONTRACT',
    defaultmessages: 'Musataha Agreement Registration',
  },
  INVESTMENT: {
    id: 'INVESTMENT',
    defaultmessages: 'Investment',
  },
  INVESTMENT_AREA: {
    id: 'INVESTMENT_AREA',
    defaultmessages: '',
  },
  INVESTOR_APPROVAL: {
    id: 'INVESTOR_APPROVAL',
    defaultmessages: 'Investor approval',
  },
  INVESTOR_IBAN_LETTER: {
    id: 'INVESTOR_IBAN_LETTER',
    defaultmessages: 'Investor IBAN Letter',
  },
  INVESTOR_RETURN: {
    id: 'INVESTOR_RETURN',
    defaultmessages: 'Investor return',
  },
  IN_PROGRESS: {
    id: 'IN_PROGRESS',
    defaultmessages: 'In progress',
  },
  ISSUED_BY_DECREE_ONLY: {
    id: 'ISSUED_BY_DECREE_ONLY',
    defaultmessages: 'Decree',
  },
  ISSUE_VALUATION_CERTIFICATE: {
    id: 'ISSUE_VALUATION_CERTIFICATE',
    defaultmessages: 'Issue Valuation Certificate (Land/Unit)',
  },
  Id: {
    id: 'Id',
    defaultmessages: 'ID',
  },
  Individual: {
    id: 'Individual',
    defaultmessages: 'Individual',
  },
  Industrial: {
    id: 'Industrial',
    defaultmessages: 'Industrial',
  },
  Initiate_service: {
    id: 'Initiate_service',
    defaultmessages: 'Initiate Service',
  },
  Inside_UAE: {
    id: 'Inside_UAE',
    defaultmessages: 'Other courts inside the UAE',
  },
  Inspected_on: {
    id: 'Inspected_on',
    defaultmessages: 'Inspected on: ',
  },
  Investment: {
    id: 'Investment',
    defaultmessages: 'Investor with Investment Agreement',
  },
  JUDGE_APPROVAL: {
    id: 'JUDGE_APPROVAL',
    defaultmessages: 'Judge approval',
  },
  JUDICIAL_GUARD: {
    id: 'JUDICIAL_GUARD',
    defaultmessages: 'Judicial guard',
  },
  LAND_EVALUATION_CERTIFICATE: {
    id: 'LAND_EVALUATION_CERTIFICATE',
    defaultmessages: 'Land valuation certificate',
  },
  LAWYER: {
    id: 'LAWYER',
    defaultmessages: 'Lawyer',
  },
  LAWYER_DOCUMENT: {
    id: 'LAWYER_DOCUMENT',
    defaultmessages: 'Lawyer document',
  },
  LAWYER_DRC_PROOF: {
    id: 'LAWYER_DRC_PROOF',
    defaultmessages: 'Lawyer ID proof',
  },
  LAWYER_LAW_FIRM_LICENSE_DOCUMENT: {
    id: 'LAWYER_LAW_FIRM_LICENSE_DOCUMENT',
    defaultmessages: 'Trade license of law firm',
  },
  LAWYER_POA_DOCUMENT: {
    id: 'LAWYER_POA_DOCUMENT',
    defaultmessages: 'Lawyer POA',
  },
  LAWYER_PROFESSIONAL_ID: {
    id: 'LAWYER_PROFESSIONAL_ID',
    defaultmessages: 'Lawyer professional ID',
  },
  LAW_FIRM_LICENSE_DOCUMENT: {
    id: 'LAW_FIRM_LICENSE_DOCUMENT',
    defaultmessages: 'Trade license of law firm',
  },
  LAW_FIRM_OR_LAWYER_DETAIL: {
    id: 'LAW_FIRM_OR_LAWYER_DETAIL',
    defaultmessages: 'Law firm/lawyer license and EID',
  },
  LCA_CONFIRM: {
    id: 'LCA_CONFIRM',
    defaultmessages: 'Confirm',
  },
  LCA_INITIATE: {
    id: 'LCA_INITIATE',
    defaultmessages: 'Start Application',
  },
  LCA_TENANT_APPROVAL: {
    id: 'LCA_TENANT_APPROVAL',
    defaultmessages: 'Lessee approval on lease agreement',
  },
  LCL_INITIATE: {
    id: 'LCL_INITIATE',
    defaultmessages: 'Initiation of lease agreement expiry',
  },
  LCL_OWNER_APPROVAL: {
    id: 'LCL_OWNER_APPROVAL',
    defaultmessages: 'Owner approval of lease agreement expiry',
  },
  LCL_TENANT_APPROVAL: {
    id: 'LCL_TENANT_APPROVAL',
    defaultmessages: 'Lessee approval of lease agreement expiry',
  },
  LEASE_ADDC_NOC: {
    id: 'LEASE_ADDC_NOC',
    defaultmessages: 'Lease NOC document',
  },
  LEASE_AGREEMENT: {
    id: 'LEASE_AGREEMENT',
    defaultmessages: 'Lease Agreement',
  },
  LEASE_AMENDMENT: {
    id: 'LEASE_AMENDMENT',
    defaultmessages: 'Lease Agreement Variation',
  },
  LEASE_CANCELLATION: {
    id: 'LEASE_CANCELLATION',
    defaultmessages: 'Lease Agreement Surrender',
  },
  LEASE_CANCEL_CONFIRM: {
    id: 'LEASE_CANCEL_CONFIRM',
    defaultmessages: 'Lease Surrender confirmation',
  },
  LEASE_CANCEL_INITIATE: {
    id: 'LEASE_CANCEL_INITIATE',
    defaultmessages: 'Initiate lease Surrender',
  },
  LEASE_CLOSURE: {
    id: 'LEASE_CLOSURE',
    defaultmessages: 'Lease Agreement Expiration',
  },
  LEASE_COURT_ORDER: {
    id: 'LEASE_COURT_ORDER',
    defaultmessages: 'Lease court order',
  },
  LEASE_DIPLOMAT: {
    id: 'LEASE_DIPLOMAT',
    defaultmessages: 'Diplomat documents',
  },
  LEASE_DMT_APPROVAL: {
    id: 'LEASE_DMT_APPROVAL',
    defaultmessages: 'Municipality approval',
  },
  LEASE_DOCUMENT: {
    id: 'LEASE_DOCUMENT',
    defaultmessages: 'Lease documents',
  },
  LEASE_OWNER_APPROVAL: {
    id: 'LEASE_OWNER_APPROVAL',
    defaultmessages: 'Lease owner approval',
  },
  LEASE_OWNER_RETURN: {
    id: 'LEASE_OWNER_RETURN',
    defaultmessages: 'Lease owner return',
  },
  LEASE_REGISTRATION: {
    id: 'LEASE_REGISTRATION',
    defaultmessages: 'Lease Agreement Registration',
  },
  LEASE_REGISTRATION_FORM: {
    id: 'LEASE_REGISTRATION_FORM',
    defaultmessages: 'Lease Agreement Registration',
  },
  LEASE_RENEWAL: {
    id: 'LEASE_RENEWAL',
    defaultmessages: 'Lease Agreement Renewal',
  },
  LEASE_TENANT_PAYMENT: {
    id: 'LEASE_TENANT_PAYMENT',
    defaultmessages: 'Lease lessee payment',
  },
  LEASE_TENANT_REJECT: {
    id: 'LEASE_TENANT_REJECT',
    defaultmessages: 'Lease lessee rejection',
  },
  LEASE_TENANT_RETURN: {
    id: 'LEASE_TENANT_RETURN',
    defaultmessages: 'Lease returned by lessee',
  },
  LEASE_TERMINATE_BY_COURT: {
    id: 'LEASE_TERMINATE_BY_COURT',
    defaultmessages: 'Agreement terminated by court',
  },
  LEASE_TERMINATION_COURT_ORDER: {
    id: 'LEASE_TERMINATION_COURT_ORDER',
    defaultmessages: 'Lease Agreement Termination by Court Order',
  },
  LEGACY_MANAGER: {
    id: 'LEGACY_MANAGER',
    defaultmessages: 'Legacy manager',
  },
  LESSOR: {
    id: 'LESSOR',
    defaultmessages: 'Lessor',
  },
  LESSOR_PAYMENT: {
    id: 'LESSOR_PAYMENT',
    defaultmessages: 'Lessor Payment',
  },
  LICENSE: {
    id: 'LICENSE',
    defaultmessages: 'Company trade license',
  },
  LONG_LEASE_SURRENDER: {
    id: 'LONG_LEASE_SURRENDER',
    defaultmessages: 'Surrender of a Long Lease',
  },
  LONG_LEASE_TO_MUSATAHA: {
    id: 'LONG_LEASE_TO_MUSATAHA',
    defaultmessages: 'Long Lease to Musataha',
  },
  LONG_LEASE_TO_MUSATAHA_ONLINE: {
    id: 'LONG_LEASE_TO_MUSATAHA_ONLINE',
    defaultmessages: 'Transfer Long lease agreement to Musataha ',
  },
  LONG_LEASE_TO_MUSATAHA_OTHERS: {
    id: 'LONG_LEASE_TO_MUSATAHA_OTHERS',
    defaultmessages: 'Other documents',
  },
  LTCO_INITIATE: {
    id: 'LTCO_INITIATE',
    defaultmessages: 'Initiation of lease agreement termination by court order',
  },
  Land: {
    id: 'Land',
    defaultmessages: 'Land',
  },
  Land_use: {
    id: 'Land_use',
    defaultmessages: 'Land use',
  },
  Languages: {
    id: 'Languages',
    defaultmessages: 'Languages',
  },
  Last_Name_Arabic_bracket: {
    id: 'Last_Name_Arabic_bracket',
    defaultmessages: 'Last Name (Arabic)',
  },
  Last_Name_English_bracket: {
    id: 'Last_Name_English_bracket',
    defaultmessages: 'Last Name (English)',
  },
  Leasable: {
    id: 'Leasable',
    defaultmessages: 'Leasable',
  },
  Lease: {
    id: 'Lease',
    defaultmessages: 'Lease',
  },
  Lease_Properties: {
    id: 'Lease_Properties',
    defaultmessages: 'Lease properties',
  },
  Lease_registration: {
    id: 'Lease_registration',
    defaultmessages: 'Lease Agreement Registration',
  },
  Leased: {
    id: 'Leased',
    defaultmessages: 'Leased',
  },
  License_source: {
    id: 'License_source',
    defaultmessages: 'License source',
  },
  Loading: {
    id: 'Loading',
    defaultmessages: 'Loading',
  },
  MAINTAIN_FILE_NOTES: {
    id: 'MAINTAIN_FILE_NOTES',
    defaultmessages: 'Maintain File Notes',
  },
  MAINTENANCE_COST_REQUIRED: {
    id: 'MAINTENANCE_COST_REQUIRED',
    defaultmessages: 'Maintenance cost is required for constructed plot',
  },
  MAKER_APPROVAL: {
    id: 'MAKER_APPROVAL',
    defaultmessages: 'Escrow bank maker approval',
  },
  MAKER_FINAL_APPROVAL: {
    id: 'MAKER_FINAL_APPROVAL',
    defaultmessages: 'Escrow bank maker final approval',
  },
  MAKER_FINAL_REVIEW: {
    id: 'MAKER_FINAL_REVIEW',
    defaultmessages: 'Escrow bank maker final review',
  },
  MAKER_RETURN: {
    id: 'MAKER_RETURN',
    defaultmessages: 'Returned by Bank Maker',
  },
  MAKER_RETURN_RELEASE: {
    id: 'MAKER_RETURN_RELEASE',
    defaultmessages: 'Maker return release',
  },
  MAKER_RETURN_TO_INSPECTION: {
    id: 'MAKER_RETURN_TO_INSPECTION',
    defaultmessages: 'Returned by Bank Maker',
  },
  MAKER_REVIEW: {
    id: 'MAKER_REVIEW',
    defaultmessages: 'Bank maker review',
  },
  MAKER_REVIEW_RELEASE: {
    id: 'MAKER_REVIEW_RELEASE',
    defaultmessages: 'Maker review release',
  },
  MALE: {
    id: 'MALE',
    defaultmessages: 'Male',
  },
  MANAGEMENT_DETAILS: {
    id: 'MANAGEMENT_DETAILS',
    defaultmessages: 'Management Details',
  },
  MARKETING_CONTENT: {
    id: 'MARKETING_CONTENT',
    defaultmessages: 'Marketing Content',
  },
  MARKETING_PLAN: {
    id: 'MARKETING_PLAN',
    defaultmessages: 'Event or Activity Plan',
  },
  MEDIATOR_APPROVAL: {
    id: 'MEDIATOR_APPROVAL',
    defaultmessages: 'Mediator approval',
  },
  MEDIATOR_PROCESSING: {
    id: 'MEDIATOR_PROCESSING',
    defaultmessages: 'In Mediation',
  },
  MILESTONE_CERTIFICATE: {
    id: 'MILESTONE_CERTIFICATE',
    defaultmessages: 'Milestone Certificate',
  },
  MINISTRY_OF_ECONOMY: {
    id: 'MINISTRY_OF_ECONOMY',
    defaultmessages: 'A letter from the Ministry of Economy on behalf of the members of the Board of Directors',
  },
  MIXED_USE: {
    id: 'MIXED_USE',
    defaultmessages: 'Mixed use',
  },
  MIX_USE: {
    id: 'MIX_USE',
    defaultmessages: 'Mixed use',
  },
  MOI_and_passport_verification: {
    id: 'MOI_and_passport_verification',
    defaultmessages: 'MOI and Passport Verification',
  },
  MOI_number: {
    id: 'MOI_number',
    defaultmessages: 'MOI Number',
  },
  MON: {
    id: 'MON',
    defaultmessages: 'MON',
  },
  MORE_DOCUMENTS_REQUIRED: {
    id: 'MORE_DOCUMENTS_REQUIRED',
    defaultmessages: 'More document required',
  },
  MORE_INFORMATION_REQUIRED: {
    id: 'MORE_INFORMATION_REQUIRED',
    defaultmessages: 'More information required',
  },
  MORTGAGE_AGREEMENT: {
    id: 'MORTGAGE_AGREEMENT',
    defaultmessages: 'Mortgage Agreement',
  },
  MORTGAGE_AGREEMENT_APPENDIX: {
    id: 'MORTGAGE_AGREEMENT_APPENDIX',
    defaultmessages: 'Mortgage Agreement Appendix (Mandatory)',
  },
  MORTGAGE_CERTIFICATE: {
    id: 'MORTGAGE_CERTIFICATE',
    defaultmessages: 'Mortgage Certificate',
  },
  MORTGAGE_CONTRACT: {
    id: 'MORTGAGE_CONTRACT',
    defaultmessages: 'Mortgage agreement',
  },
  MORTGAGE_CONTRACT_APPENDIX: {
    id: 'MORTGAGE_CONTRACT_APPENDIX',
    defaultmessages: 'Mortgage agreement appendix',
  },
  MORTGAGE_DETAILS: {
    id: 'MORTGAGE_DETAILS',
    defaultmessages: 'Mortgage details',
  },
  MORTGAGE_MODIFICATION: {
    id: 'MORTGAGE_MODIFICATION',
    defaultmessages: 'Mortgage variation',
  },
  MORTGAGE_REGISTRATION_LAND: {
    id: 'MORTGAGE_REGISTRATION_LAND',
    defaultmessages: 'Mortgage Registration Land',
  },
  MORTGAGE_REGISTRATION_UNIT: {
    id: 'MORTGAGE_REGISTRATION_UNIT',
    defaultmessages: 'Mortgage Registration Unit',
  },
  MORTGAGE_RELEASE: {
    id: 'MORTGAGE_RELEASE',
    defaultmessages: 'Mortgage Discharge',
  },
  MORTGAGE_RELEASE_CERTIFICATE: {
    id: 'MORTGAGE_RELEASE_CERTIFICATE',
    defaultmessages: 'Mortgage release certificate',
  },
  MORTGAGE_VERIFICATION_INSTRUMENT: {
    id: 'MORTGAGE_VERIFICATION_INSTRUMENT',
    defaultmessages: 'Mortgage Verification Instrument',
  },
  MR: {
    id: 'MR',
    defaultmessages: 'Mr.',
  },
  MRS: {
    id: 'MRS',
    defaultmessages: 'Mrs.',
  },
  MUNCIPALITY_PLOT_ERROR: {
    id: 'MUNCIPALITY_PLOT_ERROR',
    defaultmessages: 'The requested property is not under assigned municipality',
  },
  MUNICIPALITY_CHARGES: {
    id: 'MUNICIPALITY_CHARGES',
    defaultmessages: 'Municipality charges',
  },
  MUSATAHA: {
    id: 'MUSATAHA',
    defaultmessages: 'musataha',
  },
  MUSATAHA_APPROVAL: {
    id: 'MUSATAHA_APPROVAL',
    defaultmessages: 'Musateh approval',
  },
  MUSATAHA_CONTRACT_DETAILS: {
    id: 'MUSATAHA_CONTRACT_DETAILS',
    defaultmessages: 'Musataha Agreement Details',
  },
  MUSATAHA_DETAILS: {
    id: 'MUSATAHA_DETAILS',
    defaultmessages: 'Musateh Details',
  },
  MUSATAHA_RETURN: {
    id: 'MUSATAHA_RETURN',
    defaultmessages: 'Musataha Agreement Returned',
  },
  MUSATEH: {
    id: 'MUSATEH',
    defaultmessages: 'Musateh',
  },
  MUTUAL_AGREEMENT_OR_COURT_LETTER: {
    id: 'MUTUAL_AGREEMENT_OR_COURT_LETTER',
    defaultmessages: 'Mutual Agreement or Court Letter',
  },
  MUTUAL_AGREEMENT_WITHOUT_REFUND: {
    id: 'MUTUAL_AGREEMENT_WITHOUT_REFUND',
    defaultmessages: 'Mutual agreement (Without refund)',
  },
  MUTUAL_AGREEMENT_WITH_REFUND: {
    id: 'MUTUAL_AGREEMENT_WITH_REFUND',
    defaultmessages: 'Mutual agreement (With refund)',
  },
  Manage_my_cards: {
    id: 'Manage_my_cards',
    defaultmessages: 'Manage my cards',
  },
  Manager: {
    id: 'Manager',
    defaultmessages: 'Manager',
  },
  Manager_Cheque_or_Bank_transfer: {
    id: 'Manager_Cheque_or_Bank_transfer',
    defaultmessages: 'Manager Cheque or Bank transfer',
  },
  Marina: {
    id: 'Marina',
    defaultmessages: 'Marina',
  },
  MidTerm: {
    id: 'MidTerm',
    defaultmessages: 'MidTerm',
  },
  Monthly: {
    id: 'Monthly',
    defaultmessages: 'Monthly',
  },
  More: {
    id: 'More',
    defaultmessages: 'More',
  },
  Municipality_branch: {
    id: 'Municipality_branch',
    defaultmessages: 'Municipality branch',
  },
  Musateh: {
    id: 'Musateh',
    defaultmessages: 'Musateh',
  },
  My_contracts: {
    id: 'My_contracts',
    defaultmessages: 'My Agreement',
  },
  NATIONAL_HOUSING_MORTGAGE: {
    id: 'NATIONAL_HOUSING_MORTGAGE',
    defaultmessages: 'National Housing Mortgage',
  },
  NEW: {
    id: 'NEW',
    defaultmessages: '',
  },
  NEW_MORTGAGE_CERTIFICATE: {
    id: 'NEW_MORTGAGE_CERTIFICATE',
    defaultmessages: 'New Mortgage Certificate',
  },
  NINE: {
    id: 'NINE',
    defaultmessages: '9 Installments',
  },
  NOC: {
    id: 'NOC',
    defaultmessages: 'NOC Document',
  },
  NOC_COURT_LETTER: {
    id: 'NOC_COURT_LETTER',
    defaultmessages: 'Court order',
  },
  NOC_FROM_DEVELOPER: {
    id: 'NOC_FROM_DEVELOPER',
    defaultmessages: 'NOC from developer',
  },
  NOC_letter_from_developer: {
    id: 'NOC_letter_from_developer',
    defaultmessages: 'NOC letter from developer',
  },
  NON_UAE_RESIDENT: {
    id: 'NON_UAE_RESIDENT',
    defaultmessages: 'Non-UAE resident',
  },
  NOTIFICATION: {
    id: 'NOTIFICATION',
    defaultmessages: 'Notifications',
  },
  NOT_APPLICABLE: {
    id: 'NOT_APPLICABLE',
    defaultmessages: 'Not applicable',
  },
  NOT_INCLUDED: {
    id: 'NOT_INCLUDED',
    defaultmessages: 'Not included',
  },
  NO_LIABILITY_LETTER: {
    id: 'NO_LIABILITY_LETTER',
    defaultmessages: 'No Liability Letter from the Bank',
  },
  NO_OBJECTION_DOCUMENT: {
    id: 'NO_OBJECTION_DOCUMENT',
    defaultmessages: '',
  },
  NO_OBJECTION_LETTER: {
    id: 'NO_OBJECTION_LETTER',
    defaultmessages: 'No-Objection Letter (if applicable)',
  },
  NSTRUMENT_CONTAINING_THE_COVENANT: {
    id: 'NSTRUMENT_CONTAINING_THE_COVENANT',
    defaultmessages: 'Instrument Containing the Covenant',
  },
  Name: {
    id: 'Name',
    defaultmessages: 'Name',
  },
  Name_Arabic: {
    id: 'Name_Arabic',
    defaultmessages: 'Name in Arabic',
  },
  Name_Arabic_bracket: {
    id: 'Name_Arabic_bracket',
    defaultmessages: 'Name (Arabic)',
  },
  Name_Arabic_hint: {
    id: 'Name_Arabic_hint',
    defaultmessages: 'Name in Arabic',
  },
  Name_English: {
    id: 'Name_English',
    defaultmessages: 'Name in English',
  },
  Name_English_bracket: {
    id: 'Name_English_bracket',
    defaultmessages: 'Name (English)',
  },
  Name_English_hint: {
    id: 'Name_English_hint',
    defaultmessages: 'Name in English',
  },
  Name_lang: {
    id: 'Name_lang',
    defaultmessages: 'Name ({lang})',
  },
  National_Housing_Loans_application_has_been_rejected_successfully: {
    id: 'National_Housing_Loans_application_has_been_rejected_successfully',
    defaultmessages: 'National housing mortgage registration application has been rejected successfully',
  },
  National_Housing_Loans_application_has_been_returned_to_the_bank_maker: {
    id: 'National_Housing_Loans_application_has_been_returned_to_the_bank_maker',
    defaultmessages: 'National housing mortgage registration application has been returned to the bank maker',
  },
  National_Housing_Loans_application_has_been_returned_to_the_owner: {
    id: 'National_Housing_Loans_application_has_been_returned_to_the_owner',
    defaultmessages: 'National housing mortgage registration application has been returned to the owner',
  },
  National_Housing_Loans_application_sent_to_bank_checker_for_approval: {
    id: 'National_Housing_Loans_application_sent_to_bank_checker_for_approval',
    defaultmessages: 'National housing mortgage registration application sent to bank checker for approval',
  },
  National_Housing_Loans_application_sent_to_municipality_for_approval: {
    id: 'National_Housing_Loans_application_sent_to_municipality_for_approval',
    defaultmessages: 'National housing mortgage registration application sent to municipality for approval',
  },
  National_Housing_Loans_application_sent_to_other_owners_for_approval: {
    id: 'National_Housing_Loans_application_sent_to_other_owners_for_approval',
    defaultmessages: 'National housing mortgage registration application sent to other owners for approval',
  },
  National_Housing_Loans_application_sent_to_signatory_for_approval: {
    id: 'National_Housing_Loans_application_sent_to_signatory_for_approval',
    defaultmessages: 'National housing mortgage registration application sent to signatory for approval',
  },
  National_Housing_Loans_application_sent_to_the_bank_for_approval: {
    id: 'National_Housing_Loans_application_sent_to_the_bank_for_approval',
    defaultmessages: 'National housing mortgage registration application sent to the bank for approval',
  },
  National_Housing_Loans_certificate: {
    id: 'National_Housing_Loans_certificate',
    defaultmessages: '',
  },
  National_Housing_Loans_certificate_has_been_successfully_issued: {
    id: 'National_Housing_Loans_certificate_has_been_successfully_issued',
    defaultmessages: 'National housing mortgage registration certificate has been successfully issued',
  },
  National_housing_mortgages_are_exclusively_offered_by_First_Abu_Dhabi_Bank: {
    id: 'National_housing_mortgages_are_exclusively_offered_by_First_Abu_Dhabi_Bank',
    defaultmessages: 'National housing mortgages are exclusively offered by First Abu Dhabi Bank',
  },
  Nationality: {
    id: 'Nationality',
    defaultmessages: 'Nationality',
  },
  New: {
    id: 'New',
    defaultmessages: 'New',
  },
  News: {
    id: 'News',
    defaultmessages: 'News',
  },
  Not_Mortgaged: {
    id: 'Not_Mortgaged',
    defaultmessages: 'Not mortgaged',
  },
  Notifications: {
    id: 'Notifications',
    defaultmessages: 'Notifications',
  },
  OFFICE: {
    id: 'OFFICE',
    defaultmessages: 'Office',
  },
  OFFPLAN: {
    id: 'OFFPLAN',
    defaultmessages: 'Offplan',
  },
  OFFPLAN_AGREEMENT: {
    id: 'OFFPLAN_AGREEMENT',
    defaultmessages: 'Off-plan Sale & Purchase Agreement',
  },
  OFFPLAN_MARKETING_REQUEST: {
    id: 'OFFPLAN_MARKETING_REQUEST',
    defaultmessages: 'Permit for Marketing of Off-Plan Projects',
  },
  OFFPLAN_ONLINE_BUYER_DETAILS: {
    id: 'OFFPLAN_ONLINE_BUYER_DETAILS',
    defaultmessages: 'Buyer Details',
  },
  OFFPLAN_ONLINE_CONTRACT_DETAILS: {
    id: 'OFFPLAN_ONLINE_CONTRACT_DETAILS',
    defaultmessages: 'Agreement Details',
  },
  OFFPLAN_ONLINE_SELLING_DETAILS: {
    id: 'OFFPLAN_ONLINE_SELLING_DETAILS',
    defaultmessages: 'Seller Details',
  },
  OFFPLAN_PROJECT_REGISTRATION: {
    id: 'OFFPLAN_PROJECT_REGISTRATION',
    defaultmessages: 'Register Real Estate Development Projects',
  },
  OFFPLAN_TERMINATION: {
    id: 'OFFPLAN_TERMINATION',
    defaultmessages: 'Off plan Agreement Termination',
  },
  OFFPLAN_TERMINATION_LAND: {
    id: 'OFFPLAN_TERMINATION_LAND',
    defaultmessages: 'Off plan buy and sell plot termination',
  },
  OFFPLAN_TERMINATION_LEGAL_NOTICE: {
    id: 'OFFPLAN_TERMINATION_LEGAL_NOTICE',
    defaultmessages: 'Legal Notice',
  },
  OFFPLAN_TERMINATION_OFFLINE: {
    id: 'OFFPLAN_TERMINATION_OFFLINE',
    defaultmessages: 'Application initiated',
  },
  OFFPLAN_TERMINATION_UNIT: {
    id: 'OFFPLAN_TERMINATION_UNIT',
    defaultmessages: 'Off plan buy and sell unit termination',
  },
  OFFPLAN_TO_COMPLETE_LAND: {
    id: 'OFFPLAN_TO_COMPLETE_LAND',
    defaultmessages: 'Transfer the registered lands from an initial register to the real estate registery',
  },
  OFFPLAN_TO_COMPLETE_LAND_DMT_PROPERTY_FEE: {
    id: 'OFFPLAN_TO_COMPLETE_LAND_DMT_PROPERTY_FEE',
    defaultmessages: 'Registration fees of property details',
  },
  OFFPLAN_TO_COMPLETE_LAND_DMT_UNIT_FEE: {
    id: 'OFFPLAN_TO_COMPLETE_LAND_DMT_UNIT_FEE',
    defaultmessages: 'Registration fees of rental unit details',
  },
  OFFPLAN_TO_COMPLETE_UNIT: {
    id: 'OFFPLAN_TO_COMPLETE_UNIT',
    defaultmessages: 'Transfer the registered Unit from an initial register to the real estate registery',
  },
  OFF_PLAN_FIRST_SELL_LAND: {
    id: 'OFF_PLAN_FIRST_SELL_LAND',
    defaultmessages: 'Off Plan Plot Buy And Sell Registration',
  },
  OFF_PLAN_FIRST_SELL_PLOT: {
    id: 'OFF_PLAN_FIRST_SELL_PLOT',
    defaultmessages: 'Off Plan Plot Buy and Sell Registration',
  },
  OFF_PLAN_FIRST_SELL_UNIT: {
    id: 'OFF_PLAN_FIRST_SELL_UNIT',
    defaultmessages: 'Off Plan Unit Buy and Sell Registration',
  },
  OFF_PLAN_TERMINATION: {
    id: 'OFF_PLAN_TERMINATION',
    defaultmessages: 'Off plan Agreement Termination',
  },
  OK: {
    id: 'OK',
    defaultmessages: '',
  },
  ONE: {
    id: 'ONE',
    defaultmessages: '1 installment',
  },
  ONLINE_APPROVAL: {
    id: 'ONLINE_APPROVAL',
    defaultmessages: 'Online Approval',
  },
  ONLINE_CREATE_APPLICATION: {
    id: 'ONLINE_CREATE_APPLICATION',
    defaultmessages: 'Online Create Application',
  },
  ONLINE_DETAILS: {
    id: 'ONLINE_DETAILS',
    defaultmessages: 'Company details',
  },
  ONLINE_DOCUMENTS: {
    id: 'ONLINE_DOCUMENTS',
    defaultmessages: 'Upload documents',
  },
  ONLINE_REVIEW: {
    id: 'ONLINE_REVIEW',
    defaultmessages: 'Review',
  },
  ONLINE_TRANSFER: {
    id: 'ONLINE_TRANSFER',
    defaultmessages: 'Online Transfer',
  },
  OTHER: {
    id: 'OTHER',
    defaultmessages: 'Other',
  },
  OTHERS: {
    id: 'OTHERS',
    defaultmessages: 'Others',
  },
  OTHERS_BANK: {
    id: 'OTHERS_BANK',
    defaultmessages: 'Others Bank',
  },
  OTHERS_BANK_MAKER: {
    id: 'OTHERS_BANK_MAKER',
    defaultmessages: 'Other "bank maker"',
  },
  OTHERS_BANK_MAKER_RELEASE: {
    id: 'OTHERS_BANK_MAKER_RELEASE',
    defaultmessages: 'Other "bank maker release"',
  },
  OTHERS_DMT_RETURN_REJECT: {
    id: 'OTHERS_DMT_RETURN_REJECT',
    defaultmessages: 'Attached Response Document',
  },
  OWNER: {
    id: 'OWNER',
    defaultmessages: 'Owner',
  },
  OWNERSHIP_CERTIFICATE: {
    id: 'OWNERSHIP_CERTIFICATE',
    defaultmessages: 'Ownership Certificate',
  },
  OWNERSHIP_DEED: {
    id: 'OWNERSHIP_DEED',
    defaultmessages: 'Title Deed',
  },
  OWNERS_APPROVALS: {
    id: 'OWNERS_APPROVALS',
    defaultmessages: 'Owner Approval',
  },
  OWNER_APPROVAL: {
    id: 'OWNER_APPROVAL',
    defaultmessages: 'Owner approval',
  },
  OWNER_FINAL_APPROVAL: {
    id: 'OWNER_FINAL_APPROVAL',
    defaultmessages: 'Owner final approval',
  },
  OWNER_NOT_FOUND: {
    id: 'OWNER_NOT_FOUND',
    defaultmessages: 'Owner details not found, Unable to create request',
  },
  OWNER_RETURN: {
    id: 'OWNER_RETURN',
    defaultmessages: 'Owner return',
  },
  Occupant: {
    id: 'Occupant',
    defaultmessages: 'Occupant',
  },
  Off_plan_buy_and_sell_termination: {
    id: 'Off_plan_buy_and_sell_termination',
    defaultmessages: 'Off Plan Buy And Sell Termination',
  },
  Off_plan_buy_and_sell_termination_land: {
    id: 'Off_plan_buy_and_sell_termination_land',
    defaultmessages: 'Off Plan Buy And Sell Termination - Land',
  },
  Off_plan_buy_and_sell_termination_unit: {
    id: 'Off_plan_buy_and_sell_termination_unit',
    defaultmessages: 'Off Plan Buy And Sell Termination - Unit',
  },
  Offplan: {
    id: 'Offplan',
    defaultmessages: 'Offplan',
  },
  Offplan_BuySell_initiator_success_developer_subtitle: {
    id: 'Offplan_BuySell_initiator_success_developer_subtitle',
    defaultmessages: 'You have successfully sent the off plan sale agreement for developer approver',
  },
  Offplan_BuySell_initiator_success_signator_subtitle: {
    id: 'Offplan_BuySell_initiator_success_signator_subtitle',
    defaultmessages: ' You have successfully sent the off plan sell agreement for ADGM approval',
  },
  Offplan_BuySell_initiator_success_title: {
    id: 'Offplan_BuySell_initiator_success_title',
    defaultmessages: 'You have successfully submitted the off plan sale agreement for approval',
  },
  Offplan_buy_sell_payment_registration_fee: {
    id: 'Offplan_buy_sell_payment_registration_fee',
    defaultmessages: 'AED {r} ({p}% of sale price: AED {s})',
  },
  Outside_UAE: {
    id: 'Outside_UAE',
    defaultmessages: 'Courts outside the UAE',
  },
  Owner: {
    id: 'Owner',
    defaultmessages: 'Owner',
  },
  Owner_details: {
    id: 'Owner_details',
    defaultmessages: 'Owner details',
  },
  Owners: {
    id: 'Owners',
    defaultmessages: 'Owners',
  },
  Ownership: {
    id: 'Ownership',
    defaultmessages: 'Ownership',
  },
  Ownership_type: {
    id: 'Ownership_type',
    defaultmessages: 'Right Hold type',
  },
  PARTIES_APPROVAL: {
    id: 'PARTIES_APPROVAL',
    defaultmessages: 'Parties approval',
  },
  PARTIES_DETAILS: {
    id: 'PARTIES_DETAILS',
    defaultmessages: 'Parties details',
  },
  PARTNER: {
    id: 'PARTNER',
    defaultmessages: 'Partner',
  },
  PARTNERSHIP_AGREEMENT: {
    id: 'PARTNERSHIP_AGREEMENT',
    defaultmessages: 'Partnership Agreement',
  },
  PARTY_SIGNATURE_FINISHED: {
    id: 'PARTY_SIGNATURE_FINISHED',
    defaultmessages: 'Party Signature Finished',
  },
  PASSPORT: {
    id: 'PASSPORT',
    defaultmessages: 'Passport',
  },
  PAYMENT: {
    id: 'PAYMENT',
    defaultmessages: 'Payment Completed',
  },
  PAYMENTS: {
    id: 'PAYMENTS',
    defaultmessages: 'Payments',
  },
  PAYMENT_DETAILS: {
    id: 'PAYMENT_DETAILS',
    defaultmessages: 'Payment Details',
  },
  PAYMENT_NEW_RECEIPT: {
    id: 'PAYMENT_NEW_RECEIPT',
    defaultmessages: 'Payment receipt',
  },
  PENDING: {
    id: 'PENDING',
    defaultmessages: 'Pending',
  },
  PENDING_AUDITOR_SIGNATURE: {
    id: 'PENDING_AUDITOR_SIGNATURE',
    defaultmessages: 'Pending Authenticator Signature',
  },
  PENDING_CHECKER_APPROVAL: {
    id: 'PENDING_CHECKER_APPROVAL',
    defaultmessages: 'Pending checker approval',
  },
  PENDING_CHECKER_APPROVAL_RELEASE: {
    id: 'PENDING_CHECKER_APPROVAL_RELEASE',
    defaultmessages: 'Pending checker approval release',
  },
  PENDING_EVALUATION: {
    id: 'PENDING_EVALUATION',
    defaultmessages: 'Pending Evaluation',
  },
  PENDING_INSPECTION_AUDITOR_REVIEW: {
    id: 'PENDING_INSPECTION_AUDITOR_REVIEW',
    defaultmessages: 'Pending inspection company auditor review',
  },
  PENDING_MAKER_FINAL_REVIEW: {
    id: 'PENDING_MAKER_FINAL_REVIEW',
    defaultmessages: 'Pending escrow bank maker final review',
  },
  PENDING_MAKER_REVIEW: {
    id: 'PENDING_MAKER_REVIEW',
    defaultmessages: 'Pending bank maker review',
  },
  PENDING_MAKER_REVIEW_RELEASE: {
    id: 'PENDING_MAKER_REVIEW_RELEASE',
    defaultmessages: 'Pending maker review release',
  },
  PENDING_SIGNATURE: {
    id: 'PENDING_SIGNATURE',
    defaultmessages: 'Pending Signature',
  },
  PENDING_SURVEYOR_REVIEW: {
    id: 'PENDING_SURVEYOR_REVIEW',
    defaultmessages: 'Pending surveyor review',
  },
  PERCENTAGE: {
    id: 'PERCENTAGE',
    defaultmessages: 'Percentage',
  },
  PERMIT_ADVERTISEMENT_BROKER_LAND: {
    id: 'PERMIT_ADVERTISEMENT_BROKER_LAND',
    defaultmessages: 'Request a Permit to Advertise on Website (Land)',
  },
  PERMIT_ADVERTISEMENT_BROKER_UNIT: {
    id: 'PERMIT_ADVERTISEMENT_BROKER_UNIT',
    defaultmessages: 'Request a Permit to Advertise on Website (Unit)',
  },
  PERMIT_DETAILS: {
    id: 'PERMIT_DETAILS',
    defaultmessages: 'Permit Details',
  },
  PERMIT_DURATION: {
    id: 'PERMIT_DURATION',
    defaultmessages: 'Permit Duration',
  },
  PERMIT_TYPE: {
    id: 'PERMIT_TYPE',
    defaultmessages: 'Permit Type',
  },
  PERSONAL_PHOTO: {
    id: 'PERSONAL_PHOTO',
    defaultmessages: 'Personal Photo',
  },
  PLAINTIFF: {
    id: 'PLAINTIFF',
    defaultmessages: 'Plaintiff',
  },
  PLAINTIFF_INFO: {
    id: 'PLAINTIFF_INFO',
    defaultmessages: 'Plaintiff information',
  },
  PLAINTIFF_LICENSE_STATEMENT: {
    id: 'PLAINTIFF_LICENSE_STATEMENT',
    defaultmessages: 'Trade license',
  },
  PLAINTIFF_MOMENTUM_DOCUMENT: {
    id: 'PLAINTIFF_MOMENTUM_DOCUMENT',
    defaultmessages: 'MOA',
  },
  PLAINTIFF_OTHER: {
    id: 'PLAINTIFF_OTHER',
    defaultmessages: 'Other',
  },
  PLAINTIFF_POA_DOCUMENT: {
    id: 'PLAINTIFF_POA_DOCUMENT',
    defaultmessages: 'POA document',
  },
  PLAINTIFF_SUBMIT_APPROVAL: {
    id: 'PLAINTIFF_SUBMIT_APPROVAL',
    defaultmessages: 'Plaintiff Approval',
  },
  PLAINTIFF_USER_OR_COMPANY: {
    id: 'PLAINTIFF_USER_OR_COMPANY',
    defaultmessages: 'ID Proof',
  },
  PLOT: {
    id: 'PLOT',
    defaultmessages: 'Plots',
  },
  PLOTS: {
    id: 'PLOTS',
    defaultmessages: 'Plots',
  },
  PMA_AMENDMENT: {
    id: 'PMA_AMENDMENT',
    defaultmessages: 'Property Management Agreement Modification',
  },
  PMA_APPROVAL: {
    id: 'PMA_APPROVAL',
    defaultmessages: 'PMA approval',
  },
  PMA_CANCELLATION: {
    id: 'PMA_CANCELLATION',
    defaultmessages: 'Property Management Agreement Cancellation ',
  },
  PMA_CANCEL_INITIATE: {
    id: 'PMA_CANCEL_INITIATE',
    defaultmessages: 'Initiating PMA termination',
  },
  PMA_COMPANY: {
    id: 'PMA_COMPANY',
    defaultmessages: 'PMA company',
  },
  PMA_CONTRACT: {
    id: 'PMA_CONTRACT',
    defaultmessages: 'PMA Agreement',
  },
  PMA_OTHERS: {
    id: 'PMA_OTHERS',
    defaultmessages: 'Documents',
  },
  PMA_Payment_Success: {
    id: 'PMA_Payment_Success',
    defaultmessages: 'Payment completed successfully',
  },
  PMA_REGISTRATION: {
    id: 'PMA_REGISTRATION',
    defaultmessages: 'Register Property Management Agreement',
  },
  PMA_REG_FINAL_APPROVAL: {
    id: 'PMA_REG_FINAL_APPROVAL',
    defaultmessages: 'PMA final approval',
  },
  PMA_REG_OWNER_APPROVAL: {
    id: 'PMA_REG_OWNER_APPROVAL',
    defaultmessages: 'PMA owner approval',
  },
  PMA_REG_OWNER_RETURN: {
    id: 'PMA_REG_OWNER_RETURN',
    defaultmessages: 'PMA returned by owner',
  },
  PMA_REG_PMA_APPROVAL: {
    id: 'PMA_REG_PMA_APPROVAL',
    defaultmessages: 'PMA approval',
  },
  PMA_REG_PMA_RETURN: {
    id: 'PMA_REG_PMA_RETURN',
    defaultmessages: 'PMA has been returned successfully to the initiator',
  },
  PMA_RENEWAL: {
    id: 'PMA_RENEWAL',
    defaultmessages: 'Property Management Agreement Renewal',
  },
  PMA_RETURN: {
    id: 'PMA_RETURN',
    defaultmessages: 'Second party return',
  },
  PMA_TERMINATION_INITIATE: {
    id: 'PMA_TERMINATION_INITIATE',
    defaultmessages: 'PMA Cancellation Initiated',
  },
  PMA_agreement_application_has_been_rejected: {
    id: 'PMA_agreement_application_has_been_rejected',
    defaultmessages: 'Your PMA application has been rejected',
  },
  PMA_agreement_has_been_successfully_issued: {
    id: 'PMA_agreement_has_been_successfully_issued',
    defaultmessages: 'PMA has been successfully issued',
  },
  PMA_agreement_has_been_successfully_sent: {
    id: 'PMA_agreement_has_been_successfully_sent',
    defaultmessages: 'PMA agreement has been successfully sent for approval',
  },
  PMA_details: {
    id: 'PMA_details',
    defaultmessages: 'PMA Details',
  },
  PMC: {
    id: 'PMC',
    defaultmessages: 'Property management company',
  },
  PMC_SIGNATORY_APPROVAL: {
    id: 'PMC_SIGNATORY_APPROVAL',
    defaultmessages: 'PMC Signatory',
  },
  PMC_SIGNATORY_RETURN: {
    id: 'PMC_SIGNATORY_RETURN',
    defaultmessages: 'PMC signatory return',
  },
  POA: {
    id: 'POA',
    defaultmessages: 'POA',
  },
  POA_DETAILS: {
    id: 'POA_DETAILS',
    defaultmessages: 'POA details',
  },
  POA_DOC: {
    id: 'POA_DOC',
    defaultmessages: 'Power of attorney document',
  },
  POA_DOCUMENT: {
    id: 'POA_DOCUMENT',
    defaultmessages: 'POA document',
  },
  POA_HOLDER: {
    id: 'POA_HOLDER',
    defaultmessages: 'POA Holder',
  },
  POA_ID_PROOF: {
    id: 'POA_ID_PROOF',
    defaultmessages: 'ID Proof',
  },
  POA_TERMINATE: {
    id: 'POA_TERMINATE',
    defaultmessages: 'Terminate Power of Attorney',
  },
  POA_classification: {
    id: 'POA_classification',
    defaultmessages: 'POA classification',
  },
  POBox: {
    id: 'POBox',
    defaultmessages: 'P.O. Box',
  },
  POSITION_CERTIFICATE: {
    id: 'POSITION_CERTIFICATE',
    defaultmessages: 'Position certificate or equivalent',
  },
  POWER_OF_ATTORNEY: {
    id: 'POWER_OF_ATTORNEY',
    defaultmessages: 'Power of attorney',
  },
  PREMISE_DETAIL: {
    id: 'PREMISE_DETAIL',
    defaultmessages: 'Premise ID details',
  },
  PREVIOUS_MORTGAGE_CERTIFICATE: {
    id: 'PREVIOUS_MORTGAGE_CERTIFICATE',
    defaultmessages: 'Previous Mortgage Certificate',
  },
  PRIMARY: {
    id: 'PRIMARY',
    defaultmessages: '',
  },
  PRIVATE: {
    id: 'PRIVATE',
    defaultmessages: 'Private',
  },
  PROFILE_CREATION: {
    id: 'PROFILE_CREATION',
    defaultmessages: 'Manual Profile Creation',
  },
  PROFIT_DISTRIBUTION_PLAN: {
    id: 'PROFIT_DISTRIBUTION_PLAN',
    defaultmessages: 'Profit Distribution Plan',
  },
  PROJECT_ACCOUNT_AGREEMENT: {
    id: 'PROJECT_ACCOUNT_AGREEMENT',
    defaultmessages: 'Project Account Agreement',
  },
  PROJECT_ACCOUNT_AGREEMENT_REGISTRATION: {
    id: 'PROJECT_ACCOUNT_AGREEMENT_REGISTRATION',
    defaultmessages: 'Project Account Agreement Registration',
  },
  PROJECT_ACCOUNT_BANK_REGISTRATION: {
    id: 'PROJECT_ACCOUNT_BANK_REGISTRATION',
    defaultmessages: 'Registration of a Bank Account',
  },
  PROJECT_ACOUNT_REG_PROOF: {
    id: 'PROJECT_ACOUNT_REG_PROOF',
    defaultmessages: 'Proof of Project Account Registration',
  },
  PROJECT_APPROVAL_DOCUMENT: {
    id: 'PROJECT_APPROVAL_DOCUMENT',
    defaultmessages: 'Project Approval Documentation',
  },
  PROJECT_REGISTRATION: {
    id: 'PROJECT_REGISTRATION',
    defaultmessages: 'Project Registration',
  },
  PROJECT_REGISTRATION_LETTER: {
    id: 'PROJECT_REGISTRATION_LETTER',
    defaultmessages: 'Project Registration Letter',
  },
  PROJECT_REQUIRED_INFORMATION: {
    id: 'PROJECT_REQUIRED_INFORMATION',
    defaultmessages: 'Project Required Information',
  },
  PROPERTY_DETAIL: {
    id: 'PROPERTY_DETAIL',
    defaultmessages: 'Property Details',
  },
  PROPERTY_DETAILS: {
    id: 'PROPERTY_DETAILS',
    defaultmessages: 'Property details',
  },
  PROPERTY_DIVISION_PROPOSAL: {
    id: 'PROPERTY_DIVISION_PROPOSAL',
    defaultmessages: 'Division proposal',
  },
  PRP: {
    id: 'PRP',
    defaultmessages: 'PRP',
  },
  PUBLIC_BENEFIT_ASSOCIATION: {
    id: 'PUBLIC_BENEFIT_ASSOCIATION',
    defaultmessages: 'Public Benefit Association',
  },
  Party: {
    id: 'Party',
    defaultmessages: 'Party',
  },
  Passport: {
    id: 'Passport',
    defaultmessages: 'Passport',
  },
  Passport_expiry_date: {
    id: 'Passport_expiry_date',
    defaultmessages: 'Passport expiry date',
  },
  Passport_issue_date: {
    id: 'Passport_issue_date',
    defaultmessages: 'Passport issue date',
  },
  Passport_number: {
    id: 'Passport_number',
    defaultmessages: 'Passport number',
  },
  Passport_residency: {
    id: 'Passport_residency',
    defaultmessages: 'Passport and residency',
  },
  Pending: {
    id: 'Pending',
    defaultmessages: 'Pending',
  },
  Person: {
    id: 'Person',
    defaultmessages: 'Person',
  },
  Phone_Number: {
    id: 'Phone_Number',
    defaultmessages: 'Phone number',
  },
  Photo: {
    id: 'Photo',
    defaultmessages: 'Photo',
  },
  Please_select_your_exact_location: {
    id: 'Please_select_your_exact_location',
    defaultmessages: 'Please select your exact location',
  },
  Please_visit_the_nearest_MOI: {
    id: 'Please_visit_the_nearest_MOI',
    defaultmessages:
      'You are not eligible to access this service. Your account is either not upgraded or you have a visitor account. Please contact AccessRP to access the services.',
  },
  Plot: {
    id: 'Plot',
    defaultmessages: 'Plot',
  },
  Plots: {
    id: 'Plots',
    defaultmessages: 'Plots',
  },
  Primary: {
    id: 'Primary',
    defaultmessages: 'Primary',
  },
  Privacy_policy: {
    id: 'Privacy_policy',
    defaultmessages: 'Privacy policy',
  },
  PrivateCompanyAuth: {
    id: 'PrivateCompanyAuth',
    defaultmessages: 'Private company auth',
  },
  PrivatePOA: {
    id: 'PrivatePOA',
    defaultmessages: 'Private POA',
  },
  Proceed_with_application: {
    id: 'Proceed_with_application',
    defaultmessages: 'Proceed with the application',
  },
  Profession: {
    id: 'Profession',
    defaultmessages: 'Profession',
  },
  Profile: {
    id: 'Profile',
    defaultmessages: 'Profile',
  },
  Progress_report_history: {
    id: 'Progress_report_history',
    defaultmessages: 'Progress report history',
  },
  Projects: {
    id: 'Projects',
    defaultmessages: 'Projects',
  },
  Properties: {
    id: 'Properties',
    defaultmessages: 'properties',
  },
  Property: {
    id: 'Property',
    defaultmessages: 'Property',
  },
  Property_details: {
    id: 'Property_details',
    defaultmessages: 'Property details',
  },
  Property_number_name: {
    id: 'Property_number_name',
    defaultmessages: 'Property number',
  },
  Q: {
    id: 'Q',
    defaultmessages: 'Quarterly',
  },
  RAS_AL_KHAIMAH: {
    id: 'RAS_AL_KHAIMAH',
    defaultmessages: 'Ras Al Khaimah',
  },
  READY: {
    id: 'READY',
    defaultmessages: 'Ready',
  },
  REGISTERATION_FORM: {
    id: 'REGISTERATION_FORM',
    defaultmessages: 'Application Submitted',
  },
  REGISTERED_CAVEAT_INSTRUMENT: {
    id: 'REGISTERED_CAVEAT_INSTRUMENT',
    defaultmessages: 'Registered Caveat Instrument',
  },
  REGISTERED_COVENANT_INSTRUMENT: {
    id: 'REGISTERED_COVENANT_INSTRUMENT',
    defaultmessages: 'Registered Covenant Instrument',
  },
  REGISTER_CAVEAT: {
    id: 'REGISTER_CAVEAT',
    defaultmessages: 'Register Caveat',
  },
  REGISTER_COVENANT: {
    id: 'REGISTER_COVENANT',
    defaultmessages: 'Register Covenant',
  },
  REGISTER_COVENANT_RELEASE: {
    id: 'REGISTER_COVENANT_RELEASE',
    defaultmessages: 'Register Covenant Release',
  },
  REGISTER_DISCHARGE_MORTGAGE: {
    id: 'REGISTER_DISCHARGE_MORTGAGE',
    defaultmessages: 'Register Discharge Mortgage',
  },
  REGISTER_EASEMENT: {
    id: 'REGISTER_EASEMENT',
    defaultmessages: 'Register Easement',
  },
  REGISTER_LONG_LEASE_PLOT: {
    id: 'REGISTER_LONG_LEASE_PLOT',
    defaultmessages: 'Registration of Long Lease on Plot',
  },
  REGISTER_MORTGAGE: {
    id: 'REGISTER_MORTGAGE',
    defaultmessages: 'Register Mortgage',
  },
  REGISTER_RENEW_DEVELOPER: {
    id: 'REGISTER_RENEW_DEVELOPER',
    defaultmessages: 'Register/Renew Developer',
  },
  REGISTER_VARIATION_MORTGAGE: {
    id: 'REGISTER_VARIATION_MORTGAGE',
    defaultmessages: 'Register Variation Mortgage',
  },
  REGISTER_WITHDRAWAL_OF_CAVEAT: {
    id: 'REGISTER_WITHDRAWAL_OF_CAVEAT',
    defaultmessages: 'Register Withdrawal of Caveat',
  },
  REGISTRATION: {
    id: 'REGISTRATION',
    defaultmessages: 'Registration',
  },
  REGISTRATION_FEE: {
    id: 'REGISTRATION_FEE',
    defaultmessages: 'ADGM Fees',
  },
  REGISTRATION_FORM: {
    id: 'REGISTRATION_FORM',
    defaultmessages: 'Application Submitted',
  },
  REGISTRATION_OF_EASEMENT_INSTRUMENT: {
    id: 'REGISTRATION_OF_EASEMENT_INSTRUMENT',
    defaultmessages: 'Registration of Easement Instrument',
  },
  REG_PAYMENT: {
    id: 'REG_PAYMENT',
    defaultmessages: 'Registration Payment',
  },
  REJECTED: {
    id: 'REJECTED',
    defaultmessages: 'Rejected',
  },
  RELEASE_EASEMENT_INSTRUMENT: {
    id: 'RELEASE_EASEMENT_INSTRUMENT',
    defaultmessages: 'Release Easement Instrument',
  },
  RELEASE_FUNDS_FOR_DEVELOPMENT_COSTS: {
    id: 'RELEASE_FUNDS_FOR_DEVELOPMENT_COSTS',
    defaultmessages: 'Request to Release Funds for Development Costs',
  },
  RELEASE_PROFITS_AFTER_BUILDING_COMPLETION: {
    id: 'RELEASE_PROFITS_AFTER_BUILDING_COMPLETION',
    defaultmessages: 'Request to Release Profits (Post-Building Completion)',
  },
  RELEASE_PROFITS_BEFORE_BUILDING_COMPLETION: {
    id: 'RELEASE_PROFITS_BEFORE_BUILDING_COMPLETION',
    defaultmessages: 'Request to Release Profits (Pre-Building Completion)',
  },
  RELIGIOUS: {
    id: 'RELIGIOUS',
    defaultmessages: 'Religious',
  },
  RENEWAL: {
    id: 'RENEWAL',
    defaultmessages: 'Renewal',
  },
  RENTAL_UNIT_EVICTION_FORM: {
    id: 'RENTAL_UNIT_EVICTION_FORM',
    defaultmessages: 'Rental unit eviction form signed by the lessee',
  },
  RENT_DETAILS: {
    id: 'RENT_DETAILS',
    defaultmessages: 'Rent details',
  },
  RENT_FEE_COLLECTION: {
    id: 'RENT_FEE_COLLECTION',
    defaultmessages: 'Rent fee collection',
  },
  REPRESENTATIVE: {
    id: 'REPRESENTATIVE',
    defaultmessages: 'Representative',
  },
  'REQUEST-VALUATION-CERTIFICATE-UNIT': {
    id: 'REQUEST-VALUATION-CERTIFICATE-UNIT',
    defaultmessages: 'Unit Evaluation Certificate Issuance',
  },
  REQUEST_EXISTING_ERROR: {
    id: 'REQUEST_EXISTING_ERROR',
    defaultmessages: 'Request with the provided application id already present',
  },
  REQUEST_FORM: {
    id: 'REQUEST_FORM',
    defaultmessages: 'Request Form',
  },
  REQUEST_INTERNATIONAL_EXHIBITION_PERMIT: {
    id: 'REQUEST_INTERNATIONAL_EXHIBITION_PERMIT',
    defaultmessages: 'Request a Permit to Participate in a Foreign Real Estate Exhibition',
  },
  REQUEST_LICENCE_AUCTIONEER_COMPANY: {
    id: 'REQUEST_LICENCE_AUCTIONEER_COMPANY',
    defaultmessages: 'Register Auctioneering company',
  },
  REQUEST_LICENCE_AUCTIONEER_EMPLOYEE: {
    id: 'REQUEST_LICENCE_AUCTIONEER_EMPLOYEE',
    defaultmessages: 'Register Auctioneer (employee)',
  },
  REQUEST_LICENCE_BROKER_COMPANY: {
    id: 'REQUEST_LICENCE_BROKER_COMPANY',
    defaultmessages: 'Register Broker Company',
  },
  REQUEST_LICENCE_BROKER_EMPLOYEE: {
    id: 'REQUEST_LICENCE_BROKER_EMPLOYEE',
    defaultmessages: 'Register a Broker (Employee)',
  },
  REQUEST_LICENCE_BROKER_INDIVIDUAL: {
    id: 'REQUEST_LICENCE_BROKER_INDIVIDUAL',
    defaultmessages: 'Register a Broker (Individual)',
  },
  REQUEST_LICENCE_EVALUATOR_COMPANY: {
    id: 'REQUEST_LICENCE_EVALUATOR_COMPANY',
    defaultmessages: 'Register valuation company',
  },
  REQUEST_LICENCE_EVALUATOR_EMPLOYEE: {
    id: 'REQUEST_LICENCE_EVALUATOR_EMPLOYEE',
    defaultmessages: 'Register valuator (employee)',
  },
  REQUEST_LICENCE_PRIMARY_DEVELOPER: {
    id: 'REQUEST_LICENCE_PRIMARY_DEVELOPER',
    defaultmessages: 'Register Primary Developer',
  },
  REQUEST_LICENCE_SECONDARY_DEVELOPER: {
    id: 'REQUEST_LICENCE_SECONDARY_DEVELOPER',
    defaultmessages: 'Register Secondary Developer',
  },
  REQUEST_LICENCE_SURVEYOR_COMPANY: {
    id: 'REQUEST_LICENCE_SURVEYOR_COMPANY',
    defaultmessages: 'Register Surveying Company',
  },
  REQUEST_LICENCE_SURVEYOR_EMPLOYEE: {
    id: 'REQUEST_LICENCE_SURVEYOR_EMPLOYEE',
    defaultmessages: 'Register Surveyor (Employee)',
  },
  REQUEST_LOCAL_EXHIBITION_PERMIT: {
    id: 'REQUEST_LOCAL_EXHIBITION_PERMIT',
    defaultmessages: 'Request a Permit to Participate in a Real Estate Local Exhibition',
  },
  REQUEST_OFFPLAN_ADVERTISEMENT_PERMIT: {
    id: 'REQUEST_OFFPLAN_ADVERTISEMENT_PERMIT',
    defaultmessages: 'Request an Off-Plan Sale Advertisement Permit',
  },
  REQUEST_OFFPLAN_MARKETING_PERMIT: {
    id: 'REQUEST_OFFPLAN_MARKETING_PERMIT',
    defaultmessages: 'Request a Promotional Stand License to Market a Real Estate Development Project',
  },
  REQUEST_PROJECT_LAUNCH_EVENT_PERMIT: {
    id: 'REQUEST_PROJECT_LAUNCH_EVENT_PERMIT',
    defaultmessages: 'Request a Permit to Organize a Real Estate Project Launch Event',
  },
  REQUEST_VALUATION_CERTIFICATE_LAND: {
    id: 'REQUEST_VALUATION_CERTIFICATE_LAND',
    defaultmessages: 'Land Evaluation Certificate Issuance',
  },
  REQUEST_VALUATION_CERTIFICATE_LAND_COMMERCIAL: {
    id: 'REQUEST_VALUATION_CERTIFICATE_LAND_COMMERCIAL',
    defaultmessages: 'Plot Evaluation Certificate Commercial Fee',
  },
  REQUEST_VALUATION_CERTIFICATE_LAND_INVESTMENT: {
    id: 'REQUEST_VALUATION_CERTIFICATE_LAND_INVESTMENT',
    defaultmessages: 'Plot Evaluation Certificate Investment Fee',
  },
  REQUEST_VALUATION_CERTIFICATE_LAND_OTHER: {
    id: 'REQUEST_VALUATION_CERTIFICATE_LAND_OTHER',
    defaultmessages: 'Plot Valuation Certificate Fee',
  },
  REQUEST_VALUATION_CERTIFICATE_UNIT: {
    id: 'REQUEST_VALUATION_CERTIFICATE_UNIT',
    defaultmessages: 'Unit Evaluation Certificate Issuance',
  },
  REQUEST_VALUATION_CERTIFICATE_UNIT_OTHER: {
    id: 'REQUEST_VALUATION_CERTIFICATE_UNIT_OTHER',
    defaultmessages: 'Unit Valuation Certificate Fee',
  },
  RESERVATION_AGREEMENT_REGISTRATION: {
    id: 'RESERVATION_AGREEMENT_REGISTRATION',
    defaultmessages: 'Registration of the Reservation Agreement',
  },
  RESIDENCY: {
    id: 'RESIDENCY',
    defaultmessages: 'Residency',
  },
  RESIDENTIAL: {
    id: 'RESIDENTIAL',
    defaultmessages: 'Residential',
  },
  RESOLVED_DISPUTE_LETTER: {
    id: 'RESOLVED_DISPUTE_LETTER',
    defaultmessages: 'Resolved dispute',
  },
  RESOURCE_PLANNING: {
    id: 'RESOURCE_PLANNING',
    defaultmessages: 'Resource Planning for Managing the Account',
  },
  RESUBMITTED: {
    id: 'RESUBMITTED',
    defaultmessages: 'Resubmitted',
  },
  RESUBMIT_DROPPED_CASE: {
    id: 'RESUBMIT_DROPPED_CASE',
    defaultmessages: 'Resubmit dropped dispute',
  },
  RESUBMIT_REQUEST_ERROR: {
    id: 'RESUBMIT_REQUEST_ERROR',
    defaultmessages: 'User cannot resubmit the request when the status is',
  },
  RETAIL: {
    id: 'RETAIL',
    defaultmessages: 'Retail',
  },
  RETAIL_UNITS: {
    id: 'RETAIL_UNITS',
    defaultmessages: 'Retail Area',
  },
  RETURN: {
    id: 'RETURN',
    defaultmessages: 'Return',
  },
  RETURNED: {
    id: 'RETURNED',
    defaultmessages: 'Returned',
  },
  REVIEW: {
    id: 'REVIEW',
    defaultmessages: 'Review',
  },
  REVIEW_PAYMENT: {
    id: 'REVIEW_PAYMENT',
    defaultmessages: 'Review and payments',
  },
  REVOKE_AUTHORITY: {
    id: 'REVOKE_AUTHORITY',
    defaultmessages: 'Revoke Authority',
  },
  REVOKING_COURT_LETTER: {
    id: 'REVOKING_COURT_LETTER',
    defaultmessages: 'Revoking Court Letter',
  },
  Register_national_housing_mortgage: {
    id: 'Register_national_housing_mortgage',
    defaultmessages: 'Register national housing mortgage',
  },
  Rejected: {
    id: 'Rejected',
    defaultmessages: 'Rejected',
  },
  'Remove primary contact?': {
    id: 'Remove primary contact?',
    defaultmessages: 'Remove primary contact details?',
  },
  Remove_as_seller: {
    id: 'Remove_as_seller',
    defaultmessages: 'Remove seller',
  },
  Rent_details: {
    id: 'Rent_details',
    defaultmessages: 'Rent details',
  },
  Representative_Name: {
    id: 'Representative_Name',
    defaultmessages: 'Representative Name',
  },
  Residential: {
    id: 'Residential',
    defaultmessages: 'Residential',
  },
  ResidentialUnits: {
    id: 'ResidentialUnits',
    defaultmessages: 'Residential units',
  },
  Retail: {
    id: 'Retail',
    defaultmessages: 'Retail outlets',
  },
  Review: {
    id: 'Review',
    defaultmessages: 'Review',
  },
  Road: {
    id: 'Road',
    defaultmessages: 'Road',
  },
  SAT: {
    id: 'SAT',
    defaultmessages: 'SAT',
  },
  SECONDARY: {
    id: 'SECONDARY',
    defaultmessages: '',
  },
  SECOND_PARTY_APPROVAL: {
    id: 'SECOND_PARTY_APPROVAL',
    defaultmessages: '',
  },
  SECOND_PARTY_RETURN: {
    id: 'SECOND_PARTY_RETURN',
    defaultmessages: '',
  },
  SECURITIES_AND_COMMODITIES_AUTHORITY: {
    id: 'SECURITIES_AND_COMMODITIES_AUTHORITY',
    defaultmessages:
      'A certificate of the names of the members of the Board of Directors issued by the Securities and Commodities Authority',
  },
  SELECT_PERMISSIONS: {
    id: 'SELECT_PERMISSIONS',
    defaultmessages: 'Select permissions',
  },
  SELECT_PROPERTIES: {
    id: 'SELECT_PROPERTIES',
    defaultmessages: 'Select properties',
  },
  SELECT_PROPERTY: {
    id: 'SELECT_PROPERTY',
    defaultmessages: 'Select property',
  },
  SELLER_BUYER: {
    id: 'SELLER_BUYER',
    defaultmessages: 'Seller and buyer (1:1)',
  },
  SELLER_EXEMPT: {
    id: 'SELLER_EXEMPT',
    defaultmessages: 'Exempt seller (1%)',
  },
  SELLER_ONLY: {
    id: 'SELLER_ONLY',
    defaultmessages: 'Seller only 2%',
  },
  SELLER_ONLY_MUSATAHA: {
    id: 'SELLER_ONLY_MUSATAHA',
    defaultmessages: 'Seller only 1%',
  },
  SELLER_PAYMENT: {
    id: 'SELLER_PAYMENT',
    defaultmessages: 'Seller Payment',
  },
  SELLER_RETURN: {
    id: 'SELLER_RETURN',
    defaultmessages: 'Returned by seller',
  },
  SELL_PURCHASE: {
    id: 'SELL_PURCHASE',
    defaultmessages: 'Sell and purchase',
  },
  SELL_PURCHASE_LAND: {
    id: 'SELL_PURCHASE_LAND',
    defaultmessages: 'Sell purchase land',
  },
  SELL_PURCHASE_OFFLINE: {
    id: 'SELL_PURCHASE_OFFLINE',
    defaultmessages: 'Offline',
  },
  SELL_PURCHASE_UNIT: {
    id: 'SELL_PURCHASE_UNIT',
    defaultmessages: 'Sell purchase unit',
  },
  SERVICE: {
    id: 'SERVICE',
    defaultmessages: 'Service',
  },
  SERVICE_PROVIDER: {
    id: 'SERVICE_PROVIDER',
    defaultmessages: 'Service provider',
  },
  SERVICE_PROVIDERS_PAYMENT_LETTER: {
    id: 'SERVICE_PROVIDERS_PAYMENT_LETTER',
    defaultmessages: 'Payment request letter to the bank, supported by a project report',
  },
  SESSION_SCHEDULED: {
    id: 'SESSION_SCHEDULED',
    defaultmessages: 'Session scheduled',
  },
  SETTLEMENT_APPROVAL: {
    id: 'SETTLEMENT_APPROVAL',
    defaultmessages: 'Settlement approval',
  },
  SEVEN: {
    id: 'SEVEN',
    defaultmessages: '7 Installments',
  },
  SHARJAH: {
    id: 'SHARJAH',
    defaultmessages: 'Sharjah',
  },
  SHEIKH_HIGHNESS: {
    id: 'SHEIKH_HIGHNESS',
    defaultmessages: 'Sheikh Highness',
  },
  SHOULD_PASS_DOC_ID_CODE: {
    id: 'SHOULD_PASS_DOC_ID_CODE',
    defaultmessages: '940030',
  },
  SHOULD_PASS_DOC_ID_MSG: {
    id: 'SHOULD_PASS_DOC_ID_MSG',
    defaultmessages: 'You should share the document ID',
  },
  SHOULD_PASS_USER_OR_COMPANY_ID_CODE: {
    id: 'SHOULD_PASS_USER_OR_COMPANY_ID_CODE',
    defaultmessages: '940029',
  },
  SHOULD_PASS_USER_OR_COMPANY_ID_MSG: {
    id: 'SHOULD_PASS_USER_OR_COMPANY_ID_MSG',
    defaultmessages: 'You should share the user ID or company ID',
  },
  SIGNATORY: {
    id: 'SIGNATORY',
    defaultmessages: 'Signatory',
  },
  SIGNATURE: {
    id: 'SIGNATURE',
    defaultmessages: 'Signature',
  },
  SIGNATURE_FINISHED: {
    id: 'SIGNATURE_FINISHED',
    defaultmessages: 'Signature Finished',
  },
  SIGNED_BUY_AND_SELL_CONTRACT: {
    id: 'SIGNED_BUY_AND_SELL_CONTRACT',
    defaultmessages: 'Signed buy and sell agreement',
  },
  SIGNING_DOCUMENT: {
    id: 'SIGNING_DOCUMENT',
    defaultmessages: 'Signing Document',
  },
  SITE_PLAN: {
    id: 'SITE_PLAN',
    defaultmessages: 'Site plan',
  },
  SIX: {
    id: 'SIX',
    defaultmessages: '6 installments',
  },
  SKIPPED: {
    id: 'SKIPPED',
    defaultmessages: '',
  },
  SPECIAL_TERMS_AND_CONDITIONS: {
    id: 'SPECIAL_TERMS_AND_CONDITIONS',
    defaultmessages: 'Special terms and conditions',
  },
  SP_ONLINE_ADD_POA: {
    id: 'SP_ONLINE_ADD_POA',
    defaultmessages: 'Register Power of Attorney',
  },
  SP_ONLINE_APPROVAL: {
    id: 'SP_ONLINE_APPROVAL',
    defaultmessages: 'Approved',
  },
  SP_ONLINE_APPT_PAYMENT: {
    id: 'SP_ONLINE_APPT_PAYMENT',
    defaultmessages: 'Appointment and payment details',
  },
  SP_ONLINE_AUDITOR_SIGNATURE: {
    id: 'SP_ONLINE_AUDITOR_SIGNATURE',
    defaultmessages: 'Auditor Signature',
  },
  SP_ONLINE_BUYER_DETAILS: {
    id: 'SP_ONLINE_BUYER_DETAILS',
    defaultmessages: 'Buyer details',
  },
  SP_ONLINE_CREATE_APPLICATION: {
    id: 'SP_ONLINE_CREATE_APPLICATION',
    defaultmessages: 'Create application',
  },
  SP_ONLINE_DEED_PROC: {
    id: 'SP_ONLINE_DEED_PROC',
    defaultmessages: 'DMT final stage',
  },
  SP_ONLINE_DOCUMENTS: {
    id: 'SP_ONLINE_DOCUMENTS',
    defaultmessages: 'Documents',
  },
  SP_ONLINE_PROCESSING_APPOINTMENT: {
    id: 'SP_ONLINE_PROCESSING_APPOINTMENT',
    defaultmessages: 'Processing appointment',
  },
  SP_ONLINE_REVIEW: {
    id: 'SP_ONLINE_REVIEW',
    defaultmessages: 'Review',
  },
  SP_ONLINE_SELLING_DETAILS: {
    id: 'SP_ONLINE_SELLING_DETAILS',
    defaultmessages: 'Sale details',
  },
  STATUS_SHOULD_BE_DISPATCHER_REVIEW_CODE: {
    id: 'STATUS_SHOULD_BE_DISPATCHER_REVIEW_CODE',
    defaultmessages: '940032',
  },
  STATUS_SHOULD_BE_DISPATCHER_REVIEW_MSG: {
    id: 'STATUS_SHOULD_BE_DISPATCHER_REVIEW_MSG',
    defaultmessages: "Status should be 'DISPATCHER_REVIEW' to request DMT info",
  },
  STATUS_SHOULD_BE_REQUEST_INFO_FROM_DMT_CODE: {
    id: 'STATUS_SHOULD_BE_REQUEST_INFO_FROM_DMT_CODE',
    defaultmessages: '940033',
  },
  STATUS_SHOULD_BE_REQUEST_INFO_FROM_DMT_MSG: {
    id: 'STATUS_SHOULD_BE_REQUEST_INFO_FROM_DMT_MSG',
    defaultmessages: "Status should be 'REQUEST_INFO_FROM_DMT' to request DMT info",
  },
  STRIKED_CASE_LETTER: {
    id: 'STRIKED_CASE_LETTER',
    defaultmessages: 'Striked dispute letter',
  },
  STRIKE_APPROVAL: {
    id: 'STRIKE_APPROVAL',
    defaultmessages: 'Strike approval',
  },
  STRIKE_APPROVED: {
    id: 'STRIKE_APPROVED',
    defaultmessages: 'Strike approved',
  },
  STRIKE_CASE: {
    id: 'STRIKE_CASE',
    defaultmessages: 'Dispute striked',
  },
  SUBMITTED: {
    id: 'SUBMITTED',
    defaultmessages: 'Submitted',
  },
  SUN: {
    id: 'SUN',
    defaultmessages: 'SUN',
  },
  SUPER_ADMIN: {
    id: 'SUPER_ADMIN',
    defaultmessages: 'Main Admin',
  },
  SUPPORTING_DOCUMENTS: {
    id: 'SUPPORTING_DOCUMENTS',
    defaultmessages: 'Supporting Documents',
  },
  SURRENDER_AGREEMENT: {
    id: 'SURRENDER_AGREEMENT',
    defaultmessages: 'Surrender Agreement (signed by both parties)',
  },
  SURVEYING_CONSULTANT_RETURN: {
    id: 'SURVEYING_CONSULTANT_RETURN',
    defaultmessages: 'Surveying consultant return',
  },
  SURVEYING_CONSULTANT_REVIEW: {
    id: 'SURVEYING_CONSULTANT_REVIEW',
    defaultmessages: 'Surveying Consultant Review',
  },
  Sale_and_purchase_sucess_desc: {
    id: 'Sale_and_purchase_sucess_desc',
    defaultmessages:
      'You have successfully sent the application for other owners approval. You will be notified with their response.',
  },
  Sale_and_purchase_sucess_title: {
    id: 'Sale_and_purchase_sucess_title',
    defaultmessages: 'Sale and purchase application submitted successfully',
  },
  Search_for_Road_Landmark_and_pin_your_exact_location: {
    id: 'Search_for_Road_Landmark_and_pin_your_exact_location',
    defaultmessages: 'Search for Road, Landmark and pin your exact location',
  },
  Search_for_service: {
    id: 'Search_for_service',
    defaultmessages: 'Search for a service',
  },
  Search_properties: {
    id: 'Search_properties',
    defaultmessages: 'Search Properties',
  },
  Secondary: {
    id: 'Secondary',
    defaultmessages: 'Secondary',
  },
  See_all: {
    id: 'See_all',
    defaultmessages: 'See all',
  },
  Select_emirate: {
    id: 'Select_emirate',
    defaultmessages: 'Select Emirate',
  },
  Select_municipality_branch: {
    id: 'Select_municipality_branch',
    defaultmessages: 'Select municipality branch',
  },
  Select_property: {
    id: 'Select_property',
    defaultmessages: 'Select property',
  },
  Select_title: {
    id: 'Select_title',
    defaultmessages: 'Select title',
  },
  Sell: {
    id: 'Sell',
    defaultmessages: 'Sell Permit (Single Unit or more)',
  },
  Sell_a_property: {
    id: 'Sell_a_property',
    defaultmessages: 'Sell a property',
  },
  Sell_contract: {
    id: 'Sell_contract',
    defaultmessages: 'Sell agreement',
  },
  Sell_whole_share_100: {
    id: 'Sell_whole_share_100',
    defaultmessages: 'Sell whole share (100%)',
  },
  Seller_num_document_name: {
    id: 'Seller_num_document_name',
    defaultmessages: 'Seller #{num} documents ({name})',
  },
  Seller_only: {
    id: 'Seller_only',
    defaultmessages: 'Seller only',
  },
  Sellers_Broker: {
    id: 'Sellers_Broker',
    defaultmessages: 'Seller’s Broker',
  },
  Service_Quality: {
    id: 'Service_Quality',
    defaultmessages: 'Service Quality',
  },
  Services: {
    id: 'Services',
    defaultmessages: 'Services',
  },
  Share: {
    id: 'Share',
    defaultmessages: 'Share',
  },
  Show: {
    id: 'Show',
    defaultmessages: 'Show',
  },
  Sign_up_with_Unified_number: {
    id: 'Sign_up_with_Unified_number',
    defaultmessages: 'Sign up with your Unified number',
  },
  Size: {
    id: 'Size',
    defaultmessages: 'Size',
  },
  Skip: {
    id: 'Skip',
    defaultmessages: 'Skip',
  },
  Skip_continue_as_guest: {
    id: 'Skip_continue_as_guest',
    defaultmessages: 'Skip & continue as guest',
  },
  Submitted: {
    id: 'Submitted',
    defaultmessages: 'Application Submission Date: {s}',
  },
  SystemManagementPage_EmployeeForm_PleaseAddUserGroup: {
    id: 'SystemManagementPage_EmployeeForm_PleaseAddUserGroup',
    defaultmessages: 'Please add user group',
  },
  SystemManagementPage_ServicesSearch_title: {
    id: 'SystemManagementPage_ServicesSearch_title',
    defaultmessages: 'What are you looking for?',
  },
  TAWTHEEQ_CONTRACT: {
    id: 'TAWTHEEQ_CONTRACT',
    defaultmessages: 'Lease agreement',
  },
  TAX_INVOICE: {
    id: 'TAX_INVOICE',
    defaultmessages: 'Tax Invoice',
  },
  TEN: {
    id: 'TEN',
    defaultmessages: '10 Installments',
  },
  TENANT: {
    id: 'TENANT',
    defaultmessages: 'Lessee',
  },
  TENANT_APPROVAL: {
    id: 'TENANT_APPROVAL',
    defaultmessages: 'Lessee approval',
  },
  TENANT_DETAILS: {
    id: 'TENANT_DETAILS',
    defaultmessages: 'Lessee details',
  },
  TENANT_PAYMENT: {
    id: 'TENANT_PAYMENT',
    defaultmessages: 'Pending for lessee payment',
  },
  TENANT_RETURN: {
    id: 'TENANT_RETURN',
    defaultmessages: 'Lessee return',
  },
  TERMINATED: {
    id: 'TERMINATED',
    defaultmessages: 'Terminated',
  },
  TERMINATION_APPLICATION: {
    id: 'TERMINATION_APPLICATION',
    defaultmessages: 'Termination Application',
  },
  THIRD_PARTY: {
    id: 'THIRD_PARTY',
    defaultmessages: 'Third party',
  },
  THIRD_PARTY_EVALUATION_CERTIFICATE: {
    id: 'THIRD_PARTY_EVALUATION_CERTIFICATE',
    defaultmessages: 'Third party evaluation certificate',
  },
  THIRTY_PERCENT_NOT_PAID: {
    id: 'THIRTY_PERCENT_NOT_PAID',
    defaultmessages: '30% Not Paid',
  },
  THREE: {
    id: 'THREE',
    defaultmessages: '3 installments',
  },
  THREE_UNCAPTURED_PAYMENTS: {
    id: 'THREE_UNCAPTURED_PAYMENTS',
    defaultmessages: 'Three Uncaptured Payments',
  },
  THU: {
    id: 'THU',
    defaultmessages: 'THU',
  },
  TITLE_DEED: {
    id: 'TITLE_DEED',
    defaultmessages: 'Title deed',
  },
  TOWN_PLANNING_APPROVAL: {
    id: 'TOWN_PLANNING_APPROVAL',
    defaultmessages: 'Town Planning Approval for Commercial Activity on Residential or Investment Land',
  },
  TRANSFER_OFFPLAN_TO_COMPLETED: {
    id: 'TRANSFER_OFFPLAN_TO_COMPLETED',
    defaultmessages: 'Transfer Property from Off-plan to Completed',
  },
  TRANSFER_OF_INTEREST_LAND: {
    id: 'TRANSFER_OF_INTEREST_LAND',
    defaultmessages: 'Transfer of Interest Land',
  },
  TRANSFER_OF_INTEREST_UNIT: {
    id: 'TRANSFER_OF_INTEREST_UNIT',
    defaultmessages: 'Transfer of Interest Unit',
  },
  TRANSFER_PROPERTY: {
    id: 'TRANSFER_PROPERTY',
    defaultmessages: 'Transfer Real Property Interest',
  },
  TRANSLATOR: {
    id: 'TRANSLATOR',
    defaultmessages: 'Translator',
  },
  TRN: {
    id: 'TRN',
    defaultmessages: 'TRN',
  },
  TRN_example: {
    id: 'TRN_example',
    defaultmessages: 'e.g., 903285',
  },
  TUE: {
    id: 'TUE',
    defaultmessages: 'TUE',
  },
  TWELVE: {
    id: 'TWELVE',
    defaultmessages: '12 installments',
  },
  TWO: {
    id: 'TWO',
    defaultmessages: '2 installments',
  },
  Tenant_Details: {
    id: 'Tenant_Details',
    defaultmessages: 'Lessee details',
  },
  Tenant_details: {
    id: 'Tenant_details',
    defaultmessages: 'Lessee details',
  },
  The_NHL_info_text_bankPage: {
    id: 'The_NHL_info_text_bankPage',
    defaultmessages: 'The mortgage registration fee is 0.05% of the mortgage agreement, Maximum fees is AED 1,000,000',
  },
  The_transaction_fee_is_paid_in_person_at_the_DMT_on_day_of_appointment: {
    id: 'The_transaction_fee_is_paid_in_person_at_the_DMT_on_day_of_appointment',
    defaultmessages: 'The transaction fee is paid in person at the DMT on the day of the appointment',
  },
  'Timeout on WebWaiting': {
    id: 'Timeout on WebWaiting',
    defaultmessages: 'You have exited the notification request. Please restart the process.',
  },
  Total: {
    id: 'Total',
    defaultmessages: 'Total',
  },
  Total_installment: {
    id: 'Total_installment',
    defaultmessages: 'Total Installments',
  },
  Townhouses: {
    id: 'Townhouses',
    defaultmessages: 'Townhouse',
  },
  Trade_Licence_no: {
    id: 'Trade_Licence_no',
    defaultmessages: 'Trade license no.',
  },
  Trade_license_number: {
    id: 'Trade_license_number',
    defaultmessages: 'Commercial license number',
  },
  Transaction_fee: {
    id: 'Transaction_fee',
    defaultmessages: 'Transaction fee',
  },
  Transaction_fee_paid_by: {
    id: 'Transaction_fee_paid_by',
    defaultmessages: 'Transaction fee paid by',
  },
  True: {
    id: 'True',
    defaultmessages: 'Yes',
  },
  UAE_RESIDENT: {
    id: 'UAE_RESIDENT',
    defaultmessages: 'UAE resident',
  },
  UMM_AL_QUWAIN: {
    id: 'UMM_AL_QUWAIN',
    defaultmessages: 'Umm Al Quwain',
  },
  UNAUTHORISED: {
    id: 'UNAUTHORISED',
    defaultmessages: 'Unauthorized',
  },
  UNDER_ACTIVATION: {
    id: 'UNDER_ACTIVATION',
    defaultmessages: 'Pending activation',
  },
  UNDER_AGE_AFFAIRS_AUTHORITY: {
    id: 'UNDER_AGE_AFFAIRS_AUTHORITY',
    defaultmessages: 'Under age affairs authority',
  },
  UNDER_AGE_SUPERVISOR: {
    id: 'UNDER_AGE_SUPERVISOR',
    defaultmessages: 'Under age supervisor',
  },
  UNDER_APPROVAL: {
    id: 'UNDER_APPROVAL',
    defaultmessages: 'Pending approval',
  },
  UNDER_APROVAL: {
    id: 'UNDER_APROVAL',
    defaultmessages: 'Pending approval',
  },
  UNDER_AUDITING: {
    id: 'UNDER_AUDITING',
    defaultmessages: 'Pending audit',
  },
  UNDER_CONSTRUCTION: {
    id: 'UNDER_CONSTRUCTION',
    defaultmessages: 'Under construction',
  },
  UNDER_DAD_APPROVAL: {
    id: 'UNDER_DAD_APPROVAL',
    defaultmessages: 'Under developer affairs Dept. Approval',
  },
  UNDER_DEVELOPER_SIGNATURE: {
    id: 'UNDER_DEVELOPER_SIGNATURE',
    defaultmessages: "Developer's signatory",
  },
  UNDER_ESCROW_BANK_SIGNATURE: {
    id: 'UNDER_ESCROW_BANK_SIGNATURE',
    defaultmessages: "Bank's signatory",
  },
  UNDER_VALUATION_REVIEW: {
    id: 'UNDER_VALUATION_REVIEW',
    defaultmessages: 'Under valuation review',
  },
  UNIFIED_SPA: {
    id: 'UNIFIED_SPA',
    defaultmessages: 'Unified SPA',
  },
  UNRESOLVED_DISPUTE_LETTER: {
    id: 'UNRESOLVED_DISPUTE_LETTER',
    defaultmessages: 'Unresolved dispute',
  },
  UNT: {
    id: 'UNT',
    defaultmessages: 'UNT',
  },
  UN_EID_number: {
    id: 'UN_EID_number',
    defaultmessages: 'UN/EID number',
  },
  UN_EID_number_hint: {
    id: 'UN_EID_number_hint',
    defaultmessages: '000-0000-0000000',
  },
  UPDATE_COMPANY: {
    id: 'UPDATE_COMPANY',
    defaultmessages: 'Update Company',
  },
  UPDATE_CUSTOMER_DATA: {
    id: 'UPDATE_CUSTOMER_DATA',
    defaultmessages: 'Update professional details',
  },
  UPLOAD_DOCUMENT: {
    id: 'UPLOAD_DOCUMENT',
    defaultmessages: 'Upload documents',
  },
  UPLOAD_DOCUMENTS: {
    id: 'UPLOAD_DOCUMENTS',
    defaultmessages: 'Upload documents',
  },
  USER_LOGGEDIN_PROOF: {
    id: 'USER_LOGGEDIN_PROOF',
    defaultmessages: 'ID Proof',
  },
  Uknown_error: {
    id: 'Uknown_error',
    defaultmessages: 'Something went wrong',
  },
  Unified_info: {
    id: 'Unified_info',
    defaultmessages: 'Unified Number information',
  },
  Unified_number: {
    id: 'Unified_number',
    defaultmessages: 'Unified number',
  },
  Unit: {
    id: 'Unit',
    defaultmessages: 'Unit',
  },
  Unit_usage: {
    id: 'Unit_usage',
    defaultmessages: 'Unit usage',
  },
  Updated_date: {
    id: 'Updated_date',
    defaultmessages: 'Update Data',
  },
  VAL069_content: {
    id: 'VAL069_content',
    defaultmessages:
      'The transaction cannot be completed as there is an active application {s}. Please contact customer support if you have any inquiries.',
  },
  VAL181_content: {
    id: 'VAL181_content',
    defaultmessages: '',
  },
  VAL181_title: {
    id: 'VAL181_title',
    defaultmessages: '',
  },
  VAL500001_content: {
    id: 'VAL500001_content',
    defaultmessages: 'Please enter a valid agreement date for the industrial agreement',
  },
  VAL500001_title: {
    id: 'VAL500001_title',
    defaultmessages: 'Start date of Industrial agreement is invalid',
  },
  VAL500002_content: {
    id: 'VAL500002_content',
    defaultmessages: 'Please make sure that the industrial agreement is active',
  },
  VAL500002_title: {
    id: 'VAL500002_title',
    defaultmessages: 'Industrial agreement was not active',
  },
  VAL500004_content: {
    id: 'VAL500004_content',
    defaultmessages: 'The industrial agreement either could not be found or has expired.',
  },
  VAL500004_title: {
    id: 'VAL500004_title',
    defaultmessages: 'Industrial agreement was not found or expired',
  },
  VARIATION_OR_EXTINGUISHING_OF_COVENANTS: {
    id: 'VARIATION_OR_EXTINGUISHING_OF_COVENANTS',
    defaultmessages: 'Register Covenant Extinguishing/Variation',
  },
  VAT_percentage: {
    id: 'VAT_percentage',
    defaultmessages: '{per}% VAT',
  },
  VERIFICATION_CERTIFICATE: {
    id: 'VERIFICATION_CERTIFICATE',
    defaultmessages: 'Search Certificate',
  },
  VILLA: {
    id: 'VILLA',
    defaultmessages: 'Villas',
  },
  Vacant: {
    id: 'Vacant',
    defaultmessages: 'Vacant',
  },
  Villa: {
    id: 'Villa',
    defaultmessages: 'Villas',
  },
  Virtual_video_call: {
    id: 'Virtual_video_call',
    defaultmessages: 'Virtual video call',
  },
  WAIVER_MUSATAHA: {
    id: 'WAIVER_MUSATAHA',
    defaultmessages: 'Waiver of Musataha',
  },
  WALLET: {
    id: 'WALLET',
    defaultmessages: 'Wallet',
  },
  WALLET_TOPUP: {
    id: 'WALLET_TOPUP',
    defaultmessages: 'Credit card added',
  },
  WED: {
    id: 'WED',
    defaultmessages: 'WED',
  },
  WITHOUT_REFUND: {
    id: 'WITHOUT_REFUND',
    defaultmessages: 'Without Refund',
  },
  WITH_REFUND: {
    id: 'WITH_REFUND',
    defaultmessages: 'With Refund',
  },
  WM_ONLINE_BUYER_DETAILS: {
    id: 'WM_ONLINE_BUYER_DETAILS',
    defaultmessages: 'New Musateh Details',
  },
  WM_ONLINE_DOCUMENTS: {
    id: 'WM_ONLINE_DOCUMENTS',
    defaultmessages: 'Documents',
  },
  WM_ONLINE_REVIEW: {
    id: 'WM_ONLINE_REVIEW',
    defaultmessages: 'Review',
  },
  WM_ONLINE_SELLING_DETAILS: {
    id: 'WM_ONLINE_SELLING_DETAILS',
    defaultmessages: 'Current Musateh Details',
  },
  Wallet: {
    id: 'Wallet',
    defaultmessages: 'Wallet',
  },
  We_will_send_you_the_available_time_slots_once_the_application_is_approved_by_the_municipality: {
    id: 'We_will_send_you_the_available_time_slots_once_the_application_is_approved_by_the_municipality',
    defaultmessages: 'We will send you the available time slots once the application is approved by the municipality.',
  },
  Welcome_back: {
    id: 'Welcome_back',
    defaultmessages: 'Welcome back',
  },
  'With second-party approval': {
    id: 'With second-party approval',
    defaultmessages: 'With lessee approval',
  },
  Year: {
    id: 'Year',
    defaultmessages: 'Year',
  },
  You_can_view_contract_and_download: {
    id: 'You_can_view_contract_and_download',
    defaultmessages: 'You can now view the agreement and download it',
  },
  'You_haven’t_added_any_broker_yet': {
    id: 'You_haven’t_added_any_broker_yet',
    defaultmessages: 'You haven’t added any broker yet.',
  },
  'Your mortgage registration certificate is ready to download': {
    id: 'Your mortgage registration certificate is ready to download',
    defaultmessages: 'Your mortgage registration certificate is now ready for download.',
  },
  Your_National_Housing_Loans_application_returned_successfully: {
    id: 'Your_National_Housing_Loans_application_returned_successfully',
    defaultmessages: 'Your National housing mortgage registration application returned successfully',
  },
  _click_here: {
    id: '_click_here',
    defaultmessages: 'click here',
  },
  aadc_liability: {
    id: 'aadc_liability',
    defaultmessages: 'AADC liability',
  },
  about_dari: {
    id: 'about_dari',
    defaultmessages: 'About ADGM',
  },
  abu_dhabi_global_market_services: {
    id: 'abu_dhabi_global_market_services',
    defaultmessages: 'Abu Dhabi Global Market Services',
  },
  abu_dhabi_market_trends: {
    id: 'abu_dhabi_market_trends',
    defaultmessages: 'Abu Dhabi real estate market trends',
  },
  accept: {
    id: 'accept',
    defaultmessages: 'Accept',
  },
  accept_application_acknowledgement_message: {
    id: 'accept_application_acknowledgement_message',
    defaultmessages: 'Are you sure you want to accept this application?',
  },
  accept_modal_checkbox: {
    id: 'accept_modal_checkbox',
    defaultmessages: 'I accepted the terms of new agreement and signed it',
  },
  accept_modal_text: {
    id: 'accept_modal_text',
    defaultmessages: 'By checking the box below you are accepting the new agreement policies.',
  },
  accept_modal_title: {
    id: 'accept_modal_title',
    defaultmessages: 'Sign the agreement now',
  },
  accept_rental_unit_not_exceed: {
    id: 'accept_rental_unit_not_exceed',
    defaultmessages:
      'I, the lessee, pledge that the rental value of the rental unit does not exceed 35% of the income of the residents of the rental unit.',
  },
  accepted_the_terms_and_signed_it: {
    id: 'accepted_the_terms_and_signed_it',
    defaultmessages: 'I accepted the terms of new agreement and signed it.',
  },
  'access_to the_properties_again_immediately': {
    id: 'access_to the_properties_again_immediately',
    defaultmessages: 'This will give the employee access to the properties again immediately',
  },
  according_to_the_actual_use_of_the_rental_unit: {
    id: 'according_to_the_actual_use_of_the_rental_unit',
    defaultmessages: 'According to the actual use of the rental unit',
  },
  'account-trustee': {
    id: 'account-trustee',
    defaultmessages: 'Account Trustee',
  },
  account_trustee: {
    id: 'account_trustee',
    defaultmessages: 'Account trustee',
  },
  account_trustee_mobile: {
    id: 'account_trustee_mobile',
    defaultmessages: 'Account trustee mobile',
  },
  account_verification_thinkprop_failed: {
    id: 'account_verification_thinkprop_failed',
    defaultmessages: 'The account you are trying to verify with ThinkProp is invalid',
  },
  accumulated_amount: {
    id: 'accumulated_amount',
    defaultmessages: 'Accumulated Amount',
  },
  accumulated_or_credit_rent_amount_for_the_period: {
    id: 'accumulated_or_credit_rent_amount_for_the_period',
    defaultmessages: 'Accumulated or credited rent amount for the period {s}',
  },
  accumulated_or_credited_rent_amount_for_the_period: {
    id: 'accumulated_or_credited_rent_amount_for_the_period',
    defaultmessages: 'Accumulated or credited rent amount for the period {s}',
  },
  accumulated_rent_amount_for_the_period: {
    id: 'accumulated_rent_amount_for_the_period',
    defaultmessages: 'Accumulated rent amount for the period',
  },
  acknowledge_receipt: {
    id: 'acknowledge_receipt',
    defaultmessages: 'We will acknowledge receipt of your Feedback within 24 hours.',
  },
  acknowledgement_date: {
    id: 'acknowledgement_date',
    defaultmessages: 'Acknowledgment date',
  },
  acknowledgement_number: {
    id: 'acknowledgement_number',
    defaultmessages: 'Acknowledgement No.',
  },
  acknowledgment: {
    id: 'acknowledgment',
    defaultmessages: 'Acknowledgment',
  },
  acquired_shares: {
    id: 'acquired_shares',
    defaultmessages: 'Acquired shares',
  },
  acquiring_properties: {
    id: 'acquiring_properties',
    defaultmessages: 'Acquiring Properties',
  },
  acquisition_type: {
    id: 'acquisition_type',
    defaultmessages: 'Acquisition Type',
  },
  active: {
    id: 'active',
    defaultmessages: '',
  },
  active_agreements: {
    id: 'active_agreements',
    defaultmessages: 'Active Agreements',
  },
  active_profile: {
    id: 'active_profile',
    defaultmessages: 'Active Profile',
  },
  activity: {
    id: 'activity',
    defaultmessages: 'Activity',
  },
  activity_code: {
    id: 'activity_code',
    defaultmessages: 'Activity Code',
  },
  actual_end_date: {
    id: 'actual_end_date',
    defaultmessages: 'Actual end date',
  },
  actual_usage_type: {
    id: 'actual_usage_type',
    defaultmessages: 'Actual usage type',
  },
  adcci_number: {
    id: 'adcci_number',
    defaultmessages: 'ADCCI Number',
  },
  add: {
    id: 'add',
    defaultmessages: 'Add',
  },
  add_a_new_credit_debit_card: {
    id: 'add_a_new_credit_debit_card',
    defaultmessages: 'Add a new credit/debit card',
  },
  add_a_term: {
    id: 'add_a_term',
    defaultmessages: 'Add a term',
  },
  add_admin_success_body: {
    id: 'add_admin_success_body',
    defaultmessages:
      'Request will be reviewed by the Municipality. Once approved, the user will be granted all permissions by default.',
  },
  add_admin_success_title: {
    id: 'add_admin_success_title',
    defaultmessages: 'Request to add a company admin has been submitted successfully.',
  },
  add_appendix: {
    id: 'add_appendix',
    defaultmessages: 'Add appendix',
  },
  add_appointment_calendar: {
    id: 'add_appointment_calendar',
    defaultmessages: 'Add appointment to my calendar',
  },
  add_atleast_one_plot_before_proceed_message: {
    id: 'add_atleast_one_plot_before_proceed_message',
    defaultmessages: 'Please select or upload at least one plot before moving to the next step',
  },
  add_broker: {
    id: 'add_broker',
    defaultmessages: 'Add Broker',
  },
  add_buyer_to_continue_with_application: {
    id: 'add_buyer_to_continue_with_application',
    defaultmessages: 'To continue with the application you need to add a buyer',
  },
  add_company_employee_service_acknowledgement_text: {
    id: 'add_company_employee_service_acknowledgement_text',
    defaultmessages:
      'By clicking Confirm, you acknowledge that the employee will have access to all company properties and services according to the assigned permissions, and you authorize this action',
  },
  add_company_success_message: {
    id: 'add_company_success_message',
    defaultmessages: 'We will send you a notification when the registration has been approved by ADGM.',
  },
  add_employee: {
    id: 'add_employee',
    defaultmessages: 'Add employee',
  },
  add_employee_success_body: {
    id: 'add_employee_success_body',
    defaultmessages:
      'Your application will be reviewed by the company administrator, and they will grant you specific permissions once they approve your request',
  },
  add_employee_success_title: {
    id: 'add_employee_success_title',
    defaultmessages: 'Your request to be added as an employee to the company is successfully submitted',
  },
  add_entity: {
    id: 'add_entity',
    defaultmessages: 'Add {entity}',
  },
  add_first_party: {
    id: 'add_first_party',
    defaultmessages: 'Add first party',
  },
  add_more: {
    id: 'add_more',
    defaultmessages: 'Add More',
  },
  add_more_photos: {
    id: 'add_more_photos',
    defaultmessages: 'Add more photos',
  },
  add_more_units: {
    id: 'add_more_units',
    defaultmessages: 'Add more units',
  },
  add_musateh: {
    id: 'add_musateh',
    defaultmessages: 'Add Musateh',
  },
  add_new_buyer: {
    id: 'add_new_buyer',
    defaultmessages: 'add new buyer',
  },
  add_new_card: {
    id: 'add_new_card',
    defaultmessages: 'Add a new card',
  },
  add_new_contact_details: {
    id: 'add_new_contact_details',
    defaultmessages: 'Add new contact details',
  },
  add_new_first_party: {
    id: 'add_new_first_party',
    defaultmessages: 'Add new first-party',
  },
  add_new_occupant: {
    id: 'add_new_occupant',
    defaultmessages: 'Add New Occupant',
  },
  add_non_UAE_resident_buyer: {
    id: 'add_non_UAE_resident_buyer',
    defaultmessages: 'Add non-UAE resident buyer',
  },
  add_occupant: {
    id: 'add_occupant',
    defaultmessages: 'Add occupant',
  },
  add_other_occupant: {
    id: 'add_other_occupant',
    defaultmessages: 'Add more occupants',
  },
  add_party: {
    id: 'add_party',
    defaultmessages: 'Add party',
  },
  add_payment_plan: {
    id: 'add_payment_plan',
    defaultmessages: 'Add payment plan',
  },
  add_plan_details: {
    id: 'add_plan_details',
    defaultmessages: 'Add Plan Details',
  },
  add_plots: {
    id: 'add_plots',
    defaultmessages: 'Add ({s}) plots',
  },
  add_plots_manually: {
    id: 'add_plots_manually',
    defaultmessages: 'Add plots manually',
  },
  add_poa: {
    id: 'add_poa',
    defaultmessages: 'Add Representative',
  },
  add_primary_contact: {
    id: 'add_primary_contact',
    defaultmessages: 'Add primary contact',
  },
  add_primary_contact_hint: {
    id: 'add_primary_contact_hint',
    defaultmessages: 'If you would like to add new primary contact details, {s}',
  },
  add_properties: {
    id: 'add_properties',
    defaultmessages: 'Add Properties',
  },
  add_property: {
    id: 'add_property',
    defaultmessages: 'Add property',
  },
  add_property_message: {
    id: 'add_property_message',
    defaultmessages: 'You haven’t added any property yet.',
  },
  add_representative: {
    id: 'add_representative',
    defaultmessages: 'Add New Representative',
  },
  add_representative_poa: {
    id: 'add_representative_poa',
    defaultmessages: 'Add Representative (POA)',
  },
  add_second_party: {
    id: 'add_second_party',
    defaultmessages: 'Add Second Party',
  },
  add_selected: {
    id: 'add_selected',
    defaultmessages: 'Add selected',
  },
  add_selected_count: {
    id: 'add_selected_count',
    defaultmessages: 'Add {s} selected',
  },
  add_selected_with_count: {
    id: 'add_selected_with_count',
    defaultmessages: 'Add ({s}) selected',
  },
  add_term: {
    id: 'add_term',
    defaultmessages: 'Add Term',
  },
  add_term_here_arabic: {
    id: 'add_term_here_arabic',
    defaultmessages: 'إضافة الشرط هنا',
  },
  add_term_here_english: {
    id: 'add_term_here_english',
    defaultmessages: 'Add term here',
  },
  add_terms: {
    id: 'add_terms',
    defaultmessages: 'Add a term',
  },
  add_the_project_id_output_from_the_qa_qc_tool: {
    id: 'add_the_project_id_output_from_the_qa_qc_tool',
    defaultmessages: 'Add the project ID output from the QA/QC tool',
  },
  add_this_representative_for_other_buyers: {
    id: 'add_this_representative_for_other_buyers',
    defaultmessages: 'Add this representative for all other buyers',
  },
  add_this_representative_for_other_sellers: {
    id: 'add_this_representative_for_other_sellers',
    defaultmessages: 'Add this representative for all other sellers',
  },
  add_your_self_as_employee: {
    id: 'add_your_self_as_employee',
    defaultmessages: 'Add yourself as an employee instead?',
  },
  addc_aadc_current_liability: {
    id: 'addc_aadc_current_liability',
    defaultmessages: 'ADDC/AADC current liability',
  },
  addc_clearence: {
    id: 'addc_clearence',
    defaultmessages: 'ADDC clearance certificate',
  },
  addc_liability: {
    id: 'addc_liability',
    defaultmessages: 'ADDC liability',
  },
  addc_liability_amount_message: {
    id: 'addc_liability_amount_message',
    defaultmessages: 'This property has ADDC liability amount of AED {s}',
  },
  addc_registration_no: {
    id: 'addc_registration_no',
    defaultmessages: 'ADDC Registration No',
  },
  addingWalletAmount: {
    id: 'addingWalletAmount',
    defaultmessages: 'Adding AED {s} to your wallet',
  },
  adding_other_than_0_progress_report_condition: {
    id: 'adding_other_than_0_progress_report_condition',
    defaultmessages: 'Adding other than 0% you have to upload progress report',
  },
  additional_information: {
    id: 'additional_information',
    defaultmessages: 'Additional Information',
  },
  address: {
    id: 'address',
    defaultmessages: 'Address',
  },
  address_placeholder: {
    id: 'address_placeholder',
    defaultmessages: 'Ex. Al Raha Beach, Abu Dhabi',
  },
  adgm_authority_fees: {
    id: 'adgm_authority_fees',
    defaultmessages: 'ADGM Authority Fees',
  },
  adgm_fee: {
    id: 'adgm_fee',
    defaultmessages: 'ADGM Fee',
  },
  adgm_fees_2: {
    id: 'adgm_fees_2',
    defaultmessages: 'ADGM Fees (2%)',
  },
  adgm_real_property_feedback: {
    id: 'adgm_real_property_feedback',
    defaultmessages: 'ADGM Real Property Feedback',
  },
  adgm_services: {
    id: 'adgm_services',
    defaultmessages: 'ADGM Services',
  },
  adgm_wallet: {
    id: 'adgm_wallet',
    defaultmessages: 'ADGM Wallet',
  },
  admin: {
    id: 'admin',
    defaultmessages: 'Admin',
  },
  admin_add_employee_success_title: {
    id: 'admin_add_employee_success_title',
    defaultmessages: 'You have successfully added an employee to your company',
  },
  admin_user_role_have_been_given_full_permissions: {
    id: 'admin_user_role_have_been_given_full_permissions',
    defaultmessages: 'Admin user role have been given full permissions.',
  },
  adres_mortgage_discharge_fee_65_vat: {
    id: 'adres_mortgage_discharge_fee_65_vat',
    defaultmessages: 'Mortgage Discharge Fee: 65 AED + VAT (if applicable)',
  },
  advance_filter: {
    id: 'advance_filter',
    defaultmessages: 'Advanced Filters',
  },
  advanced_filters: {
    id: 'advanced_filters',
    defaultmessages: 'Advanced Filters',
  },
  advertising_permit_request: {
    id: 'advertising_permit_request',
    defaultmessages: 'Request for Permit to Undertake Advertising',
  },
  advertising_permit_request_description: {
    id: 'advertising_permit_request_description',
    defaultmessages:
      'This service allows developers to obtain a permit to advertise Off-Plan Projects through any communication medium, including print, electronic, broadcast, and outdoor media',
  },
  adwea_acknowledgment_details: {
    id: 'adwea_acknowledgment_details',
    defaultmessages: 'ADWEA acknowledgment details',
  },
  adwea_bill_paid_by: {
    id: 'adwea_bill_paid_by',
    defaultmessages: 'ADGM fees',
  },
  affection_plan: {
    id: 'affection_plan',
    defaultmessages: 'Affection plan',
  },
  affection_plan_mandatory: {
    id: 'affection_plan_mandatory',
    defaultmessages: 'Affection Plan (Mandatory)',
  },
  agreement: {
    id: 'agreement',
    defaultmessages: 'Agreement',
  },
  agreement_amount_percentage_charge_rate: {
    id: 'agreement_amount_percentage_charge_rate',
    defaultmessages: 'Agreement amount percentage is the charge rate agreed between both parties',
  },
  agreement_details: {
    id: 'agreement_details',
    defaultmessages: 'Agreement details',
  },
  agreement_duration: {
    id: 'agreement_duration',
    defaultmessages: 'Agreement Duration',
  },
  agreement_duration_amount: {
    id: 'agreement_duration_amount',
    defaultmessages: 'Agreement duration and amount',
  },
  agreement_duration_amount_hint: {
    id: 'agreement_duration_amount_hint',
    defaultmessages: 'Minimum duration is 3 months. Maximum duration is 4 years.',
  },
  agreement_duration_amount_v2: {
    id: 'agreement_duration_amount_v2',
    defaultmessages: 'Agreement duration & amount',
  },
  agreement_expiry_date: {
    id: 'agreement_expiry_date',
    defaultmessages: 'Agreement Expiry Date',
  },
  agreement_issuance_date: {
    id: 'agreement_issuance_date',
    defaultmessages: 'Agreement Issuance Date',
  },
  agreement_linked_to_unit_has_sub_leases: {
    id: 'agreement_linked_to_unit_has_sub_leases',
    defaultmessages: 'This agreement is linked to a parent unit that has sub-leases',
  },
  agreement_new_policies_acknowledgment_message: {
    id: 'agreement_new_policies_acknowledgment_message',
    defaultmessages: 'By checking the box below, you agree to accept the new Agreement policies',
  },
  agreement_no: {
    id: 'agreement_no',
    defaultmessages: 'Agreement No: {a}',
  },
  agreement_placeholder: {
    id: 'agreement_placeholder',
    defaultmessages: 'ex. 123123124',
  },
  agreement_registration: {
    id: 'agreement_registration',
    defaultmessages: 'Agreement registration',
  },
  agreement_termination: {
    id: 'agreement_termination',
    defaultmessages: 'Agreement termination',
  },
  aknowledgment_text: {
    id: 'aknowledgment_text',
    defaultmessages:
      'The Lessor declares and undertakes that all data, information, and documents submitted in this application are valid. They also acknowledge that the Lessee has handed over the property and is no longer occupying it. In addition, the Lessor undertakes that they will bear all legal, judicial, and financial consequences, responsibilities, liabilities, and/or obligations arising from closing the lease agreement in AccessRP against any claim and/or dispute in this regard, and without any responsibility from ADGM towards any third party.',
  },
  all_online_applications: {
    id: 'all_online_applications',
    defaultmessages: 'All online applications must be paid exclusively through online payment methods.',
  },
  all_permissions_are_granted_for_admin_users: {
    id: 'all_permissions_are_granted_for_admin_users',
    defaultmessages: 'All permissions are granted for Admin users',
  },
  all_plots: {
    id: 'all_plots',
    defaultmessages: 'All plots ({s})',
  },
  all_shares_100: {
    id: 'all_shares_100',
    defaultmessages: 'All shares (100%)',
  },
  all_shown_active_agreements_only: {
    id: 'all_shown_active_agreements_only',
    defaultmessages: 'All shown agreements below are active agreements only!',
  },
  all_the_data_you_have_entered_in_this_form_will_be_discarded: {
    id: 'all_the_data_you_have_entered_in_this_form_will_be_discarded',
    defaultmessages: 'All data entered in this form will be discarded',
  },
  allotment: {
    id: 'allotment',
    defaultmessages: 'Allotment',
  },
  allow: {
    id: 'allow',
    defaultmessages: 'Allow',
  },
  allow_first_party_access: {
    id: 'allow_first_party_access',
    defaultmessages: 'Allow first party access',
  },
  allow_tenant_to_sublease: {
    id: 'allow_tenant_to_sublease',
    defaultmessages: 'Allow lessee to sublease',
  },
  allow_tenant_to_sublease_hint: {
    id: 'allow_tenant_to_sublease_hint',
    defaultmessages:
      'This allows your lessee to lease the property to a third party for a time period on the existing agreement',
  },
  allowed_permissions: {
    id: 'allowed_permissions',
    defaultmessages: 'Permissions',
  },
  allowed_permissions_v2: {
    id: 'allowed_permissions_v2',
    defaultmessages: 'Allowed permissions',
  },
  allowed_services: {
    id: 'allowed_services',
    defaultmessages: 'Allowed Services',
  },
  allowed_sub_lease: {
    id: 'allowed_sub_lease',
    defaultmessages: 'Allowed Sub-lease',
  },
  allowed_to_sublease: {
    id: 'allowed_to_sublease',
    defaultmessages: 'Subleasing allowed',
  },
  amenities: {
    id: 'amenities',
    defaultmessages: 'Amenities',
  },
  amineties_status: {
    id: 'amineties_status',
    defaultmessages: 'Amineties status',
  },
  amount: {
    id: 'amount',
    defaultmessages: 'Amount',
  },
  amount_12345: {
    id: 'amount_12345',
    defaultmessages: '12345',
  },
  amount_AED: {
    id: 'amount_AED',
    defaultmessages: 'Amount (AED)',
  },
  amount_AED_Rent: {
    id: 'amount_AED_Rent',
    defaultmessages: '{amount} AED / Per Property',
  },
  amount_aed: {
    id: 'amount_aed',
    defaultmessages: 'Amount in AED',
  },
  amount_aed_Property: {
    id: 'amount_aed_Property',
    defaultmessages: '{amount} AED / Per property',
  },
  amount_auto_calculated_based_on_percentage: {
    id: 'amount_auto_calculated_based_on_percentage',
    defaultmessages: 'Amount auto calculated based on the percentage',
  },
  amount_in_aed: {
    id: 'amount_in_aed',
    defaultmessages: 'Amount in AED',
  },
  amount_in_words: {
    id: 'amount_in_words',
    defaultmessages: 'Amount in words',
  },
  amount_to_be_forfeited_to_developer: {
    id: 'amount_to_be_forfeited_to_developer',
    defaultmessages: 'Amount to be forfeited to developer',
  },
  amount_to_be_forfeited_to_developer_aed: {
    id: 'amount_to_be_forfeited_to_developer_aed',
    defaultmessages: 'Amount to be forfeited to developer (AED)',
  },
  amount_to_be_refunded_to_buyer: {
    id: 'amount_to_be_refunded_to_buyer',
    defaultmessages: 'Amount to be refunded to Buyer',
  },
  amount_to_be_refunded_to_buyer_aed: {
    id: 'amount_to_be_refunded_to_buyer_aed',
    defaultmessages: 'Amount to be refunded to buyer (AED)',
  },
  amount_to_be_refunded_to_buyer_name: {
    id: 'amount_to_be_refunded_to_buyer_name',
    defaultmessages: 'Amount to be refunded to #{num} buyer ({buyerName})',
  },
  amount_to_be_refunded_to_this_buyer: {
    id: 'amount_to_be_refunded_to_this_buyer',
    defaultmessages: 'Amount to be refunded to this Buyer',
  },
  and: {
    id: 'and',
    defaultmessages: 'and',
  },
  annual_rent_amount: {
    id: 'annual_rent_amount',
    defaultmessages: 'Annual rent amount',
  },
  annual_rent_amount_based_on_your_input: {
    id: 'annual_rent_amount_based_on_your_input',
    defaultmessages: 'Annual rent amount based on your input',
  },
  annual_rent_amount_based_on_your_input_desc: {
    id: 'annual_rent_amount_based_on_your_input_desc',
    defaultmessages: 'The annual rent amount is calculated by dividing your input by the total months added',
  },
  anual_rent_text: {
    id: 'anual_rent_text',
    defaultmessages: 'The annual rent amount is calculated by dividing your input by the total months added',
  },
  any_mortgages: {
    id: 'any_mortgages',
    defaultmessages: 'Any mortgages',
  },
  any_transfer_of_ownership: {
    id: 'any_transfer_of_ownership',
    defaultmessages: 'Any Transfer of ownership',
  },
  apartment: {
    id: 'apartment',
    defaultmessages: 'Apartment',
  },
  app_version_web: {
    id: 'app_version_web',
    defaultmessages: 'Application version',
  },
  appendix: {
    id: 'appendix',
    defaultmessages: 'Appendix',
  },
  appendix_hint: {
    id: 'appendix_hint',
    defaultmessages: 'You can write your own terms here',
  },
  appendix_hint_ar: {
    id: 'appendix_hint_ar',
    defaultmessages: 'أضف الشرط الخاص بك باللغة العربية هنا',
  },
  appendix_hint_en: {
    id: 'appendix_hint_en',
    defaultmessages: 'Add your terms in English here',
  },
  applicant_details: {
    id: 'applicant_details',
    defaultmessages: 'Applicant Details',
  },
  applicant_type: {
    id: 'applicant_type',
    defaultmessages: 'Applicant Type',
  },
  application_approved_proceed_to_payment: {
    id: 'application_approved_proceed_to_payment',
    defaultmessages: 'The application has been approved, please proceed for payment.',
  },
  application_auto_cancelation: {
    id: 'application_auto_cancelation',
    defaultmessages:
      'This application will be auto-canceled if the payment is not processed within 10 days after the municipality approval date.',
  },
  application_completed_after_approval: {
    id: 'application_completed_after_approval',
    defaultmessages: 'Application completed after approval',
  },
  application_details: {
    id: 'application_details',
    defaultmessages: 'Application Details',
  },
  application_documents: {
    id: 'application_documents',
    defaultmessages: 'Application Documents',
  },
  application_documents_lowerCase: {
    id: 'application_documents_lowerCase',
    defaultmessages: 'Application documents',
  },
  application_fee_non_refundable_notice: {
    id: 'application_fee_non_refundable_notice',
    defaultmessages:
      'Please note that application fees are non-refundable in the event of cancellation or rejection of the application.',
  },
  application_follow_up: {
    id: 'application_follow_up',
    defaultmessages: 'Application follow up',
  },
  application_form: {
    id: 'application_form',
    defaultmessages: 'Application Form',
  },
  application_has_been_cancelled_successfully: {
    id: 'application_has_been_cancelled_successfully',
    defaultmessages: 'Application has been cancelled Successfully',
  },
  application_has_been_forwarded_to_bank_for_approval: {
    id: 'application_has_been_forwarded_to_bank_for_approval',
    defaultmessages: 'The application has been forwarded to the bank for approval',
  },
  application_has_been_rejected: {
    id: 'application_has_been_rejected',
    defaultmessages: '',
  },
  application_has_been_rejected_successfully: {
    id: 'application_has_been_rejected_successfully',
    defaultmessages: 'The application has been rejected successfully',
  },
  application_has_been_returned_successfully: {
    id: 'application_has_been_returned_successfully',
    defaultmessages: 'The application has been returned successfully',
  },
  application_has_been_sent_to_be_reviewed_by_ADGM: {
    id: 'application_has_been_sent_to_be_reviewed_by_ADGM',
    defaultmessages: 'Your application has been sent to be reviewed by ADGM.',
  },
  application_has_been_sent_to_be_reviewed_by_company_admin: {
    id: 'application_has_been_sent_to_be_reviewed_by_company_admin',
    defaultmessages: 'Your application has been sent to be reviewed by Company admin.',
  },
  application_history: {
    id: 'application_history',
    defaultmessages: 'Application history',
  },
  application_is_complete_and_sent_to_owner: {
    id: 'application_is_complete_and_sent_to_owner',
    defaultmessages: 'Your application is now completed and has been sent to the owner for final payment',
  },
  application_is_sent_to_back_office_for_further_approval: {
    id: 'application_is_sent_to_back_office_for_further_approval',
    defaultmessages: 'The application has been sent to the Back Office for final approval',
  },
  application_journey: {
    id: 'application_journey',
    defaultmessages: 'Application Journey',
  },
  application_no: {
    id: 'application_no',
    defaultmessages: 'Application Number',
  },
  application_number: {
    id: 'application_number',
    defaultmessages: 'Application number',
  },
  application_number_label: {
    id: 'application_number_label',
    defaultmessages: 'Application No.',
  },
  application_rejected: {
    id: 'application_rejected',
    defaultmessages: 'Application rejected',
  },
  application_rejected_successful: {
    id: 'application_rejected_successful',
    defaultmessages: 'Application rejected successfully',
  },
  application_rejected_successfully: {
    id: 'application_rejected_successfully',
    defaultmessages: 'Your application has been rejected successfully',
  },
  application_returned_to_initiator: {
    id: 'application_returned_to_initiator',
    defaultmessages: 'Your application has been returned to the initiator',
  },
  application_returned_to_initiator_to_fix_issues: {
    id: 'application_returned_to_initiator_to_fix_issues',
    defaultmessages: 'Your application will be returned to the initiator to fix the issues and will submit it again',
  },
  application_reviewed_and_approved_by_back_office: {
    id: 'application_reviewed_and_approved_by_back_office',
    defaultmessages: 'Please check the application later on to ensure if it was reviewed and approved by back office.',
  },
  application_sent_back_office_approval: {
    id: 'application_sent_back_office_approval',
    defaultmessages: 'Application is sent to Back Office for approval',
  },
  application_sent_to_bank_checker_for_approval: {
    id: 'application_sent_to_bank_checker_for_approval',
    defaultmessages: 'The application has been sent to the bank checker for approval',
  },
  application_sent_to_bank_maker_for_approval: {
    id: 'application_sent_to_bank_maker_for_approval',
    defaultmessages: 'The application has been sent to the bank maker for approval',
  },
  application_sent_to_broker_for_approval: {
    id: 'application_sent_to_broker_for_approval',
    defaultmessages: 'The application has been sent to the broker for approval.',
  },
  application_sent_to_dmt_for_approval: {
    id: 'application_sent_to_dmt_for_approval',
    defaultmessages: 'We sent your application for DMT approval',
  },
  application_sent_to_municipality_gis_team: {
    id: 'application_sent_to_municipality_gis_team',
    defaultmessages: 'Your application will be sent to Municipality GIS team',
  },
  application_sent_to_owner_for_approval: {
    id: 'application_sent_to_owner_for_approval',
    defaultmessages: 'The application has been sent to the owner for approval.',
  },
  application_sent_to_owner_of_approval: {
    id: 'application_sent_to_owner_of_approval',
    defaultmessages: 'Your application has been sent to the other owners for approval',
  },
  application_sent_to_surveying_consultant: {
    id: 'application_sent_to_surveying_consultant',
    defaultmessages: 'Your application will be sent to the surveying consultant',
  },
  application_status: {
    id: 'application_status',
    defaultmessages: 'Application status',
  },
  application_steps: {
    id: 'application_steps',
    defaultmessages: 'Steps to apply',
  },
  application_steps_v2: {
    id: 'application_steps_v2',
    defaultmessages: 'Application steps',
  },
  application_submitted: {
    id: 'application_submitted',
    defaultmessages: 'Application submitted',
  },
  application_terminated: {
    id: 'application_terminated',
    defaultmessages: 'Application Terminated',
  },
  application_terminated_successful: {
    id: 'application_terminated_successful',
    defaultmessages: 'Application is cancelled successfully',
  },
  application_terminated_successfully: {
    id: 'application_terminated_successfully',
    defaultmessages: 'Your application has been terminated successfully ',
  },
  application_title: {
    id: 'application_title',
    defaultmessages: 'My applications',
  },
  application_to_bank_mortgage_registration: {
    id: 'application_to_bank_mortgage_registration',
    defaultmessages: 'The application has been sent to the bank for mortgage registration',
  },
  application_to_buyer_payment: {
    id: 'application_to_buyer_payment',
    defaultmessages: 'The application has been sent to the buyer for payment.',
  },
  application_type: {
    id: 'application_type',
    defaultmessages: 'Application type',
  },
  application_user_role: {
    id: 'application_user_role',
    defaultmessages: 'User Role',
  },
  apply: {
    id: 'apply',
    defaultmessages: 'Apply',
  },
  appointment: {
    id: 'appointment',
    defaultmessages: 'Appointment',
  },
  appointment_booking: {
    id: 'appointment_booking',
    defaultmessages: 'Appointment booking',
  },
  appointment_scheduled_for_signature_date_time: {
    id: 'appointment_scheduled_for_signature_date_time',
    defaultmessages: 'The appointment has been scheduled for the application signature on {date} at {time}',
  },
  appointment_scheduled_successfully: {
    id: 'appointment_scheduled_successfully',
    defaultmessages: 'Appointment scheduled successfully',
  },
  approval_from_back_office: {
    id: 'approval_from_back_office',
    defaultmessages: 'Approval from Back Office',
  },
  approve: {
    id: 'approve',
    defaultmessages: 'Approve',
  },
  approve_cancellation_text: {
    id: 'approve_cancellation_text',
    defaultmessages: 'We will send you a notification once the application is completed and signed.',
  },
  approve_cancellation_title: {
    id: 'approve_cancellation_title',
    defaultmessages: 'Your agreement is surrendered successfully',
  },
  approved_architectural_plans_building_permits: {
    id: 'approved_architectural_plans_building_permits',
    defaultmessages: 'Approved Architectural Plans (Building Permits)',
  },
  approved_architectural_plans_mandatory: {
    id: 'approved_architectural_plans_mandatory',
    defaultmessages: 'Approved Architectural Plans (Building Permits) (Mandatory)',
  },
  approved_caveat_instrument_mandatory: {
    id: 'approved_caveat_instrument_mandatory',
    defaultmessages: 'Approved Caveat Instrument (Mandatory)',
  },
  approved_musataha_contract_dmt_subtitle: {
    id: 'approved_musataha_contract_dmt_subtitle',
    defaultmessages: 'The application has been forwarded to the ADGM for approval',
  },
  approved_musataha_contract_subtitle: {
    id: 'approved_musataha_contract_subtitle',
    defaultmessages: 'The application has been forwarded to the Musateh for approval',
  },
  approved_musataha_contract_title: {
    id: 'approved_musataha_contract_title',
    defaultmessages: 'You have approved the Musataha agreement registration application',
  },
  approved_offplan_sale_agreement: {
    id: 'approved_offplan_sale_agreement',
    defaultmessages: 'You approved the off plan sale agreement!',
  },
  approver_feedback: {
    id: 'approver_feedback',
    defaultmessages: 'Approver Feedback',
  },
  approximate_time_to_submit: {
    id: 'approximate_time_to_submit',
    defaultmessages: 'Approximate time to complete',
  },
  ar: {
    id: 'ar',
    defaultmessages: 'العربيّة',
  },
  arabic: {
    id: 'arabic',
    defaultmessages: 'العربية',
  },
  architecture_drawings: {
    id: 'architecture_drawings',
    defaultmessages: 'Architecture drawings & Permits/ sellable area Plan',
  },
  are_you_sure: {
    id: 'are_you_sure',
    defaultmessages: 'Are you sure?',
  },
  are_you_sure_permit_will_be_exclusively_assigned_to_broker: {
    id: 'are_you_sure_permit_will_be_exclusively_assigned_to_broker',
    defaultmessages: 'Are you sure this permit will be exclusively assigned to the selected broker?',
  },
  are_you_sure_want_to_remove_building: {
    id: 'are_you_sure_want_to_remove_building',
    defaultmessages: 'Are you sure you want to remove all units under this building',
  },
  are_you_sure_you_want_to_remove_primary_contact: {
    id: 'are_you_sure_you_want_to_remove_primary_contact',
    defaultmessages: 'Are you sure you want to remove, {s} from your primary contact list?',
  },
  are_you_sure_you_want_to_remove_property: {
    id: 'are_you_sure_you_want_to_remove_property',
    defaultmessages: 'Are you sure you want to remove unit {s} from the selected properties?',
  },
  are_you_sure_you_want_to_terminate_pma_contract: {
    id: 'are_you_sure_you_want_to_terminate_pma_contract',
    defaultmessages: 'Are you sure you want to cancel the PMA agreement for this property',
  },
  area: {
    id: 'area',
    defaultmessages: 'Area',
  },
  area_of_expertise: {
    id: 'area_of_expertise',
    defaultmessages: 'Area of expertise',
  },
  area_size: {
    id: 'area_size',
    defaultmessages: 'Area size',
  },
  area_unit: {
    id: 'area_unit',
    defaultmessages: '{s} sqm',
  },
  area_usage: {
    id: 'area_usage',
    defaultmessages: 'Area usage',
  },
  as_of_date: {
    id: 'as_of_date',
    defaultmessages: 'As of date: {s}',
  },
  at_least_one_seller_should_have_selling_percentage_greater_than_zero: {
    id: 'at_least_one_seller_should_have_selling_percentage_greater_than_zero',
    defaultmessages: 'At least one seller must have a selling percentage greater than 0%.',
  },
  atleast_one_not_hundred: {
    id: 'atleast_one_not_hundred',
    defaultmessages: 'At least one buyer should have less than 100% as a mortgage share value\n',
  },
  atleast_one_not_hundred_selling_share: {
    id: 'atleast_one_not_hundred_selling_share',
    defaultmessages: 'At least one seller must have a selling share value of less than 100%.',
  },
  atleast_one_not_zero: {
    id: 'atleast_one_not_zero',
    defaultmessages: 'At least one buyer should have more than 0% as a mortgage percentage value!',
  },
  atleast_two_units_selected: {
    id: 'atleast_two_units_selected',
    defaultmessages: 'At least two units should be selected to continue.',
  },
  atleast_two_units_selected_to_continue: {
    id: 'atleast_two_units_selected_to_continue',
    defaultmessages:
      'You have selected less than 2 units and to continue with Multiple lease agreement select at least two units.',
  },
  attach_other_supporting_documents_if_required: {
    id: 'attach_other_supporting_documents_if_required',
    defaultmessages: 'Attach any additional supporting documents if needed.',
  },
  attached_response_document: {
    id: 'attached_response_document',
    defaultmessages: 'Attached Response Document',
  },
  attendee: {
    id: 'attendee',
    defaultmessages: 'Attendee',
  },
  auctioneer: {
    id: 'auctioneer',
    defaultmessages: 'Auctioneers',
  },
  auctioneer_company: {
    id: 'auctioneer_company',
    defaultmessages: 'Auctioneering Company',
  },
  auctioneer_employee: {
    id: 'auctioneer_employee',
    defaultmessages: 'Auctioneer Employee',
  },
  auditor_documents: {
    id: 'auditor_documents',
    defaultmessages: 'Auditor uploaded documents',
  },
  auditor_feedback: {
    id: 'auditor_feedback',
    defaultmessages: 'Auditor Feedback',
  },
  auditor_report: {
    id: 'auditor_report',
    defaultmessages: 'Auditor’s Report',
  },
  authenticated_document: {
    id: 'authenticated_document',
    defaultmessages: 'Document to be verified',
  },
  authorization_date: {
    id: 'authorization_date',
    defaultmessages: 'Authorization date',
  },
  authorization_no: {
    id: 'authorization_no',
    defaultmessages: 'Authorization no',
  },
  authorizations: {
    id: 'authorizations',
    defaultmessages: 'Authorizations',
  },
  authorizations_desc: {
    id: 'authorizations_desc',
    defaultmessages: 'Manage Authorizations',
  },
  authorized_bank_signatory_poa: {
    id: 'authorized_bank_signatory_poa',
    defaultmessages: 'Authorized Bank Signatory POA',
  },
  authorized_by: {
    id: 'authorized_by',
    defaultmessages: 'Authorized by',
  },
  auto_cancelled_reason_inactivity: {
    id: 'auto_cancelled_reason_inactivity',
    defaultmessages:
      "We've cancelled your application. It was automatically cancelled due to inactivity for more than 10 days.",
  },
  available_balance: {
    id: 'available_balance',
    defaultmessages: 'Available Balance',
  },
  available_escrow_balance: {
    id: 'available_escrow_balance',
    defaultmessages: 'Available escrow account balance',
  },
  average_price_methodology_statement: {
    id: 'average_price_methodology_statement',
    defaultmessages:
      'In the previous decade, Abu Dhabi’s real estate market witnessed considerable growth with the emergence of freehold areas, which have predominated performance trends. Notwithstanding, special-case transactions remain a common occurrence, as such, these outliers were filtered using both “hard-stop” methods – pertaining to the absolute values of registered transactions – as well as using “Z-score” analysis, whereby unrepresentative transactions (based on standard deviations from the mean) were excluded. The presented figures aim to illustrate predominant market sentiment, with median prices conveying the tendency towards particular price points in materialized transactions, and “observed” highs and lows conveying the high and low interquartile ranges.',
  },
  average_price_methodology_statement_title: {
    id: 'average_price_methodology_statement_title',
    defaultmessages: 'Average Price Calculation Methodology',
  },
  average_prices: {
    id: 'average_prices',
    defaultmessages: 'Average prices',
  },
  average_prices_in_abu_dhabi: {
    id: 'average_prices_in_abu_dhabi',
    defaultmessages: 'Average prices in Abu Dhabi city',
  },
  avg_avg_emirate_abu_dhabi_title: {
    id: 'avg_avg_emirate_abu_dhabi_title',
    defaultmessages: 'Average prices in emirate of Abu Dhabi',
  },
  avg_price_disclaimer_title: {
    id: 'avg_price_disclaimer_title',
    defaultmessages: 'Average Price Calculation Methodology',
  },
  axis_status: {
    id: 'axis_status',
    defaultmessages: 'Axis status',
  },
  back: {
    id: 'back',
    defaultmessages: 'Back',
  },
  back_to_applications: {
    id: 'back_to_applications',
    defaultmessages: 'Back to applications',
  },
  back_to_employee_management: {
    id: 'back_to_employee_management',
    defaultmessages: 'Back to employee management',
  },
  back_to_home: {
    id: 'back_to_home',
    defaultmessages: 'Home',
  },
  back_to_homepage: {
    id: 'back_to_homepage',
    defaultmessages: 'Back to Homepage',
  },
  back_to_login: {
    id: 'back_to_login',
    defaultmessages: 'Back to Login',
  },
  back_to_properties: {
    id: 'back_to_properties',
    defaultmessages: 'Back to Properties',
  },
  back_to_review: {
    id: 'back_to_review',
    defaultmessages: 'Back to review',
  },
  back_to_service_charges: {
    id: 'back_to_service_charges',
    defaultmessages: 'Back to service charges',
  },
  balance: {
    id: 'balance',
    defaultmessages: 'Balance',
  },
  balance_exclamation: {
    id: 'balance_exclamation',
    defaultmessages: 'Ending balance in escrow account + Ending balance in retention account',
  },
  balconies_area: {
    id: 'balconies_area',
    defaultmessages: 'Balconies area',
  },
  bank: {
    id: 'bank',
    defaultmessages: 'Bank',
  },
  bank_and_owner: {
    id: 'bank_and_owner',
    defaultmessages: 'Bank and property owner',
  },
  bank_and_pmc: {
    id: 'bank_and_pmc',
    defaultmessages: 'Bank and Property Management Company',
  },
  bank_approver: {
    id: 'bank_approver',
    defaultmessages: 'Bank approver',
  },
  bank_balance_sheet_last_7_days: {
    id: 'bank_balance_sheet_last_7_days',
    defaultmessages: 'Balance sheet from the bank to approve the payments, this document validity is 7 days',
  },
  bank_checker_return_with_feedback: {
    id: 'bank_checker_return_with_feedback',
    defaultmessages: 'Bank checker returned the application with feedback',
  },
  bank_checker_review_and_approves: {
    id: 'bank_checker_review_and_approves',
    defaultmessages: 'Bank Checker reviews and approves.',
  },
  bank_details: {
    id: 'bank_details',
    defaultmessages: 'Bank details',
  },
  bank_escrow_statement: {
    id: 'bank_escrow_statement',
    defaultmessages: 'Bank Escrow Statement',
  },
  bank_escrow_statement_mandatory_if_applicable: {
    id: 'bank_escrow_statement_mandatory_if_applicable',
    defaultmessages: 'Bank Escrow Statement (Mandatory) (if applicable)',
  },
  bank_letter: {
    id: 'bank_letter',
    defaultmessages: 'Bank letter',
  },
  bank_letter_for_the_current_balance_in_the_escrow_account: {
    id: 'bank_letter_for_the_current_balance_in_the_escrow_account',
    defaultmessages: 'Bank letter for the current balance in the escrow account',
  },
  bank_letter_showing_the_current_balance_escrow_account_mandatory_withindays: {
    id: 'bank_letter_showing_the_current_balance_escrow_account_mandatory_withindays',
    defaultmessages:
      'Bank letter indicating the current balance in the escrow account (required if the letter is dated within seven days of the application submission)',
  },
  bank_maker_checker_review_discharge_details: {
    id: 'bank_maker_checker_review_discharge_details',
    defaultmessages: 'Bank Maker and checker review the discharge details (If Applicable)',
  },
  bank_maker_checker_review_mortgage_details: {
    id: 'bank_maker_checker_review_mortgage_details',
    defaultmessages: 'Bank Maker and checker review the mortgage details',
  },
  bank_maker_documents: {
    id: 'bank_maker_documents',
    defaultmessages: 'Bank Maker Documents',
  },
  bank_maker_fill_all_mortgage_details: {
    id: 'bank_maker_fill_all_mortgage_details',
    defaultmessages: 'Bank Maker enters all mortgage details.',
  },
  bank_maker_fill_all_mrtgage_details: {
    id: 'bank_maker_fill_all_mrtgage_details',
    defaultmessages: 'Bank Maker fills all mortgage details.',
  },
  bank_maker_release_documents: {
    id: 'bank_maker_release_documents',
    defaultmessages: 'Bank Maker Release Documents',
  },
  bank_maker_return_with_feedback: {
    id: 'bank_maker_return_with_feedback',
    defaultmessages: 'Bank maker returned the application with feedback',
  },
  bank_maker_reviews_the_changes: {
    id: 'bank_maker_reviews_the_changes',
    defaultmessages: 'The Bank Maker reviews the changes',
  },
  bank_name: {
    id: 'bank_name',
    defaultmessages: 'Bank name',
  },
  bank_reference_number: {
    id: 'bank_reference_number',
    defaultmessages: 'Bank Reference Number',
  },
  bank_signatory: {
    id: 'bank_signatory',
    defaultmessages: 'Bank signatory',
  },
  bank_signatory_details_poa: {
    id: 'bank_signatory_details_poa',
    defaultmessages: 'Bank Signatory Details (POA)',
  },
  bank_signatory_details_poa_discharge: {
    id: 'bank_signatory_details_poa_discharge',
    defaultmessages: 'Bank Signatory Details (Discharge POA)',
  },
  bank_transfer: {
    id: 'bank_transfer',
    defaultmessages: 'Bank transfer',
  },
  bank_transfer_document: {
    id: 'bank_transfer_document',
    defaultmessages: 'Bank transfer document',
  },
  bank_transfer_proof: {
    id: 'bank_transfer_proof',
    defaultmessages: 'Bank Transfer Proof',
  },
  banking_license_mandatory: {
    id: 'banking_license_mandatory',
    defaultmessages: 'Banking License (Mandatory)',
  },
  bathroom: {
    id: 'bathroom',
    defaultmessages: 'Bathrooms',
  },
  bathrooms: {
    id: 'bathrooms',
    defaultmessages: 'Bathrooms',
  },
  because_you_have_mortgaged_plots_only_pdf_file_is_supported: {
    id: 'because_you_have_mortgaged_plots_only_pdf_file_is_supported',
    defaultmessages: 'Because you have mortgaged plots. Only PDF file is supported',
  },
  become_a_partner: {
    id: 'become_a_partner',
    defaultmessages: 'Become a partner',
  },
  bedroom: {
    id: 'bedroom',
    defaultmessages: 'Bedroom',
  },
  bedrooms: {
    id: 'bedrooms',
    defaultmessages: 'Bedrooms',
  },
  bedrooms_number: {
    id: 'bedrooms_number',
    defaultmessages: '# of bedrooms',
  },
  beneficiary: {
    id: 'beneficiary',
    defaultmessages: 'Beneficiary',
  },
  blocked: {
    id: 'blocked',
    defaultmessages: 'Blocked',
  },
  blocklist: {
    id: 'blocklist',
    defaultmessages: 'Unavailable Unit(s) List',
  },
  blocks: {
    id: 'blocks',
    defaultmessages: 'Blocks',
  },
  blocks_list: {
    id: 'blocks_list',
    defaultmessages: 'Blocks list',
  },
  book_an_appointment: {
    id: 'book_an_appointment',
    defaultmessages: 'Book an appointment',
  },
  book_now: {
    id: 'book_now',
    defaultmessages: 'Book Now',
  },
  branch: {
    id: 'branch',
    defaultmessages: 'Branch',
  },
  branch_name: {
    id: 'branch_name',
    defaultmessages: 'Branch name',
  },
  brief_description: {
    id: 'brief_description',
    defaultmessages: 'Brief description of your feedback',
  },
  broker: {
    id: 'broker',
    defaultmessages: 'Broker',
  },
  'broker-individual': {
    id: 'broker-individual',
    defaultmessages: 'Broker Company',
  },
  'broker-permit': {
    id: 'broker-permit',
    defaultmessages: 'Broker Property Advertising Permit',
  },
  broker_details: {
    id: 'broker_details',
    defaultmessages: 'Broker Details',
  },
  broker_exclusivity: {
    id: 'broker_exclusivity',
    defaultmessages: 'Broker exclusivity',
  },
  broker_name_arabic: {
    id: 'broker_name_arabic',
    defaultmessages: 'Broker Name (Arabic)',
  },
  broker_name_english: {
    id: 'broker_name_english',
    defaultmessages: 'Broker Name (English)',
  },
  brokerage_contract_no: {
    id: 'brokerage_contract_no',
    defaultmessages: 'Brokerage agreement no',
  },
  browse_directory: {
    id: 'browse_directory',
    defaultmessages: 'Browse directory',
  },
  building: {
    id: 'building',
    defaultmessages: 'Building',
  },
  building_completion_certificate: {
    id: 'building_completion_certificate',
    defaultmessages: 'Building Completion Certificate — BCC (Mandatory)',
  },
  building_completion_certificate_bcc_mandatory: {
    id: 'building_completion_certificate_bcc_mandatory',
    defaultmessages: 'Building Completion Certificate (BCC) (Mandatory)',
  },
  building_details: {
    id: 'building_details',
    defaultmessages: 'Building details',
  },
  building_name: {
    id: 'building_name',
    defaultmessages: 'Building name',
  },
  building_name_number: {
    id: 'building_name_number',
    defaultmessages: 'Building number',
  },
  building_num: {
    id: 'building_num',
    defaultmessages: 'Building no.',
  },
  building_pictures: {
    id: 'building_pictures',
    defaultmessages: 'Building Pictures',
  },
  building_ref_number: {
    id: 'building_ref_number',
    defaultmessages: 'Building reference number',
  },
  building_reg_number: {
    id: 'building_reg_number',
    defaultmessages: 'Building reg. number',
  },
  building_registration_fee_paid_by_developer: {
    id: 'building_registration_fee_paid_by_developer',
    defaultmessages: 'Building registration fees paid by the developer',
  },
  building_registration_number_name: {
    id: 'building_registration_number_name',
    defaultmessages: 'Building Registration Number',
  },
  building_registration_number_plc: {
    id: 'building_registration_number_plc',
    defaultmessages: 'Enter Building Registration Number',
  },
  building_usage: {
    id: 'building_usage',
    defaultmessages: 'Building usage',
  },
  burden_and_benefit: {
    id: 'burden_and_benefit',
    defaultmessages: 'Burden and Benefits',
  },
  button: {
    id: 'button',
    defaultmessages: 'Go to landing page',
  },
  buy_and_sell_unit_plot: {
    id: 'buy_and_sell_unit_plot',
    defaultmessages: 'Buy and Sell (Unit/ Plot)',
  },
  buy_sell: {
    id: 'buy_sell',
    defaultmessages: 'Buy & Sell',
  },
  buy_sell_agreement_mandatory: {
    id: 'buy_sell_agreement_mandatory',
    defaultmessages: 'Buy & Sell Agreement (Mandatory)',
  },
  buyer: {
    id: 'buyer',
    defaultmessages: 'Buyer',
  },
  'buyer_#num': {
    id: 'buyer_#num',
    defaultmessages: 'Buyer #{num}',
  },
  buyer_account_number: {
    id: 'buyer_account_number',
    defaultmessages: 'Buyer account number',
  },
  buyer_attende_list: {
    id: 'buyer_attende_list',
    defaultmessages: 'Buyer’s Attendees list',
  },
  buyer_bank: {
    id: 'buyer_bank',
    defaultmessages: 'Buyer bank',
  },
  buyer_bank_country: {
    id: 'buyer_bank_country',
    defaultmessages: 'Buyer bank country',
  },
  buyer_bank_details: {
    id: 'buyer_bank_details',
    defaultmessages: 'Buyer bank details',
  },
  buyer_bank_details_buyer_name: {
    id: 'buyer_bank_details_buyer_name',
    defaultmessages: '#{num} Buyer bank details ({buyerName})',
  },
  buyer_bank_name: {
    id: 'buyer_bank_name',
    defaultmessages: 'Buyer Bank Name',
  },
  buyer_detail: {
    id: 'buyer_detail',
    defaultmessages: "Buyer's details",
  },
  buyer_documents: {
    id: 'buyer_documents',
    defaultmessages: 'buyer documents',
  },
  buyer_expired_passport: {
    id: 'buyer_expired_passport',
    defaultmessages: 'The buyer you are trying to add has an expired passport, Please make sure  buyer info is updated',
  },
  buyer_iban_letter: {
    id: 'buyer_iban_letter',
    defaultmessages: 'Buyer IBAN letter',
  },
  buyer_iban_letter_mandatory_if_applicable: {
    id: 'buyer_iban_letter_mandatory_if_applicable',
    defaultmessages: 'Buyer IBAN letter (Mandatory) (if applicable)',
  },
  buyer_iban_letter_number_name: {
    id: 'buyer_iban_letter_number_name',
    defaultmessages: '#{number} Buyer IBAN letter ({name})',
  },
  buyer_iban_or_swift: {
    id: 'buyer_iban_or_swift',
    defaultmessages: 'Buyer IBAN',
  },
  buyer_list: {
    id: 'buyer_list',
    defaultmessages: 'Buyers list',
  },
  buyer_mortgage_shares: {
    id: 'buyer_mortgage_shares',
    defaultmessages: 'Buyer mortgage shares',
  },
  buyer_name: {
    id: 'buyer_name',
    defaultmessages: 'Buyer Name',
  },
  buyer_not_selected_yet: {
    id: 'buyer_not_selected_yet',
    defaultmessages: 'You haven’t selected any buyer yet',
  },
  buyer_num: {
    id: 'buyer_num',
    defaultmessages: 'Buyer #{num}',
  },
  buyer_returned_application_with_feedback: {
    id: 'buyer_returned_application_with_feedback',
    defaultmessages: 'Buyer returned the application with feedback.',
  },
  buyer_s_details: {
    id: 'buyer_s_details',
    defaultmessages: "Buyer's details",
  },
  buyer_served_with_two_legal_notice_for_nonpayment: {
    id: 'buyer_served_with_two_legal_notice_for_nonpayment',
    defaultmessages: 'The Buyer has been served with two legal notice for non-payment',
  },
  buyers: {
    id: 'buyers',
    defaultmessages: 'Buyers',
  },
  buyers_bank_details: {
    id: 'buyers_bank_details',
    defaultmessages: 'Buyer’s bank details',
  },
  buyers_details: {
    id: 'buyers_details',
    defaultmessages: 'Buyer’s  details',
  },
  buying_percentage: {
    id: 'buying_percentage',
    defaultmessages: 'Buying percentage',
  },
  by: {
    id: 'by',
    defaultmessages: 'By',
  },
  calculate_fee: {
    id: 'calculate_fee',
    defaultmessages: 'Calculate fee',
  },
  calculate_fees: {
    id: 'calculate_fees',
    defaultmessages: 'Calculate Fees',
  },
  call: {
    id: 'call',
    defaultmessages: 'Call',
  },
  call_centre: {
    id: 'call_centre',
    defaultmessages: 'Call center',
  },
  cancel: {
    id: 'cancel',
    defaultmessages: 'Cancel',
  },
  'cancel application': {
    id: 'cancel application',
    defaultmessages: 'Cancel application?',
  },
  cancel_agreement: {
    id: 'cancel_agreement',
    defaultmessages: 'Cancel Agreement',
  },
  cancel_application: {
    id: 'cancel_application',
    defaultmessages: 'Cancel Application',
  },
  cancel_application_content: {
    id: 'cancel_application_content',
    defaultmessages: 'Are you sure you want to cancel application?',
  },
  cancel_contract: {
    id: 'cancel_contract',
    defaultmessages: 'Surrender agreement',
  },
  cancel_contract_popup_alert_message: {
    id: 'cancel_contract_popup_alert_message',
    defaultmessages: 'The next agreement you would like to issue should be on the same day of Surrender or after.',
  },
  cancel_tenancy_contract: {
    id: 'cancel_tenancy_contract',
    defaultmessages: 'Surrender lease agreement',
  },
  canceled_signing_process: {
    id: 'canceled_signing_process',
    defaultmessages: 'User cancelled the login',
  },
  cancellation_sucess_tooltip: {
    id: 'cancellation_sucess_tooltip',
    defaultmessages: 'Your lessee has accepted the lease Surrender agreement',
  },
  cancelled: {
    id: 'cancelled',
    defaultmessages: 'Surrendered',
  },
  cant_initiate_service: {
    id: 'cant_initiate_service',
    defaultmessages: 'You cant initiate any service on this property',
  },
  cases: {
    id: 'cases',
    defaultmessages: 'Disputes',
  },
  cash_delivery_agreement: {
    id: 'cash_delivery_agreement',
    defaultmessages: 'Cash',
  },
  cash_delivery_agreement_document: {
    id: 'cash_delivery_agreement_document',
    defaultmessages: 'Cash delivery agreement document',
  },
  category: {
    id: 'category',
    defaultmessages: 'Category',
  },
  caveats_number: {
    id: 'caveats_number',
    defaultmessages: 'Caveat Number',
  },
  certificate: {
    id: 'certificate',
    defaultmessages: 'Certificates',
  },
  certificate_being_generated: {
    id: 'certificate_being_generated',
    defaultmessages: 'Your certificate is being generated.',
  },
  certificate_date: {
    id: 'certificate_date',
    defaultmessages: 'Certificate Date',
  },
  certificate_is_being_generated_msg: {
    id: 'certificate_is_being_generated_msg',
    defaultmessages:
      'The certificate is currently being generated and will be ready within 5 to 10 minutes. Please check your application again shortly to download your certificate once it becomes available.',
  },
  certificate_number: {
    id: 'certificate_number',
    defaultmessages: 'Certificate Number',
  },
  certificate_timeout_error_message: {
    id: 'certificate_timeout_error_message',
    defaultmessages: 'Your request has been approved and your certificate will be generated within 15 minutes',
  },
  certificate_type: {
    id: 'certificate_type',
    defaultmessages: 'Certificate type',
  },
  certificates_desc: {
    id: 'certificates_desc',
    defaultmessages: 'Get the certificates related to your property',
  },
  certified: {
    id: 'certified',
    defaultmessages: 'Certified',
  },
  change: {
    id: 'change',
    defaultmessages: 'Change',
  },
  change_in_duration_fee: {
    id: 'change_in_duration_fee',
    defaultmessages: 'Change in Duration Fees',
  },
  change_in_mortgage_degree: {
    id: 'change_in_mortgage_degree',
    defaultmessages: 'Change in Mortgage Degree',
  },
  change_in_mortgage_degree_AED: {
    id: 'change_in_mortgage_degree_AED',
    defaultmessages: 'Change in Mortgage Degree: 100 AED',
  },
  change_in_mortgage_duration_AED: {
    id: 'change_in_mortgage_duration_AED',
    defaultmessages: 'Change in Mortgage Duration: 1000 AED',
  },
  change_in_mortgage_duration_fee: {
    id: 'change_in_mortgage_duration_fee',
    defaultmessages: 'Mortgage Duration Change Fee',
  },
  change_in_mortgage_terms_and_conditions_AED: {
    id: 'change_in_mortgage_terms_and_conditions_AED',
    defaultmessages: 'Change in Mortgage Terms & Conditions: 200 AED',
  },
  change_in_mortgage_terms_conditions_fee: {
    id: 'change_in_mortgage_terms_conditions_fee',
    defaultmessages: 'Change in Mortgage Terms & Conditions Fee',
  },
  change_in_terms_and_conditions_AED: {
    id: 'change_in_terms_and_conditions_AED',
    defaultmessages: 'Change in Terms & Conditions: 100 AED',
  },
  change_in_terms_conditions_fee: {
    id: 'change_in_terms_conditions_fee',
    defaultmessages: 'Change in Terms & Conditions Fees',
  },
  changes_saved_successfully: {
    id: 'changes_saved_successfully',
    defaultmessages: 'changes are saved successfully',
  },
  chat_with_dari: {
    id: 'chat_with_dari',
    defaultmessages: 'Chat with Dari',
  },
  check_all: {
    id: 'check_all',
    defaultmessages: 'Check all',
  },
  check_list_here: {
    id: 'check_list_here',
    defaultmessages: 'Check list here',
  },
  check_now: {
    id: 'check_now',
    defaultmessages: 'Check Now',
  },
  check_validity: {
    id: 'check_validity',
    defaultmessages: 'Check validity',
  },
  check_your_tasks: {
    id: 'check_your_tasks',
    defaultmessages: 'Check out your tasks & notifications',
  },
  checkout: {
    id: 'checkout',
    defaultmessages: 'Checkout',
  },
  cheque: {
    id: 'cheque',
    defaultmessages: 'Cheque',
  },
  cheque_document: {
    id: 'cheque_document',
    defaultmessages: 'Cheque document',
  },
  choose_appointment_type_for_verification_attendance: {
    id: 'choose_appointment_type_for_verification_attendance',
    defaultmessages: 'Choose the appointment type for Verification attendance.',
  },
  choose_date: {
    id: 'choose_date',
    defaultmessages: 'Choose date',
  },
  choose_municipality: {
    id: 'choose_municipality',
    defaultmessages: 'Choose municipality',
  },
  choose_option: {
    id: 'choose_option',
    defaultmessages: 'Choose option',
  },
  choose_party: {
    id: 'choose_party',
    defaultmessages: 'Choose the agreement parties',
  },
  choose_preferred_time_slot: {
    id: 'choose_preferred_time_slot',
    defaultmessages: 'Choose preferred time slot ',
  },
  choose_righthold_type: {
    id: 'choose_righthold_type',
    defaultmessages: 'Choose right hold type',
  },
  choose_termination_cause: {
    id: 'choose_termination_cause',
    defaultmessages: 'Choose the cause of termination',
  },
  citizen_resident: {
    id: 'citizen_resident',
    defaultmessages: 'Citizen / Resident',
  },
  claim_value: {
    id: 'claim_value',
    defaultmessages: 'Claim value (AED)',
  },
  claim_value_: {
    id: 'claim_value_',
    defaultmessages: 'Claim value',
  },
  classification: {
    id: 'classification',
    defaultmessages: 'Classification',
  },
  clear: {
    id: 'clear',
    defaultmessages: 'Clear',
  },
  clear_all: {
    id: 'clear_all',
    defaultmessages: 'Clear all',
  },
  clear_all_plots: {
    id: 'clear_all_plots',
    defaultmessages: 'Clear all plots',
  },
  clear_all_plots_text: {
    id: 'clear_all_plots_text',
    defaultmessages: 'Are you sure to clear all imported plots from the project?',
  },
  clear_all_properties: {
    id: 'clear_all_properties',
    defaultmessages: 'Are you sure you want to remove all selected properties?',
  },
  clear_all_selections: {
    id: 'clear_all_selections',
    defaultmessages: 'Clear all selections',
  },
  clear_properties: {
    id: 'clear_properties',
    defaultmessages: 'Clear all properties',
  },
  clear_sub_lease_dependencies_on_cancellation: {
    id: 'clear_sub_lease_dependencies_on_cancellation',
    defaultmessages: 'Ensure all sub-lease dependencies are cleared before surrendering or terminating the agreement.',
  },
  click_here: {
    id: 'click_here',
    defaultmessages: 'Click here',
  },
  close: {
    id: 'close',
    defaultmessages: 'Close',
  },
  closed: {
    id: 'closed',
    defaultmessages: 'Closed',
  },
  closure_of_tenancy_forwarded_to_tenant: {
    id: 'closure_of_tenancy_forwarded_to_tenant',
    defaultmessages:
      'Your expiration application for lease agreement has been forwarded successfully to the lessee for approval',
  },
  cn: {
    id: 'cn',
    defaultmessages: 'CN',
  },
  comapny_submit_success: {
    id: 'comapny_submit_success',
    defaultmessages: 'You have submitted Registration of company application successfully',
  },
  commercial: {
    id: 'commercial',
    defaultmessages: 'Commercial',
  },
  commercial_AED_amount: {
    id: 'commercial_AED_amount',
    defaultmessages: 'Commercial: AED 5,000',
  },
  commercial_breakdown: {
    id: 'commercial_breakdown',
    defaultmessages: 'Commercial breakdown',
  },
  commercial_license: {
    id: 'commercial_license',
    defaultmessages: 'Commercial License',
  },
  commercial_license_mandatory: {
    id: 'commercial_license_mandatory',
    defaultmessages: 'Commercial License (Mandatory)',
  },
  commercial_license_no: {
    id: 'commercial_license_no',
    defaultmessages: 'Commercial License Number',
  },
  commercial_license_number_not_exists: {
    id: 'commercial_license_number_not_exists',
    defaultmessages: 'Commercial license number does not exist',
  },
  commercial_license_number_to_fetch: {
    id: 'commercial_license_number_to_fetch',
    defaultmessages: "Enter the commercial license number to fetch the company's details",
  },
  commission_percentage: {
    id: 'commission_percentage',
    defaultmessages: 'Commission percentage',
  },
  common_module: {
    id: 'common_module',
    defaultmessages: 'Main Module',
  },
  community: {
    id: 'community',
    defaultmessages: 'Community',
  },
  company: {
    id: 'company',
    defaultmessages: 'Company',
  },
  company_Name: {
    id: 'company_Name',
    defaultmessages: 'Company Name',
  },
  company_acknowledgement: {
    id: 'company_acknowledgement',
    defaultmessages: 'Company Acknowledgment',
  },
  company_acknowledgement_letter: {
    id: 'company_acknowledgement_letter',
    defaultmessages: 'Company Acknowledgment Letter',
  },
  company_activity: {
    id: 'company_activity',
    defaultmessages: 'Company Activity',
  },
  'company_activity(ies)': {
    id: 'company_activity(ies)',
    defaultmessages: 'Company activity(ies)',
  },
  company_address: {
    id: 'company_address',
    defaultmessages: 'Company Address',
  },
  company_admin_dmt_approval: {
    id: 'company_admin_dmt_approval',
    defaultmessages: 'Your application to assign a company admin has been sent to the Municipality for approval.',
  },
  company_already_exists: {
    id: 'company_already_exists',
    defaultmessages: 'Company already exists',
  },
  company_already_exists_but_no_users_registered: {
    id: 'company_already_exists_but_no_users_registered',
    defaultmessages: 'This company already exists but it has no users registered',
  },
  company_already_registered: {
    id: 'company_already_registered',
    defaultmessages: 'Company already registered on ADGM',
  },
  company_details: {
    id: 'company_details',
    defaultmessages: 'Company details',
  },
  company_email: {
    id: 'company_email',
    defaultmessages: 'Company email',
  },
  company_email_hint: {
    id: 'company_email_hint',
    defaultmessages: 'Your company email address will be used for official communication purposes only.',
  },
  company_employees: {
    id: 'company_employees',
    defaultmessages: 'Company employees',
  },
  company_fax: {
    id: 'company_fax',
    defaultmessages: 'Company Fax',
  },
  company_homepage: {
    id: 'company_homepage',
    defaultmessages: 'Company',
  },
  company_info: {
    id: 'company_info',
    defaultmessages: 'Company information',
  },
  company_information: {
    id: 'company_information',
    defaultmessages: 'Company information',
  },
  company_landline: {
    id: 'company_landline',
    defaultmessages: 'Company Landline',
  },
  company_management_desc: {
    id: 'company_management_desc',
    defaultmessages: 'Manage Your Company',
  },
  company_mobile_number: {
    id: 'company_mobile_number',
    defaultmessages: 'Company Contact Number',
  },
  company_name: {
    id: 'company_name',
    defaultmessages: 'Company name',
  },
  company_name_arabic: {
    id: 'company_name_arabic',
    defaultmessages: 'Company name (Arabic)',
  },
  company_name_arabic_hint: {
    id: 'company_name_arabic_hint',
    defaultmessages: 'Company name in Arabic',
  },
  company_name_english: {
    id: 'company_name_english',
    defaultmessages: 'Company name (English)',
  },
  company_name_english_hint: {
    id: 'company_name_english_hint',
    defaultmessages: 'Company name in English',
  },
  company_name_hint: {
    id: 'company_name_hint',
    defaultmessages: 'e.g., Homes Agency',
  },
  company_num: {
    id: 'company_num',
    defaultmessages: 'Company #{s}',
  },
  company_number: {
    id: 'company_number',
    defaultmessages: 'Company number',
  },
  company_number_hint: {
    id: 'company_number_hint',
    defaultmessages: 'Your company phone number is provided for official communication purposes only.',
  },
  company_origin: {
    id: 'company_origin',
    defaultmessages: 'Company country of origin',
  },
  company_phone: {
    id: 'company_phone',
    defaultmessages: 'Company phone',
  },
  company_profession: {
    id: 'company_profession',
    defaultmessages: 'Company profession',
  },
  company_profession_license_no: {
    id: 'company_profession_license_no',
    defaultmessages: 'Company profession license number',
  },
  company_profile: {
    id: 'company_profile',
    defaultmessages: 'Company profile',
  },
  company_profile_title: {
    id: 'company_profile_title',
    defaultmessages: 'This information is retrieved and cannot be edited',
  },
  company_representative_info: {
    id: 'company_representative_info',
    defaultmessages: 'In order to proceed, Adding representative is mandatory for this company',
  },
  company_trade_license_eg: {
    id: 'company_trade_license_eg',
    defaultmessages: 'Ex. TC124124',
  },
  company_type: {
    id: 'company_type',
    defaultmessages: 'Company type',
  },
  complaint: {
    id: 'complaint',
    defaultmessages: 'Complaint',
  },
  complaint_number: {
    id: 'complaint_number',
    defaultmessages: 'Complaint number',
  },
  complete: {
    id: 'complete',
    defaultmessages: 'Complete',
  },
  complete_the_payment: {
    id: 'complete_the_payment',
    defaultmessages: 'Complete the Payment',
  },
  complete_this_form_to_send_us_inquiry: {
    id: 'complete_this_form_to_send_us_inquiry',
    defaultmessages: 'Complete this form to send us your inquiry',
  },
  completed_project_status_tooltip_message: {
    id: 'completed_project_status_tooltip_message',
    defaultmessages: 'Projects registered with an escrow account',
  },
  completed_projects: {
    id: 'completed_projects',
    defaultmessages: 'Completed Projects',
  },
  completed_the_seller_payment: {
    id: 'completed_the_seller_payment',
    defaultmessages: 'You have successfully completed the seller payment',
  },
  completion: {
    id: 'completion',
    defaultmessages: 'Completion rate',
  },
  completion_listing: {
    id: 'completion_listing',
    defaultmessages: 'Completion',
  },
  completion_percentage: {
    id: 'completion_percentage',
    defaultmessages: 'Completion Percentage',
  },
  compliance_report: {
    id: 'compliance_report',
    defaultmessages: 'Compliance Report',
  },
  conceded_case_approved_title: {
    id: 'conceded_case_approved_title',
    defaultmessages: 'You have successfully approved the concession',
  },
  conceded_case_returned_title: {
    id: 'conceded_case_returned_title',
    defaultmessages: 'You have successfully returned the concession decision',
  },
  condition_num: {
    id: 'condition_num',
    defaultmessages: 'Condition {s}',
  },
  confirm: {
    id: 'confirm',
    defaultmessages: 'Confirm',
  },
  confirm_Otp: {
    id: 'confirm_Otp',
    defaultmessages: 'Confirm OTP',
  },
  congratulations_you_have_been_assigned_as_pma: {
    id: 'congratulations_you_have_been_assigned_as_pma',
    defaultmessages: 'Congratulations! Your PMA has been successfully activated.',
  },
  congratulations_you_have_renewed_your_pma: {
    id: 'congratulations_you_have_renewed_your_pma',
    defaultmessages: 'Congratulations You have renewed your PMA',
  },
  conract_share_percentage: {
    id: 'conract_share_percentage',
    defaultmessages: 'Agreement share percentage',
  },
  consent_from_other_parties: {
    id: 'consent_from_other_parties',
    defaultmessages: 'Consent from Other Parties',
  },
  consent_from_other_parties_if_applicable: {
    id: 'consent_from_other_parties_if_applicable',
    defaultmessages: 'Consent from Other Parties (if applicable)',
  },
  constitutional_documents_articles_of_association: {
    id: 'constitutional_documents_articles_of_association',
    defaultmessages: 'Constitutional documents (e.g., Articles of Association)',
  },
  constructed: {
    id: 'constructed',
    defaultmessages: 'Constructed',
  },
  construction_cost: {
    id: 'construction_cost',
    defaultmessages: 'Construction cost',
  },
  construction_cost_exclamation: {
    id: 'construction_cost_exclamation',
    defaultmessages: 'Total construction cost of the project',
  },
  construction_date: {
    id: 'construction_date',
    defaultmessages: 'Construction date',
  },
  construction_on_land: {
    id: 'construction_on_land',
    defaultmessages: 'Construction on land',
  },
  construction_project_plan: {
    id: 'construction_project_plan',
    defaultmessages: 'Construction project plan',
  },
  construction_status: {
    id: 'construction_status',
    defaultmessages: 'Construction status',
  },
  contact: {
    id: 'contact',
    defaultmessages: 'Contact',
  },
  contact_details: {
    id: 'contact_details',
    defaultmessages: 'Contact details',
  },
  contact_information: {
    id: 'contact_information',
    defaultmessages: 'Contact Information',
  },
  contact_us_now: {
    id: 'contact_us_now',
    defaultmessages: 'Contact us now',
  },
  continue: {
    id: 'continue',
    defaultmessages: 'Continue',
  },
  continue_application: {
    id: 'continue_application',
    defaultmessages: 'Continue application',
  },
  continue_without_mortgage_registration: {
    id: 'continue_without_mortgage_registration',
    defaultmessages: 'Continue without mortgage registration',
  },
  contract: {
    id: 'contract',
    defaultmessages: 'Agreement',
  },
  contract_active: {
    id: 'contract_active',
    defaultmessages: 'The lease agreement is active and verified.',
  },
  contract_amount: {
    id: 'contract_amount',
    defaultmessages: 'Agreement amount',
  },
  contract_amount_percentage_content: {
    id: 'contract_amount_percentage_content',
    defaultmessages: 'Agreement rate is the charge rate agreed on between both parties',
  },
  contract_cancelation_date: {
    id: 'contract_cancelation_date',
    defaultmessages: 'Agreement Surrender date',
  },
  contract_cancellation: {
    id: 'contract_cancellation',
    defaultmessages: 'Surrender agreement',
  },
  contract_cancellation_btn: {
    id: 'contract_cancellation_btn',
    defaultmessages: 'Surrender lease agreement',
  },
  contract_cancellation_successful_sent_to_owner_content: {
    id: 'contract_cancellation_successful_sent_to_owner_content',
    defaultmessages: 'We will notify the owner with your response',
  },
  contract_cancellation_tenant_text: {
    id: 'contract_cancellation_tenant_text',
    defaultmessages: 'Are you sure you want to accept the agreement Surrender for this property?',
  },
  contract_cancellation_tenant_title: {
    id: 'contract_cancellation_tenant_title',
    defaultmessages: 'Agreement Surrender',
  },
  contract_cancellation_text: {
    id: 'contract_cancellation_text',
    defaultmessages: 'Are you sure you want to cancel the agreement for this property?',
  },
  contract_cancellation_title: {
    id: 'contract_cancellation_title',
    defaultmessages: 'Surrender agreement?',
  },
  contract_cancelled: {
    id: 'contract_cancelled',
    defaultmessages: 'The lease agreement is surrendered.',
  },
  contract_classifications_type: {
    id: 'contract_classifications_type',
    defaultmessages: 'Agreement classification type',
  },
  contract_closed: {
    id: 'contract_closed',
    defaultmessages: 'The lease agreement is closed.',
  },
  contract_closure: {
    id: 'contract_closure',
    defaultmessages: 'Expire agreement',
  },
  contract_closure_btn: {
    id: 'contract_closure_btn',
    defaultmessages: 'Expire lease agreement',
  },
  contract_closure_sent: {
    id: 'contract_closure_sent',
    defaultmessages: 'Your lease agreement expiration application has been successfully submitted for approval.',
  },
  contract_date: {
    id: 'contract_date',
    defaultmessages: 'Agreement date',
  },
  contract_details: {
    id: 'contract_details',
    defaultmessages: 'Agreement details',
  },
  contract_end_date: {
    id: 'contract_end_date',
    defaultmessages: 'Agreement end date',
  },
  contract_end_date_desc: {
    id: 'contract_end_date_desc',
    defaultmessages: 'The agreement period should be at least 3 months',
  },
  contract_expired: {
    id: 'contract_expired',
    defaultmessages: 'The lease agreement is expired.',
  },
  contract_has_been_terminated_successfully: {
    id: 'contract_has_been_terminated_successfully',
    defaultmessages: 'The off-plan buy and sell agreement has been terminated successfully',
  },
  contract_id: {
    id: 'contract_id',
    defaultmessages: 'Agreement ID',
  },
  contract_length: {
    id: 'contract_length',
    defaultmessages: 'Agreement length',
  },
  contract_length_with_grace_period: {
    id: 'contract_length_with_grace_period',
    defaultmessages: 'Agreement length (with grace period)',
  },
  contract_must_be_greater_than_12_months: {
    id: 'contract_must_be_greater_than_12_months',
    defaultmessages: 'Agreement duration must be greater than 12 months',
  },
  contract_must_be_greater_than_1_month: {
    id: 'contract_must_be_greater_than_1_month',
    defaultmessages: 'Agreement must be greater than 1 month',
  },
  contract_no: {
    id: 'contract_no',
    defaultmessages: 'Agreement No',
  },
  contract_no_required: {
    id: 'contract_no_required',
    defaultmessages: 'Agreement number is required',
  },
  contract_num: {
    id: 'contract_num',
    defaultmessages: 'Agreement {number}',
  },
  contract_number: {
    id: 'contract_number',
    defaultmessages: 'Agreement number',
  },
  contract_period: {
    id: 'contract_period',
    defaultmessages: 'Agreement period',
  },
  contract_registration_date: {
    id: 'contract_registration_date',
    defaultmessages: 'Agreement registration date',
  },
  contract_registration_fee: {
    id: 'contract_registration_fee',
    defaultmessages: 'Agreement registration fee',
  },
  contract_rejection_buyer: {
    id: 'contract_rejection_buyer',
    defaultmessages: 'Buyer has returned the agreement',
  },
  contract_rejection_seller: {
    id: 'contract_rejection_seller',
    defaultmessages: 'Seller has returned the agreement',
  },
  contract_remaining_amount: {
    id: 'contract_remaining_amount',
    defaultmessages: 'Agreement remaining amount',
  },
  contract_returned: {
    id: 'contract_returned',
    defaultmessages: 'Agreement returned',
  },
  contract_returned_content: {
    id: 'contract_returned_content',
    defaultmessages: 'Your return of the application has been forwarded to the initiator with feedback',
  },
  contract_returned_successfully: {
    id: 'contract_returned_successfully',
    defaultmessages: 'Your application has been returned successfully to the initiator',
  },
  contract_shares_percentage: {
    id: 'contract_shares_percentage',
    defaultmessages: 'Agreement shares percentage',
  },
  contract_start_date: {
    id: 'contract_start_date',
    defaultmessages: 'Agreement start date',
  },
  contract_status: {
    id: 'contract_status',
    defaultmessages: 'Agreement status',
  },
  contract_terminate: {
    id: 'contract_terminate',
    defaultmessages: 'The lease agreement is terminated',
  },
  contract_termination_date: {
    id: 'contract_termination_date',
    defaultmessages: 'Agreement termination date',
  },
  contract_termination_title: {
    id: 'contract_termination_title',
    defaultmessages: 'Your application with the lessee has been terminated',
  },
  contract_type: {
    id: 'contract_type',
    defaultmessages: 'Agreement type',
  },
  contract_value: {
    id: 'contract_value',
    defaultmessages: 'Agreement value',
  },
  contracts: {
    id: 'contracts',
    defaultmessages: 'Agreements',
  },
  controller_court_letter: {
    id: 'controller_court_letter',
    defaultmessages: 'Controller court letter',
  },
  copied: {
    id: 'copied',
    defaultmessages: 'Copied',
  },
  copy: {
    id: 'copy',
    defaultmessages: 'Copy',
  },
  copy_of_developers_valid_license: {
    id: 'copy_of_developers_valid_license',
    defaultmessages: 'Copy of Developer’s valid license',
  },
  country: {
    id: 'country',
    defaultmessages: 'Country',
  },
  cour_order_mandatory_if_applicable: {
    id: 'cour_order_mandatory_if_applicable',
    defaultmessages: 'Court Order (Mandatory) (if applicable)',
  },
  court_letter: {
    id: 'court_letter',
    defaultmessages: 'Court letter',
  },
  court_letter_for_poa_revoking_mandatory: {
    id: 'court_letter_for_poa_revoking_mandatory',
    defaultmessages: 'Court Letter for POA Revoking (Mandatory)',
  },
  court_letter_poa_mandatory: {
    id: 'court_letter_poa_mandatory',
    defaultmessages: 'Court Letter (POA) (Mandatory)',
  },
  court_order: {
    id: 'court_order',
    defaultmessages: 'Court Order',
  },
  court_order_if_applicable: {
    id: 'court_order_if_applicable',
    defaultmessages: 'Court Order (if applicable)',
  },
  court_order_mandatory: {
    id: 'court_order_mandatory',
    defaultmessages: 'Court order (Mandatory)',
  },
  court_order_optional: {
    id: 'court_order_optional',
    defaultmessages: 'Court Order (Optional)',
  },
  covenant_number: {
    id: 'covenant_number',
    defaultmessages: 'Covenant Number',
  },
  cover: {
    id: 'cover',
    defaultmessages: 'cover',
  },
  create_password: {
    id: 'create_password',
    defaultmessages: 'Please create password',
  },
  create_password_descritption: {
    id: 'create_password_descritption',
    defaultmessages:
      'Please enter a strong password minimum 8 characters including uppercase, lowercase, numbers and special characters',
  },
  create_password_msg: {
    id: 'create_password_msg',
    defaultmessages: 'Minimum 8 characters including uppercase, lowercase, numbers and special characters',
  },
  created: {
    id: 'created',
    defaultmessages: 'Created on',
  },
  creation_date_from: {
    id: 'creation_date_from',
    defaultmessages: 'Creation date (From)',
  },
  creation_date_to: {
    id: 'creation_date_to',
    defaultmessages: 'Creation date (To)',
  },
  criminal_clearance_certificate_for_management_team_members: {
    id: 'criminal_clearance_certificate_for_management_team_members',
    defaultmessages: 'Criminal clearance certificate for management team members',
  },
  currency: {
    id: 'currency',
    defaultmessages: 'AED',
  },
  currency_field_hint: {
    id: 'currency_field_hint',
    defaultmessages: 'AED 1,000',
  },
  current_addc_aadc_liability: {
    id: 'current_addc_aadc_liability',
    defaultmessages: 'Current ADDC/AADC liability',
  },
  current_contract_details: {
    id: 'current_contract_details',
    defaultmessages: 'Current agreement details',
  },
  current_contract_documents: {
    id: 'current_contract_documents',
    defaultmessages: 'Current agreement documents',
  },
  current_liability_paid_by: {
    id: 'current_liability_paid_by',
    defaultmessages: 'Current Liability paid by',
  },
  current_mortgage_contract_details: {
    id: 'current_mortgage_contract_details',
    defaultmessages: 'Current Mortgage Agreement Details',
  },
  current_mortgages: {
    id: 'current_mortgages',
    defaultmessages: 'Current Mortgages',
  },
  current_musateh: {
    id: 'current_musateh',
    defaultmessages: 'Current Musateh',
  },
  current_musateh_details: {
    id: 'current_musateh_details',
    defaultmessages: 'Current Musateh Details',
  },
  current_musateh_num: {
    id: 'current_musateh_num',
    defaultmessages: 'Current Musateh #{num}',
  },
  currently_owned_land: {
    id: 'currently_owned_land',
    defaultmessages: 'Currently Owned Land/s',
  },
  currently_owned_unit: {
    id: 'currently_owned_unit',
    defaultmessages: 'Currently Owned Unit/s',
  },
  currently_this_owner_does_not_own_any_land: {
    id: 'currently_this_owner_does_not_own_any_land',
    defaultmessages: 'Oops! This owner does not currently own any land/s',
  },
  currently_this_owner_does_not_own_any_units: {
    id: 'currently_this_owner_does_not_own_any_units',
    defaultmessages: 'Oops! This owner does not currently own any unit/s',
  },
  customer_support_email: {
    id: 'customer_support_email',
    defaultmessages: 'Customer support email',
  },
  dari_agent_contact_appoinment: {
    id: 'dari_agent_contact_appoinment',
    defaultmessages:
      'Application has been submitted successfully. The agent of Dari at your place will contact you to schedule the appointment',
  },
  dari_agent_contact_info: {
    id: 'dari_agent_contact_info',
    defaultmessages:
      'The application has been approved by the municipality, The agent of Dari at your place will contact you to schedule the appointment',
  },
  dari_app: {
    id: 'dari_app',
    defaultmessages: 'Dari App',
  },
  dari_at_your_Place: {
    id: 'dari_at_your_Place',
    defaultmessages: 'DARI At your Place',
  },
  dari_at_your_place_services: {
    id: 'dari_at_your_place_services',
    defaultmessages: 'Dari at your place services',
  },
  dari_fee: {
    id: 'dari_fee',
    defaultmessages: 'Electronic Service Fees paid by',
  },
  dari_office_fees: {
    id: 'dari_office_fees',
    defaultmessages: 'DARI Office fees',
  },
  dari_office_services: {
    id: 'dari_office_services',
    defaultmessages: 'DARI Office services',
  },
  dari_office_services_and_fees: {
    id: 'dari_office_services_and_fees',
    defaultmessages: 'DARI Office Services and Fees',
  },
  dari_offices: {
    id: 'dari_offices',
    defaultmessages: 'DARI Office',
  },
  dari_payment: {
    id: 'dari_payment',
    defaultmessages: 'Electronic Service Fees',
  },
  dari_pending_payment: {
    id: 'dari_pending_payment',
    defaultmessages: 'Pending payment',
  },
  dari_qa_qc_check: {
    id: 'dari_qa_qc_check',
    defaultmessages: 'DARI QA/QC check',
  },
  dari_service: {
    id: 'dari_service',
    defaultmessages: 'DARI service',
  },
  dari_services: {
    id: 'dari_services',
    defaultmessages: 'DARI services',
  },
  dari_smart_offices: {
    id: 'dari_smart_offices',
    defaultmessages: 'DARI Offices',
  },
  dari_smart_offices_label: {
    id: 'dari_smart_offices_label',
    defaultmessages: 'DARI smart offices',
  },
  dari_support: {
    id: 'dari_support',
    defaultmessages: 'AccessRP support',
  },
  dari_terms_condition: {
    id: 'dari_terms_condition',
    defaultmessages: 'I accept ADGM terms & conditions.',
  },
  dari_virtual_contact_info: {
    id: 'dari_virtual_contact_info',
    defaultmessages:
      'The application has been approved by municipality, Please make sure to save the appointment in your calendar',
  },
  dari_wallet: {
    id: 'dari_wallet',
    defaultmessages: 'DARI wallet',
  },
  dari_wallet_disabled_alert_for_addc_liability: {
    id: 'dari_wallet_disabled_alert_for_addc_liability',
    defaultmessages: 'You can not utilize AccessRP wallet balance to make payment of ADDC liability',
  },
  daro_office_location: {
    id: 'daro_office_location',
    defaultmessages: 'AccessRP Office Location',
  },
  date: {
    id: 'date',
    defaultmessages: 'Date',
  },
  date_not_allowed: {
    id: 'date_not_allowed',
    defaultmessages: 'Date is not allowed',
  },
  date_of_blocking: {
    id: 'date_of_blocking',
    defaultmessages: 'Date of blocking',
  },
  date_of_sale: {
    id: 'date_of_sale',
    defaultmessages: 'Date of sale',
  },
  date_of_waiver: {
    id: 'date_of_waiver',
    defaultmessages: 'Date of waiver',
  },
  date_range: {
    id: 'date_range',
    defaultmessages: 'Date range',
  },
  date_range_helper: {
    id: 'date_range_helper',
    defaultmessages: 'You can specify a date range (From - To)',
  },
  date_range_label: {
    id: 'date_range_label',
    defaultmessages: 'Date Range',
  },
  date_time: {
    id: 'date_time',
    defaultmessages: 'Date & time',
  },
  day: {
    id: 'day',
    defaultmessages: 'day',
  },
  days: {
    id: 'days',
    defaultmessages: 'Days',
  },
  dcr_mandatory: {
    id: 'dcr_mandatory',
    defaultmessages: 'Development Control Regulations (Mandatory)',
  },
  deactivate: {
    id: 'deactivate',
    defaultmessages: 'Deactivate',
  },
  deactivate_employee_popup_description: {
    id: 'deactivate_employee_popup_description',
    defaultmessages: 'This will revoke all access and permissions temporarily',
  },
  deactivate_employee_popup_title: {
    id: 'deactivate_employee_popup_title',
    defaultmessages: 'Deactivate employee?',
  },
  deactivate_from: {
    id: 'deactivate_from',
    defaultmessages: 'Deactivate from',
  },
  deactivate_until: {
    id: 'deactivate_until',
    defaultmessages: 'Deactivate until',
  },
  deactivated: {
    id: 'deactivated',
    defaultmessages: 'Deactivated',
  },
  debit_credit: {
    id: 'debit_credit',
    defaultmessages: 'Debit/Credit',
  },
  debit_credit_card: {
    id: 'debit_credit_card',
    defaultmessages: 'Debit/credit card',
  },
  debit_or_credit_card: {
    id: 'debit_or_credit_card',
    defaultmessages: 'Debit/Credit Card',
  },
  decision: {
    id: 'decision',
    defaultmessages: 'Decision',
  },
  decrease_in_mortgage_value: {
    id: 'decrease_in_mortgage_value',
    defaultmessages: 'Decrease in Mortgage Value',
  },
  decrease_in_mortgage_value_AED: {
    id: 'decrease_in_mortgage_value_AED',
    defaultmessages: 'Decrease in Mortgage Value: 100 AED',
  },
  defendant: {
    id: 'defendant',
    defaultmessages: 'Defendant',
  },
  defendants: {
    id: 'defendants',
    defaultmessages: 'Defendants',
  },
  delayed_rent_after: {
    id: 'delayed_rent_after',
    defaultmessages: 'Delayed rents after 2019',
  },
  delayed_rent_amount_including_vat: {
    id: 'delayed_rent_amount_including_vat',
    defaultmessages: 'Delayed rent amount including VAT 5% until {s}',
  },
  delayed_rent_amount_including_vat_for_the_period: {
    id: 'delayed_rent_amount_including_vat_for_the_period',
    defaultmessages: 'Delayed rent amount including VAT until {s}',
  },
  delayed_rent_amount_until: {
    id: 'delayed_rent_amount_until',
    defaultmessages: 'Delayed rent amount until 31/12/2018',
  },
  delayed_rents_before: {
    id: 'delayed_rents_before',
    defaultmessages: 'Delayed rents before {s}',
  },
  delete: {
    id: 'delete',
    defaultmessages: 'Delete',
  },
  delete_employee: {
    id: 'delete_employee',
    defaultmessages: 'Delete employee',
  },
  delete_employee_pop_up: {
    id: 'delete_employee_pop_up',
    defaultmessages: 'Delete employee?',
  },
  delete_employee_pop_up_desc: {
    id: 'delete_employee_pop_up_desc',
    defaultmessages: 'This will remove them permanently and revoke all access and permissions on your properties',
  },
  demand: {
    id: 'demand',
    defaultmessages: 'Demand',
  },
  demands: {
    id: 'demands',
    defaultmessages: 'Demands',
  },
  deposit: {
    id: 'deposit',
    defaultmessages: 'Deposit',
  },
  description: {
    id: 'description',
    defaultmessages: 'Description',
  },
  description_hint: {
    id: 'description_hint',
    defaultmessages: 'Tell us a little more about the problem you are facing so that we can help you',
  },
  description_is_invalid: {
    id: 'description_is_invalid',
    defaultmessages: 'Description required',
  },
  detail_screen_certificate_service_content: {
    id: 'detail_screen_certificate_service_content',
    defaultmessages:
      'All the certificates you need for your properties are now at your fingertips, obtain and download any property-related certificate smoothly through AccessRP including:\n-Valuation certificate, certifying the fair market value of your property at time of sale or purchase\n-Search Certificate, certifying your ownership of an asset or property\n-Ownership Deed/Title Deed, certifying your ownership of a property with all legal rights\n-Properties Ownership certificate, certifying all properties owned by you\n-Site Plan, a large-scale drawing of the site for an existing or proposed development',
  },
  detail_screen_company_managment_service_content: {
    id: 'detail_screen_company_managment_service_content',
    defaultmessages:
      'DARI — the digital real estate ecosystem — offers real estate company owners in Abu Dhabi multiple services through "My Company" feature. As an owner or representative, you have the option to register a company account, register an employee account and/or manage an employee account.',
  },
  detail_screen_company_managment_service_title: {
    id: 'detail_screen_company_managment_service_title',
    defaultmessages: 'Manage Your Company',
  },
  detail_screen_lease_service_content: {
    id: 'detail_screen_lease_service_content',
    defaultmessages:
      "Benefit from a smart and smooth process when handling your leased property. You can now fully manage it through DARI - the digital real estate ecosystem.\nDARI's platform allows you to amend, renew, close a lease agreement, terminate it by court order or register a new one. It also enables you to register two types of property management agreements: property management company and freehold management agreement. DARI provides enhanced new features such as having multiple bilingual appendices and enabling payments from the initiator. All these features include full assistance on any governmental procedure as DARI is backed by the Abu Dhabi government, making it possible to finalize lease procedures officially and intelligently.",
  },
  detail_screen_owner_service_content: {
    id: 'detail_screen_owner_service_content',
    defaultmessages:
      'Quickly and easily register or cancel power of attorney (POA) through the Authorizations feature available on in AccessRP — the digital real estate ecosystem. As a continuously growing and developing platform, further services will be added to this section, including: registering property management agreements as well as renewing, amending and cancelling them.',
  },
  detail_screen_owner_service_title: {
    id: 'detail_screen_owner_service_title',
    defaultmessages: 'Manage Authorizations',
  },
  detail_screen_transaction_service_content: {
    id: 'detail_screen_transaction_service_content',
    defaultmessages:
      'Complete the process of selling and buying your property in Abu Dhabi (land, unit or villa apartment) through AccessRP — the digital real estate ecosystem. Have a personalized experience and valuate your property, initiate and complete a sale agreement and register it. Wherever you are in the selling and buying process of properties, AccessRP is the solution to help you complete your transactions effortlessly and efficiently.',
  },
  detailed_description: {
    id: 'detailed_description',
    defaultmessages: 'Detailed Description',
  },
  detailed_response: {
    id: 'detailed_response',
    defaultmessages: 'You will receive a detailed response within 2-4 hours',
  },
  details: {
    id: 'details',
    defaultmessages: 'Details',
  },
  details_screen_certificate_service_title: {
    id: 'details_screen_certificate_service_title',
    defaultmessages: 'Get the certificates related to your property',
  },
  details_screen_directory_content: {
    id: 'details_screen_directory_content',
    defaultmessages:
      "DARI's directory offers you full access to a list of Abu Dhabi-licensed professionals in the real estate industry. This includes licensed brokers that can assist you in and manage any official procedure, surveyors to measure and determine your property borders, valuators to internally and externally value your property and auctioneers to lead property sales in auctions. As an investor, the directory allows you to explore projects and opportunities in Abu Dhabi.",
  },
  details_screen_directory_title: {
    id: 'details_screen_directory_title',
    defaultmessages: 'Explore the real estate directory',
  },
  details_screen_lease_service_title: {
    id: 'details_screen_lease_service_title',
    defaultmessages: 'Lease a property in Abu Dhabi',
  },
  details_screen_sale_service_title: {
    id: 'details_screen_sale_service_title',
    defaultmessages: 'Sell and purchase property in Abu Dhabi',
  },
  developer: {
    id: 'developer',
    defaultmessages: 'Developer',
  },
  developer_IBAN_letter_Mandatory_if_an_amount_is_to_be_forfeited_to_the_developer_account: {
    id: 'developer_IBAN_letter_Mandatory_if_an_amount_is_to_be_forfeited_to_the_developer_account',
    defaultmessages: 'Developer IBAN Letter (Mandatory if an amount is to be forfeited to the developer’s account)',
  },
  developer_account_number: {
    id: 'developer_account_number',
    defaultmessages: 'Developer account number',
  },
  developer_address: {
    id: 'developer_address',
    defaultmessages: "Developer's address",
  },
  developer_bank: {
    id: 'developer_bank',
    defaultmessages: 'Developer bank',
  },
  developer_bank_country: {
    id: 'developer_bank_country',
    defaultmessages: 'Developer bank country',
  },
  developer_bank_details: {
    id: 'developer_bank_details',
    defaultmessages: 'Developer bank details',
  },
  developer_bank_name: {
    id: 'developer_bank_name',
    defaultmessages: 'developer bank name',
  },
  developer_details: {
    id: 'developer_details',
    defaultmessages: 'Developer details',
  },
  developer_full_project_fees_and_duration: {
    id: 'developer_full_project_fees_and_duration',
    defaultmessages:
      'This permit type will be for a full project, and its duration will be 3 months with 25,000 AED fees.',
  },
  developer_iban_letter: {
    id: 'developer_iban_letter',
    defaultmessages: 'Developer IBAN Letter',
  },
  developer_iban_letter_mandatory_if_applicable: {
    id: 'developer_iban_letter_mandatory_if_applicable',
    defaultmessages: 'Developer IBAN Letter (Mandatory) (if applicable)',
  },
  developer_iban_or_swift: {
    id: 'developer_iban_or_swift',
    defaultmessages: 'Developer IBAN',
  },
  developer_name: {
    id: 'developer_name',
    defaultmessages: 'Developer name',
  },
  developer_noc_mandatory: {
    id: 'developer_noc_mandatory',
    defaultmessages: 'Developer NOC (Mandatory in case of leasehold property)',
  },
  developer_notice_date: {
    id: 'developer_notice_date',
    defaultmessages: 'Registration Notice Date',
  },
  developer_returned_application_with_feedback: {
    id: 'developer_returned_application_with_feedback',
    defaultmessages: 'Developer returned the application with feedback.',
  },
  developer_sell_contract_mandatory: {
    id: 'developer_sell_contract_mandatory',
    defaultmessages: 'Developer Sell Contract (Mandatory In case of leasehold property)',
  },
  developer_should_complete_payment: {
    id: 'developer_should_complete_payment',
    defaultmessages: 'Developer should complete the payment',
  },
  developers: {
    id: 'developers',
    defaultmessages: 'Developers',
  },
  development_control_regulations: {
    id: 'development_control_regulations',
    defaultmessages: 'Development Control Regulations',
  },
  dialog_only_on_web_title: {
    id: 'dialog_only_on_web_title',
    defaultmessages: 'Service unavailable on current platform',
  },
  didnt_receive_code: {
    id: 'didnt_receive_code',
    defaultmessages: "Didn't receive a code?",
  },
  'digital-transfer-of-interest-land': {
    id: 'digital-transfer-of-interest-land',
    defaultmessages: 'Digital Transfer of Interest — Land',
  },
  'digital-transfer-of-interest-unit': {
    id: 'digital-transfer-of-interest-unit',
    defaultmessages: 'Digital Transfer of Interest — Unit',
  },
  digital_products: {
    id: 'digital_products',
    defaultmessages: 'Digital Products',
  },
  digital_transfer_of_interest_application_returned: {
    id: 'digital_transfer_of_interest_application_returned',
    defaultmessages: 'The digital transfer of interest application has been returned.',
  },
  digital_transfer_of_interest_application_sent_to_bank_checker_for_approva: {
    id: 'digital_transfer_of_interest_application_sent_to_bank_checker_for_approva',
    defaultmessages: 'The Digital Transfer of Interest application has been sent to the bank checker for approval.',
  },
  digital_transfer_of_interest_application_sent_to_bank_checker_for_approval: {
    id: 'digital_transfer_of_interest_application_sent_to_bank_checker_for_approval',
    defaultmessages: 'The Digital Transfer of Interest application has been sent to the bank checker for approval.',
  },
  digital_transfer_of_interest_land_description: {
    id: 'digital_transfer_of_interest_land_description',
    defaultmessages:
      'This exclusive service is designed for developers, enabling seamless and efficient unit ownership transfers with a mortgage registration feature. It streamlines the process through a fully digital workflow, eliminating the need for in-person visits to ADGM offices.',
  },
  digital_transfer_of_interest_registration_fees: {
    id: 'digital_transfer_of_interest_registration_fees',
    defaultmessages: 'Digital Transfer of Interest Fees',
  },
  digital_transfer_of_interest_registration_is_completed: {
    id: 'digital_transfer_of_interest_registration_is_completed',
    defaultmessages: 'Digital Transfer of Interest Registration is Completed',
  },
  digital_transfer_of_interest_subtitle_buyer_approval: {
    id: 'digital_transfer_of_interest_subtitle_buyer_approval',
    defaultmessages:
      'Please check the application later, once it has been reviewed and approved by the selected bank and ADGM.',
  },
  digital_transfer_of_interest_unit_description: {
    id: 'digital_transfer_of_interest_unit_description',
    defaultmessages:
      'This exclusive service is designed for developers, enabling seamless and efficient unit ownership transfers with a mortgage registration feature. It streamlines the process through a fully digital workflow, eliminating the need for in-person visits to ADGM offices.',
  },
  diplomat: {
    id: 'diplomat',
    defaultmessages: 'Diplomat',
  },
  diplomat_document: {
    id: 'diplomat_document',
    defaultmessages: 'Diplomat documents',
  },
  diplomat_id: {
    id: 'diplomat_id',
    defaultmessages: 'Diplomat ID',
  },
  diplomat_id_number: {
    id: 'diplomat_id_number',
    defaultmessages: 'Diplomat ID',
  },
  diplomat_type: {
    id: 'diplomat_type',
    defaultmessages: 'Diplomat type',
  },
  directories_desc: {
    id: 'directories_desc',
    defaultmessages: 'Explore the real estate directory',
  },
  dirham: {
    id: 'dirham',
    defaultmessages: 'Dirham(s)',
  },
  discard: {
    id: 'discard',
    defaultmessages: 'Discard',
  },
  discard_changes: {
    id: 'discard_changes',
    defaultmessages: 'Discard changes',
  },
  discharge_fe: {
    id: 'discharge_fe',
    defaultmessages: 'Discharge Fee',
  },
  discharge_fee_per_properties: {
    id: 'discharge_fee_per_properties',
    defaultmessages: 'AED 1000 x {num} properties discharged',
  },
  discharge_letter_from_the_bank_mandatory: {
    id: 'discharge_letter_from_the_bank_mandatory',
    defaultmessages: 'Discharge Letter from the Bank (Mandatory)',
  },
  discharge_of_mortgage: {
    id: 'discharge_of_mortgage',
    defaultmessages: 'Discharge of Mortgage',
  },
  discharge_of_mortgage_1000_aed: {
    id: 'discharge_of_mortgage_1000_aed',
    defaultmessages: '1,000 AED per property',
  },
  discharged: {
    id: 'discharged',
    defaultmessages: 'Discharged',
  },
  discover_projects_title: {
    id: 'discover_projects_title',
    defaultmessages: '',
  },
  dispatcher: {
    id: 'dispatcher',
    defaultmessages: 'Dispatcher',
  },
  dispatcher_dmt_approval_title: {
    id: 'dispatcher_dmt_approval_title',
    defaultmessages: 'The application has been successfully forwarded to the DMT for approval',
  },
  dispute_details: {
    id: 'dispute_details',
    defaultmessages: 'Dispute details',
  },
  dispute_details_title: {
    id: 'dispute_details_title',
    defaultmessages: 'Application details',
  },
  dispute_info_title: {
    id: 'dispute_info_title',
    defaultmessages: 'Dispute information',
  },
  dispute_type: {
    id: 'dispute_type',
    defaultmessages: 'Dispute type',
  },
  disputes: {
    id: 'disputes',
    defaultmessages: 'Disputes',
  },
  district: {
    id: 'district',
    defaultmessages: 'District',
  },
  dmp_approval: {
    id: 'dmp_approval',
    defaultmessages: 'DMP approval',
  },
  dmt_appointment_title: {
    id: 'dmt_appointment_title',
    defaultmessages: 'Book a DMT appointment',
  },
  dmt_approval_success: {
    id: 'dmt_approval_success',
    defaultmessages:
      'Lease agreement has been approved by the DMT. Sign and pay the fee to formally register the agreement.',
  },
  dmt_approval_text: {
    id: 'dmt_approval_text',
    defaultmessages: 'You can now book an appointment with ADGM to sign the agreement',
  },
  dmt_approval_title: {
    id: 'dmt_approval_title',
    defaultmessages: 'Congratulations! Your sales agreement has been approved by ADGM.',
  },
  dmt_downtime_message: {
    id: 'dmt_downtime_message',
    defaultmessages:
      'There is a scheduled system maintenance on Friday 26th of January 03:00 PM till 08:00 PM and Sunday 28th of January 06:00 PM till Monday 29th of January 01:00 AM, In this time you might face some unexpected behavior or slowness in the system',
  },
  do_include_the_mortgage_registration_with_service: {
    id: 'do_include_the_mortgage_registration_with_service',
    defaultmessages: 'Would you like to include the mortgage registration with this service?',
  },
  do_you_have_properties_not_appearing: {
    id: 'do_you_have_properties_not_appearing',
    defaultmessages: 'Do you have properties that are still not appearing here?',
  },
  document: {
    id: 'document',
    defaultmessages: 'Document',
  },
  document_invalid: {
    id: 'document_invalid',
    defaultmessages: 'The document you have uploaded is not verified.',
  },
  document_valid: {
    id: 'document_valid',
    defaultmessages: 'The document you have uploaded is verified',
  },
  document_verification: {
    id: 'document_verification',
    defaultmessages: 'Documents Verification',
  },
  document_you_uploaded: {
    id: 'document_you_uploaded',
    defaultmessages: 'The document you have uploaded is',
  },
  documents: {
    id: 'documents',
    defaultmessages: 'Documents',
  },
  documents_from_approver: {
    id: 'documents_from_approver',
    defaultmessages: 'Approver Uploaded Documents',
  },
  documents_from_auditor: {
    id: 'documents_from_auditor',
    defaultmessages: 'Auditor Uploaded Documents',
  },
  documents_from_the_admin: {
    id: 'documents_from_the_admin',
    defaultmessages: 'Documents from the admin',
  },
  documents_validation_msg: {
    id: 'documents_validation_msg',
    defaultmessages: 'Maximum file size: 20 MB. Allowed file types: PDF, PNG, JPEG.',
  },
  done: {
    id: 'done',
    defaultmessages: 'Done',
  },
  dont_have_access_to_this_email: {
    id: 'dont_have_access_to_this_email',
    defaultmessages: 'Don’t have access to this email?',
  },
  dont_have_account: {
    id: 'dont_have_account',
    defaultmessages: "Don't have an account?",
  },
  dont_have_uae_pass_account: {
    id: 'dont_have_uae_pass_account',
    defaultmessages: 'Do not have UAE PASS account?',
  },
  download: {
    id: 'download',
    defaultmessages: 'Download',
  },
  download_PDF: {
    id: 'download_PDF',
    defaultmessages: 'Download PDF',
  },
  download_all: {
    id: 'download_all',
    defaultmessages: 'Download all documents',
  },
  download_both_receipts: {
    id: 'download_both_receipts',
    defaultmessages: 'Download both receipts',
  },
  download_certificate: {
    id: 'download_certificate',
    defaultmessages: 'Download certificate',
  },
  download_certificate_payment_receipt: {
    id: 'download_certificate_payment_receipt',
    defaultmessages: 'Download the Certificate and payment receipt',
  },
  download_contract: {
    id: 'download_contract',
    defaultmessages: 'Download agreement',
  },
  download_excel_template: {
    id: 'download_excel_template',
    defaultmessages: 'Download excel template',
  },
  download_images: {
    id: 'download_images',
    defaultmessages: 'Download Images',
  },
  download_land_verification_certificate: {
    id: 'download_land_verification_certificate',
    defaultmessages: 'Download the Land Search Certificate',
  },
  download_materials: {
    id: 'download_materials',
    defaultmessages: 'Download materials',
  },
  download_mortgage_certificate: {
    id: 'download_mortgage_certificate',
    defaultmessages: 'Download mortgage certificate',
  },
  download_mortgage_variation_certificate: {
    id: 'download_mortgage_variation_certificate',
    defaultmessages: 'Download Mortgage Variation Certificate',
  },
  download_mortgaged_title_deed: {
    id: 'download_mortgaged_title_deed',
    defaultmessages: 'Download mortgaged title deed',
  },
  download_musataha_contract: {
    id: 'download_musataha_contract',
    defaultmessages: 'Download Musataha Agreement',
  },
  download_ownership_certificate: {
    id: 'download_ownership_certificate',
    defaultmessages: 'Download the Ownership Certificate',
  },
  download_payment_receipt: {
    id: 'download_payment_receipt',
    defaultmessages: 'Download payment receipts',
  },
  download_payment_receipts: {
    id: 'download_payment_receipts',
    defaultmessages: 'Download payment receipts',
  },
  download_permit_certificate: {
    id: 'download_permit_certificate',
    defaultmessages: 'Download the permit',
  },
  download_receipt: {
    id: 'download_receipt',
    defaultmessages: 'Download receipt',
  },
  download_report: {
    id: 'download_report',
    defaultmessages: 'Download report',
  },
  download_site_plan_certificate: {
    id: 'download_site_plan_certificate',
    defaultmessages: 'Download the Site Plan Certificate',
  },
  download_spa: {
    id: 'download_spa',
    defaultmessages: 'Download SPA document',
  },
  download_template: {
    id: 'download_template',
    defaultmessages: 'Download template',
  },
  download_the_certificate_and_payment_receipt: {
    id: 'download_the_certificate_and_payment_receipt',
    defaultmessages: 'Download the Certificate and Payment Receipt',
  },
  download_the_certificate_of_permission: {
    id: 'download_the_certificate_of_permission',
    defaultmessages: 'Download the Advertisement Permit',
  },
  download_the_payment_receipt: {
    id: 'download_the_payment_receipt',
    defaultmessages: 'Download the Payment Receipt',
  },
  download_title_deed: {
    id: 'download_title_deed',
    defaultmessages: 'Download Title Deed',
  },
  download_title_deed_certificate: {
    id: 'download_title_deed_certificate',
    defaultmessages: 'Download the Title Deed Certificate',
  },
  download_transactions_details: {
    id: 'download_transactions_details',
    defaultmessages: 'Download transactions detail',
  },
  download_unified_SPA_template: {
    id: 'download_unified_SPA_template',
    defaultmessages: 'Download Unified SPA Template',
  },
  download_unit_verification_certificate: {
    id: 'download_unit_verification_certificate',
    defaultmessages: 'Download the Unit Search Certificate',
  },
  downloadthe_certificate_and_payment_receipt: {
    id: 'downloadthe_certificate_and_payment_receipt',
    defaultmessages: 'Download Your Certificate and Payment Receipt',
  },
  drag_and_drop_your_photos_here: {
    id: 'drag_and_drop_your_photos_here',
    defaultmessages: 'Or drag and drop your photos here. JPEG, PNG 3 mb maximum are allowed',
  },
  drag_drop_excel_text_hint: {
    id: 'drag_drop_excel_text_hint',
    defaultmessages: 'drag and drop XLSX file here',
  },
  drag_drop_file_hint: {
    id: 'drag_drop_file_hint',
    defaultmessages: 'Drag and drop your file here',
  },
  drc_application_cancel_warning_message: {
    id: 'drc_application_cancel_warning_message',
    defaultmessages: 'Are you sure you want to cancel application?',
  },
  drc_payment_completed_title: {
    id: 'drc_payment_completed_title',
    defaultmessages: 'Your payment has been processed successfully',
  },
  dropped_case_resubmitted_title: {
    id: 'dropped_case_resubmitted_title',
    defaultmessages: 'You have successfully approved the case drop',
  },
  dropped_case_returned_title: {
    id: 'dropped_case_returned_title',
    defaultmessages: 'You have successfully returned the case',
  },
  due_rent_amount: {
    id: 'due_rent_amount',
    defaultmessages: 'Due rent amount',
  },
  duration: {
    id: 'duration',
    defaultmessages: 'Duration',
  },
  duration_AED: {
    id: 'duration_AED',
    defaultmessages: 'Duration: 1000 AED',
  },
  duration_should_be_within_the_period: {
    id: 'duration_should_be_within_the_period',
    defaultmessages: 'Duration should be within the period',
  },
  duration_should_be_within_the_possessive_mortgage_contract_period: {
    id: 'duration_should_be_within_the_possessive_mortgage_contract_period',
    defaultmessages:
      'Duration should be within the Possessory Mortgage agreement period. ({startDate} to {endDate}) with a Minimum duration of 3 months and the maximum duration is 4 years.',
  },
  easement_release: {
    id: 'easement_release',
    defaultmessages: 'Easement Cancellation / Release',
  },
  easement_release_description: {
    id: 'easement_release_description',
    defaultmessages:
      'A registered easement can be varied or fully or partially terminated by registering a release of easement.',
  },
  easements_number: {
    id: 'easements_number',
    defaultmessages: 'Easement Number',
  },
  edit_a_term: {
    id: 'edit_a_term',
    defaultmessages: 'Edit Term',
  },
  edit_application: {
    id: 'edit_application',
    defaultmessages: 'Edit application',
  },
  edit_broker: {
    id: 'edit_broker',
    defaultmessages: 'Edit Broker',
  },
  edit_contract: {
    id: 'edit_contract',
    defaultmessages: 'Edit agreement',
  },
  edit_employee_details: {
    id: 'edit_employee_details',
    defaultmessages: 'Edit Employee Details',
  },
  edit_party_details: {
    id: 'edit_party_details',
    defaultmessages: 'Edit party details',
  },
  edit_permissions: {
    id: 'edit_permissions',
    defaultmessages: 'Edit Permissions',
  },
  eg: {
    id: 'eg',
    defaultmessages: 'e.g',
  },
  eg_20_percent: {
    id: 'eg_20_percent',
    defaultmessages: 'e.g., 20%',
  },
  eg_aed_30000: {
    id: 'eg_aed_30000',
    defaultmessages: 'e.g., AED 30,000',
  },
  eg_num: {
    id: 'eg_num',
    defaultmessages: 'e.g., 50',
  },
  eid: {
    id: 'eid',
    defaultmessages: 'EID',
  },
  eid_card: {
    id: 'eid_card',
    defaultmessages: 'EID card',
  },
  eid_card_document: {
    id: 'eid_card_document',
    defaultmessages: 'EID card document',
  },
  eid_document: {
    id: 'eid_document',
    defaultmessages: 'EID document',
  },
  eid_less_than_15_character: {
    id: 'eid_less_than_15_character',
    defaultmessages: 'EID number should be 15 characters',
  },
  eid_moi: {
    id: 'eid_moi',
    defaultmessages: 'EID/MOI',
  },
  eid_moi_num: {
    id: 'eid_moi_num',
    defaultmessages: 'EID/MOI Number',
  },
  eid_should_be_not_empty: {
    id: 'eid_should_be_not_empty',
    defaultmessages: 'EID number required',
  },
  eid_uid_license_number: {
    id: 'eid_uid_license_number',
    defaultmessages: 'EID, UID and License Number',
  },
  eid_un: {
    id: 'eid_un',
    defaultmessages: 'EID/Unified Number',
  },
  eid_un_no: {
    id: 'eid_un_no',
    defaultmessages: 'EID/MOI no.',
  },
  eid_un_number: {
    id: 'eid_un_number',
    defaultmessages: 'EID/UN number',
  },
  electronic_administrative_services_allowance: {
    id: 'electronic_administrative_services_allowance',
    defaultmessages: 'Electronic Service Fees',
  },
  electronic_administrative_services_allowance_including_VAT: {
    id: 'electronic_administrative_services_allowance_including_VAT',
    defaultmessages: 'Electronic Service Fees (Including VAT)',
  },
  electronic_service_fees_AED_amount_VAT: {
    id: 'electronic_service_fees_AED_amount_VAT',
    defaultmessages: 'Electronic Service Fees: {num} AED + {per}% VAT',
  },
  elife_success_text: {
    id: 'elife_success_text',
    defaultmessages: 'Your request has been submitted. You will be contacted within 3 to 4 business days.',
  },
  email: {
    id: 'email',
    defaultmessages: 'Email',
  },
  email_Address: {
    id: 'email_Address',
    defaultmessages: 'Email Address',
  },
  email_address: {
    id: 'email_address',
    defaultmessages: 'Email address',
  },
  email_address_verified_successfully: {
    id: 'email_address_verified_successfully',
    defaultmessages: 'Your email address has been successfully verified',
  },
  email_cannot_be_empty: {
    id: 'email_cannot_be_empty',
    defaultmessages: 'Email address required',
  },
  email_hint: {
    id: 'email_hint',
    defaultmessages: 'example@email.com',
  },
  email_id: {
    id: 'email_id',
    defaultmessages: 'Email ID',
  },
  email_is_invalid: {
    id: 'email_is_invalid',
    defaultmessages: 'Username or password is incorrect',
  },
  email_us_your_case_at: {
    id: 'email_us_your_case_at',
    defaultmessages: 'Please email us your case at',
  },
  email_verifed_msg: {
    id: 'email_verifed_msg',
    defaultmessages: 'Your email has been successfully set',
  },
  embassy: {
    id: 'embassy',
    defaultmessages: 'Embassy',
  },
  embassy_license_number: {
    id: 'embassy_license_number',
    defaultmessages: 'Embassy License Number',
  },
  emirate: {
    id: 'emirate',
    defaultmessages: 'Emirate',
  },
  emirates_ID: {
    id: 'emirates_ID',
    defaultmessages: 'Emirates ID',
  },
  emirates_expiry_date: {
    id: 'emirates_expiry_date',
    defaultmessages: 'EID Expiry Date',
  },
  emirates_id: {
    id: 'emirates_id',
    defaultmessages: 'Emirates ID/Unified Number',
  },
  emirates_issue_date: {
    id: 'emirates_issue_date',
    defaultmessages: 'EID Issue Date',
  },
  employee_account_deactivation: {
    id: 'employee_account_deactivation',
    defaultmessages: 'Account has been deactivated.',
  },
  employee_account_deactivation_until: {
    id: 'employee_account_deactivation_until',
    defaultmessages: 'Account has been deactivated until {date}.',
  },
  employee_details: {
    id: 'employee_details',
    defaultmessages: 'Employee details',
  },
  employee_information: {
    id: 'employee_information',
    defaultmessages: 'Employee Information',
  },
  employee_name: {
    id: 'employee_name',
    defaultmessages: 'Employee name',
  },
  employees: {
    id: 'employees',
    defaultmessages: 'Employees',
  },
  employees_management: {
    id: 'employees_management',
    defaultmessages: 'Employee management',
  },
  employment_contract: {
    id: 'employment_contract',
    defaultmessages: 'Employment agreement',
  },
  empty_directory_profession_title: {
    id: 'empty_directory_profession_title',
    defaultmessages: 'No directory',
  },
  empty_directory_project_title: {
    id: 'empty_directory_project_title',
    defaultmessages: 'No project',
  },
  en: {
    id: 'en',
    defaultmessages: 'English',
  },
  end_date: {
    id: 'end_date',
    defaultmessages: 'End date',
  },
  end_date_is_required: {
    id: 'end_date_is_required',
    defaultmessages: 'end date is required',
  },
  engineering: {
    id: 'engineering',
    defaultmessages: 'Engineering',
  },
  english: {
    id: 'english',
    defaultmessages: 'English',
  },
  enhanced_document_verification: {
    id: 'enhanced_document_verification',
    defaultmessages: 'Enhanced Document Verification',
  },
  enhanced_document_verification_content: {
    id: 'enhanced_document_verification_content',
    defaultmessages:
      'The enhanced document verification tool uses blockchain technology to verify ADGM issued documents. The verification response will confirm whether this document has been issued by ADGM.',
  },
  enroll_property_in_tawtheeq: {
    id: 'enroll_property_in_tawtheeq',
    defaultmessages: 'Register the property in Tawtheeq',
  },
  enter: {
    id: 'enter',
    defaultmessages: 'Enter',
  },
  enter_application_id: {
    id: 'enter_application_id',
    defaultmessages: 'Enter application ID',
  },
  enter_application_number: {
    id: 'enter_application_number',
    defaultmessages: 'Enter application number',
  },
  enter_authorization_number: {
    id: 'enter_authorization_number',
    defaultmessages: 'Enter authorization number',
  },
  enter_certificate_number: {
    id: 'enter_certificate_number',
    defaultmessages: 'Enter Certificate Number',
  },
  enter_commercial_license_number: {
    id: 'enter_commercial_license_number',
    defaultmessages: 'Enter commercial license number',
  },
  'enter_commercial_license_number_to_fetch_the_company’s_details': {
    id: 'enter_commercial_license_number_to_fetch_the_company’s_details',
    defaultmessages: 'Enter the commercial license number to fetch the company’s details',
  },
  enter_company_name: {
    id: 'enter_company_name',
    defaultmessages: 'Enter company name',
  },
  enter_contact_number: {
    id: 'enter_contact_number',
    defaultmessages: 'Enter your phone number',
  },
  enter_contract_amount: {
    id: 'enter_contract_amount',
    defaultmessages: '',
  },
  enter_eid_number: {
    id: 'enter_eid_number',
    defaultmessages: 'Enter EID number',
  },
  enter_eid_number_here: {
    id: 'enter_eid_number_here',
    defaultmessages: 'Enter EID number here',
  },
  enter_email_address: {
    id: 'enter_email_address',
    defaultmessages: 'Enter email address',
  },
  enter_embassy_license_to_fetch_company_detail: {
    id: 'enter_embassy_license_to_fetch_company_detail',
    defaultmessages: 'Enter embassy license to fetch company details',
  },
  enter_embassy_license_to_fetch_company_details: {
    id: 'enter_embassy_license_to_fetch_company_details',
    defaultmessages: "Enter the Embassy license number to fetch the company's details",
  },
  enter_full_name: {
    id: 'enter_full_name',
    defaultmessages: 'Enter your full name',
  },
  enter_government_license_to_fetch_company_details: {
    id: 'enter_government_license_to_fetch_company_details',
    defaultmessages: "Enter the Government license number to fetch the company's details",
  },
  enter_government_to_fetch_company_details: {
    id: 'enter_government_to_fetch_company_details',
    defaultmessages: 'Government License Number',
  },
  enter_number: {
    id: 'enter_number',
    defaultmessages: 'Enter Number',
  },
  enter_phone_number: {
    id: 'enter_phone_number',
    defaultmessages: 'Enter phone number',
  },
  enter_place_of_birth: {
    id: 'enter_place_of_birth',
    defaultmessages: 'Enter place of birth',
  },
  enter_premise_id: {
    id: 'enter_premise_id',
    defaultmessages: 'Enter premise ID',
  },
  enter_premise_id_fetch_unit_details: {
    id: 'enter_premise_id_fetch_unit_details',
    defaultmessages: 'Enter the premise ID to retrieve the unit details',
  },
  enter_price: {
    id: 'enter_price',
    defaultmessages: 'Enter Price',
  },
  enter_qa_qc_certificate_code_gis_project_id: {
    id: 'enter_qa_qc_certificate_code_gis_project_id',
    defaultmessages: 'Enter QA/QC certificate code (GIS project ID)',
  },
  enter_reason_for_reject: {
    id: 'enter_reason_for_reject',
    defaultmessages: 'Please enter your reason for rejecting this application',
  },
  enter_reason_for_reject_new: {
    id: 'enter_reason_for_reject_new',
    defaultmessages: 'Please enter your reason for reject',
  },
  enter_reason_for_return: {
    id: 'enter_reason_for_return',
    defaultmessages: 'Please enter your reason for return',
  },
  enter_tenancy_contract_number: {
    id: 'enter_tenancy_contract_number',
    defaultmessages: 'Enter lease agreement number',
  },
  enter_tenant_name: {
    id: 'enter_tenant_name',
    defaultmessages: 'Enter Lessee Name',
  },
  enter_the_POA_number_to_fetch_representative_details: {
    id: 'enter_the_POA_number_to_fetch_representative_details',
    defaultmessages: 'Enter the POA number to fetch representative details.',
  },
  enter_trade_license_warning: {
    id: 'enter_trade_license_warning',
    defaultmessages: "Enter the trade license number to fetch the company's details",
  },
  enter_transaction_ID: {
    id: 'enter_transaction_ID',
    defaultmessages: 'Enter transaction ID',
  },
  enter_un_eid_number_to_fetch_the_person_s_details: {
    id: 'enter_un_eid_number_to_fetch_the_person_s_details',
    defaultmessages: 'Enter UN/EID number to fetch the person’s details',
  },
  enter_unit_registration_number: {
    id: 'enter_unit_registration_number',
    defaultmessages: 'Enter unit registration number',
  },
  enter_username: {
    id: 'enter_username',
    defaultmessages: 'Enter username',
  },
  enter_your_address: {
    id: 'enter_your_address',
    defaultmessages: 'Enter your address',
  },
  enter_your_email: {
    id: 'enter_your_email',
    defaultmessages: 'Enter your email',
  },
  enter_your_last_name: {
    id: 'enter_your_last_name',
    defaultmessages: 'Enter your last name',
  },
  enter_your_name: {
    id: 'enter_your_name',
    defaultmessages: 'Enter your name',
  },
  enter_your_number: {
    id: 'enter_your_number',
    defaultmessages: 'Enter your number',
  },
  entity: {
    id: 'entity',
    defaultmessages: 'Entity',
  },
  entity_Id_number: {
    id: 'entity_Id_number',
    defaultmessages: 'Entity ID number',
  },
  entity_details: {
    id: 'entity_details',
    defaultmessages: '{entity} details',
  },
  'error_ 50000105': {
    id: 'error_ 50000105',
    defaultmessages: 'User is not found',
  },
  error_000011: {
    id: 'error_000011',
    defaultmessages: 'Legal form does not exist in our system',
  },
  error_100000: {
    id: 'error_100000',
    defaultmessages: 'Unsupported file format',
  },
  error_10000001: {
    id: 'error_10000001',
    defaultmessages: 'Application type is in-valid',
  },
  error_10000016: {
    id: 'error_10000016',
    defaultmessages: 'Individual can not initiate this service.',
  },
  error_10000020: {
    id: 'error_10000020',
    defaultmessages: 'Comments is required',
  },
  error_10000021: {
    id: 'error_10000021',
    defaultmessages: 'Document Id is required',
  },
  error_10000022: {
    id: 'error_10000022',
    defaultmessages: 'Reason is required',
  },
  error_10000023: {
    id: 'error_10000023',
    defaultmessages: 'Document does not exist',
  },
  error_10000024: {
    id: 'error_10000024',
    defaultmessages: 'Documents not approved',
  },
  error_10000025: {
    id: 'error_10000025',
    defaultmessages: 'Kindly update your professional details to access the service',
  },
  error_10000026: {
    id: 'error_10000026',
    defaultmessages: 'End date should be greater then start date',
  },
  error_10000027: {
    id: 'error_10000027',
    defaultmessages: 'Start date should not be greater or equal then end date',
  },
  error_10000028: {
    id: 'error_10000028',
    defaultmessages: 'Application is already in under approval.',
  },
  error_10000029: {
    id: 'error_10000029',
    defaultmessages: 'Maximum length is 250',
  },
  error_10000035: {
    id: 'error_10000035',
    defaultmessages: 'No company users found',
  },
  error_10000039: {
    id: 'error_10000039',
    defaultmessages: 'Something went wrong please try again',
  },
  error_10000040: {
    id: 'error_10000040',
    defaultmessages: 'Document sub type is required',
  },
  error_10000042: {
    id: 'error_10000042',
    defaultmessages: 'Failed to connect to DARI Value service',
  },
  error_10000043: {
    id: 'error_10000043',
    defaultmessages: 'Project number should not be empty',
  },
  error_10000044: {
    id: 'error_10000044',
    defaultmessages: 'Event date should not be empty',
  },
  error_10000045: {
    id: 'error_10000045',
    defaultmessages: 'Event time should not be empty',
  },
  error_10000046: {
    id: 'error_10000046',
    defaultmessages:
      'You cannot initiate this service as a broker because you do not hold a valid broker license. Please ensure you have an active and valid license before proceeding.',
  },
  error_10000050: {
    id: 'error_10000050',
    defaultmessages: 'Nationality is mandatory',
  },
  error_10000051: {
    id: 'error_10000051',
    defaultmessages: 'Exhibition name should not be empty',
  },
  error_10000052: {
    id: 'error_10000052',
    defaultmessages: 'Failed to connect to DARI Value service',
  },
  error_10000053: {
    id: 'error_10000053',
    defaultmessages: 'Required fields are missing, Selling Price needs to be greater than "0".',
  },
  error_10000055: {
    id: 'error_10000055',
    defaultmessages: 'Country ID should not be empty',
  },
  error_10000056: {
    id: 'error_10000056',
    defaultmessages: 'Invalid Exhibition ID',
  },
  error_10000057: {
    id: 'error_10000057',
    defaultmessages: 'DARI Value application number not found',
  },
  error_10000060: {
    id: 'error_10000060',
    defaultmessages:
      'You are not eligible for Class A. Class A must have 1 surveying engineering consultant and 5 surveying engineers.',
  },
  error_10000061: {
    id: 'error_10000061',
    defaultmessages:
      'You are not eligible for Class B. Class B must have 1 surveying engineering consultant, 1 surveying engineer, and 2 surveyor assistants.',
  },
  error_10000062: {
    id: 'error_10000062',
    defaultmessages:
      'You are not eligible for Class C. Class C must have 2 surveyor assistants and 1 surveying engineer.',
  },
  error_10000063: {
    id: 'error_10000063',
    defaultmessages: 'A secondary agreement already exists',
  },
  error_10000065: {
    id: 'error_10000065',
    defaultmessages: 'Amount is Mandatory',
  },
  error_10000068: {
    id: 'error_10000068',
    defaultmessages: "The secondary agreement's start date must not precede the primary agreement's one",
  },
  error_10000069: {
    id: 'error_10000069',
    defaultmessages: "The secondary agreement's end date must not exceed the primary agreement's one",
  },
  error_10000072: {
    id: 'error_10000072',
    defaultmessages: 'User can download the permit as long as it is valid',
  },
  error_10000073: {
    id: 'error_10000073',
    defaultmessages: 'User can download the QR code as long as the permit is valid',
  },
  error_10000074: {
    id: 'error_10000074',
    defaultmessages: 'The permit is valid for one month from the date of issuance',
  },
  error_10000076: {
    id: 'error_10000076',
    defaultmessages: 'The remaining years of the primary Musataha agreement cannot be less than 10 years',
  },
  error_10000077: {
    id: 'error_10000077',
    defaultmessages: 'Maximum agreement length should be 50 years',
  },
  error_10000078: {
    id: 'error_10000078',
    defaultmessages: 'Initiator is financially blocked',
  },
  error_10000084: {
    id: 'error_10000084',
    defaultmessages: 'Neither the owner nor the POA is the initiator',
  },
  error_10000091: {
    id: 'error_10000091',
    defaultmessages: 'Owner cannot add him/herself as a Musateh',
  },
  error_10000092: {
    id: 'error_10000092',
    defaultmessages: 'Initiate the primary Musataha agreement on ELMS first',
  },
  error_10000093: {
    id: 'error_10000093',
    defaultmessages: 'Cannot initiate a primary Musataha agreement on a non-tradable property',
  },
  error_10000094: {
    id: 'error_10000094',
    defaultmessages:
      'Cannot initiate a primary Musataha application. The owner does not have the required ownership type, i.e. allotment, relinquish of allotment, or usufruct.',
  },
  error_10000095: {
    id: 'error_10000095',
    defaultmessages: 'Initiator does not have the required permission to register a secondary Musataha agreement',
  },
  error_10000096: {
    id: 'error_10000096',
    defaultmessages: 'Surveyor type is mandatory',
  },
  error_10000097: {
    id: 'error_10000097',
    defaultmessages: 'POA has no rights',
  },
  error_10000098: {
    id: 'error_10000098',
    defaultmessages:
      'Register primary musataha agreement and secondary musataha agreement on same property is not allowed',
  },
  error_100001: {
    id: 'error_100001',
    defaultmessages: 'Properties should be selected from same municipality',
  },
  error_10000101: {
    id: 'error_10000101',
    defaultmessages: "The agreement hasn't been generated yet. Please try again in 10 minutes.",
  },
  error_10000111: {
    id: 'error_10000111',
    defaultmessages: 'Document is not ready to download',
  },
  error_10000115: {
    id: 'error_10000115',
    defaultmessages: 'Could not complete ELMS Application. Please try again later.',
  },
  error_10000117: {
    id: 'error_10000117',
    defaultmessages: 'Amount must be entered as a precise decimal value, e.g. (19.4)',
  },
  error_10000119: {
    id: 'error_10000119',
    defaultmessages: 'No available Musataha agreement found on this property',
  },
  error_10000120: {
    id: 'error_10000120',
    defaultmessages: 'Only a Musateh can initiate the secondary agreement',
  },
  error_10000121: {
    id: 'error_10000121',
    defaultmessages: "Owner's POA cannot initiate the secondary agreement registration application",
  },
  error_100002: {
    id: 'error_100002',
    defaultmessages: 'Property Blocked',
  },
  error_100003: {
    id: 'error_100003',
    defaultmessages: 'Property is Partially Blocked',
  },
  error_100004: {
    id: 'error_100004',
    defaultmessages: 'Owner is Blocked',
  },
  error_100005: {
    id: 'error_100005',
    defaultmessages: 'Owner is Partially Blocked',
  },
  error_100006: {
    id: 'error_100006',
    defaultmessages: 'Invalid Plot',
  },
  error_100007: {
    id: 'error_100007',
    defaultmessages: 'Not having access to this property',
  },
  error_100008: {
    id: 'error_100008',
    defaultmessages: 'Property is not the plot',
  },
  error_100009: {
    id: 'error_100009',
    defaultmessages: 'Property share is not 100%',
  },
  error_100010: {
    id: 'error_100010',
    defaultmessages: 'Plot Excel Sheet Format is invalid',
  },
  error_100011: {
    id: 'error_100011',
    defaultmessages: 'Failed to upload the Excel sheet',
  },
  error_100012: {
    id: 'error_100012',
    defaultmessages: 'Could not fetch property information',
  },
  error_100013: {
    id: 'error_100013',
    defaultmessages: 'Failed to call ELMS API',
  },
  error_100014: {
    id: 'error_100014',
    defaultmessages: 'Active Application on plot',
  },
  error_100015: {
    id: 'error_100015',
    defaultmessages: 'Logged-In user must be company',
  },
  error_100016: {
    id: 'error_100016',
    defaultmessages: 'Invalid units found in the excel sheet',
  },
  error_100017: {
    id: 'error_100017',
    defaultmessages: 'surveyor not found',
  },
  error_100018: {
    id: 'error_100018',
    defaultmessages: 'Application is already picked by surveyor',
  },
  error_100019: {
    id: 'error_100019',
    defaultmessages: 'Properties are not added to the application',
  },
  error_100020: {
    id: 'error_100020',
    defaultmessages: 'project category cannot be primary for secondary developer',
  },
  error_100021: {
    id: 'error_100021',
    defaultmessages: 'surveyor company was not found',
  },
  error_100022: {
    id: 'error_100022',
    defaultmessages: 'ELMS application instance id is null',
  },
  error_100023: {
    id: 'error_100023',
    defaultmessages: 'some units are not added to BDMS',
  },
  error_100024: {
    id: 'error_100024',
    defaultmessages: 'invalid application status',
  },
  error_100025: {
    id: 'error_100025',
    defaultmessages: 'image not found',
  },
  error_100026: {
    id: 'error_100026',
    defaultmessages: 'You can’t perform AccessRP and GIS approval for the same application',
  },
  error_100027: {
    id: 'error_100027',
    defaultmessages: 'You can’t perform developer affair and municipality GIS approval for the same application',
  },
  error_100028: {
    id: 'error_100028',
    defaultmessages: 'Surveyor company has no owner',
  },
  error_100029: {
    id: 'error_100029',
    defaultmessages: 'surveyor company has invalid license',
  },
  error_100030: {
    id: 'error_100030',
    defaultmessages: 'Main Project Info is missing',
  },
  error_100031: {
    id: 'error_100031',
    defaultmessages: "One or more buildings were found as 'registered' in the project unit details file",
  },
  error_100032: {
    id: 'error_100032',
    defaultmessages: 'Invalid Data in the inventory sheet',
  },
  error_100033: {
    id: 'error_100033',
    defaultmessages:
      'This user does not have the permission to pay using ADGM wallet, kindly contact admin or pay using Debit/Credit card',
  },
  error_100034: {
    id: 'error_100034',
    defaultmessages: 'Project ID cannot be empty',
  },
  error_100035: {
    id: 'error_100035',
    defaultmessages: 'Project is not accessible to the logged-in user',
  },
  error_100036: {
    id: 'error_100036',
    defaultmessages: 'Account trustee not found',
  },
  error_100037: {
    id: 'error_100037',
    defaultmessages: 'Escrow account details cannot be empty',
  },
  error_100038: {
    id: 'error_100038',
    defaultmessages: 'Escrow account number cannot be empty',
  },
  error_100039: {
    id: 'error_100039',
    defaultmessages: 'Escrow account IBAN cannot be empty',
  },
  error_100040: {
    id: 'error_100040',
    defaultmessages: 'Escrow retention number cannot be empty',
  },
  error_100041: {
    id: 'error_100041',
    defaultmessages: 'ELMS project ID cannot be empty',
  },
  error_100042: {
    id: 'error_100042',
    defaultmessages: 'Could not find properties for this project',
  },
  error_100043: {
    id: 'error_100043',
    defaultmessages: 'Could not find company information for account trustee',
  },
  error_100044: {
    id: 'error_100044',
    defaultmessages: 'Escrow trustee company has an invalid license',
  },
  error_100045: {
    id: 'error_100045',
    defaultmessages: 'Not an authorized signatory',
  },
  error_100046: {
    id: 'error_100046',
    defaultmessages: 'Could not find a condition for the given application ID and condition ID combination',
  },
  error_100047: {
    id: 'error_100047',
    defaultmessages: 'Escrow project agreement condition not found',
  },
  error_100048: {
    id: 'error_100048',
    defaultmessages: 'Cannot return the application',
  },
  error_100049: {
    id: 'error_100049',
    defaultmessages: 'Invalid action for this step',
  },
  error_100050: {
    id: 'error_100050',
    defaultmessages: 'Reason for return cannot exceed 255 characters',
  },
  error_100051: {
    id: 'error_100051',
    defaultmessages: 'Reason for return is required',
  },
  error_100052: {
    id: 'error_100052',
    defaultmessages: 'Trustee approval can be given only by the selected trustee',
  },
  error_100053: {
    id: 'error_100053',
    defaultmessages: 'Escrow account agreement not found',
  },
  error_100054: {
    id: 'error_100054',
    defaultmessages: 'Escrow account details cannot be saved in this step',
  },
  error_100055: {
    id: 'error_100055',
    defaultmessages: 'Escrow trustee not selected',
  },
  error_100056: {
    id: 'error_100056',
    defaultmessages: "Escrow trustee's municipality not provided",
  },
  error_100057: {
    id: 'error_100057',
    defaultmessages: "Developer's registered municipality not provided",
  },
  error_100058: {
    id: 'error_100058',
    defaultmessages: 'Escrow trustee not selected',
  },
  error_100059: {
    id: 'error_100059',
    defaultmessages: 'Selected profession type is not an account trustee',
  },
  error_100060: {
    id: 'error_100060',
    defaultmessages: 'Invalid company owner ID',
  },
  error_100061: {
    id: 'error_100061',
    defaultmessages: 'Central Bank license is invalid.',
  },
  error_100062: {
    id: 'error_100062',
    defaultmessages: 'The entered escrow account number is already associated with another real estate project',
  },
  error_100063: {
    id: 'error_100063',
    defaultmessages: 'The entered escrow account IBAN is already associated with another real estate project',
  },
  error_100064: {
    id: 'error_100064',
    defaultmessages: 'The entered retention account number is already associated with another real estate project',
  },
  error_100065: {
    id: 'error_100065',
    defaultmessages: 'Could not find valid profession agreement from ELMS',
  },
  error_100068: {
    id: 'error_100068',
    defaultmessages: 'The entered retention IBAN number is already associated with another real estate project.',
  },
  error_100070: {
    id: 'error_100070',
    defaultmessages: 'The selected account trustee does not have an authorized signatory',
  },
  error_100071: {
    id: 'error_100071',
    defaultmessages: 'Only a bank can initiate this type of PMA agreement',
  },
  error_100072: {
    id: 'error_100072',
    defaultmessages: 'Selecting Involved Parties is required',
  },
  error_100073: {
    id: 'error_100073',
    defaultmessages: 'Possessory Mortgage not found',
  },
  error_100074: {
    id: 'error_100074',
    defaultmessages: 'Cannot find Mortgage Bank on DARI',
  },
  error_100075: {
    id: 'error_100075',
    defaultmessages: 'Possessory Mortgage details not found',
  },
  error_100076: {
    id: 'error_100076',
    defaultmessages: 'agreement start date cannot be before mortgage start date',
  },
  error_100077: {
    id: 'error_100077',
    defaultmessages: 'agreement end date cannot be after mortgage end date',
  },
  error_100078: {
    id: 'error_100078',
    defaultmessages: 'Mortgage agreement date is empty',
  },
  error_100079: {
    id: 'error_100079',
    defaultmessages: 'agreement start date cannot be before Mortgage agreement date',
  },
  error_100080: {
    id: 'error_100080',
    defaultmessages: 'Only a Bank or PMC can initiate this type of PMA agreement',
  },
  error_100081: {
    id: 'error_100081',
    defaultmessages: 'Workflow ID is mandatory',
  },
  error_100082: {
    id: 'error_100082',
    defaultmessages: 'Certificate Number is mandatory',
  },
  error_100083: {
    id: 'error_100083',
    defaultmessages: 'Plot Number is mandatory',
  },
  error_100084: {
    id: 'error_100084',
    defaultmessages: 'user municipality is different than the application municipality',
  },
  error_100085: {
    id: 'error_100085',
    defaultmessages: 'File type does not match its contents',
  },
  error_100086: {
    id: 'error_100086',
    defaultmessages: 'File name is too long',
  },
  error_100087: {
    id: 'error_100087',
    defaultmessages: 'Application cannot be submitted on the current step',
  },
  error_100088: {
    id: 'error_100088',
    defaultmessages: 'Agreement amount cannot exceed 10 digits',
  },
  error_100089: {
    id: 'error_100089',
    defaultmessages: 'Company trade license is expired.',
  },
  error_100092: {
    id: 'error_100092',
    defaultmessages: 'The start date of the agreement is one day after the PMA ends.',
  },
  error_100095: {
    id: 'error_100095',
    defaultmessages: 'Second Party is Blocked',
  },
  error_100098: {
    id: 'error_100098',
    defaultmessages: 'Required amount is mandatory',
  },
  error_100099: {
    id: 'error_100099',
    defaultmessages: 'Please enter the IBAN in order to proceed',
  },
  error_100100: {
    id: 'error_100100',
    defaultmessages: 'Service provider company type is mandatory',
  },
  error_100101: {
    id: 'error_100101',
    defaultmessages: 'Project payment details not found',
  },
  error_100102: {
    id: 'error_100102',
    defaultmessages: 'Service provider not found on DARI',
  },
  error_100103: {
    id: 'error_100103',
    defaultmessages: 'Could not find the service provider details with the trade license number',
  },
  error_100104: {
    id: 'error_100104',
    defaultmessages: 'Service provider ID cannot be empty',
  },
  error_100105: {
    id: 'error_100105',
    defaultmessages: 'Cannot return the application to the designated party',
  },
  error_100106: {
    id: 'error_100106',
    defaultmessages: 'Inspection company does not exist on DARI',
  },
  error_100107: {
    id: 'error_100107',
    defaultmessages: 'The service provider is different from the inspection company',
  },
  error_100108: {
    id: 'error_100108',
    defaultmessages: 'Unable to find the inspection company on the system for removal',
  },
  error_100109: {
    id: 'error_100109',
    defaultmessages: 'Inspection company not found',
  },
  error_100110: {
    id: 'error_100110',
    defaultmessages: 'Total construction cost should not be null',
  },
  error_100111: {
    id: 'error_100111',
    defaultmessages: 'Total progress percentage should not be null',
  },
  error_100112: {
    id: 'error_100112',
    defaultmessages: 'Total progress percentage is less than 20%',
  },
  error_100113: {
    id: 'error_100113',
    defaultmessages: 'Escrow account balance should not be null',
  },
  error_100114: {
    id: 'error_100114',
    defaultmessages: 'Payment method should not be empty',
  },
  error_100115: {
    id: 'error_100115',
    defaultmessages: 'VAT status could not be empty',
  },
  error_100116: {
    id: 'error_100116',
    defaultmessages: 'You cannot perform this action',
  },
  error_100117: {
    id: 'error_100117',
    defaultmessages: 'The payment exceeds the available escrow account balance',
  },
  error_100118: {
    id: 'error_100118',
    defaultmessages: 'Inspection company not found',
  },
  error_100119: {
    id: 'error_100119',
    defaultmessages: 'Required data is invalid',
  },
  error_100120: {
    id: 'error_100120',
    defaultmessages: 'Inspection company not found on AccessRP',
  },
  error_100121: {
    id: 'error_100121',
    defaultmessages: 'It is required to add at least one service provider',
  },
  error_100122: {
    id: 'error_100122',
    defaultmessages: 'Service provider company type must be selected',
  },
  error_100123: {
    id: 'error_100123',
    defaultmessages: 'IBAN should have 23 characters',
  },
  error_100124: {
    id: 'error_100124',
    defaultmessages: 'IBAN field accepts letters and numbers only',
  },
  error_100125: {
    id: 'error_100125',
    defaultmessages: 'Could not find project',
  },
  error_100126: {
    id: 'error_100126',
    defaultmessages: 'Bank not found on AccessRP',
  },
  error_100129: {
    id: 'error_100129',
    defaultmessages: 'The logged-in user is not the same as the one accepted, or this application is not accepted',
  },
  error_100130: {
    id: 'error_100130',
    defaultmessages: 'Invalid Task Type',
  },
  error_100131: {
    id: 'error_100131',
    defaultmessages: 'A service provider already exists with the same company type',
  },
  error_100132: {
    id: 'error_100132',
    defaultmessages: 'The requested amount should not be more than 20 digits',
  },
  error_100133: {
    id: 'error_100133',
    defaultmessages: 'Could not find an investment agreement on land',
  },
  error_100134: {
    id: 'error_100134',
    defaultmessages: 'Could not save the investment agreement details',
  },
  error_100135: {
    id: 'error_100135',
    defaultmessages: 'Could not fetch the investment agreement details',
  },
  error_100136: {
    id: 'error_100136',
    defaultmessages: 'agreement duration cannot exceed 10 years',
  },
  error_100137: {
    id: 'error_100137',
    defaultmessages: 'agreement end date must not exceed the investment agreement end date',
  },
  error_100138: {
    id: 'error_100138',
    defaultmessages: 'agreement start date must not precede the investment agreement start date',
  },
  error_100140: {
    id: 'error_100140',
    defaultmessages: 'The second party has financial obligations',
  },
  error_100141: {
    id: 'error_100141',
    defaultmessages: 'Properties should be selected from same sector',
  },
  error_100142: {
    id: 'error_100142',
    defaultmessages: 'Properties should be selected from same district',
  },
  error_100143: {
    id: 'error_100143',
    defaultmessages: 'Primary project must have ownership plots',
  },
  error_100144: {
    id: 'error_100144',
    defaultmessages: 'Secondary project must have ownership and Musataha plots',
  },
  error_100145: {
    id: 'error_100145',
    defaultmessages: "The number of plots in the inventory sheet doesn't match with project plots",
  },
  error_100146: {
    id: 'error_100146',
    defaultmessages: 'The municipality uploaded in the sheet is incorrect',
  },
  error_100147: {
    id: 'error_100147',
    defaultmessages: 'The community uploaded in the sheet is incorrect',
  },
  error_100148: {
    id: 'error_100148',
    defaultmessages: 'The district uploaded in the sheet is incorrect',
  },
  error_100149: {
    id: 'error_100149',
    defaultmessages: 'Project name in English already exist for same developer',
  },
  error_100150: {
    id: 'error_100150',
    defaultmessages: 'Project name in Arabic already exist for same developer',
  },
  error_100151: {
    id: 'error_100151',
    defaultmessages: 'Municipality is missing in uploaded inventory sheet',
  },
  error_100152: {
    id: 'error_100152',
    defaultmessages: 'Community is missing in uploaded inventory sheet',
  },
  error_100153: {
    id: 'error_100153',
    defaultmessages: 'District is missing in uploaded inventory sheet',
  },
  error_100154: {
    id: 'error_100154',
    defaultmessages: 'Unit number is missing in uploaded inventory sheet',
  },
  error_100155: {
    id: 'error_100155',
    defaultmessages: 'Plot number is missing in uploaded inventory sheet',
  },
  error_100156: {
    id: 'error_100156',
    defaultmessages: 'Unit number is missing in uploaded inventory sheet',
  },
  error_100157: {
    id: 'error_100157',
    defaultmessages: 'Building number can only be numeric value',
  },
  error_100159: {
    id: 'error_100159',
    defaultmessages: 'Plot sheet should not be empty',
  },
  error_100160: {
    id: 'error_100160',
    defaultmessages: 'Inventory sheet should not be empty',
  },
  error_100161: {
    id: 'error_100161',
    defaultmessages: "The number of plots in the inventory sheet doesn't match with the project plots",
  },
  error_100162: {
    id: 'error_100162',
    defaultmessages: 'Road is required in case of Al Ain City',
  },
  error_100163: {
    id: 'error_100163',
    defaultmessages: "Road in the inventory sheet doesn't match with the project plots",
  },
  error_100164: {
    id: 'error_100164',
    defaultmessages: "Plot number in the inventory sheet doesn't match with the project plots",
  },
  error_1200001: {
    id: 'error_1200001',
    defaultmessages: "PMC doesn't have a valid PMA.",
  },
  error_1200011: {
    id: 'error_1200011',
    defaultmessages: 'PMC have block',
  },
  error_1200013: {
    id: 'error_1200013',
    defaultmessages: 'Owner has blocks',
  },
  error_1200022: {
    id: 'error_1200022',
    defaultmessages: 'No properties available for selected project',
  },
  error_1200024: {
    id: 'error_1200024',
    defaultmessages: 'Developer is blocked.',
  },
  error_1200030: {
    id: 'error_1200030',
    defaultmessages: "User doesn't have broker initiate permission",
  },
  error_1200031: {
    id: 'error_1200031',
    defaultmessages: "Broker doesn't have a valid broker license",
  },
  error_13000003: {
    id: 'error_13000003',
    defaultmessages: 'Invalid Initiator Party',
  },
  error_200000: {
    id: 'error_200000',
    defaultmessages:
      'The company license source must be ADGM  to be eligible for registering tenancy agreements in Al-Maryah or Al-Reem islands',
  },
  error_200001: {
    id: 'error_200001',
    defaultmessages:
      'agreement duration cannot exceed 1 year for properties located inside Al-Maryah and Al-Reem islands',
  },
  error_200002: {
    id: 'error_200002',
    defaultmessages: 'Exceeded maximum grace period {s}',
  },
  error_200003: {
    id: 'error_200003',
    defaultmessages: 'Grace period is not allowed for government and diplomat agreements',
  },
  error_200004: {
    id: 'error_200004',
    defaultmessages: 'The agreement duration is less than the minimum requirement of {s} days',
  },
  error_200005: {
    id: 'error_200005',
    defaultmessages: 'Only the guardian can initiate this service',
  },
  error_200006: {
    id: 'error_200006',
    defaultmessages: 'Agreement minimum duration with grace period is not met {s}',
  },
  error_200007: {
    id: 'error_200007',
    defaultmessages: 'Invalid POA. It should be valid for 3 years.',
  },
  error_200008: {
    id: 'error_200008',
    defaultmessages: 'First party is not configured',
  },
  error_200009: {
    id: 'error_200009',
    defaultmessages: 'Second party is not configured',
  },
  error_200010: {
    id: 'error_200010',
    defaultmessages: 'Residential agreements are not allowed on commercial units',
  },
  error_200012: {
    id: 'error_200012',
    defaultmessages: 'Date of birth is invalid',
  },
  error_200013: {
    id: 'error_200013',
    defaultmessages: 'unable to fetch details',
  },
  error_200014: {
    id: 'error_200014',
    defaultmessages:
      'Company cannot be added as the first party because another one already exists under this category.',
  },
  error_200016: {
    id: 'error_200016',
    defaultmessages: 'Individual is not a first party company employee',
  },
  error_200018: {
    id: 'error_200018',
    defaultmessages: 'Mortgage type cannot be swapped without consent',
  },
  error_200019: {
    id: 'error_200019',
    defaultmessages: 'At least 1 property should exist in mortgage',
  },
  error_200020: {
    id: 'error_200020',
    defaultmessages: 'Invalid valuator profession id',
  },
  error_200021: {
    id: 'error_200021',
    defaultmessages: 'Company cannot be added as a First party as an Individual is already added under this category',
  },
  error_200022: {
    id: 'error_200022',
    defaultmessages: 'The agreement start date can be set to any date up to 30 days max from the initiation day.',
  },
  error_200023: {
    id: 'error_200023',
    defaultmessages: 'The agreement end date cannot be set to a date before the initiation date for AceesRP online.',
  },
  error_200024: {
    id: 'error_200024',
    defaultmessages:
      'The agreement initiated by AccessRP admin (only for those mandated by the court order), the agreement end date can be set to a date before the initiation date.',
  },
  error_200025: {
    id: 'error_200025',
    defaultmessages: 'Can not renew agreement that will expire after more than 180 days',
  },
  error_20020: {
    id: 'error_20020',
    defaultmessages: 'Could not fetch property details',
  },
  error_20021: {
    id: 'error_20021',
    defaultmessages: 'Owner does not exist',
  },
  error_20022: {
    id: 'error_20022',
    defaultmessages: 'Owner is blocked',
  },
  error_20023: {
    id: 'error_20023',
    defaultmessages: 'Owner is financially blocked',
  },
  error_20025: {
    id: 'error_20025',
    defaultmessages: 'For Under age classification, first party owner must be under age as well',
  },
  error_300003: {
    id: 'error_300003',
    defaultmessages:
      "This representative is declared for this application with different representative type, you can't change the representative type",
  },
  error_300007: {
    id: 'error_300007',
    defaultmessages: 'City is mandatory',
  },
  error_300008: {
    id: 'error_300008',
    defaultmessages: 'Country is mandatory',
  },
  error_300009: {
    id: 'error_300009',
    defaultmessages: 'Representative already exists',
  },
  error_300010: {
    id: 'error_300010',
    defaultmessages: 'District ID is mandatory',
  },
  error_300011: {
    id: 'error_300011',
    defaultmessages: 'Community ID is mandatory',
  },
  error_300012: {
    id: 'error_300012',
    defaultmessages: 'Both Emirates ID and Unified Number are required',
  },
  error_300013: {
    id: 'error_300013',
    defaultmessages: 'EID is mandatory',
  },
  error_300014: {
    id: 'error_300014',
    defaultmessages: 'MOI number is mandatory',
  },
  error_300015: {
    id: 'error_300015',
    defaultmessages: 'Passport number is mandatory',
  },
  error_300017: {
    id: 'error_300017',
    defaultmessages: 'License number is mandatory',
  },
  error_300018: {
    id: 'error_300018',
    defaultmessages: 'Authorization agreement type is mandatory',
  },
  error_300019: {
    id: 'error_300019',
    defaultmessages: 'agreement number is mandatory',
  },
  error_300020: {
    id: 'error_300020',
    defaultmessages: 'Party already exists',
  },
  error_300021: {
    id: 'error_300021',
    defaultmessages: 'Authorization agreement type and classification are mandatory.',
  },
  error_300022: {
    id: 'error_300022',
    defaultmessages: 'Authorization agreement classification and type are mandatory.',
  },
  error_300023: {
    id: 'error_300023',
    defaultmessages: 'Authorization agreement classification is invalid',
  },
  error_300024: {
    id: 'error_300024',
    defaultmessages: 'Agency cannot have a company as the first party.',
  },
  error_300025: {
    id: 'error_300025',
    defaultmessages: 'Company signatory cannot have an individual as the first party.',
  },
  error_300026: {
    id: 'error_300026',
    defaultmessages: 'Agency cannot have a company as the second party.',
  },
  error_300027: {
    id: 'error_300027',
    defaultmessages: 'Company cannot have another one as the second party.',
  },
  error_300028: {
    id: 'error_300028',
    defaultmessages: 'Surrender date is not between agreement start and end date',
  },
  error_300029: {
    id: 'error_300029',
    defaultmessages:
      'Please download the variated mortgage agreement from mortgage modification application. application number {applicationNumber}',
  },
  error_400: {
    id: 'error_400',
    defaultmessages: 'Duplicate Record',
  },
  error_403: {
    id: 'error_403',
    defaultmessages: 'Access denied',
  },
  error_43: {
    id: 'error_43',
    defaultmessages: 'invalid plot',
  },
  error_50000100: {
    id: 'error_50000100',
    defaultmessages: 'Only guardian can initiate this service',
  },
  error_50000103: {
    id: 'error_50000103',
    defaultmessages: 'You have no rights to perform this action',
  },
  error_50000123: {
    id: 'error_50000123',
    defaultmessages: 'Company commercial license is expired',
  },
  error_50000135: {
    id: 'error_50000135',
    defaultmessages: 'POA validity is invalid — it should be valid for 3 years',
  },
  error_50000142: {
    id: 'error_50000142',
    defaultmessages: 'Company cannot be added as a first party as another company already exists under this category',
  },
  error_50000143: {
    id: 'error_50000143',
    defaultmessages: 'Company is not associated to employee added as second party',
  },
  error_50000144: {
    id: 'error_50000144',
    defaultmessages: 'Individual is not a first party company employee',
  },
  error_50000179: {
    id: 'error_50000179',
    defaultmessages: "The agreement start date should be later than the previous agreement's closure date",
  },
  error_50000180: {
    id: 'error_50000180',
    defaultmessages: 'Agreement start date should be equal or greater than the previous agreement Surrender date',
  },
  error_50000181: {
    id: 'error_50000181',
    defaultmessages: "The agreement start date should be later than the previous agreement's surrender date",
  },
  error_50000192: {
    id: 'error_50000192',
    defaultmessages: 'Agreement No. is not correct, please enter a valid agreement No.',
  },
  error_50000199: {
    id: 'error_50000199',
    defaultmessages: 'Broker not found',
  },
  error_50000235: {
    id: 'error_50000235',
    defaultmessages: 'You have no rights to perform this action',
  },
  error_50000236: {
    id: 'error_50000236',
    defaultmessages: 'Second party not found in the PMA!',
  },
  error_50000237: {
    id: 'error_50000237',
    defaultmessages: 'The PMA has expired. Please renew it to proceed with any actions.',
  },
  error_50000238: {
    id: 'error_50000238',
    defaultmessages: 'The logged-in PMC/User does not have permission.',
  },
  error_50000243: {
    id: 'error_50000243',
    defaultmessages:
      'The agreement minimum duration is not as per the agreement type selected, please adjust the duration and try again ',
  },
  error_5000025672: {
    id: 'error_5000025672',
    defaultmessages: 'Lessee phone number has an invalid format',
  },
  error_500002568: {
    id: 'error_500002568',
    defaultmessages: 'Agreement type is mandatory',
  },
  error_500002570: {
    id: 'error_500002570',
    defaultmessages: 'Unable to save the application',
  },
  error_500002571: {
    id: 'error_500002571',
    defaultmessages: 'Customer does not exist',
  },
  error_500002573: {
    id: 'error_500002573',
    defaultmessages: 'The company with the given commercial license number does not exist',
  },
  error_500002574: {
    id: 'error_500002574',
    defaultmessages: 'Lessee type is mandatory',
  },
  error_500002575: {
    id: 'error_500002575',
    defaultmessages: 'The premise ID is mandatory',
  },
  error_500002578: {
    id: 'error_500002578',
    defaultmessages: 'Commercial License No is required',
  },
  error_500002579: {
    id: 'error_500002579',
    defaultmessages: 'The representative name is mandatory',
  },
  error_500002580: {
    id: 'error_500002580',
    defaultmessages: 'The representative ID is mandatory',
  },
  error_500002581: {
    id: 'error_500002581',
    defaultmessages: 'Company name is mandatory',
  },
  error_500002582: {
    id: 'error_500002582',
    defaultmessages: "The company's email is mandatory",
  },
  error_500002583: {
    id: 'error_500002583',
    defaultmessages: 'The phone number is mandatory',
  },
  error_500002586: {
    id: 'error_500002586',
    defaultmessages: 'Lessee name is mandatory',
  },
  error_500002587: {
    id: 'error_500002587',
    defaultmessages: 'Lessee email is mandatory',
  },
  error_500002588: {
    id: 'error_500002588',
    defaultmessages: 'Lessee phone number is mandatory',
  },
  error_500002590: {
    id: 'error_500002590',
    defaultmessages: 'Agreement start date is mandatory',
  },
  error_500002591: {
    id: 'error_500002591',
    defaultmessages: 'Agreement end date is mandatory',
  },
  error_500002592: {
    id: 'error_500002592',
    defaultmessages: 'No. of installments field is required.',
  },
  error_500002593: {
    id: 'error_500002593',
    defaultmessages: 'Payment method is mandatory',
  },
  error_500002595: {
    id: 'error_500002595',
    defaultmessages: 'Total amount should be present',
  },
  error_500002601: {
    id: 'error_500002601',
    defaultmessages: "You can't use this commercial license for government or diplomat",
  },
  error_500002609: {
    id: 'error_500002609',
    defaultmessages: 'Agreement end date cannot be more than PMA end date',
  },
  error_50000261: {
    id: 'error_50000261',
    defaultmessages: 'Primary contact is mandatory',
  },
  error_500002619: {
    id: 'error_500002619',
    defaultmessages: 'Same occupant already added',
  },
  error_500002622: {
    id: 'error_500002622',
    defaultmessages: 'At least two properties should be added for multiple unit case',
  },
  error_50000264: {
    id: 'error_50000264',
    defaultmessages:
      "You can't select the primary lessor as a primary contact in case if you select the primary lessor a company",
  },
  error_500002647: {
    id: 'error_500002647',
    defaultmessages: 'Passport is expired',
  },
  error_500002650: {
    id: 'error_500002650',
    defaultmessages: 'Invalid date of birth',
  },
  error_500002652: {
    id: 'error_500002652',
    defaultmessages: 'Commercial License should be registered in ADGM',
  },
  error_500002653: {
    id: 'error_500002653',
    defaultmessages: 'Only commercial companies are allowed in public benefit association',
  },
  error_500002654: {
    id: 'error_500002654',
    defaultmessages: 'Passport number is required',
  },
  error_500002655: {
    id: 'error_500002655',
    defaultmessages: 'User with the same passport number already exists',
  },
  error_500002662: {
    id: 'error_500002662',
    defaultmessages: 'User with the same email already exists',
  },
  error_500002663: {
    id: 'error_500002663',
    defaultmessages: 'Mobile number is empty or invalid',
  },
  error_500002664: {
    id: 'error_500002664',
    defaultmessages: 'User with the same mobile already exists',
  },
  error_500002667: {
    id: 'error_500002667',
    defaultmessages: 'The entered mobile number is already linked to another application',
  },
  error_500002669: {
    id: 'error_500002669',
    defaultmessages: 'The agreement start date can be up to max 30 days from the initiation date',
  },
  error_500002671: {
    id: 'error_500002671',
    defaultmessages: 'This employee is already assigned to this company',
  },
  error_500002672: {
    id: 'error_500002672',
    defaultmessages: 'Lessee phone number has invalid format',
  },
  error_500002673: {
    id: 'error_500002673',
    defaultmessages: 'The phone number has an invalid format',
  },
  error_500002674: {
    id: 'error_500002674',
    defaultmessages: 'Lessee email has an invalid format',
  },
  error_500002675: {
    id: 'error_500002675',
    defaultmessages: 'Mobile Number or Email has an invalid format',
  },
  error_500002676: {
    id: 'error_500002676',
    defaultmessages: 'You can do the residential agreement only in residential properties',
  },
  error_500002677: {
    id: 'error_500002677',
    defaultmessages: 'You cannot add yourself as an employee. Please try logging in with a different account.',
  },
  error_500002678: {
    id: 'error_500002678',
    defaultmessages: 'Right hold type is mandatory',
  },
  error_500002679: {
    id: 'error_500002679',
    defaultmessages: 'Paid by is mandatory',
  },
  error_500002680: {
    id: 'error_500002680',
    defaultmessages: 'Leasehold agreement should exist on the land',
  },
  error_500002681: {
    id: 'error_500002681',
    defaultmessages: 'Installments are not found for the agreement',
  },
  error_500002682: {
    id: 'error_500002682',
    defaultmessages: 'License number is missing',
  },
  error_500002683: {
    id: 'error_500002683',
    defaultmessages: 'Government companies should not be allowed as second party',
  },
  error_500002684: {
    id: 'error_500002684',
    defaultmessages: 'The company with given license number does not exist',
  },
  error_500002685: {
    id: 'error_500002685',
    defaultmessages: 'Failed to save the payment receipt',
  },
  error_500002686: {
    id: 'error_500002686',
    defaultmessages: 'Failed to save the payment wallet receipt',
  },
  error_500002687: {
    id: 'error_500002687',
    defaultmessages: 'The company is not registered in AccessRP',
  },
  error_500002688: {
    id: 'error_500002688',
    defaultmessages: "The company's license is expired",
  },
  error_500002689: {
    id: 'error_500002689',
    defaultmessages: 'Failed to perform a person inquiry',
  },
  error_500002690: {
    id: 'error_500002690',
    defaultmessages: 'Company is not registered in AccessRP',
  },
  error_500002691: {
    id: 'error_500002691',
    defaultmessages: 'Applicant already exists for this application',
  },
  error_500002692: {
    id: 'error_500002692',
    defaultmessages: 'Applicant is not found for this application',
  },
  error_500002693: {
    id: 'error_500002693',
    defaultmessages: 'Applicant mobile number is invalid',
  },
  error_500002694: {
    id: 'error_500002694',
    defaultmessages: 'Applicant email is invalid',
  },
  error_500002695: {
    id: 'error_500002695',
    defaultmessages: 'Customer should be an individual not a company',
  },
  error_500002696: {
    id: 'error_500002696',
    defaultmessages: 'Application should be offline',
  },
  error_500002697: {
    id: 'error_500002697',
    defaultmessages: 'Applicant should exist',
  },
  error_500002698: {
    id: 'error_500002698',
    defaultmessages: 'Application notification config is not found',
  },
  error_500002699: {
    id: 'error_500002699',
    defaultmessages: 'The payment link is invalid !',
  },
  error_500002700: {
    id: 'error_500002700',
    defaultmessages: 'The payment link is expired!',
  },
  error_500002701: {
    id: 'error_500002701',
    defaultmessages: "The applicant's mobile number is not registered in the UAE.",
  },
  error_500002706: {
    id: 'error_500002706',
    defaultmessages: 'A user with the same Emirates ID already exists.',
  },
  error_500002713: {
    id: 'error_500002713',
    defaultmessages: 'UN/EID is not valid, please make sure you enter it',
  },
  error_500002714: {
    id: 'error_500002714',
    defaultmessages: 'Application type is not valid',
  },
  error_500002715: {
    id: 'error_500002715',
    defaultmessages:
      'Ownership changed please cancel this PMA agreement and initiate a new PMA for each owner separately.',
  },
  error_500002720: {
    id: 'error_500002720',
    defaultmessages: 'Only the leaseholder is authorized to generate the certificate.',
  },
  error_500002723: {
    id: 'error_500002723',
    defaultmessages: 'Please download the mortgage agreement from the most recent mortgage service application.',
  },
  error_500002729: {
    id: 'error_500002729',
    defaultmessages: "Mortgage start and end dates must fall within the leasehold agreement's start and end dates",
  },
  error_500002732: {
    id: 'error_500002732',
    defaultmessages: 'This service can only be used with an ADGM license',
  },
  error_500002733: {
    id: 'error_500002733',
    defaultmessages: 'Only the leaseholder is authorized to initiate this service',
  },
  error_500002737: {
    id: 'error_500002737',
    defaultmessages:
      'You cannot release all properties from this mortgage agreement using the Mortgage Variation service! To release all mortgages in this agreement, please use the Mortgage Discharge service.',
  },
  error_500002741: {
    id: 'error_500002741',
    defaultmessages: 'The selling amount must be greater than 0.',
  },
  error_500002742: {
    id: 'error_500002742',
    defaultmessages: ' The evaluation amount must be greater than 0.',
  },
  error_500002744: {
    id: 'error_500002744',
    defaultmessages: 'The end date should be after the start date!',
  },
  error_500002754: {
    id: 'error_500002754',
    defaultmessages: 'Occupant mobile number is required',
  },
  error_500002756: {
    id: 'error_500002756',
    defaultmessages: "The occupant's email format is invalid. Please enter a valid email address.",
  },
  error_500002757: {
    id: 'error_500002757',
    defaultmessages: "The occupant's mobile number has an invalid format. Please enter a valid mobile number.",
  },
  error_500002758: {
    id: 'error_500002758',
    defaultmessages: 'The agreement end date cannot be later than 31/12/2025.',
  },
  error_500002781: {
    id: 'error_500002781',
    defaultmessages: 'Card payment is already in progress. Please try again shortly.',
  },
  error_500002798: {
    id: 'error_500002798',
    defaultmessages: 'Agreement start date should not be before {date}.',
  },
  error_500002799: {
    id: 'error_500002799',
    defaultmessages: 'Agreement end date should not be after {date}.',
  },
  error_500002800: {
    id: 'error_500002800',
    defaultmessages: 'Parent agreement start date should not be after sub agreement start date',
  },
  error_500002801: {
    id: 'error_500002801',
    defaultmessages: 'Parent agreement end date should not be before sub lease agreement end date\n ',
  },
  error_500002802: {
    id: 'error_500002802',
    defaultmessages: 'You have no right for subleasing! only lessee allowed for subleasing initiation.',
  },
  error_500002805: {
    id: 'error_500002805',
    defaultmessages: 'Subleasing allowed on commercial agreement type  only.',
  },
  error_500002809: {
    id: 'error_500002809',
    defaultmessages: "Lessor and lessee can't be the same person",
  },
  error_500002818: {
    id: 'error_500002818',
    defaultmessages: 'You can\'t modify permission now!  because master or child agreement under "In progress" state.',
  },
  error_500002821: {
    id: 'error_500002821',
    defaultmessages: 'Attendance type is mandatory !',
  },
  error_500002822: {
    id: 'error_500002822',
    defaultmessages: 'ESCROW details not found',
  },
  error_500002823: {
    id: 'error_500002823',
    defaultmessages: 'ESCROW Bank details not found',
  },
  error_500002824: {
    id: 'error_500002824',
    defaultmessages: 'Flow type is mandatory',
  },
  error_500002825: {
    id: 'error_500002825',
    defaultmessages: 'Non payment option only selectable by developer',
  },
  error_500002826: {
    id: 'error_500002826',
    defaultmessages: 'Forfeited amount is mandatory',
  },
  error_500002827: {
    id: 'error_500002827',
    defaultmessages: 'Refunded amount is mandatory',
  },
  error_500002828: {
    id: 'error_500002828',
    defaultmessages: "Both refunded and forfeited amount can't be zero; at least one must be greater than zero",
  },
  error_500002829: {
    id: 'error_500002829',
    defaultmessages: "Total refunded amount and buyers' refunded amount sum should be the same",
  },
  error_500002830: {
    id: 'error_500002830',
    defaultmessages: 'Please add termination details first',
  },
  error_500002831: {
    id: 'error_500002831',
    defaultmessages: 'Forfeited amount must be greater than zero',
  },
  error_500002832: {
    id: 'error_500002832',
    defaultmessages: "Same Committee member can't be selected again",
  },
  error_500002833: {
    id: 'error_500002833',
    defaultmessages: "Paid amount can't be greater than 70% of sale amount",
  },
  error_500002842: {
    id: 'error_500002842',
    defaultmessages: 'Only the developer can initiate this service',
  },
  error_500002844: {
    id: 'error_500002844',
    defaultmessages: "Paid amount can't be greater than sale amount",
  },
  error_500003: {
    id: 'error_500003',
    defaultmessages:
      'Agreement amount should not exceed more than 5% of the previous agreement amount and the entered rent amount for the selected period.',
  },
  error_5000032: {
    id: 'error_5000032',
    defaultmessages: 'Invalid application status',
  },
  error_500006: {
    id: 'error_500006',
    defaultmessages: 'Developer is not found',
  },
  error_500007: {
    id: 'error_500007',
    defaultmessages: 'Unsupported file format',
  },
  error_5000096: {
    id: 'error_5000096',
    defaultmessages: 'File name is too long',
  },
  error_500022: {
    id: 'error_500022',
    defaultmessages: 'Under age sellers must have representatives',
  },
  error_500023: {
    id: 'error_500023',
    defaultmessages: 'Add representative failed',
  },
  error_500024: {
    id: 'error_500024',
    defaultmessages: 'Representative not found',
  },
  error_500025: {
    id: 'error_500025',
    defaultmessages: 'Transaction share exceeds ownership',
  },
  error_500026: {
    id: 'error_500026',
    defaultmessages: 'invalid shares should between 1 and 100',
  },
  error_500027: {
    id: 'error_500027',
    defaultmessages: 'Total shares should not be greater than 100%',
  },
  error_500028: {
    id: 'error_500028',
    defaultmessages: 'Party list cannot be empty',
  },
  error_50002800: {
    id: 'error_50002800',
    defaultmessages: 'Parent agreement start date should not be after sub lease agreement start date',
  },
  error_500029: {
    id: 'error_500029',
    defaultmessages: 'Buyer company and user ID cannot be null at the same time.',
  },
  error_500030: {
    id: 'error_500030',
    defaultmessages: 'Party ID cannot be null',
  },
  error_500031: {
    id: 'error_500031',
    defaultmessages: 'Selected party does not exist',
  },
  error_500032: {
    id: 'error_500032',
    defaultmessages: 'Invalid shares should be between 1 and 100',
  },
  error_500033: {
    id: 'error_500033',
    defaultmessages: 'Total buying shares should be 100%',
  },
  error_500034: {
    id: 'error_500034',
    defaultmessages: 'Seller and buyer cannot be the same.',
  },
  error_500035: {
    id: 'error_500035',
    defaultmessages: 'Seller company must have a POA.',
  },
  error_500036: {
    id: 'error_500036',
    defaultmessages: 'Service fees are not configured properly on our system.',
  },
  error_500037: {
    id: 'error_500037',
    defaultmessages: 'Owner is already the seller',
  },
  error_500038: {
    id: 'error_500038',
    defaultmessages: 'Broker already exists',
  },
  error_500039: {
    id: 'error_500039',
    defaultmessages: 'agreement not found',
  },
  error_500040: {
    id: 'error_500040',
    defaultmessages:
      'Cannot add a new company representative. You can only select one from the existing representatives.',
  },
  error_500041: {
    id: 'error_500041',
    defaultmessages: 'Payment not completed',
  },
  error_500042: {
    id: 'error_500042',
    defaultmessages: 'Appointment not selected',
  },
  error_500043: {
    id: 'error_500043',
    defaultmessages: 'Non UAE national buyers are not allowed if the property is under a non investment area',
  },
  error_500044: {
    id: 'error_500044',
    defaultmessages: 'Invalid EID or date of birth',
  },
  error_500045: {
    id: 'error_500045',
    defaultmessages: 'agreement start date should be greater than the previous agreement expiry date, {date}',
  },
  error_500046: {
    id: 'error_500046',
    defaultmessages:
      'agreement start date should be equal or greater than the previous agreement Surrender date, {date}',
  },
  error_500047: {
    id: 'error_500047',
    defaultmessages: 'agreement start date should be greater than the previous agreement termination date, {date}',
  },
  error_500048: {
    id: 'error_500048',
    defaultmessages: 'User should log in using the UAE Pass, not the standard login method.',
  },
  error_500049: {
    id: 'error_500049',
    defaultmessages: 'Signer should have a SOP3 account',
  },
  error_500050: {
    id: 'error_500050',
    defaultmessages: 'An incomplete signing document with this task ID cannot be found.',
  },
  error_500051: {
    id: 'error_500051',
    defaultmessages: 'You are not authorized to access these company signing tasks.',
  },
  error_500052: {
    id: 'error_500052',
    defaultmessages: 'You are not authorized to access these signing tasks.',
  },
  error_500053: {
    id: 'error_500053',
    defaultmessages: 'Already signed',
  },
  error_500054: {
    id: 'error_500054',
    defaultmessages: "The party cannot be found within the application's listed parties.",
  },
  error_500055: {
    id: 'error_500055',
    defaultmessages: 'Could not find the application signing document.',
  },
  error_500056: {
    id: 'error_500056',
    defaultmessages: 'User should log in using the UAE Pass, not the standard login method.',
  },
  error_500057: {
    id: 'error_500057',
    defaultmessages: 'Got invalid signing process from the UAE Pass',
  },
  error_500058: {
    id: 'error_500058',
    defaultmessages: 'PDF does not contain the signature location.',
  },
  error_500059: {
    id: 'error_500059',
    defaultmessages: 'Only the auditor can initiate the agreement signature step.',
  },
  error_500060: {
    id: 'error_500060',
    defaultmessages: 'The document does not contain valid signatures.',
  },
  error_500061: {
    id: 'error_500061',
    defaultmessages: 'Surrender/termination date is not between agreement start and end date',
  },
  error_500062: {
    id: 'error_500062',
    defaultmessages: 'Surrender/termination date can be up to 30 days in the past',
  },
  error_500063: {
    id: 'error_500063',
    defaultmessages: "Surrender/termination date can't be in future",
  },
  error_500064: {
    id: 'error_500064',
    defaultmessages: '',
  },
  error_500065: {
    id: 'error_500065',
    defaultmessages: '',
  },
  error_500066: {
    id: 'error_500066',
    defaultmessages: '',
  },
  error_65: {
    id: 'error_65',
    defaultmessages: 'Please pass a valid legal form',
  },
  error_838301: {
    id: 'error_838301',
    defaultmessages: 'Failed to call ELMS service',
  },
  error_838304: {
    id: 'error_838304',
    defaultmessages: 'Error in sending OTP',
  },
  error_838306: {
    id: 'error_838306',
    defaultmessages: 'Emirates ID or Unified Number are missing',
  },
  error_83831: {
    id: 'error_83831',
    defaultmessages: 'Failed to fetch property valuation amount',
  },
  error_838311: {
    id: 'error_838311',
    defaultmessages: "MOI's user information is not available",
  },
  error_838312: {
    id: 'error_838312',
    defaultmessages: 'User information is incomplete',
  },
  error_838314: {
    id: 'error_838314',
    defaultmessages: 'User not found',
  },
  error_838317: {
    id: 'error_838317',
    defaultmessages: 'EID not found',
  },
  error_838318: {
    id: 'error_838318',
    defaultmessages: 'Pin ID is invalid',
  },
  error_838319: {
    id: 'error_838319',
    defaultmessages: 'Already logged in as Individual',
  },
  error_83832: {
    id: 'error_83832',
    defaultmessages: 'Group name required',
  },
  error_838320: {
    id: 'error_838320',
    defaultmessages: 'User not found',
  },
  error_838328: {
    id: 'error_838328',
    defaultmessages: 'Email address is invalid',
  },
  error_838329: {
    id: 'error_838329',
    defaultmessages: 'Permission ID is required',
  },
  error_83833: {
    id: 'error_83833',
    defaultmessages: 'Group permissions required',
  },
  error_838330: {
    id: 'error_838330',
    defaultmessages: 'One or more permission IDs are not found',
  },
  error_838331: {
    id: 'error_838331',
    defaultmessages: 'Group ID does not exist',
  },
  error_838332: {
    id: 'error_838332',
    defaultmessages: 'User already exists',
  },
  error_838333: {
    id: 'error_838333',
    defaultmessages: 'Unable to send email',
  },
  error_83834: {
    id: 'error_83834',
    defaultmessages: 'Group already exists',
  },
  error_838356: {
    id: 'error_838356',
    defaultmessages: 'Please enter a valid mobile number in order to proceed',
  },
  error_83836: {
    id: 'error_83836',
    defaultmessages: 'The provided ID is invalid',
  },
  error_83837: {
    id: 'error_83837',
    defaultmessages: 'Please use EID instead of UID',
  },
  error_838371: {
    id: 'error_838371',
    defaultmessages: 'Mobile number is not found in MOI',
  },
  error_838374: {
    id: 'error_838374',
    defaultmessages: 'If your account exists you will receive an email to reset your password',
  },
  error_838375: {
    id: 'error_838375',
    defaultmessages: 'Wrong password. Try again or click Forgot password to reset it.',
  },
  error_838376: {
    id: 'error_838376',
    defaultmessages: 'Invalid OTP code',
  },
  error_838377: {
    id: 'error_838377',
    defaultmessages: 'This email id is linked to Emirates ID / unified number, try to login using the same details.',
  },
  error_838378: {
    id: 'error_838378',
    defaultmessages: 'User has been already verified',
  },
  error_838379: {
    id: 'error_838379',
    defaultmessages:
      'It seems like the link is expired or already used, if you forgot your password, Please contact customer support if you have any inquiries.',
  },
  error_83838: {
    id: 'error_83838',
    defaultmessages: 'Could not fetch groups',
  },
  error_838380: {
    id: 'error_838380',
    defaultmessages: 'Link is invalid',
  },
  error_838381: {
    id: 'error_838381',
    defaultmessages: 'EID Or Unified number is mandatory',
  },
  error_838382: {
    id: 'error_838382',
    defaultmessages: 'Incorrect information being passed',
  },
  error_838383: {
    id: 'error_838383',
    defaultmessages: 'Company not found',
  },
  error_838384: {
    id: 'error_838384',
    defaultmessages: 'Selected user is already a primary contact',
  },
  error_838387: {
    id: 'error_838387',
    defaultmessages:
      'Company user account is no longer active. Account can be reactivated at any time by the company admin.',
  },
  error_83839: {
    id: 'error_83839',
    defaultmessages: 'One or more group names are invalid',
  },
  error_83840: {
    id: 'error_83840',
    defaultmessages: 'One group at least should be associated with the user',
  },
  error_838401: {
    id: 'error_838401',
    defaultmessages: 'property not found',
  },
  error_838404: {
    id: 'error_838404',
    defaultmessages: 'Property not accessible',
  },
  error_838406: {
    id: 'error_838406',
    defaultmessages: 'agreement not found',
  },
  error_83841: {
    id: 'error_83841',
    defaultmessages: 'Group name should not contain special characters',
  },
  error_838410: {
    id: 'error_838410',
    defaultmessages: 'lease agreement Id not found',
  },
  error_838411: {
    id: 'error_838411',
    defaultmessages: 'Lease agreement not found',
  },
  error_838414: {
    id: 'error_838414',
    defaultmessages: 'License is expired',
  },
  error_838418: {
    id: 'error_838418',
    defaultmessages: 'EID Expired',
  },
  error_838426: {
    id: 'error_838426',
    defaultmessages: 'Representative can only be an individual',
  },
  error_838428: {
    id: 'error_838428',
    defaultmessages: 'Invalid Company Owner ID',
  },
  error_838445: {
    id: 'error_838445',
    defaultmessages: 'PMA agreement logged in has no permission',
  },
  error_838460: {
    id: 'error_838460',
    defaultmessages: 'Emirates ID & Unified Number both are invalid',
  },
  error_838462: {
    id: 'error_838462',
    defaultmessages: 'Please complete service conditions to proceed with the service',
  },
  error_838463: {
    id: 'error_838463',
    defaultmessages:
      'The account of the buyer you added is not linked to the Electronic Land Management System (AccessRP). Please reach out to the municipality employee to link the account before proceeding with the application process.',
  },
  error_838465: {
    id: 'error_838465',
    defaultmessages: 'Could not fetch success response from ELMS for the MOI search',
  },
  error_838466: {
    id: 'error_838466',
    defaultmessages: 'Unified number/EID number is not valid, Please make sure you enter it correctly',
  },
  error_838476: {
    id: 'error_838476',
    defaultmessages: 'Application ID is required',
  },
  error_838479: {
    id: 'error_838479',
    defaultmessages:
      'The company was not found, either the license number is invalid or it is not registered on AccessRP.',
  },
  error_838492: {
    id: 'error_838492',
    defaultmessages: 'PMA type is required',
  },
  error_838493: {
    id: 'error_838493',
    defaultmessages: 'Incorrect agreement ID',
  },
  error_838494: {
    id: 'error_838494',
    defaultmessages: 'agreement ID not found',
  },
  error_838495: {
    id: 'error_838495',
    defaultmessages: 'Unable to get ownership details',
  },
  error_838496: {
    id: 'error_838496',
    defaultmessages: 'Parent agreement not found',
  },
  error_838497: {
    id: 'error_838497',
    defaultmessages: 'Musataha agreement not found',
  },
  error_838498: {
    id: 'error_838498',
    defaultmessages: 'Musataha agreement not active',
  },
  error_838527: {
    id: 'error_838527',
    defaultmessages: 'Percentage maximum value can be 100',
  },
  error_838534: {
    id: 'error_838534',
    defaultmessages: 'Total Installment Amount is invalid',
  },
  error_838538: {
    id: 'error_838538',
    defaultmessages: 'Transfer off plan to complete with mortgage field was not sent correctly',
  },
  error_838539: {
    id: 'error_838539',
    defaultmessages: 'Developer not found in the system',
  },
  error_838540: {
    id: 'error_838540',
    defaultmessages: 'Transfer registration fees paid by is invalid',
  },
  error_838541: {
    id: 'error_838541',
    defaultmessages: 'Enroll property in tawtheeq field is invalid',
  },
  error_838543: {
    id: 'error_838543',
    defaultmessages: 'Selected user is already a primary contact',
  },
  error_838544: {
    id: 'error_838544',
    defaultmessages: 'Buyer(s) is invalid',
  },
  error_838545: {
    id: 'error_838545',
    defaultmessages: 'User is not found',
  },
  error_838546: {
    id: 'error_838546',
    defaultmessages: 'Mortgage registration fees paid by feild is invalid',
  },
  error_838547: {
    id: 'error_838547',
    defaultmessages: 'This property cannot be enrolled in tawtheeq',
  },
  error_838548: {
    id: 'error_838548',
    defaultmessages: 'This property is enrolled in tawtheeq in another application',
  },
  error_838549: {
    id: 'error_838549',
    defaultmessages: 'There is another application in progress for this owner',
  },
  error_838550: {
    id: 'error_838550',
    defaultmessages: 'Please update the Ownership details in the Land System',
  },
  error_838551: {
    id: 'error_838551',
    defaultmessages: 'Failed to search agreements',
  },
  error_838552: {
    id: 'error_838552',
    defaultmessages: 'Initiator must be a Lessee',
  },
  error_838556: {
    id: 'error_838556',
    defaultmessages: 'Owner does not exists',
  },
  error_838560: {
    id: 'error_838560',
    defaultmessages: 'Project Details not found',
  },
  error_8385600: {
    id: 'error_8385600',
    defaultmessages:
      'The commercial license of the added company has expired. Please request the company to update its profile',
  },
  error_838561: {
    id: 'error_838561',
    defaultmessages: 'Project Id cannot be null',
  },
  error_838562: {
    id: 'error_838562',
    defaultmessages: 'Escrow Account is not registered in AccessRP',
  },
  error_838563: {
    id: 'error_838563',
    defaultmessages: 'Escrow Account Bank Details not found',
  },
  error_838567: {
    id: 'error_838567',
    defaultmessages: 'Failed to Validate Buildings in AccessRP',
  },
  error_838568: {
    id: 'error_838568',
    defaultmessages: 'Unable to get authorization details',
  },
  error_838569: {
    id: 'error_838569',
    defaultmessages: 'Unable to get the details of the initiator party',
  },
  error_838570: {
    id: 'error_838570',
    defaultmessages: 'Another application of the same type is in progress',
  },
  error_838572: {
    id: 'error_838572',
    defaultmessages: 'Cannot register more than two company admin accounts',
  },
  error_838573: {
    id: 'error_838573',
    defaultmessages: 'Application not processed. Trade license does not match.',
  },
  error_838574: {
    id: 'error_838574',
    defaultmessages: 'Multiple company profiles exist',
  },
  error_838575: {
    id: 'error_838575',
    defaultmessages: 'Application in progress',
  },
  error_838576: {
    id: 'error_838576',
    defaultmessages: 'Non-UAE residents cannot select "employee" as an applicant',
  },
  error_838580: {
    id: 'error_838580',
    defaultmessages: 'project name (EN) is mandatory',
  },
  error_838581: {
    id: 'error_838581',
    defaultmessages: 'project name (AR) is mandatory',
  },
  error_838582: {
    id: 'error_838582',
    defaultmessages: 'project category is mandatory',
  },
  error_838583: {
    id: 'error_838583',
    defaultmessages: 'project description (EN) is mandatory',
  },
  error_838584: {
    id: 'error_838584',
    defaultmessages: 'project description(AR) is mandatory',
  },
  error_838585: {
    id: 'error_838585',
    defaultmessages: 'project type is mandatory',
  },
  error_838586: {
    id: 'error_838586',
    defaultmessages: 'expected start date is mandatory',
  },
  error_838587: {
    id: 'error_838587',
    defaultmessages: 'expected end date is mandatory',
  },
  error_838588: {
    id: 'error_838588',
    defaultmessages: 'project value is mandatory',
  },
  error_838589: {
    id: 'error_838589',
    defaultmessages: 'project construction cost is mandatory',
  },
  error_838590: {
    id: 'error_838590',
    defaultmessages: 'expected start date must be before expected end date',
  },
  error_838591: {
    id: 'error_838591',
    defaultmessages: 'primary developer is mandatory if project category is secondary',
  },
  error_838592: {
    id: 'error_838592',
    defaultmessages: 'main project number is mandatory if project category is secondary',
  },
  error_838593: {
    id: 'error_838593',
    defaultmessages: 'Multi Unit agreements not allowed for this Unit',
  },
  error_838594: {
    id: 'error_838594',
    defaultmessages: 'Cannot delete or deactivate admin accounts unless another admin account is active',
  },
  error_838595: {
    id: 'error_838595',
    defaultmessages: 'Trade license details do not exist',
  },
  error_838596: {
    id: 'error_838596',
    defaultmessages: 'Failed to fetch trade license status',
  },
  error_838597: {
    id: 'error_838597',
    defaultmessages: 'Trade license has been cancelled',
  },
  error_838598: {
    id: 'error_838598',
    defaultmessages: 'Sub PMA is not allowed on this Agreement',
  },
  error_838599: {
    id: 'error_838599',
    defaultmessages: 'This PMA has exceeded the limit allowed for creating Sub-PMA',
  },
  error_838600: {
    id: 'error_838600',
    defaultmessages: 'The party initiating this agreement is not authorized to initiate Sub-PMA',
  },
  error_838601: {
    id: 'error_838601',
    defaultmessages: 'Account deactivation date is invalid',
  },
  error_838667: {
    id: 'error_838667',
    defaultmessages:
      'The commercial license of the added company has expired. Please request the company to update its profile',
  },
  error_900001: {
    id: 'error_900001',
    defaultmessages: 'Parent application type is invalid',
  },
  error_900002: {
    id: 'error_900002',
    defaultmessages: 'ID is required',
  },
  error_900003: {
    id: 'error_900003',
    defaultmessages: 'ID is required',
  },
  error_900004: {
    id: 'error_900004',
    defaultmessages: 'User is not logged in or does not exist in our system',
  },
  error_900005: {
    id: 'error_900005',
    defaultmessages: 'Company does not exist in our system',
  },
  error_900006: {
    id: 'error_900006',
    defaultmessages: 'Application ID does not exist in our system',
  },
  error_900007: {
    id: 'error_900007',
    defaultmessages: 'Company with the given trade license number does not exist',
  },
  error_900008: {
    id: 'error_900008',
    defaultmessages: 'Application type/source not found',
  },
  error_900009: {
    id: 'error_900009',
    defaultmessages: 'Email ID is required',
  },
  error_90001: {
    id: 'error_90001',
    defaultmessages: 'Failed to fetch service details from the database',
  },
  error_900010: {
    id: 'error_900010',
    defaultmessages: 'Application ID is not valid',
  },
  error_900012: {
    id: 'error_900012',
    defaultmessages: 'You cannot send the application to the Department of Law in its current status',
  },
  error_900013: {
    id: 'error_900013',
    defaultmessages: 'You cannot submit the application in its current status',
  },
  error_900014: {
    id: 'error_900014',
    defaultmessages: 'agreement type not found',
  },
  error_900015: {
    id: 'error_900015',
    defaultmessages: 'agreement classification not found',
  },
  error_900016: {
    id: 'error_900016',
    defaultmessages: 'agreement party type not found',
  },
  error_900019: {
    id: 'error_900019',
    defaultmessages: 'You have no permission to add new employees',
  },
  error_90002: {
    id: 'error_90002',
    defaultmessages: 'Application type does not exist',
  },
  error_900020: {
    id: 'error_900020',
    defaultmessages: 'Invalid operation',
  },
  error_900021: {
    id: 'error_900021',
    defaultmessages: 'Invalid operation',
  },
  error_900022: {
    id: 'error_900022',
    defaultmessages: 'Task not found',
  },
  error_900023: {
    id: 'error_900023',
    defaultmessages: 'Task party not found',
  },
  error_900025: {
    id: 'error_900025',
    defaultmessages: 'Party does not exist with the given owner ID',
  },
  error_900026: {
    id: 'error_900026',
    defaultmessages: 'POA user does not exist',
  },
  error_900027: {
    id: 'error_900027',
    defaultmessages: 'Could not find POA to delete for the given owner ID',
  },
  error_900028: {
    id: 'error_900028',
    defaultmessages: 'License does not exist',
  },
  error_900029: {
    id: 'error_900029',
    defaultmessages: 'You cannot verify and give approval for the same application',
  },
  error_90003: {
    id: 'error_90003',
    defaultmessages: 'Validation fail',
  },
  error_900030: {
    id: 'error_900030',
    defaultmessages: 'You cannot perform an audit and give HOD approval for the same application',
  },
  error_900031: {
    id: 'error_900031',
    defaultmessages: 'You cannot verify and give HOD approval for the same application',
  },
  error_900032: {
    id: 'error_900032',
    defaultmessages: 'Application status is invalid',
  },
  error_900033: {
    id: 'error_900033',
    defaultmessages: 'Application already terminated',
  },
  error_900034: {
    id: 'error_900034',
    defaultmessages: "You can't cancel a completed application",
  },
  error_900035: {
    id: 'error_900035',
    defaultmessages: '900035',
  },
  error_90004: {
    id: 'error_90004',
    defaultmessages: 'Could not fetch user ID. Could not log in.',
  },
  error_90005: {
    id: 'error_90005',
    defaultmessages: "Could not fetch the user's login information",
  },
  error_900055: {
    id: 'error_900055',
    defaultmessages: 'Company name should be present',
  },
  error_900056: {
    id: 'error_900056',
    defaultmessages: 'Company name in arabic should be present',
  },
  error_900058: {
    id: 'error_900058',
    defaultmessages: 'Trade license issue date is required',
  },
  error_900059: {
    id: 'error_900059',
    defaultmessages: 'Trade license expiry date is required',
  },
  error_90006: {
    id: 'error_90006',
    defaultmessages: 'Could not fetch the permission information',
  },
  error_900060: {
    id: 'error_900060',
    defaultmessages: 'TRN is a required field',
  },
  error_900061: {
    id: 'error_900061',
    defaultmessages: 'agreement PDF not found',
  },
  error_900062: {
    id: 'error_900062',
    defaultmessages: 'You cannot remove representative assigned in agreement',
  },
  error_900071: {
    id: 'error_900071',
    defaultmessages: 'POA number is mandatory',
  },
  error_900078: {
    id: 'error_900078',
    defaultmessages: 'Please enter your email address',
  },
  error_900079: {
    id: 'error_900079',
    defaultmessages: 'Please enter your phone number',
  },
  error_90008: {
    id: 'error_90008',
    defaultmessages: 'Application number does not exist',
  },
  error_90010: {
    id: 'error_90010',
    defaultmessages: 'Could not select the application. An error occurred while saving it in the database.',
  },
  error_900100: {
    id: 'error_900100',
    defaultmessages: '"Transaction fee paid by" field is required ',
  },
  error_90011: {
    id: 'error_90011',
    defaultmessages: "Application's instant ID is empty",
  },
  error_90012: {
    id: 'error_90012',
    defaultmessages: 'The given ID does not exist in the database',
  },
  error_90013: {
    id: 'error_90013',
    defaultmessages: 'Could not delete service permission',
  },
  error_900133: {
    id: 'error_900133',
    defaultmessages: 'You have no permission to perform this action',
  },
  error_900135: {
    id: 'error_900135',
    defaultmessages: 'PMA agreement not found',
  },
  error_900136: {
    id: 'error_900136',
    defaultmessages: 'You have no permission to initiate this application',
  },
  error_900137: {
    id: 'error_900137',
    defaultmessages: 'No party found in PMA agreement',
  },
  error_900138: {
    id: 'error_900138',
    defaultmessages: 'You have no right to cancel this PMA agreement',
  },
  error_900139: {
    id: 'error_900139',
    defaultmessages: 'Owner user ID or company ID cannot be empty',
  },
  error_90014: {
    id: 'error_90014',
    defaultmessages: 'Could not fetch application permission status by ID',
  },
  error_900140: {
    id: 'error_900140',
    defaultmessages: 'Owner does not exist with the given user ID or company ID',
  },
  error_900141: {
    id: 'error_900141',
    defaultmessages: 'PMA agreement expired please renew it to perform any action',
  },
  error_900142: {
    id: 'error_900142',
    defaultmessages: 'You have no access to this application',
  },
  error_900143: {
    id: 'error_900143',
    defaultmessages: 'Receipt date is required',
  },
  error_900144: {
    id: 'error_900144',
    defaultmessages: 'Receipt number is required',
  },
  error_900145: {
    id: 'error_900145',
    defaultmessages: 'Payment ID is required',
  },
  error_900146: {
    id: 'error_900146',
    defaultmessages: 'Application ID is mandatory',
  },
  error_900147: {
    id: 'error_900147',
    defaultmessages: 'Paid in advance is mandatory',
  },
  error_90015: {
    id: 'error_90015',
    defaultmessages: 'Could not delete application permission status',
  },
  error_900159: {
    id: 'error_900159',
    defaultmessages: 'agreement Id is invalid',
  },
  error_90016: {
    id: 'error_90016',
    defaultmessages: 'Could not get the permissions with the provided IDs',
  },
  error_900160: {
    id: 'error_900160',
    defaultmessages: 'Payment details not found',
  },
  error_900161: {
    id: 'error_900161',
    defaultmessages: 'Pay in advance years cannot be less than 1',
  },
  error_900162: {
    id: 'error_900162',
    defaultmessages: 'Application was not initiated properly',
  },
  error_900169: {
    id: 'error_900169',
    defaultmessages: 'The agreement end date must be after the agreement start date',
  },
  error_90017: {
    id: 'error_90017',
    defaultmessages: 'Duplicate attribute ID is not allowed',
  },
  error_900171: {
    id: 'error_900171',
    defaultmessages: 'Company type is mandatory',
  },
  error_900172: {
    id: 'error_900172',
    defaultmessages: 'Company email should be present',
  },
  error_900173: {
    id: 'error_900173',
    defaultmessages: 'Company mobile should be present',
  },
  error_900174: {
    id: 'error_900174',
    defaultmessages: 'Company address (EN) should be present',
  },
  error_900175: {
    id: 'error_900175',
    defaultmessages: 'Company address (AR) should be present',
  },
  error_90018: {
    id: 'error_90018',
    defaultmessages: "Could not update the application admin's status in the database",
  },
  error_90030: {
    id: 'error_90030',
    defaultmessages: 'agreement amount is required',
  },
  error_910001: {
    id: 'error_910001',
    defaultmessages: 'Failed to call ELMS service',
  },
  error_910002: {
    id: 'error_910002',
    defaultmessages: 'User is not logged in or does not exist in our system',
  },
  error_910003: {
    id: 'error_910003',
    defaultmessages: 'Company does not exist in our system',
  },
  error_910005: {
    id: 'error_910005',
    defaultmessages: 'Carousel does not exist in the system',
  },
  error_910042: {
    id: 'error_910042',
    defaultmessages: 'Failed to call Market Data Service',
  },
  error_910043: {
    id: 'error_910043',
    defaultmessages: 'Request text is required',
  },
  error_910044: {
    id: 'error_910044',
    defaultmessages: 'Document type is required',
  },
  error_910045: {
    id: 'error_910045',
    defaultmessages: 'Building ID is required',
  },
  error_910047: {
    id: 'error_910047',
    defaultmessages: 'Lessee EID/Trade License number is required',
  },
  error_910048: {
    id: 'error_910048',
    defaultmessages: 'Invalid License Number',
  },
  error_920015: {
    id: 'error_920015',
    defaultmessages: 'Failed to cancel the application',
  },
  error_920016: {
    id: 'error_920016',
    defaultmessages: 'Unable to get latest document details',
  },
  error_920019: {
    id: 'error_920019',
    defaultmessages: 'UN/EID number does not match any registered brokers',
  },
  error_920020: {
    id: 'error_920020',
    defaultmessages: 'You cannot assign to the same auditor',
  },
  error_930001: {
    id: 'error_930001',
    defaultmessages: 'Owner not found',
  },
  error_930002: {
    id: 'error_930002',
    defaultmessages: 'Application not found',
  },
  error_930003: {
    id: 'error_930003',
    defaultmessages: 'Buyer user not found',
  },
  error_930004: {
    id: 'error_930004',
    defaultmessages: 'Subtype is required',
  },
  error_930005: {
    id: 'error_930005',
    defaultmessages: 'Application ID is required',
  },
  error_930006: {
    id: 'error_930006',
    defaultmessages: 'Application does not belong to buyer',
  },
  error_930007: {
    id: 'error_930007',
    defaultmessages: 'ELMS "add buyer" failed',
  },
  error_930008: {
    id: 'error_930008',
    defaultmessages: 'ELMS "update buyer" failed',
  },
  error_930010: {
    id: 'error_930010',
    defaultmessages: 'ELMS "add buyer to application" failed',
  },
  error_930011: {
    id: 'error_930011',
    defaultmessages: 'Non-local national number is required',
  },
  error_930013: {
    id: 'error_930013',
    defaultmessages: 'Family number is required',
  },
  error_930014: {
    id: 'error_930014',
    defaultmessages: 'Family ID required',
  },
  error_930015: {
    id: 'error_930015',
    defaultmessages: 'Emirate required',
  },
  error_930016: {
    id: 'error_930016',
    defaultmessages: "Buyer's documents are not uploaded",
  },
  error_930017: {
    id: 'error_930017',
    defaultmessages: 'Company application not found',
  },
  error_930018: {
    id: 'error_930018',
    defaultmessages: 'ELMS "add company owner" failed',
  },
  error_930019: {
    id: 'error_930019',
    defaultmessages: 'ELMS company owner information update failed',
  },
  error_930020: {
    id: 'error_930020',
    defaultmessages: 'No owner found',
  },
  error_930021: {
    id: 'error_930021',
    defaultmessages: 'Percentage number cannot be greater than 100',
  },
  error_930022: {
    id: 'error_930022',
    defaultmessages: 'No signatory found',
  },
  error_930023: {
    id: 'error_930023',
    defaultmessages: 'Same owner has been already added',
  },
  error_930024: {
    id: 'error_930024',
    defaultmessages: 'No party exists',
  },
  error_930025: {
    id: 'error_930025',
    defaultmessages: 'Owner party does not exist',
  },
  error_930026: {
    id: 'error_930026',
    defaultmessages: 'Failed to fetch owner infromation from ELMS',
  },
  error_930027: {
    id: 'error_930027',
    defaultmessages: 'Invalid input',
  },
  error_930028: {
    id: 'error_930028',
    defaultmessages: 'Owner party not found',
  },
  error_930029: {
    id: 'error_930029',
    defaultmessages: 'Invalid input',
  },
  error_930030: {
    id: 'error_930030',
    defaultmessages: 'POA details are invalid',
  },
  error_930031: {
    id: 'error_930031',
    defaultmessages: 'Invalid input',
  },
  error_930032: {
    id: 'error_930032',
    defaultmessages: 'Cannot add owner',
  },
  error_930033: {
    id: 'error_930033',
    defaultmessages: 'Owner documents are not uploaded',
  },
  error_930034: {
    id: 'error_930034',
    defaultmessages: 'POA details end date is not valid',
  },
  error_930035: {
    id: 'error_930035',
    defaultmessages: 'POA details start date is not valid',
  },
  error_930036: {
    id: 'error_930036',
    defaultmessages: 'Could not fetch owner details',
  },
  error_930037: {
    id: 'error_930037',
    defaultmessages: 'Invalid owner type. You can only update owner (person).',
  },
  error_930038: {
    id: 'error_930038',
    defaultmessages: 'Application agreement not found',
  },
  error_930039: {
    id: 'error_930039',
    defaultmessages: 'Unable to save application',
  },
  error_930040: {
    id: 'error_930040',
    defaultmessages: 'No record found',
  },
  error_930041: {
    id: 'error_930041',
    defaultmessages: 'At least one employee should be present',
  },
  error_930042: {
    id: 'error_930042',
    defaultmessages: 'At least one initiator should be present',
  },
  error_930043: {
    id: 'error_930043',
    defaultmessages: 'Employee already exists in your company',
  },
  error_930044: {
    id: 'error_930044',
    defaultmessages: 'Received an error from ELMS on owner API details',
  },
  error_930045: {
    id: 'error_930045',
    defaultmessages: 'Empty response error from ELMS for owner API details',
  },
  error_930046: {
    id: 'error_930046',
    defaultmessages: 'Unsuccessful response error from ELMS for owner API details',
  },
  error_930047: {
    id: 'error_930047',
    defaultmessages: 'Buyer does not have EID or UID',
  },
  error_930048: {
    id: 'error_930048',
    defaultmessages: 'Buyer does not have a license number',
  },
  error_930049: {
    id: 'error_930049',
    defaultmessages: 'Buyer company is not registered with AccessRP',
  },
  error_930050: {
    id: 'error_930050',
    defaultmessages: 'Failed to get user login details',
  },
  error_930051: {
    id: 'error_930051',
    defaultmessages: 'No ELMS user ID for the logged in user',
  },
  error_930052: {
    id: 'error_930052',
    defaultmessages: 'Empty response error from ELMS to add API buyer',
  },
  error_930053: {
    id: 'error_930053',
    defaultmessages: 'Unsuccessful response error from ELMS to add API buyer',
  },
  error_930054: {
    id: 'error_930054',
    defaultmessages: 'Buyer already exists',
  },
  error_930055: {
    id: 'error_930055',
    defaultmessages: "Cannot terminate POA due to the application's active status",
  },
  error_930056: {
    id: 'error_930056',
    defaultmessages: 'Documents are not uploaded',
  },
  error_930057: {
    id: 'error_930057',
    defaultmessages: 'Could not save the user details in DARI',
  },
  error_930058: {
    id: 'error_930058',
    defaultmessages: 'Could not create owner file',
  },
  error_930059: {
    id: 'error_930059',
    defaultmessages: 'Could not update owner information',
  },
  error_930060: {
    id: 'error_930060',
    defaultmessages: 'The buyer must be a UAE national',
  },
  error_930061: {
    id: 'error_930061',
    defaultmessages: "The buyer's mobile number is required",
  },
  error_930062: {
    id: 'error_930062',
    defaultmessages: 'You cannot remove representative assigned in agreement',
  },
  error_930063: {
    id: 'error_930063',
    defaultmessages: 'User not found',
  },
  error_930083: {
    id: 'error_930083',
    defaultmessages: 'Please enter a valid email in order to proceed',
  },
  error_930100: {
    id: 'error_930100',
    defaultmessages: 'Failed to fetch lease agreement details',
  },
  error_930102: {
    id: 'error_930102',
    defaultmessages: 'Document type is required',
  },
  error_930103: {
    id: 'error_930103',
    defaultmessages: 'Buyer already deleted',
  },
  error_930104: {
    id: 'error_930104',
    defaultmessages: 'The lessee cannot be the buyer',
  },
  error_930108: {
    id: 'error_930108',
    defaultmessages: 'Broker Already exists',
  },
  error_930109: {
    id: 'error_930109',
    defaultmessages: 'Broker Already deleted',
  },
  error_930110: {
    id: 'error_930110',
    defaultmessages: 'Broker Does Not Belong To Application',
  },
  error_930111: {
    id: 'error_930111',
    defaultmessages: 'Buyer is blocked',
  },
  error_930112: {
    id: 'error_930112',
    defaultmessages: 'Project expat percentage is exceeded',
  },
  error_930114: {
    id: 'error_930114',
    defaultmessages: 'Buyer and seller can’t be the same parties',
  },
  error_930115: {
    id: 'error_930115',
    defaultmessages: 'Full amount is invalid',
  },
  error_930116: {
    id: 'error_930116',
    defaultmessages: 'Percentage value must be 100',
  },
  error_930119: {
    id: 'error_930119',
    defaultmessages: 'User has permissions at a different bank',
  },
  error_930120: {
    id: 'error_930120',
    defaultmessages: 'Company activity not found',
  },
  error_930121: {
    id: 'error_930121',
    defaultmessages: 'No company admin found. Please add an admin user.',
  },
  error_930122: {
    id: 'error_930122',
    defaultmessages: "User hasn't UAE Special Nationality",
  },
  error_930123: {
    id: 'error_930123',
    defaultmessages:
      'The buyer you are trying to add has an expired passport. Please make sure that the buyer details are updated.',
  },
  error_930124: {
    id: 'error_930124',
    defaultmessages: 'Initiator party cannot be deleted',
  },
  error_940001: {
    id: 'error_940001',
    defaultmessages: 'Dispute detail is mandatory',
  },
  error_940002: {
    id: 'error_940002',
    defaultmessages: 'Dispute type is mandatory',
  },
  error_940003: {
    id: 'error_940003',
    defaultmessages: 'Dispute subtype is mandatory',
  },
  error_940004: {
    id: 'error_940004',
    defaultmessages: 'Dispute subtype is mandatory',
  },
  error_940005: {
    id: 'error_940005',
    defaultmessages: 'User type is mandatory',
  },
  error_940006: {
    id: 'error_940006',
    defaultmessages: 'Application does not exist',
  },
  error_940007: {
    id: 'error_940007',
    defaultmessages: 'Properties are mandatory',
  },
  error_940008: {
    id: 'error_940008',
    defaultmessages: 'You can select properties manually or from the existing ones. You can not add both.',
  },
  error_940009: {
    id: 'error_940009',
    defaultmessages: 'AccessRP API is failing',
  },
  error_940010: {
    id: 'error_940010',
    defaultmessages: 'No record exist',
  },
  error_940011: {
    id: 'error_940011',
    defaultmessages: 'Property address is mandatory',
  },
  error_940012: {
    id: 'error_940012',
    defaultmessages: 'Municipality is mandatory',
  },
  error_940013: {
    id: 'error_940013',
    defaultmessages: 'User does not exist',
  },
  error_940014: {
    id: 'error_940014',
    defaultmessages: 'You are not entering correct information',
  },
  error_940015: {
    id: 'error_940015',
    defaultmessages: 'Company not found',
  },
  error_940016: {
    id: 'error_940016',
    defaultmessages: "You can't add the same plaintiff and defendant",
  },
  error_940017: {
    id: 'error_940017',
    defaultmessages: 'Dispute demand does not exist',
  },
  error_940018: {
    id: 'error_940018',
    defaultmessages: "You can't add the same user",
  },
  error_940019: {
    id: 'error_940019',
    defaultmessages: 'Party type does not match',
  },
  error_940020: {
    id: 'error_940020',
    defaultmessages: 'Application ID is mandatory',
  },
  error_940023: {
    id: 'error_940023',
    defaultmessages: 'Reason is mandatory',
  },
  error_940024: {
    id: 'error_940024',
    defaultmessages: 'Mediator ID is mandatory',
  },
  error_940025: {
    id: 'error_940025',
    defaultmessages: 'Appointment date is mandatory',
  },
  error_940026: {
    id: 'error_940026',
    defaultmessages: 'Appointment slot is mandatory',
  },
  error_940027: {
    id: 'error_940027',
    defaultmessages: 'Reschedule detail is mandatory',
  },
  error_940028: {
    id: 'error_940028',
    defaultmessages: 'No appointment found for this dispute',
  },
  error_940034: {
    id: 'error_940034',
    defaultmessages: 'Booking not found',
  },
  error_940035: {
    id: 'error_940035',
    defaultmessages: 'Invalid language value',
  },
  error_940036: {
    id: 'error_940036',
    defaultmessages: "You can't add the same law firm",
  },
  error_940037: {
    id: 'error_940037',
    defaultmessages: 'Owner ID in properties does not match',
  },
  error_940038: {
    id: 'error_940038',
    defaultmessages: 'Please fill in the form before submitting',
  },
  error_940039: {
    id: 'error_940039',
    defaultmessages: 'You are inserting duplicate plot IDs',
  },
  error_940040: {
    id: 'error_940040',
    defaultmessages: 'Demand is mandatory',
  },
  error_940043: {
    id: 'error_940043',
    defaultmessages: 'Claim value should be a positive number',
  },
  error_940044: {
    id: 'error_940044',
    defaultmessages: 'Interest should be a positive number',
  },
  error_940045: {
    id: 'error_940045',
    defaultmessages: 'Please insert the correct key',
  },
  error_940046: {
    id: 'error_940046',
    defaultmessages: 'Please insert at least one parameter value',
  },
  error_940047: {
    id: 'error_940047',
    defaultmessages: 'Please share plaintiff list',
  },
  error_940048: {
    id: 'error_940048',
    defaultmessages: 'Please share defendant list',
  },
  error_940049: {
    id: 'error_940049',
    defaultmessages: "You can't perform this action right now",
  },
  error_940050: {
    id: 'error_940050',
    defaultmessages: 'You are passing a duplicate record',
  },
  error_940051: {
    id: 'error_940051',
    defaultmessages: "You can't select mortgage properties",
  },
  error_940052: {
    id: 'error_940052',
    defaultmessages: "You can't select blocked properties",
  },
  error_950001: {
    id: 'error_950001',
    defaultmessages: 'No record found',
  },
  error_950002: {
    id: 'error_950002',
    defaultmessages: 'User is not logged in or does not exist in our system',
  },
  error_950003: {
    id: 'error_950003',
    defaultmessages: 'Application ID is required',
  },
  error_950004: {
    id: 'error_950004',
    defaultmessages: 'Application type is required',
  },
  error_950005: {
    id: 'error_950005',
    defaultmessages: 'Payment type is required',
  },
  error_950006: {
    id: 'error_950006',
    defaultmessages: 'Payment mode is required',
  },
  error_950007: {
    id: 'error_950007',
    defaultmessages: 'Payment mode should be a card or wallet',
  },
  error_950008: {
    id: 'error_950008',
    defaultmessages: 'Unable to proceed with application. Please contact customer support if you have any inquiries.',
  },
  error_950009: {
    id: 'error_950009',
    defaultmessages: 'Payment ID is required',
  },
  error_950010: {
    id: 'error_950010',
    defaultmessages: 'Payment has been already processed',
  },
  error_950011: {
    id: 'error_950011',
    defaultmessages: 'Duplicate record',
  },
  error_950012: {
    id: 'error_950012',
    defaultmessages: 'Service fee does not exist in our system',
  },
  error_950013: {
    id: 'error_950013',
    defaultmessages: 'Service fee is not configuring properly in our system',
  },
  error_950014: {
    id: 'error_950014',
    defaultmessages: 'An exception occurred in the database',
  },
  error_950015: {
    id: 'error_950015',
    defaultmessages: 'No wallet exists',
  },
  error_950016: {
    id: 'error_950016',
    defaultmessages: 'Amount should not be empty or less than zero',
  },
  error_950017: {
    id: 'error_950017',
    defaultmessages: 'Insufficient balance',
  },
  error_950018: {
    id: 'error_950018',
    defaultmessages: 'Service fee is not configuring correctly',
  },
  error_950019: {
    id: 'error_950019',
    defaultmessages: 'Cannot recalculate as payment status is "completed"',
  },
  error_950020: {
    id: 'error_950020',
    defaultmessages: 'No application found',
  },
  error_950021: {
    id: 'error_950021',
    defaultmessages: 'No application found',
  },
  error_950022: {
    id: 'error_950022',
    defaultmessages: 'Company does not exist in our system',
  },
  error_950023: {
    id: 'error_950023',
    defaultmessages: 'Application does not exist in our system',
  },
  error_950024: {
    id: 'error_950024',
    defaultmessages: 'Application transaction amount is greater than zero',
  },
  error_950025: {
    id: 'error_950025',
    defaultmessages: 'No application exists',
  },
  error_950026: {
    id: 'error_950026',
    defaultmessages: 'Payment service settings are missing',
  },
  error_950027: {
    id: 'error_950027',
    defaultmessages: 'No payment is found for provided receipt number',
  },
  error_950028: {
    id: 'error_950028',
    defaultmessages: 'Failed to upload data on GCS',
  },
  error_950029: {
    id: 'error_950029',
    defaultmessages: 'Failed to check status on GCS',
  },
  error_950030: {
    id: 'error_950030',
    defaultmessages: 'Failed to get owner details from DARI',
  },
  error_950031: {
    id: 'error_950031',
    defaultmessages: 'Could not fetch payment information',
  },
  error_950032: {
    id: 'error_950032',
    defaultmessages: 'Could not fetch party details from DARI',
  },
  error_950033: {
    id: 'error_950033',
    defaultmessages: 'Could not fetch application settings',
  },
  error_950034: {
    id: 'error_950034',
    defaultmessages: 'Failed to get owner details from ELMS',
  },
  error_950035: {
    id: 'error_950035',
    defaultmessages: 'Receipt amount should be the same as voucher amount',
  },
  error_950037: {
    id: 'error_950037',
    defaultmessages: 'Payment not successful',
  },
  error_950038: {
    id: 'error_950038',
    defaultmessages: 'Unable to generate certificate',
  },
  error_950040: {
    id: 'error_950040',
    defaultmessages: 'Payment already done',
  },
  error_950043: {
    id: 'error_950043',
    defaultmessages: 'Rent payment amount not calculated',
  },
  error_950044: {
    id: 'error_950044',
    defaultmessages: 'Unable to determine agreement. Could be data issue or old agreement',
  },
  error_950050: {
    id: 'error_950050',
    defaultmessages:
      'Another POA is registered under the same authorization number, please cancel the previous one or add a different authorization number',
  },
  error_950051: {
    id: 'error_950051',
    defaultmessages:
      'Maximum number of admins already registered for this company, please select a different user role or delete/deactivate one of the currently active admins',
  },
  error_960007: {
    id: 'error_960007',
    defaultmessages: 'Document type is required',
  },
  error_960008: {
    id: 'error_960008',
    defaultmessages: 'Application ID is required',
  },
  error_960010: {
    id: 'error_960010',
    defaultmessages: 'Unified SPA Document is mandatory to upload',
  },
  error_970000: {
    id: 'error_970000',
    defaultmessages: 'Application ID invalid',
  },
  error_970001: {
    id: 'error_970001',
    defaultmessages: 'Application is saved successfully',
  },
  error_970002: {
    id: 'error_970002',
    defaultmessages: 'Company with the given trade license number does not exist',
  },
  error_970003: {
    id: 'error_970003',
    defaultmessages: 'User does not exist',
  },
  error_970005: {
    id: 'error_970005',
    defaultmessages: 'Premise address is required',
  },
  error_970005_content: {
    id: 'error_970005_content',
    defaultmessages: 'Deposit is required',
  },
  error_970006: {
    id: 'error_970006',
    defaultmessages: 'Application does not exist',
  },
  error_970007: {
    id: 'error_970007',
    defaultmessages: 'Application has been already terminated',
  },
  error_970008: {
    id: 'error_970008',
    defaultmessages: 'You do not have permission to access this application',
  },
  error_970009: {
    id: 'error_970009',
    defaultmessages: 'You do not have permission to accept, reject or terminate application',
  },
  error_970010: {
    id: 'error_970010',
    defaultmessages: 'You do not have permission to accept or reject application',
  },
  error_970011: {
    id: 'error_970011',
    defaultmessages: 'agreement does not exist',
  },
  error_970012: {
    id: 'error_970012',
    defaultmessages: 'The same occupant has been already added',
  },
  error_970013: {
    id: 'error_970013',
    defaultmessages: 'EID or Unified Number do not exist in our system',
  },
  error_970014: {
    id: 'error_970014',
    defaultmessages: 'You are sending the wrong information',
  },
  error_970015: {
    id: 'error_970015',
    defaultmessages: 'ELMS premise detail API calling error',
  },
  error_970016: {
    id: 'error_970016',
    defaultmessages: 'This premise address is invalid',
  },
  error_970017: {
    id: 'error_970017',
    defaultmessages: 'No record found',
  },
  error_970018: {
    id: 'error_970018',
    defaultmessages: 'The rent amount should not be increased by more than 5% of the previous rent amount',
  },
  error_970019: {
    id: 'error_970019',
    defaultmessages: 'You cannot amend the lease after 7 days',
  },
  error_970020: {
    id: 'error_970020',
    defaultmessages: 'You cannot variate the lease period to be 4 or more years.',
  },
  error_970021: {
    id: 'error_970021',
    defaultmessages: 'You cannot variate the lease period to be 4 years or less.',
  },
  error_970022: {
    id: 'error_970022',
    defaultmessages: 'You cannot generate a agreement without payment',
  },
  error_970023: {
    id: 'error_970023',
    defaultmessages: 'You cannot add a primary lessor without having multiple owners',
  },
  error_970024: {
    id: 'error_970024',
    defaultmessages: 'Provided party is not the owner of the property',
  },
  error_970025: {
    id: 'error_970025',
    defaultmessages: 'Could not find primary lessor',
  },
  error_970026: {
    id: 'error_970026',
    defaultmessages: 'Payment is already processed',
  },
  error_970027: {
    id: 'error_970027',
    defaultmessages: 'Lease agreement is not found. Please contact system administration.',
  },
  error_970028: {
    id: 'error_970028',
    defaultmessages: 'This trade license cannot be used by a government entity or diplomat',
  },
  error_970029: {
    id: 'error_970029',
    defaultmessages: 'You cannot add an occupant for commercial and industrial agreement types',
  },
  error_970030: {
    id: 'error_970030',
    defaultmessages: 'Grace period should not be greater than 90 days',
  },
  error_970031: {
    id: 'error_970031',
    defaultmessages: 'You cannot rent residential land for industrial purposes',
  },
  error_970032: {
    id: 'error_970032',
    defaultmessages: 'You cannot rent residential land for industrial purposes',
  },
  error_970033: {
    id: 'error_970033',
    defaultmessages: 'You cannot rent residential land for industrial purposes and vice versa',
  },
  error_970035: {
    id: 'error_970035',
    defaultmessages: 'Failed to call ELMS service',
  },
  error_970036: {
    id: 'error_970036',
    defaultmessages: 'Municipality ID is required',
  },
  error_970037: {
    id: 'error_970037',
    defaultmessages: 'Property details are required',
  },
  error_970038: {
    id: 'error_970038',
    defaultmessages: 'agreement type is required',
  },
  error_970039: {
    id: 'error_970039',
    defaultmessages: 'Premise ID is required',
  },
  error_970040: {
    id: 'error_970040',
    defaultmessages: 'Lessee type is required',
  },
  error_970041: {
    id: 'error_970041',
    defaultmessages: 'Premise address is required',
  },
  error_970042: {
    id: 'error_970042',
    defaultmessages: 'Company details are required',
  },
  error_970043: {
    id: 'error_970043',
    defaultmessages: 'Trade license no. is required',
  },
  error_970044: {
    id: 'error_970044',
    defaultmessages: 'Representative name is required',
  },
  error_970045: {
    id: 'error_970045',
    defaultmessages: 'Representative ID is required',
  },
  error_970046: {
    id: 'error_970046',
    defaultmessages: 'Company name is required',
  },
  error_970047: {
    id: 'error_970047',
    defaultmessages: 'Company email is required',
  },
  error_970048: {
    id: 'error_970048',
    defaultmessages: 'Company phone number is required',
  },
  error_970049: {
    id: 'error_970049',
    defaultmessages: "Individual's details are required",
  },
  error_97005: {
    id: 'error_97005',
    defaultmessages: 'Document type not found',
  },
  error_970050: {
    id: 'error_970050',
    defaultmessages: 'EID/Unified Number is required',
  },
  error_970051: {
    id: 'error_970051',
    defaultmessages: 'Lessee name is required',
  },
  error_970052: {
    id: 'error_970052',
    defaultmessages: 'Lessee email is required',
  },
  error_970053: {
    id: 'error_970053',
    defaultmessages: 'Lessee phone number is required',
  },
  error_970054: {
    id: 'error_970054',
    defaultmessages: 'Rental details are required',
  },
  error_970055: {
    id: 'error_970055',
    defaultmessages: 'agreement start date is required',
  },
  error_970056: {
    id: 'error_970056',
    defaultmessages: 'agreement end date is required',
  },
  error_970057: {
    id: 'error_970057',
    defaultmessages: 'Deposit amount is required',
  },
  error_970058: {
    id: 'error_970058',
    defaultmessages: 'No. of installments is required',
  },
  error_970059: {
    id: 'error_970059',
    defaultmessages: 'Payment method is required',
  },
  error_970060: {
    id: 'error_970060',
    defaultmessages: 'ADWEA type required',
  },
  error_970061: {
    id: 'error_970061',
    defaultmessages: 'Total amount required',
  },
  error_970062: {
    id: 'error_970062',
    defaultmessages: 'Annual total required',
  },
  error_970063: {
    id: 'error_970063',
    defaultmessages: 'Reserve company details are required',
  },
  error_970064: {
    id: 'error_970064',
    defaultmessages: 'Reserve name is required',
  },
  error_970065: {
    id: 'error_970065',
    defaultmessages: 'Diplomat ID is required',
  },
  error_970066: {
    id: 'error_970066',
    defaultmessages: 'Court number is required',
  },
  error_970067: {
    id: 'error_970067',
    defaultmessages: 'An approval is required',
  },
  error_970068: {
    id: 'error_970068',
    defaultmessages: 'Rejection reason is required',
  },
  error_970069: {
    id: 'error_970069',
    defaultmessages: 'Application ID is required',
  },
  error_970081: {
    id: 'error_970081',
    defaultmessages: 'You cannot select Utility bill by lessee because premise id is shared',
  },
  error_970084: {
    id: 'error_970084',
    defaultmessages: 'Amount type is required',
  },
  error_970085: {
    id: 'error_970085',
    defaultmessages: 'PMA type details are required',
  },
  error_970086: {
    id: 'error_970086',
    defaultmessages: 'License not found',
  },
  error_970087: {
    id: 'error_970087',
    defaultmessages: 'License status not found',
  },
  error_970088: {
    id: 'error_970088',
    defaultmessages: 'Company license is cancelled',
  },
  error_970089: {
    id: 'error_970089',
    defaultmessages: 'PMC should be registered in AccessRP',
  },
  error_970090: {
    id: 'error_970090',
    defaultmessages: 'Required License Activities not found',
  },
  error_970091: {
    id: 'error_970091',
    defaultmessages: 'agreement period must be 3 months minimum',
  },
  error_970092: {
    id: 'error_970092',
    defaultmessages: 'agreement period must be 4 years maximum',
  },
  error_970093: {
    id: 'error_970093',
    defaultmessages: 'Property is not accessible',
  },
  error_970094: {
    id: 'error_970094',
    defaultmessages: 'Property validation attempts failed',
  },
  error_970095: {
    id: 'error_970095',
    defaultmessages: 'Property owners not found',
  },
  error_970096: {
    id: 'error_970096',
    defaultmessages: 'Owner mismatch found',
  },
  error_970097: {
    id: 'error_970097',
    defaultmessages: 'Multiple buildings found',
  },
  error_970098: {
    id: 'error_970098',
    defaultmessages:
      'Company with given license number %s for this property does not exist on AccessRP. Please inform the company representative to register the company with AccessRP',
  },
  error_970099: {
    id: 'error_970099',
    defaultmessages: 'PMC type is not for individuals',
  },
  error_970101: {
    id: 'error_970101',
    defaultmessages: 'Lease agreement end date cannot be more than Property management agreement date',
  },
  error_970102: {
    id: 'error_970102',
    defaultmessages: 'PMA renewal service does not allow you to add a property',
  },
  error_970103: {
    id: 'error_970103',
    defaultmessages: 'Sub PMA agreement dates should be in between or equal to parent PMA agreement dates',
  },
  error_970104: {
    id: 'error_970104',
    defaultmessages: 'Parent PMA agreement duration should be larger than all sub PMA agreements duration',
  },
  error_970105: {
    id: 'error_970105',
    defaultmessages: "You can't remove this property because this property is associated to a sub PMA agreement",
  },
  error_970106: {
    id: 'error_970106',
    defaultmessages: 'Mutual agreement or court order is mandatory',
  },
  error_970107: {
    id: 'error_970107',
    defaultmessages: 'Court number is mandatory',
  },
  error_970108: {
    id: 'error_970108',
    defaultmessages: 'agreement must be 2 years maximum',
  },
  error_970109: {
    id: 'error_970109',
    defaultmessages: 'agreement is not ready yet, please check after sometime',
  },
  error_970110: {
    id: 'error_970110',
    defaultmessages: 'PDF agreement not found contact system administration',
  },
  error_970111: {
    id: 'error_970111',
    defaultmessages: 'agreement properties not found, Add some properties first',
  },
  error_970112: {
    id: 'error_970112',
    defaultmessages: 'Building Reg Number is invalid',
  },
  error_970113: {
    id: 'error_970113',
    defaultmessages: 'At least one occupant should be added',
  },
  error_970114: {
    id: 'error_970114',
    defaultmessages: 'Email is mandatory',
  },
  error_970115: {
    id: 'error_970115',
    defaultmessages: 'Mobile number is mandatory',
  },
  error_970116: {
    id: 'error_970116',
    defaultmessages: 'Incorrect information being passed',
  },
  error_970117: {
    id: 'error_970117',
    defaultmessages: "Without selecting primary lessor you can't choose primary lessor as primary contact",
  },
  error_970118: {
    id: 'error_970118',
    defaultmessages: 'Primary Contact does not exist',
  },
  error_970119: {
    id: 'error_970119',
    defaultmessages: 'Please select primary contact of primary lessor',
  },
  error_970120: {
    id: 'error_970120',
    defaultmessages: 'Primary contact is mandatory',
  },
  error_970123: {
    id: 'error_970123',
    defaultmessages: 'This property is restricted',
  },
  error_970124: {
    id: 'error_970124',
    defaultmessages: "You can't select lessee type person",
  },
  error_970125: {
    id: 'error_970125',
    defaultmessages: 'trade license classification cannot be industrial leader',
  },
  error_970126: {
    id: 'error_970126',
    defaultmessages: 'ِAddress should contain- Mussaffah -',
  },
  error_970127: {
    id: 'error_970127',
    defaultmessages: 'Establishment date should be from 2017 onwards',
  },
  error_970128: {
    id: 'error_970128',
    defaultmessages: 'There is an active property management agreement registration application on this property',
  },
  error_970129: {
    id: 'error_970129',
    defaultmessages: 'Please enter a valid trade license number that starts with CN',
  },
  error_970130: {
    id: 'error_970130',
    defaultmessages: 'For agreement type industrial you can use only industrial license',
  },
  error_970135: {
    id: 'error_970135',
    defaultmessages: 'At least one occupant should be added for every unit',
  },
  error_970136: {
    id: 'error_970136',
    defaultmessages: 'Atleast two properties should be added for multiple unit case',
  },
  error_970139: {
    id: 'error_970139',
    defaultmessages: 'This agreement type and lessee type combination is invalid.',
  },
  error_970140: {
    id: 'error_970140',
    defaultmessages: 'agreement must be 1 year minimum.',
  },
  error_970141: {
    id: 'error_970141',
    defaultmessages: 'Total rent amount has been exceeded',
  },
  error_970142: {
    id: 'error_970142',
    defaultmessages: 'Occupants exceeded.',
  },
  error_970143: {
    id: 'error_970143',
    defaultmessages: 'Company License not Allowed.',
  },
  error_970144: {
    id: 'error_970144',
    defaultmessages: 'Lessee type not Allowed.',
  },
  error_970145: {
    id: 'error_970145',
    defaultmessages: 'agreement type not Allowed.',
  },
  error_970146: {
    id: 'error_970146',
    defaultmessages: 'Occupants Required',
  },
  error_970147: {
    id: 'error_970147',
    defaultmessages: 'Unit cannot be removed in multi unit agreement for Renewal and Modification',
  },
  error_970148: {
    id: 'error_970148',
    defaultmessages: 'Unit cannot be added in multi unit agreement for Renewal and Modification',
  },
  error_970150: {
    id: 'error_970150',
    defaultmessages: 'No of installments must be a Positive Non-Zero number',
  },
  error_970151: {
    id: 'error_970151',
    defaultmessages:
      'please specify search filters like agreement number, unit registration number, building registration number, or plot number',
  },
  error_980001: {
    id: 'error_980001',
    defaultmessages: 'Unable to generate certificate',
  },
  error_98001: {
    id: 'error_98001',
    defaultmessages: 'Failed to fetch property valuation amount',
  },
  error_98002: {
    id: 'error_98002',
    defaultmessages: 'Failed to submit the application',
  },
  error_98003: {
    id: 'error_98003',
    defaultmessages: 'Failed to fetch the application details',
  },
  error_98004: {
    id: 'error_98004',
    defaultmessages: 'Failed to update the application status',
  },
  error_98005: {
    id: 'error_98005',
    defaultmessages: 'Failed to approve the application',
  },
  error_98006: {
    id: 'error_98006',
    defaultmessages: 'Failed to reject the application',
  },
  error_98007: {
    id: 'error_98007',
    defaultmessages: 'Could not fetch the user login information',
  },
  error_98009: {
    id: 'error_98009',
    defaultmessages: 'Failed to resubmit the application',
  },
  error_98010: {
    id: 'error_98010',
    defaultmessages: 'Failed to pass the application to HOD',
  },
  error_98011: {
    id: 'error_98011',
    defaultmessages: 'You cannot submit the application from the current status details',
  },
  error_980114: {
    id: 'error_980114',
    defaultmessages: 'Application terminated',
  },
  error_98012: {
    id: 'error_98012',
    defaultmessages: 'Application does not exist',
  },
  error_98013: {
    id: 'error_98013',
    defaultmessages: 'Failed to cancel the application',
  },
  error_980147: {
    id: 'error_980147',
    defaultmessages: 'Could not fetch GIS Site Plan Images for this property',
  },
  error_980155: {
    id: 'error_980155',
    defaultmessages: 'Unable to generate certificate',
  },
  error_98016: {
    id: 'error_98016',
    defaultmessages: 'Failed to reject the application',
  },
  error_980164: {
    id: 'error_980164',
    defaultmessages: 'agreement details are missing',
  },
  error_980165: {
    id: 'error_980165',
    defaultmessages: 'agreement start date is mandatory',
  },
  error_980166: {
    id: 'error_980166',
    defaultmessages: 'agreement end date is mandatory',
  },
  error_980167: {
    id: 'error_980167',
    defaultmessages: 'agreement maximum duration is 30 years',
  },
  error_980168: {
    id: 'error_980168',
    defaultmessages: 'agreement duration must be in years only',
  },
  error_980169: {
    id: 'error_980169',
    defaultmessages: 'Draft is required',
  },
  error_98017: {
    id: 'error_98017',
    defaultmessages: 'Invalid payment method, selling price is more than 20% of evaluation price.',
  },
  error_980170: {
    id: 'error_980170',
    defaultmessages: 'Seller is not a Leasehold agreement lessee',
  },
  error_980171: {
    id: 'error_980171',
    defaultmessages: 'Selling percentage cannot be more than 100%',
  },
  error_980172: {
    id: 'error_980172',
    defaultmessages: 'Buyer was not found',
  },
  error_980173: {
    id: 'error_980173',
    defaultmessages: 'Buying percentage cannot be more than 100%',
  },
  error_980174: {
    id: 'error_980174',
    defaultmessages: "Total buyer's percentage should be 100%",
  },
  error_980175: {
    id: 'error_980175',
    defaultmessages: 'All buyers should have buying percentage',
  },
  error_980176: {
    id: 'error_980176',
    defaultmessages: 'Payment already done',
  },
  error_980177: {
    id: 'error_980177',
    defaultmessages: 'No record found',
  },
  error_98018: {
    id: 'error_98018',
    defaultmessages: 'Could not fetch data from ELMS',
  },
  error_980183: {
    id: 'error_980183',
    defaultmessages: 'Shared mortgage is mandatory',
  },
  error_980184: {
    id: 'error_980184',
    defaultmessages: 'Mortgage owner specific shares is mandatory',
  },
  error_980185: {
    id: 'error_980185',
    defaultmessages:
      'The provided Owner ID or specific shares for the mortgage are invalid. Please verify the information and try again.',
  },
  error_980189: {
    id: 'error_980189',
    defaultmessages: 'You must be logged in as a company admin to select the application.',
  },
  error_98019: {
    id: 'error_98019',
    defaultmessages: 'Invalid property type',
  },
  error_980190: {
    id: 'error_980190',
    defaultmessages: 'Some mandatory fields not found on ELMS',
  },
  error_980191: {
    id: 'error_980191',
    defaultmessages: 'No Bank signatory selected for this application',
  },
  error_980196: {
    id: 'error_980196',
    defaultmessages: 'Full share mortgage with the same insurance degree is not allowed',
  },
  error_980197: {
    id: 'error_980197',
    defaultmessages: 'Not allowed to have second partial shares mortgage with same insurance degree for the same owner',
  },
  error_980198: {
    id: 'error_980198',
    defaultmessages: 'Application is already under bank maker review',
  },
  error_980199: {
    id: 'error_980199',
    defaultmessages: 'Mortgage Details are not allowed',
  },
  error_98020: {
    id: 'error_98020',
    defaultmessages: 'Empty response error for ELMS owner details from API',
  },
  error_980200: {
    id: 'error_980200',
    defaultmessages: 'Mortgage Details is missing',
  },
  error_980201: {
    id: 'error_980201',
    defaultmessages: 'You cannot complete the application from the current status',
  },
  error_980202: {
    id: 'error_980202',
    defaultmessages: 'Non-UAE nationals are not allowed to register a National Housing Mortgage on their shares',
  },
  error_980208: {
    id: 'error_980208',
    defaultmessages: 'Buyer Refund amount cannot be empty',
  },
  error_980209: {
    id: 'error_980209',
    defaultmessages: 'Termination type cannot be empty',
  },
  error_98021: {
    id: 'error_98021',
    defaultmessages: 'Cannot be assigned to the same auditor',
  },
  error_980210: {
    id: 'error_980210',
    defaultmessages: 'Total paid amount cannot be empty',
  },
  error_980211: {
    id: 'error_980211',
    defaultmessages: 'Developer forfeited amount cannot be empty',
  },
  error_980212: {
    id: 'error_980212',
    defaultmessages: 'Party bank info cannot be empty',
  },
  error_980213: {
    id: 'error_980213',
    defaultmessages: 'Party bank IBAN cannot be empty',
  },
  error_980214: {
    id: 'error_980214',
    defaultmessages: 'Party bank country cannot be empty',
  },
  error_980215: {
    id: 'error_980215',
    defaultmessages: 'Party bank account details cannot be empty',
  },
  error_980216: {
    id: 'error_980216',
    defaultmessages: 'Buyer refund amount cannot be more than paid amount',
  },
  error_980217: {
    id: 'error_980217',
    defaultmessages: 'Developer is not found',
  },
  error_980218: {
    id: 'error_980218',
    defaultmessages: 'Total refund and forfeited amount not equal to paid amount',
  },
  error_980219: {
    id: 'error_980219',
    defaultmessages: 'Total paid amount should be equal to the forfeited amount to the developer',
  },
  error_98022: {
    id: 'error_98022',
    defaultmessages: 'Party does not have a license number',
  },
  error_98023: {
    id: 'error_98023',
    defaultmessages: 'Party company is not registered in DARI',
  },
  error_98024: {
    id: 'error_98024',
    defaultmessages: 'Buyer does not exist',
  },
  error_98025: {
    id: 'error_98025',
    defaultmessages: 'Could not find an active POA agreement',
  },
  error_98026: {
    id: 'error_98026',
    defaultmessages: 'All company parties must have POA',
  },
  error_98027: {
    id: 'error_98027',
    defaultmessages: 'Could not fetch GIS site plan images for this property',
  },
  error_98028: {
    id: 'error_98028',
    defaultmessages: 'Could not fetch party details from DARI',
  },
  error_98029: {
    id: 'error_98029',
    defaultmessages: 'Could not register the payment',
  },
  error_98030: {
    id: 'error_98030',
    defaultmessages: 'Could not fetch application settings',
  },
  error_98031: {
    id: 'error_98031',
    defaultmessages: 'Could not fetch transaction data from ELMS',
  },
  error_98033: {
    id: 'error_98033',
    defaultmessages: 'Could not fetch authority signature',
  },
  error_98034: {
    id: 'error_98034',
    defaultmessages: 'Could not save user details on DARI',
  },
  error_98035: {
    id: 'error_98035',
    defaultmessages: 'Could not fetch payment details',
  },
  error_ERR_EXISTING_APPS_IN_PROGRESS: {
    id: 'error_ERR_EXISTING_APPS_IN_PROGRESS',
    defaultmessages: 'Existing Application in progress',
  },
  error_invalid_link: {
    id: 'error_invalid_link',
    defaultmessages: 'You are trying to open invalid link',
  },
  error_recalculte_Fee: {
    id: 'error_recalculte_Fee',
    defaultmessages: 'Recalculate Fees',
  },
  error_title_container: {
    id: 'error_title_container',
    defaultmessages: '%1$s. %2$s',
  },
  errors: {
    id: 'errors',
    defaultmessages: 'Errors',
  },
  errror_13000003: {
    id: 'errror_13000003',
    defaultmessages: 'Invalid Initiator Party',
  },
  escrow_account: {
    id: 'escrow_account',
    defaultmessages: 'Escrow Account',
  },
  escrow_account_agreement: {
    id: 'escrow_account_agreement',
    defaultmessages: 'Escrow account agreement',
  },
  escrow_account_agreement_registration: {
    id: 'escrow_account_agreement_registration',
    defaultmessages: 'Escrow account agreement registration',
  },
  escrow_account_details: {
    id: 'escrow_account_details',
    defaultmessages: 'Escrow account details',
  },
  escrow_account_details_and_transactions_will_appear_here: {
    id: 'escrow_account_details_and_transactions_will_appear_here',
    defaultmessages: 'Escrow account details and transactions will appear here once an account is registered',
  },
  escrow_account_number: {
    id: 'escrow_account_number',
    defaultmessages: 'Escrow account number',
  },
  escrow_account_registration: {
    id: 'escrow_account_registration',
    defaultmessages: 'Escrow account registration',
  },
  escrow_account_registration_accpet_signatory_title: {
    id: 'escrow_account_registration_accpet_signatory_title',
    defaultmessages: 'The escrow account agreement has been accepted and signed successfully',
  },
  escrow_account_registration_accpet_title: {
    id: 'escrow_account_registration_accpet_title',
    defaultmessages: 'You have accepted the escrow account agreement registration application successfully',
  },
  escrow_account_reject_message_subtitle: {
    id: 'escrow_account_reject_message_subtitle',
    defaultmessages: 'The application has been rejected',
  },
  escrow_account_reject_message_title: {
    id: 'escrow_account_reject_message_title',
    defaultmessages: 'You have rejected the escrow account agreement registration application',
  },
  escrow_account_return_message_title: {
    id: 'escrow_account_return_message_title',
    defaultmessages: 'You have returned the escrow account agreement registration application',
  },
  escrow_account_success_sub_title: {
    id: 'escrow_account_success_sub_title',
    defaultmessages: 'Your application will be sent to the escrow bank maker to review',
  },
  escrow_account_success_title: {
    id: 'escrow_account_success_title',
    defaultmessages: 'You have submitted the escrow account agreement registration application successfully',
  },
  escrow_balance: {
    id: 'escrow_balance',
    defaultmessages: 'Escrow balance',
  },
  escrow_balance_exclamation: {
    id: 'escrow_balance_exclamation',
    defaultmessages: 'Total credited in main escrow - Total debited in main escrow',
  },
  escrow_email: {
    id: 'escrow_email',
    defaultmessages: 'Account Trustee Email',
  },
  escrow_iban: {
    id: 'escrow_iban',
    defaultmessages: 'Escrow Account IBAN',
  },
  escrow_number: {
    id: 'escrow_number',
    defaultmessages: 'Escrow number',
  },
  escrow_rejection_title: {
    id: 'escrow_rejection_title',
    defaultmessages: 'Please enter your reason(s) for rejecting the escrow account agreement registration',
  },
  escrow_service_providers_payment_approval_developer_approver_initator_success_title: {
    id: 'escrow_service_providers_payment_approval_developer_approver_initator_success_title',
    defaultmessages:
      'The Request Payment Approval from Real Estate Project Escrow Account application has been submitted successfully.',
  },
  escrow_service_providers_payment_approval_developer_initator_success_title: {
    id: 'escrow_service_providers_payment_approval_developer_initator_success_title',
    defaultmessages:
      'The Request Payment Approval from Real Estate Project Escrow Account application has been submitted successfully.',
  },
  escrow_service_providers_payment_approval_inspection_company_auditor_success_title: {
    id: 'escrow_service_providers_payment_approval_inspection_company_auditor_success_title',
    defaultmessages:
      'You have approved the Request Payment Approval from Real Estate Project Escrow Account application successfully',
  },
  escrow_trustee: {
    id: 'escrow_trustee',
    defaultmessages: 'Escrow Trustee',
  },
  establish_agreement: {
    id: 'establish_agreement',
    defaultmessages: 'Establish Agreement',
  },
  establish_agreement_mandatory: {
    id: 'establish_agreement_mandatory',
    defaultmessages: 'Establish Agreement (Optional)',
  },
  establish_contract_documents: {
    id: 'establish_contract_documents',
    defaultmessages: 'Establishment Agreement',
  },
  establishment_date: {
    id: 'establishment_date',
    defaultmessages: 'Establishment Date',
  },
  etisalat: {
    id: 'etisalat',
    defaultmessages: 'Etisalat',
  },
  evaluation_certificate_mandatory: {
    id: 'evaluation_certificate_mandatory',
    defaultmessages: 'Evaluation Certificate (Mandatory)',
  },
  evaluation_details: {
    id: 'evaluation_details',
    defaultmessages: 'Evaluation details',
  },
  evaluation_document_mandatory: {
    id: 'evaluation_document_mandatory',
    defaultmessages: 'Evaluation Document (Mandatory)',
  },
  evaluation_fee_field_desc: {
    id: 'evaluation_fee_field_desc',
    defaultmessages: 'Evaluation fee is calculated as 15% of the total evaluation price',
  },
  evaluation_price: {
    id: 'evaluation_price',
    defaultmessages: 'Valuation price',
  },
  evaluation_purpose: {
    id: 'evaluation_purpose',
    defaultmessages: 'Evaluation purpose',
  },
  evaluation_reason: {
    id: 'evaluation_reason',
    defaultmessages: 'Valuation Reason',
  },
  evaluation_value: {
    id: 'evaluation_value',
    defaultmessages: 'Evaluation Value',
  },
  evaluationn_fee_field_title: {
    id: 'evaluationn_fee_field_title',
    defaultmessages: 'Municipality evaluation fees (15%)',
  },
  evaluator_company: {
    id: 'evaluator_company',
    defaultmessages: 'Valuation Company',
  },
  evaluator_employee: {
    id: 'evaluator_employee',
    defaultmessages: 'Valuator Employee',
  },
  event_date: {
    id: 'event_date',
    defaultmessages: 'Event Date',
  },
  event_time: {
    id: 'event_time',
    defaultmessages: 'Event Time',
  },
  evidence_of_development_experience_and_previous_projects: {
    id: 'evidence_of_development_experience_and_previous_projects',
    defaultmessages: 'Evidence of Development Experience and Previous Projects',
  },
  evidences: {
    id: 'evidences',
    defaultmessages: 'Evidences',
  },
  exclusivity: {
    id: 'exclusivity',
    defaultmessages: 'Exclusivity',
  },
  execution_stamp_success_title: {
    id: 'execution_stamp_success_title',
    defaultmessages: 'The execution stamp was successfully added to the settlement generated for this dispute',
  },
  existing_active_pma: {
    id: 'existing_active_pma',
    defaultmessages: 'There is an existing active Property Management Agreement (PMA) for this property.',
  },
  existing_mortgage: {
    id: 'existing_mortgage',
    defaultmessages: 'Existing Mortgage',
  },
  existing_mortgage_description: {
    id: 'existing_mortgage_description',
    defaultmessages:
      'Please note that this property has an existing mortgage. You will need to arrange for its discharge during the transfer of interest.',
  },
  existing_representative: {
    id: 'existing_representative',
    defaultmessages: 'Existing Representative',
  },
  expected_end_date: {
    id: 'expected_end_date',
    defaultmessages: 'Expected end date',
  },
  expected_start_date: {
    id: 'expected_start_date',
    defaultmessages: 'Expected start date',
  },
  expert: {
    id: 'expert',
    defaultmessages: 'Expert',
  },
  expert_approval_success_title: {
    id: 'expert_approval_success_title',
    defaultmessages: 'You have successfully accepted the work requested for this dispute',
  },
  expert_court_letter: {
    id: 'expert_court_letter',
    defaultmessages: 'Expert court letter',
  },
  expert_license: {
    id: 'expert_license',
    defaultmessages: 'License document',
  },
  expert_report_submit_success_title: {
    id: 'expert_report_submit_success_title',
    defaultmessages: 'You have successfully submitted your report',
  },
  expert_return_success_title: {
    id: 'expert_return_success_title',
    defaultmessages: 'You have successfully returned the work assigned to you for this dispute',
  },
  expire: {
    id: 'expire',
    defaultmessages: 'Expire',
  },
  expired: {
    id: 'expired',
    defaultmessages: 'Expired',
  },
  expiry_date: {
    id: 'expiry_date',
    defaultmessages: 'Expiry date',
  },
  expiry_date_hint: {
    id: 'expiry_date_hint',
    defaultmessages: 'MM/YY',
  },
  explore_all_agreements: {
    id: 'explore_all_agreements',
    defaultmessages: 'Explore all Agreements',
  },
  explore_all_data: {
    id: 'explore_all_data',
    defaultmessages: 'Explore the Available Services',
  },
  explore_all_leased_properties: {
    id: 'explore_all_leased_properties',
    defaultmessages: 'Explore all Leased Properties',
  },
  explore_all_owned_properties: {
    id: 'explore_all_owned_properties',
    defaultmessages: 'Explore all Owned Properties',
  },
  explore_all_real_state_projects: {
    id: 'explore_all_real_state_projects',
    defaultmessages: 'Explore all Real Estate Projects',
  },
  explore_all_services: {
    id: 'explore_all_services',
    defaultmessages: 'Explore All Services',
  },
  explore_more: {
    id: 'explore_more',
    defaultmessages: 'Explore More',
  },
  extension_approval_success_title: {
    id: 'extension_approval_success_title',
    defaultmessages: 'You have successfully accepted the mediation period extension request',
  },
  extension_return_success_title: {
    id: 'extension_return_success_title',
    defaultmessages: 'You have successfully declined the mediation period extension request',
  },
  extra_charge_1050: {
    id: 'extra_charge_1050',
    defaultmessages: 'Extra charge for AccessRP office service is AED 1050 for this application',
  },
  family_no_document: {
    id: 'family_no_document',
    defaultmessages: 'Family no. document',
  },
  fech_unit_details: {
    id: 'fech_unit_details',
    defaultmessages: 'Fetch all units details',
  },
  feedback_category: {
    id: 'feedback_category',
    defaultmessages: 'Feedback Category',
  },
  feedback_for_reject: {
    id: 'feedback_for_reject',
    defaultmessages: 'Feedback note for rejection',
  },
  feedback_note_for_rejection: {
    id: 'feedback_note_for_rejection',
    defaultmessages: 'Feedback note for rejection',
  },
  feedback_note_for_return: {
    id: 'feedback_note_for_return',
    defaultmessages: 'Feedback note for return',
  },
  feedback_pma_return: {
    id: 'feedback_pma_return',
    defaultmessages: 'The application has been returned successfully to the initiator',
  },
  feedback_submitted_successfully: {
    id: 'feedback_submitted_successfully',
    defaultmessages: 'Feedback Submitted Successfully',
  },
  feedback_text: {
    id: 'feedback_text',
    defaultmessages: 'Feedback/reason for return & reject',
  },
  feedback_thanks: {
    id: 'feedback_thanks',
    defaultmessages: 'Thank you for participating. Your response has been recorded.',
  },
  fees: {
    id: 'fees',
    defaultmessages: 'Fees',
  },
  fees_information: {
    id: 'fees_information',
    defaultmessages: 'Fees Information',
  },
  fetch: {
    id: 'fetch',
    defaultmessages: 'Fetch',
  },
  fetch_details: {
    id: 'fetch_details',
    defaultmessages: 'Fetch details',
  },
  field_is_required: {
    id: 'field_is_required',
    defaultmessages: 'Please fill all required fields',
  },
  fields_marked_required: {
    id: 'fields_marked_required',
    defaultmessages: 'All fields marked with * are required',
  },
  'file-invalid-type': {
    id: 'file-invalid-type',
    defaultmessages: 'File type is not supported',
  },
  fill_the_mortgage_details_and_calculate: {
    id: 'fill_the_mortgage_details_and_calculate',
    defaultmessages: "Fill in the Mortgage Details and click 'Calculate Fees' to view the registration fees.",
  },
  fill_the_selling_details_and_calculate: {
    id: 'fill_the_selling_details_and_calculate',
    defaultmessages: 'Fill the selling details and “calculate fee” to get the registration fee',
  },
  financial: {
    id: 'financial',
    defaultmessages: 'Financial',
  },
  financial_information: {
    id: 'financial_information',
    defaultmessages: 'Financial information',
  },
  financing_mortgages: {
    id: 'financing_mortgages',
    defaultmessages: 'Financing & Mortgages',
  },
  first_parties: {
    id: 'first_parties',
    defaultmessages: 'First Parties',
  },
  first_party: {
    id: 'first_party',
    defaultmessages: 'First party',
  },
  five_percent_of_total_agreement_amount: {
    id: 'five_percent_of_total_agreement_amount',
    defaultmessages: '5% of the total agreement amount',
  },
  fixed_service: {
    id: 'fixed_service',
    defaultmessages: 'Fixed Services',
  },
  floor_number: {
    id: 'floor_number',
    defaultmessages: 'Floor number',
  },
  follow_up_satisfaction: {
    id: 'follow_up_satisfaction',
    defaultmessages: 'If needed, we will follow up to ensure your satisfaction',
  },
  follow_us: {
    id: 'follow_us',
    defaultmessages: 'Follow us',
  },
  follow_us_on: {
    id: 'follow_us_on',
    defaultmessages: 'Follow us on',
  },
  footer_title: {
    id: 'footer_title',
    defaultmessages: '© 2025 Abu Dhabi Global Market. All rights reserved.',
  },
  for_any_assistance: {
    id: 'for_any_assistance',
    defaultmessages: 'For any assistance or inquiries please email us',
  },
  for_more_details: {
    id: 'for_more_details',
    defaultmessages: 'For more details',
  },
  force_update_title: {
    id: 'force_update_title',
    defaultmessages: 'It is time for an upgrade',
  },
  forfeited_amount_will_be_transferred_to_this_bank_account: {
    id: 'forfeited_amount_will_be_transferred_to_this_bank_account',
    defaultmessages: 'The forfeited amount will be transferred to this bank account',
  },
  forfeited_to_developer: {
    id: 'forfeited_to_developer',
    defaultmessages: 'Forfeited to developer',
  },
  forgot_password: {
    id: 'forgot_password',
    defaultmessages: 'Forgot password?',
  },
  free: {
    id: 'free',
    defaultmessages: 'Free',
  },
  free_hold: {
    id: 'free_hold',
    defaultmessages: 'Freehold',
  },
  free_on_the_app_store: {
    id: 'free_on_the_app_store',
    defaultmessages: 'Free on the App store',
  },
  frequency: {
    id: 'frequency',
    defaultmessages: 'Frequency',
  },
  from: {
    id: 'from',
    defaultmessages: 'From',
  },
  full: {
    id: 'full',
    defaultmessages: 'Full',
  },
  full_Name: {
    id: 'full_Name',
    defaultmessages: 'Full Name',
  },
  full_address: {
    id: 'full_address',
    defaultmessages: 'Full address',
  },
  full_name: {
    id: 'full_name',
    defaultmessages: 'Full name',
  },
  full_payment: {
    id: 'full_payment',
    defaultmessages: 'Full amount',
  },
  full_project: {
    id: 'full_project',
    defaultmessages: 'Sell Permit (Full Project)',
  },
  full_project_24500_500_5_percent: {
    id: 'full_project_24500_500_5_percent',
    defaultmessages: 'Full Project: AED 24,500 + AED 500 + 5% VAT for 3 months.',
  },
  future_interest_freehold: {
    id: 'future_interest_freehold',
    defaultmessages: 'Future Interest (Freehold)',
  },
  gcc_identity_card: {
    id: 'gcc_identity_card',
    defaultmessages: 'GCC Identity Card',
  },
  gcc_identity_card_mandatory: {
    id: 'gcc_identity_card_mandatory',
    defaultmessages: 'GCC Identity Card (Mandatory)',
  },
  gcc_number: {
    id: 'gcc_number',
    defaultmessages: 'GCC ID',
  },
  general: {
    id: 'general',
    defaultmessages: 'General',
  },
  get_a_firsthand_look_at_the_real_estate_insights_shaping_tomorrow_markets: {
    id: 'get_a_firsthand_look_at_the_real_estate_insights_shaping_tomorrow_markets',
    defaultmessages: "Get a firsthand look at the real estate insights shaping tomorrow's markets.",
  },
  get_details: {
    id: 'get_details',
    defaultmessages: 'Get Details',
  },
  gis_plans: {
    id: 'gis_plans',
    defaultmessages: 'GIS plans',
  },
  go_to_applications: {
    id: 'go_to_applications',
    defaultmessages: 'View All Applications',
  },
  go_to_payment: {
    id: 'go_to_payment',
    defaultmessages: 'Go to payment',
  },
  go_to_properties: {
    id: 'go_to_properties',
    defaultmessages: 'Go to properties',
  },
  go_to_service: {
    id: 'go_to_service',
    defaultmessages: 'Go to service',
  },
  go_to_services: {
    id: 'go_to_services',
    defaultmessages: 'Go to Services',
  },
  government: {
    id: 'government',
    defaultmessages: 'Government',
  },
  government_entity: {
    id: 'government_entity',
    defaultmessages: 'Government entity name',
  },
  government_entity_name: {
    id: 'government_entity_name',
    defaultmessages: 'Government entity name',
  },
  government_license_no: {
    id: 'government_license_no',
    defaultmessages: 'Government license no',
  },
  government_license_number: {
    id: 'government_license_number',
    defaultmessages: 'Government License Number',
  },
  government_license_number_hint: {
    id: 'government_license_number_hint',
    defaultmessages: 'ex. GOV-123243235',
  },
  grace_period: {
    id: 'grace_period',
    defaultmessages: 'Grace period(days)',
  },
  grant_employee_access_to_the_properties: {
    id: 'grant_employee_access_to_the_properties',
    defaultmessages: 'This will grant the employee immediate access to the properties.',
  },
  guarantor_details: {
    id: 'guarantor_details',
    defaultmessages: 'Guarantor Details',
  },
  guardian: {
    id: 'guardian',
    defaultmessages: 'Guardian',
  },
  guardian_court_letter: {
    id: 'guardian_court_letter',
    defaultmessages: 'Guardian court letter',
  },
  guest: {
    id: 'guest',
    defaultmessages: 'Guest',
  },
  guest_login_title: {
    id: 'guest_login_title',
    defaultmessages:
      'Your account is not verified yet. Verify your account to enjoy the full experience and access all DARI services.',
  },
  happy: {
    id: 'happy',
    defaultmessages: 'Happy',
  },
  hash_party: {
    id: 'hash_party',
    defaultmessages: 'Party no.{n}',
  },
  have_any_feedback: {
    id: 'have_any_feedback',
    defaultmessages: 'Have any feedback?',
  },
  headquarters: {
    id: 'headquarters',
    defaultmessages: 'Headquarters',
  },
  help: {
    id: 'help',
    defaultmessages: 'Help',
  },
  help_support: {
    id: 'help_support',
    defaultmessages: 'Help & support',
  },
  hide_units: {
    id: 'hide_units',
    defaultmessages: 'Hide units',
  },
  hires_court_letter: {
    id: 'hires_court_letter',
    defaultmessages: 'Heirs court letter',
  },
  history: {
    id: 'history',
    defaultmessages: '',
  },
  home: {
    id: 'home',
    defaultmessages: 'Home',
  },
  home_directory_profession_description: {
    id: 'home_directory_profession_description',
    defaultmessages: 'Your guide to licensed real estate professions in Abu Dhabi',
  },
  home_directory_project_description: {
    id: 'home_directory_project_description',
    defaultmessages: 'Explore registered real estate projects in Abu Dhabi',
  },
  hotelUnits: {
    id: 'hotelUnits',
    defaultmessages: 'Hotel units',
  },
  i_accept_terms_and_conditions_of_cancellation: {
    id: 'i_accept_terms_and_conditions_of_cancellation',
    defaultmessages: 'I accepted the terms of agreement Surrender and signed it',
  },
  i_accepted_the_terms_of_contract_termination_and_signed_it: {
    id: 'i_accepted_the_terms_of_contract_termination_and_signed_it',
    defaultmessages: 'I accepted the terms of agreement cancellation and signed it',
  },
  i_acknowledge: {
    id: 'i_acknowledge',
    defaultmessages: 'I acknowledge',
  },
  i_have_read_and_accept_the_no_objection_certificate: {
    id: 'i_have_read_and_accept_the_no_objection_certificate',
    defaultmessages: 'I have read and accept the no objection certificate',
  },
  i_have_read_and_accept_the_undertaking_letter: {
    id: 'i_have_read_and_accept_the_undertaking_letter',
    defaultmessages: 'I have read and accept the undertaking letter',
  },
  iban_placeholder: {
    id: 'iban_placeholder',
    defaultmessages: 'e.g. AE930331597634214261934',
  },
  id_eid_number: {
    id: 'id_eid_number',
    defaultmessages: 'ID/EID number',
  },
  identification_document: {
    id: 'identification_document',
    defaultmessages: 'Identification Document',
  },
  identification_documents_emirates_or_passport: {
    id: 'identification_documents_emirates_or_passport',
    defaultmessages: 'Identification Documents (Emirates ID or Passport)',
  },
  identity_proof_documents_mandatory: {
    id: 'identity_proof_documents_mandatory',
    defaultmessages: 'Identity Proof Documents (Mandatory)',
  },
  imported_plots_count: {
    id: 'imported_plots_count',
    defaultmessages: '{s} plots imported successfully',
  },
  in: {
    id: 'in',
    defaultmessages: 'IN',
  },
  in_person_fee: {
    id: 'in_person_fee',
    defaultmessages: 'In-person Fees',
  },
  include_all_shares: {
    id: 'include_all_shares',
    defaultmessages: 'Include all shares',
  },
  increase_in_mortgage_value: {
    id: 'increase_in_mortgage_value',
    defaultmessages: 'Increase in Mortgage Value',
  },
  increase_in_mortgage_value_AED__percent_on_the_difference_in_mortgage_value: {
    id: 'increase_in_mortgage_value_AED__percent_on_the_difference_in_mortgage_value',
    defaultmessages: 'Increase in Mortgage Amount: 100 AED + 0.1% on the difference in mortgage amount',
  },
  increase_mortgage_value_per_the_increase_amount: {
    id: 'increase_mortgage_value_per_the_increase_amount',
    defaultmessages: 'Increase in Mortgage Value (100 AED + 0.1% of the increase amount)',
  },
  individual_details: {
    id: 'individual_details',
    defaultmessages: 'Individual’s details',
  },
  individual_information: {
    id: 'individual_information',
    defaultmessages: 'Individual information',
  },
  individual_representative_info_for_buyer: {
    id: 'individual_representative_info_for_buyer',
    defaultmessages:
      'The added representative will attend the sale and purchase transaction session and will sign the agreement on behalf of the buyer',
  },
  individual_representative_info_for_seller: {
    id: 'individual_representative_info_for_seller',
    defaultmessages:
      'The added representative will attend the sale and purchase transaction session and will sign the agreement on behalf of the seller',
  },
  industrial: {
    id: 'industrial',
    defaultmessages: 'Industrial',
  },
  information_attached_modal_checkbox: {
    id: 'information_attached_modal_checkbox',
    defaultmessages:
      'I declare that the information in this application and any attachments are true and complete as at the date of application',
  },
  initiate: {
    id: 'initiate',
    defaultmessages: 'Initiate',
  },
  initiate_a_service: {
    id: 'initiate_a_service',
    defaultmessages: 'Initiate a service',
  },
  initiate_application: {
    id: 'initiate_application',
    defaultmessages: 'Initiate Application',
  },
  initiate_on_behalf_of: {
    id: 'initiate_on_behalf_of',
    defaultmessages: 'Initiate on behalf of',
  },
  initiate_your_application: {
    id: 'initiate_your_application',
    defaultmessages: 'Initiate Your Application',
  },
  initiated_as: {
    id: 'initiated_as',
    defaultmessages: 'Initiated As',
  },
  initiated_by: {
    id: 'initiated_by',
    defaultmessages: 'Initiated by {s}',
  },
  initiated_by_text: {
    id: 'initiated_by_text',
    defaultmessages: 'Initiated by',
  },
  initiator: {
    id: 'initiator',
    defaultmessages: 'Initiator',
  },
  initiator_POA_details: {
    id: 'initiator_POA_details',
    defaultmessages: 'Initiator (POA details)',
  },
  initiator_name: {
    id: 'initiator_name',
    defaultmessages: 'Initiator name',
  },
  insert_amount: {
    id: 'insert_amount',
    defaultmessages: 'Insert amount',
  },
  inside_uae: {
    id: 'inside_uae',
    defaultmessages: 'Inside UAE',
  },
  insights: {
    id: 'insights',
    defaultmessages: '',
  },
  inspected_by: {
    id: 'inspected_by',
    defaultmessages: 'Inspected by',
  },
  inspection: {
    id: 'inspection',
    defaultmessages: 'Inspection Company',
  },
  inspection_date: {
    id: 'inspection_date',
    defaultmessages: 'Inspection date',
  },
  installment_dates_are_invalid: {
    id: 'installment_dates_are_invalid',
    defaultmessages: 'Installment dates are invalid!',
  },
  installment_type: {
    id: 'installment_type',
    defaultmessages: 'Installment Type',
  },
  installment_with_order_num: {
    id: 'installment_with_order_num',
    defaultmessages: 'installment {s}',
  },
  installments: {
    id: 'installments',
    defaultmessages: 'Installments',
  },
  instant_services: {
    id: 'instant_services',
    defaultmessages: 'Instant Services',
  },
  instant_services_success_subtitle: {
    id: 'instant_services_success_subtitle',
    defaultmessages: 'You will be notified once the application is reviewed by ADGM.',
  },
  instant_services_success_title: {
    id: 'instant_services_success_title',
    defaultmessages: 'Application has been successfully submitted.',
  },
  instrument_containing_the_covenant_mandatory: {
    id: 'instrument_containing_the_covenant_mandatory',
    defaultmessages: 'Instrument Containing the Covenant (Mandatory)',
  },
  insurance_amount: {
    id: 'insurance_amount',
    defaultmessages: 'Insurance Amount',
  },
  insurance_amount_hint: {
    id: 'insurance_amount_hint',
    defaultmessages: 'Ex. AED 10,000',
  },
  insurance_certificate: {
    id: 'insurance_certificate',
    defaultmessages: 'Insurance certificate',
  },
  insurance_company: {
    id: 'insurance_company',
    defaultmessages: 'Insurance Company',
  },
  insurance_company_name_ar: {
    id: 'insurance_company_name_ar',
    defaultmessages: 'Insurance Company Name (Arabic)',
  },
  insurance_company_name_en: {
    id: 'insurance_company_name_en',
    defaultmessages: 'Insurance Company Name (English)',
  },
  insurance_company_name_placeholder: {
    id: 'insurance_company_name_placeholder',
    defaultmessages: 'Ex. ABC company',
  },
  insurance_company_name_placeholder_ar: {
    id: 'insurance_company_name_placeholder_ar',
    defaultmessages: 'Ex. ABC company',
  },
  insurance_degree: {
    id: 'insurance_degree',
    defaultmessages: 'Insurance Degree',
  },
  interest_percentage: {
    id: 'interest_percentage',
    defaultmessages: 'Percentage of interest (%)',
  },
  internal_area: {
    id: 'internal_area',
    defaultmessages: 'Internal area',
  },
  invalid_broker_details_provide: {
    id: 'invalid_broker_details_provide',
    defaultmessages:
      'The broker information you have entered is incorrect or does not match our records. Please review the details and try again.',
  },
  invalid_broker_details_provided: {
    id: 'invalid_broker_details_provided',
    defaultmessages:
      'The broker details provided are invalid and this request cannot proceed. Please review the broker information and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  invalid_email: {
    id: 'invalid_email',
    defaultmessages: 'Invalid email',
  },
  invalid_premise_id: {
    id: 'invalid_premise_id',
    defaultmessages: 'Invalid Premise ID',
  },
  'inventory_sheet_doesn’t_match': {
    id: 'inventory_sheet_doesn’t_match',
    defaultmessages: 'Inventory sheet doesn’t match',
  },
  investment: {
    id: 'investment',
    defaultmessages: 'Investor with Investment Agreement',
  },
  investor_IBAN_letter_mandatory_if_a_refund_is_due_to_the_investor: {
    id: 'investor_IBAN_letter_mandatory_if_a_refund_is_due_to_the_investor',
    defaultmessages: 'Investor IBAN Letter (Mandatory if a refund is due to the investor)',
  },
  invoices_or_cost_breakdown: {
    id: 'invoices_or_cost_breakdown',
    defaultmessages: 'Invoices or Cost Breakdown',
  },
  is_pma_exist_card_content: {
    id: 'is_pma_exist_card_content',
    defaultmessages:
      'There is an active property management agreement for this property, which ends on {date}. You will not be able to lease this property under a possessory mortgage. Would you like to continue?',
  },
  issuance_date: {
    id: 'issuance_date',
    defaultmessages: 'Issuance date',
  },
  'issue-ownership-certificate': {
    id: 'issue-ownership-certificate',
    defaultmessages: 'Ownership Certificate Issuance',
  },
  'issue-site-plan': {
    id: 'issue-site-plan',
    defaultmessages: 'Site Plan Certificate Issuance',
  },
  'issue-title-deed-land': {
    id: 'issue-title-deed-land',
    defaultmessages: 'Land Title Deed Certificate Issuance',
  },
  'issue-title-deed-unit': {
    id: 'issue-title-deed-unit',
    defaultmessages: 'Unit Title Deed Certificate Issuance',
  },
  'issue-valuation-certificate': {
    id: 'issue-valuation-certificate',
    defaultmessages: 'Issue Valuation Certificate (Land/Unit)',
  },
  'issue-verification-certificate-land': {
    id: 'issue-verification-certificate-land',
    defaultmessages: 'Land Search Certificate Issuance',
  },
  'issue-verification-certificate-unit': {
    id: 'issue-verification-certificate-unit',
    defaultmessages: 'Unit Search Certificate Issuance',
  },
  issue_hint: {
    id: 'issue_hint',
    defaultmessages: 'What is the issue about?',
  },
  issue_new_certificate: {
    id: 'issue_new_certificate',
    defaultmessages: 'Issue new certificate',
  },
  issue_new_title_deed: {
    id: 'issue_new_title_deed',
    defaultmessages: 'Issue new title deed',
  },
  issue_ownership_certificate_description: {
    id: 'issue_ownership_certificate_description',
    defaultmessages:
      'Through this service you can obtain a Property Ownership Certificate, which verifies and confirms your current or previous ownership of registered units or lands located exclusively on Al Mariyah and Al Reem Islands.',
  },
  issue_site_plan: {
    id: 'issue_site_plan',
    defaultmessages: 'Site Plan Certificate Issuance',
  },
  issue_site_plan_description: {
    id: 'issue_site_plan_description',
    defaultmessages:
      'Through this service you can request the issuance of a site plan for your properties, containing important information such as the geographical data of a specific property.',
  },
  issue_title_deed: {
    id: 'issue_title_deed',
    defaultmessages: 'Issue title deed',
  },
  issue_title_deed_land: {
    id: 'issue_title_deed_land',
    defaultmessages: 'Land Title Deed Certificate Issuance',
  },
  issue_title_deed_land_description: {
    id: 'issue_title_deed_land_description',
    defaultmessages: 'Through this service, you can request an ownership deed of land.',
  },
  issue_title_deed_unit: {
    id: 'issue_title_deed_unit',
    defaultmessages: 'Unit Title Deed Certificate Issuance',
  },
  issue_title_deed_unit_description: {
    id: 'issue_title_deed_unit_description',
    defaultmessages: 'Through this service, you can request an ownership deed for an individual unit.',
  },
  issue_type: {
    id: 'issue_type',
    defaultmessages: 'Issue type',
  },
  issue_type_cannot_be_empty: {
    id: 'issue_type_cannot_be_empty',
    defaultmessages: 'Issue type required',
  },
  issue_valuation_certificate_description: {
    id: 'issue_valuation_certificate_description',
    defaultmessages:
      'This service provides an official document certifying the assessed value of a property (land or unit) for legal, financial, or administrative purposes.',
  },
  issue_verification_certificate_land: {
    id: 'issue_verification_certificate_land',
    defaultmessages: 'Land Search Certificate Issuance',
  },
  issue_verification_certificate_land_description: {
    id: 'issue_verification_certificate_land_description',
    defaultmessages:
      'Through this service, you can request a search certificate confirming any restrictions on a plot of land, such as active mortgages.',
  },
  issue_verification_certificate_unit: {
    id: 'issue_verification_certificate_unit',
    defaultmessages: 'Unit Search Certificate Issuance',
  },
  issue_verification_certificate_unit_description: {
    id: 'issue_verification_certificate_unit_description',
    defaultmessages:
      'Through this service, you can request a search certificate verifying any restrictions on a single unit, such as active mortgages.',
  },
  issue_with_user_profile: {
    id: 'issue_with_user_profile',
    defaultmessages: 'Issue with User Profile',
  },
  it_can_be_zero_0: {
    id: 'it_can_be_zero_0',
    defaultmessages: 'It can be zero "0"',
  },
  justification_report: {
    id: 'justification_report',
    defaultmessages: 'Justification Report',
  },
  land_area: {
    id: 'land_area',
    defaultmessages: 'Land area',
  },
  land_details: {
    id: 'land_details',
    defaultmessages: 'Land Details',
  },
  land_evaluation_certificate: {
    id: 'land_evaluation_certificate',
    defaultmessages: 'Land valuation certificate',
  },
  land_evaluation_certification_document: {
    id: 'land_evaluation_certification_document',
    defaultmessages: 'Land evaluation certification document',
  },
  land_number: {
    id: 'land_number',
    defaultmessages: 'Plot number',
  },
  language: {
    id: 'language',
    defaultmessages: 'Language',
  },
  last_update: {
    id: 'last_update',
    defaultmessages: 'Last update',
  },
  last_update_on: {
    id: 'last_update_on',
    defaultmessages: 'Last update on: {d}',
  },
  late_filling_fees: {
    id: 'late_filling_fees',
    defaultmessages: 'Late Filing Fees',
  },
  late_registration_fine: {
    id: 'late_registration_fine',
    defaultmessages: 'Late Registration Fine',
  },
  latest_progress_report: {
    id: 'latest_progress_report',
    defaultmessages: 'Latest progress report',
  },
  latest_report: {
    id: 'latest_report',
    defaultmessages: 'Latest report',
  },
  latest_service_charges: {
    id: 'latest_service_charges',
    defaultmessages: 'Latest service charges',
  },
  latest_transactions: {
    id: 'latest_transactions',
    defaultmessages: 'Latest transactions',
  },
  law_directory: {
    id: 'law_directory',
    defaultmessages: 'Law Directory',
  },
  lawyer: {
    id: 'lawyer',
    defaultmessages: 'Lawyer',
  },
  leasable_properties: {
    id: 'leasable_properties',
    defaultmessages: 'Leasable Properties',
  },
  lease: {
    id: 'lease',
    defaultmessages: 'Lease',
  },
  lease_agreement_Optional_required_if_linked_with_unit_or_building: {
    id: 'lease_agreement_Optional_required_if_linked_with_unit_or_building',
    defaultmessages: 'Lease Agreement (Optional; Required if Linked to a Unit or Building)',
  },
  lease_agreement_fees: {
    id: 'lease_agreement_fees',
    defaultmessages: 'Lease Agreement Fees',
  },
  lease_agreement_mandatory: {
    id: 'lease_agreement_mandatory',
    defaultmessages: 'Lease Agreement (Mandatory)',
  },
  lease_agreement_optional: {
    id: 'lease_agreement_optional',
    defaultmessages: 'Lease Agreement (Optional)',
  },
  lease_agreement_preview: {
    id: 'lease_agreement_preview',
    defaultmessages: 'Lease Agreement Preview',
  },
  lease_agreement_signed_notification: {
    id: 'lease_agreement_signed_notification',
    defaultmessages: 'We will send you a notification when the agreement has been signed by your lessee',
  },
  lease_cancellation_tenant_approval_text: {
    id: 'lease_cancellation_tenant_approval_text',
    defaultmessages: 'Your Surrender of lease agreement has been forwarded to the lessee',
  },
  lease_closure_cancellation_text: {
    id: 'lease_closure_cancellation_text',
    defaultmessages:
      'Your lease agreement surrender application has been successfully forwarded to other owners for approval',
  },
  lease_contracts: {
    id: 'lease_contracts',
    defaultmessages: 'Lease agreements',
  },
  lease_desc: {
    id: 'lease_desc',
    defaultmessages: 'Lease a property in Abu Dhabi',
  },
  lease_final_approval: {
    id: 'lease_final_approval',
    defaultmessages: 'Lease final approval',
  },
  lease_hold: {
    id: 'lease_hold',
    defaultmessages: 'Leasehold',
  },
  lease_hold_details: {
    id: 'lease_hold_details',
    defaultmessages: 'Leasehold Details',
  },
  lease_hold_end_date: {
    id: 'lease_hold_end_date',
    defaultmessages: 'Leasehold End Date',
  },
  lease_property_lessor: {
    id: 'lease_property_lessor',
    defaultmessages: 'Property lessors ({s})',
  },
  lease_reg_reject: {
    id: 'lease_reg_reject',
    defaultmessages: 'Lease registration rejection',
  },
  lease_submit_success: {
    id: 'lease_submit_success',
    defaultmessages: 'Your lease agreement registration application has been submitted successfully for approval',
  },
  lease_submit_success_text: {
    id: 'lease_submit_success_text',
    defaultmessages: 'Your modify request for agreement has been submitted successfully for review',
  },
  lease_surrender_fee_policy: {
    id: 'lease_surrender_fee_policy',
    defaultmessages:
      'In the case of lease surrender, the remaining 5% ADGM fee will still be collected by TAQA upon surrender of the agreement.',
  },
  lease_surrender_success_title: {
    id: 'lease_surrender_success_title',
    defaultmessages: 'Your lease agreement surrender application has been successfully submitted for approval',
  },
  lease_tenant_approval: {
    id: 'lease_tenant_approval',
    defaultmessages: 'Lease lessee approval',
  },
  lease_terminate_by_court_submission: {
    id: 'lease_terminate_by_court_submission',
    defaultmessages:
      'Your lease agreement termination by court order application has been successfully forwarded to ADGM for approval',
  },
  lease_type: {
    id: 'lease_type',
    defaultmessages: 'Lease type',
  },
  lease_unit_details: {
    id: 'lease_unit_details',
    defaultmessages: 'Lease unit details',
  },
  leased_properties: {
    id: 'leased_properties',
    defaultmessages: 'Leased Properties',
  },
  leasehold_agreement_details: {
    id: 'leasehold_agreement_details',
    defaultmessages: 'Leasehold Agreement Details',
  },
  legal_form: {
    id: 'legal_form',
    defaultmessages: 'Legal form',
  },
  legal_notice: {
    id: 'legal_notice',
    defaultmessages: 'Legal Notice',
  },
  legal_notice_date: {
    id: 'legal_notice_date',
    defaultmessages: 'Legal Notice Date',
  },
  legal_notice_description: {
    id: 'legal_notice_description',
    defaultmessages:
      'This service enables real estate developers to issue an official legal notice to buyers for the termination of an off-plan sales agreement, in accordance with applicable regulations and contractual terms.',
  },
  legal_notice_mandatory: {
    id: 'legal_notice_mandatory',
    defaultmessages: 'Legal Notice (Mandatory)',
  },
  legal_notice_numbering: {
    id: 'legal_notice_numbering',
    defaultmessages: 'Legal Notice #{num}',
  },
  less_demands: {
    id: 'less_demands',
    defaultmessages: 'View fewer demands',
  },
  lessor: {
    id: 'lessor',
    defaultmessages: 'Lessor',
  },
  lessor_details: {
    id: 'lessor_details',
    defaultmessages: 'Lessor details',
  },
  let_you_know_certificate_is_ready: {
    id: 'let_you_know_certificate_is_ready',
    defaultmessages: 'Please check the application again once the certificate is ready for download.',
  },
  license: {
    id: 'license',
    defaultmessages: 'License No.',
  },
  license_document: {
    id: 'license_document',
    defaultmessages: 'License documents',
  },
  license_end_date_DD_MM_YYYY: {
    id: 'license_end_date_DD_MM_YYYY',
    defaultmessages: 'License end date',
  },
  license_expiry_date: {
    id: 'license_expiry_date',
    defaultmessages: 'License expiry date',
  },
  license_first_issuance_date: {
    id: 'license_first_issuance_date',
    defaultmessages: 'License First Issuance Date',
  },
  license_issue_date: {
    id: 'license_issue_date',
    defaultmessages: 'License issue date',
  },
  license_number: {
    id: 'license_number',
    defaultmessages: 'License number',
  },
  license_number_not_exists: {
    id: 'license_number_not_exists',
    defaultmessages: 'Trade license number not found',
  },
  license_source: {
    id: 'license_source',
    defaultmessages: 'License issued from',
  },
  like_to_request: {
    id: 'like_to_request',
    defaultmessages: 'What would you like to request?',
  },
  link_content: {
    id: 'link_content',
    defaultmessages: 'Link Content',
  },
  location: {
    id: 'location',
    defaultmessages: 'Location',
  },
  login: {
    id: 'login',
    defaultmessages: 'Login',
  },
  loginButtonContinue: {
    id: 'loginButtonContinue',
    defaultmessages: 'Continue',
  },
  loginFieldEmail: {
    id: 'loginFieldEmail',
    defaultmessages: 'Email',
  },
  loginFieldPassword: {
    id: 'loginFieldPassword',
    defaultmessages: 'Your password',
  },
  login_service_down_message: {
    id: 'login_service_down_message',
    defaultmessages:
      'We are currently experiencing technical issues with the login service. Our teams are actively working to resolve the issue. We appreciate your patience and expect to be back online shortly.',
  },
  login_sign_up: {
    id: 'login_sign_up',
    defaultmessages: 'Log in',
  },
  login_sign_up_web: {
    id: 'login_sign_up_web',
    defaultmessages: 'Log in',
  },
  login_sign_up_with_unified_number: {
    id: 'login_sign_up_with_unified_number',
    defaultmessages: 'Log in/Sign up with Unified number',
  },
  login_was_unsuccessful: {
    id: 'login_was_unsuccessful',
    defaultmessages: 'Login was unsuccessful',
  },
  login_with_email_and_password: {
    id: 'login_with_email_and_password',
    defaultmessages: 'Please login using your verified email address and password',
  },
  logout: {
    id: 'logout',
    defaultmessages: 'Logout',
  },
  logout_home_page_title: {
    id: 'logout_home_page_title',
    defaultmessages: 'AccessRP - the solution for all real estate requirements in ADGM',
  },
  'long-lease-surrender': {
    id: 'long-lease-surrender',
    defaultmessages: 'Surrender of a Long Lease',
  },
  long_lease_agreement_on_plot: {
    id: 'long_lease_agreement_on_plot',
    defaultmessages: 'Long Lease Agreement on Plot',
  },
  long_lease_agreement_on_plot_optional: {
    id: 'long_lease_agreement_on_plot_optional',
    defaultmessages: 'Long Lease Agreement on Plot (Optional)',
  },
  long_lease_surrender_description: {
    id: 'long_lease_surrender_description',
    defaultmessages:
      'This service facilitates the voluntary termination of a long lease agreement before its expiration. The surrender involves mutual agreement between the lessor and lessee, with updates to property records to reflect the termination.',
  },
  long_term_helper: {
    id: 'long_term_helper',
    defaultmessages: 'An agreement of 4 to 25 years is considered a long-term',
  },
  long_trem: {
    id: 'long_trem',
    defaultmessages: 'Long Term',
  },
  love_to_hear: {
    id: 'love_to_hear',
    defaultmessages: "Click here - we'd love to hear it",
  },
  maid_rooms: {
    id: 'maid_rooms',
    defaultmessages: 'Maid rooms',
  },
  main_license_number: {
    id: 'main_license_number',
    defaultmessages: 'Main License Number',
  },
  main_pma: {
    id: 'main_pma',
    defaultmessages: 'Main PMA',
  },
  main_project_number: {
    id: 'main_project_number',
    defaultmessages: 'Main project number',
  },
  maintain_file_notes: {
    id: 'maintain_file_notes',
    defaultmessages: 'Maintain File Notes',
  },
  maintain_file_notes_description: {
    id: 'maintain_file_notes_description',
    defaultmessages:
      'This service is for updating property information, including all relevant details about the property.',
  },
  make_an_appointment: {
    id: 'make_an_appointment',
    defaultmessages: 'Make an appointment',
  },
  make_cover: {
    id: 'make_cover',
    defaultmessages: 'Make cover',
  },
  management_team_details: {
    id: 'management_team_details',
    defaultmessages: 'Management Team Details',
  },
  manager_cheque: {
    id: 'manager_cheque',
    defaultmessages: 'Manager cheque',
  },
  manual_profile_application_submitted_successfully_for_approval: {
    id: 'manual_profile_application_submitted_successfully_for_approval',
    defaultmessages: 'Your application for manual profile creation was successfully submitted for approval',
  },
  manual_profile_creation: {
    id: 'manual_profile_creation',
    defaultmessages: 'Manual Profile Creation',
  },
  map_view: {
    id: 'map_view',
    defaultmessages: 'Map View',
  },
  market_data: {
    id: 'market_data',
    defaultmessages: 'Market Data',
  },
  market_data_disclaimer: {
    id: 'market_data_disclaimer',
    defaultmessages:
      "For the specified time periods, both sale and mortgage transactions are aggregated. For example, the figures for off-plan property sales in the first quarter of 2021 represent the sum of all such completed sales between midnight on January 1, 2021 and midnight on April 1, 2021.\nAdditionally, it should be noted that for sale transactions, the effective date on the sale and purchase agreement or the date of the sale's registration with municipal authorities, whichever is more readily available and applicable, is considered the transactional date, and aggregations are calculated accordingly. For mortgages, the registration dates are always taken to be the transactional dates.\n\nThis data is intended to convey indicative real estate market movements and no liability is accepted to any third party for the whole or any part of its contents. The information and analysis have been obtained from or based on information which was current at the time of sourcing from official transactional records and other third-party sources generally regarded to be reliable and assumptions which are generally considered reasonable. \nIt should be noted that the calculation of the price indices, average sale prices, and average rental prices is a multi-faceted exercise typically involving extensive data cleansing, advanced statistical methods, and the qualitative knowledge of market experts. Notwithstanding, the aforementioned market indicators are acutely sensitive to changing conditions, variations in any one of which may significantly affect quantitative outputs.",
  },
  market_data_disclaimer_title: {
    id: 'market_data_disclaimer_title',
    defaultmessages: 'Disclaimer',
  },
  market_data_title: {
    id: 'market_data_title',
    defaultmessages: 'Welcome the Market Data of Abu Dhabi',
  },
  marketing_materials: {
    id: 'marketing_materials',
    defaultmessages: 'Marketing materials',
  },
  master: {
    id: 'master',
    defaultmessages: 'Master',
  },
  master_contract_number: {
    id: 'master_contract_number',
    defaultmessages: 'Master Agreement Number',
  },
  master_lease: {
    id: 'master_lease',
    defaultmessages: 'Lease',
  },
  max_doc_size: {
    id: 'max_doc_size',
    defaultmessages: 'Maximum file size is 20 MB',
  },
  max_photo_size: {
    id: 'max_photo_size',
    defaultmessages: 'Maximum file size is 2 MB',
  },
  max_text_text: {
    id: 'max_text_text',
    defaultmessages: 'The maximum character count is 500',
  },
  maximum_file_size_Allowed_file_types: {
    id: 'maximum_file_size_Allowed_file_types',
    defaultmessages: 'Maximum file size 20 MB. Allowed file types: PDF, PNG, JPEG.',
  },
  maximum_file_size_allowed_file_types: {
    id: 'maximum_file_size_allowed_file_types',
    defaultmessages: 'Maximum 20MB | PDF, JPEG and PNG files are supported.',
  },
  maximum_lease_hold_is_198_years: {
    id: 'maximum_lease_hold_is_198_years',
    defaultmessages: 'Maximum leasehold is 198 years',
  },
  mediator: {
    id: 'mediator',
    defaultmessages: 'Mediator',
  },
  menu: {
    id: 'menu',
    defaultmessages: 'Menu',
  },
  meps_preliminary_architectural_approval: {
    id: 'meps_preliminary_architectural_approval',
    defaultmessages: 'MEPS Preliminary Architectural Approval',
  },
  meps_preliminary_architectural_approval_mandatory: {
    id: 'meps_preliminary_architectural_approval_mandatory',
    defaultmessages: 'MEPS Preliminary Architectural Approval (Mandatory)',
  },
  method: {
    id: 'method',
    defaultmessages: 'Method',
  },
  milestone_payment_certification_issues: {
    id: 'milestone_payment_certification_issues',
    defaultmessages: 'Milestone Payment Certification (issued by a qualified Engineering Auditor)',
  },
  million: {
    id: 'million',
    defaultmessages: 'M',
  },
  minimum_duration_lease_renewal: {
    id: 'minimum_duration_lease_renewal',
    defaultmessages: 'Minimum duration for renewal should be at least one day',
  },
  mixed: {
    id: 'mixed',
    defaultmessages: 'Mixed',
  },
  moa: {
    id: 'moa',
    defaultmessages: 'Memorandum of Association (MOA)',
  },
  mobile: {
    id: 'mobile',
    defaultmessages: 'Mobile number',
  },
  mobile_number_hint: {
    id: 'mobile_number_hint',
    defaultmessages: '+971500000000',
  },
  mobile_words: {
    id: 'mobile_words',
    defaultmessages: 'Mobile',
  },
  modification_of_mortgage: {
    id: 'modification_of_mortgage',
    defaultmessages: 'Variation of Mortgage',
  },
  modified_mortgage_contract_details: {
    id: 'modified_mortgage_contract_details',
    defaultmessages: 'Modified Mortgage Agreement Details',
  },
  modify: {
    id: 'modify',
    defaultmessages: 'Modify',
  },
  modify_selection: {
    id: 'modify_selection',
    defaultmessages: 'Modify selection',
  },
  modify_tenancy_title: {
    id: 'modify_tenancy_title',
    defaultmessages: 'Your lease agreement variation application has been submitted successfully for approval',
  },
  module: {
    id: 'module',
    defaultmessages: 'Module',
  },
  moi_hint: {
    id: 'moi_hint',
    defaultmessages: 'Ex: 123457',
  },
  moi_unified_number: {
    id: 'moi_unified_number',
    defaultmessages: 'MOI Unified Number',
  },
  monthly: {
    id: 'monthly',
    defaultmessages: 'Last 30 days',
  },
  monthly_installments_paid_by_tenant: {
    id: 'monthly_installments_paid_by_tenant',
    defaultmessages: 'Monthly installments (including in the ADDC bills) — Paid by Lessee',
  },
  monthly_transactions: {
    id: 'monthly_transactions',
    defaultmessages: 'Transactions in the last 30 days',
  },
  more: {
    id: 'more',
    defaultmessages: 'More',
  },
  more_info: {
    id: 'more_info',
    defaultmessages: 'More info',
  },
  mortgage: {
    id: 'mortgage',
    defaultmessages: 'Mortgages',
  },
  'mortgage-modification': {
    id: 'mortgage-modification',
    defaultmessages: 'Mortgage Variation',
  },
  'mortgage-registration-land': {
    id: 'mortgage-registration-land',
    defaultmessages: 'Mortgage Registration — Land',
  },
  'mortgage-registration-unit': {
    id: 'mortgage-registration-unit',
    defaultmessages: 'Mortgage Registration — Unit',
  },
  'mortgage-release': {
    id: 'mortgage-release',
    defaultmessages: 'Mortgage Discharge',
  },
  mortgage_Release_application_has_been_returned_bank_maker: {
    id: 'mortgage_Release_application_has_been_returned_bank_maker',
    defaultmessages: 'Mortgage Release application has been returned to the bank maker.',
  },
  mortgage_Release_application_returned_to_the_initiator: {
    id: 'mortgage_Release_application_returned_to_the_initiator',
    defaultmessages: 'Mortgage Release application has been returned to the initiator.',
  },
  mortgage_agreement_appendix: {
    id: 'mortgage_agreement_appendix',
    defaultmessages: 'Mortgage Agreement Appendix',
  },
  mortgage_agreement_appendix_bank: {
    id: 'mortgage_agreement_appendix_bank',
    defaultmessages: 'Mortgage Agreement Appendix Bank',
  },
  mortgage_agreement_appendix_bank_maker: {
    id: 'mortgage_agreement_appendix_bank_maker',
    defaultmessages: 'Mortgage Agreement Appendix Bank Maker',
  },
  mortgage_agreement_appendix_bank_maker_release: {
    id: 'mortgage_agreement_appendix_bank_maker_release',
    defaultmessages: 'Mortgage Agreement Appendix Bank Maker Release',
  },
  mortgage_agreement_appendix_mandatory: {
    id: 'mortgage_agreement_appendix_mandatory',
    defaultmessages: 'Mortgage Agreement Appendix (Mandatory)',
  },
  mortgage_agreement_mandatory: {
    id: 'mortgage_agreement_mandatory',
    defaultmessages: 'Mortgage Agreement (Mandatory)',
  },
  mortgage_agreement_optional: {
    id: 'mortgage_agreement_optional',
    defaultmessages: 'Mortgage Agreement (Optional).',
  },
  mortgage_amount: {
    id: 'mortgage_amount',
    defaultmessages: 'Mortgage amount',
  },
  mortgage_amount_words: {
    id: 'mortgage_amount_words',
    defaultmessages: 'Mortgage amount (in words)',
  },
  mortgage_application_rejected_successfully: {
    id: 'mortgage_application_rejected_successfully',
    defaultmessages: 'Mortgage registration application has been rejected successfully',
  },
  mortgage_application_returned_successfully: {
    id: 'mortgage_application_returned_successfully',
    defaultmessages: 'Mortgage registration application has been returned successfully',
  },
  mortgage_application_sent_to_bank_for_approval: {
    id: 'mortgage_application_sent_to_bank_for_approval',
    defaultmessages: 'Mortgage registration application sent to bank for approval',
  },
  mortgage_application_sent_to_other_owners_for_approval: {
    id: 'mortgage_application_sent_to_other_owners_for_approval',
    defaultmessages: 'Mortgage registration application sent to other owners for approval',
  },
  mortgage_application_sent_to_signatory_for_approval: {
    id: 'mortgage_application_sent_to_signatory_for_approval',
    defaultmessages: 'Mortgage registration application sent to signatory for approval',
  },
  mortgage_application_terminated_successfully: {
    id: 'mortgage_application_terminated_successfully',
    defaultmessages: 'Mortgage registration application has been terminated successfully',
  },
  mortgage_authority: {
    id: 'mortgage_authority',
    defaultmessages: 'Mortgage Authority',
  },
  mortgage_bank: {
    id: 'mortgage_bank',
    defaultmessages: 'Mortgage bank',
  },
  mortgage_certificate_mandatory: {
    id: 'mortgage_certificate_mandatory',
    defaultmessages: 'Mortgage Certificate (Mandatory)',
  },
  mortgage_certificate_optional: {
    id: 'mortgage_certificate_optional',
    defaultmessages: 'Mortgage Certificate (Optional)',
  },
  mortgage_contract: {
    id: 'mortgage_contract',
    defaultmessages: 'Mortgage agreement',
  },
  mortgage_contract_details: {
    id: 'mortgage_contract_details',
    defaultmessages: 'Mortgage Agreement Details',
  },
  mortgage_data: {
    id: 'mortgage_data',
    defaultmessages: 'Mortgage data',
  },
  mortgage_discharge_1000_aed: {
    id: 'mortgage_discharge_1000_aed',
    defaultmessages: 'Discharge of mortgage: 1,000 AED per property',
  },
  mortgage_discharge_fee_Including_vat: {
    id: 'mortgage_discharge_fee_Including_vat',
    defaultmessages: 'Mortgage Discharge Fee (Including VAT)',
  },
  mortgage_discharge_is_completed: {
    id: 'mortgage_discharge_is_completed',
    defaultmessages: 'Mortgage discharge is completed',
  },
  mortgage_emirate_abu_dhabi_title: {
    id: 'mortgage_emirate_abu_dhabi_title',
    defaultmessages: 'Mortgages in emirate of Abu Dhabi',
  },
  mortgage_end_date: {
    id: 'mortgage_end_date',
    defaultmessages: 'Mortgage end date',
  },
  mortgage_modification: {
    id: 'mortgage_modification',
    defaultmessages: 'Mortgage Variation',
  },
  mortgage_modification_application_has_been_forwarded_to_the_bank_maker_for_approval: {
    id: 'mortgage_modification_application_has_been_forwarded_to_the_bank_maker_for_approval',
    defaultmessages: 'Mortgage Variation application sent to the bank maker for approval.',
  },
  mortgage_modification_application_has_been_rejected: {
    id: 'mortgage_modification_application_has_been_rejected',
    defaultmessages: 'Mortgage variation application has been rejected.',
  },
  mortgage_modification_application_has_been_returned_to_the_bank_maker: {
    id: 'mortgage_modification_application_has_been_returned_to_the_bank_maker',
    defaultmessages: 'Mortgage variation application has been returned to the bank maker.',
  },
  mortgage_modification_application_returned_to_the_initiator: {
    id: 'mortgage_modification_application_returned_to_the_initiator',
    defaultmessages: 'Mortgage Variation application has been returned to the initiator.',
  },
  mortgage_modification_application_sent_to_adgm_for_approval: {
    id: 'mortgage_modification_application_sent_to_adgm_for_approval',
    defaultmessages: 'Mortgage Variation application sent to back office for approval.',
  },
  mortgage_modification_application_sent_to_bank_checker_for_approval: {
    id: 'mortgage_modification_application_sent_to_bank_checker_for_approval',
    defaultmessages: 'Mortgage Variation application sent to the bank checker for approval.',
  },
  mortgage_modification_application_sent_to_bank_for_approval: {
    id: 'mortgage_modification_application_sent_to_bank_for_approval',
    defaultmessages: 'Mortgage Variation application sent to the bank for approval.',
  },
  mortgage_modification_application_sent_to_bank_maker_for_approval: {
    id: 'mortgage_modification_application_sent_to_bank_maker_for_approval',
    defaultmessages: 'Mortgage Variation application has been sent to the bank maker for approval',
  },
  mortgage_modification_application_sent_to_other_owners_for_approval: {
    id: 'mortgage_modification_application_sent_to_other_owners_for_approval',
    defaultmessages: 'Mortgage Variation application sent to the other owner for approval.',
  },
  mortgage_modification_application_sent_to_the_other_owners_for_approval: {
    id: 'mortgage_modification_application_sent_to_the_other_owners_for_approval',
    defaultmessages: '',
  },
  mortgage_modification_description: {
    id: 'mortgage_modification_description',
    defaultmessages:
      'Through this service, the mortgaged property owner can initiate the service, while the bank only can modify the agreement details such as the mortgage amount, degree, duration, terms, evaluation company, and discharge of mortgage for a property.',
  },
  mortgage_modification_fees: {
    id: 'mortgage_modification_fees',
    defaultmessages: 'Mortgage Variation Fees',
  },
  mortgage_plot_including_all_shares: {
    id: 'mortgage_plot_including_all_shares',
    defaultmessages: 'Mortgage plot including all shares',
  },
  mortgage_reg_fee: {
    id: 'mortgage_reg_fee',
    defaultmessages: 'Mortgage registration fee (0.09%)',
  },
  mortgage_registeration_fee_hint: {
    id: 'mortgage_registeration_fee_hint',
    defaultmessages: '(0.1% from the mortgage amount)',
  },
  mortgage_registration: {
    id: 'mortgage_registration',
    defaultmessages: 'Mortgage Registration',
  },
  mortgage_registration_application_rejected_successfully: {
    id: 'mortgage_registration_application_rejected_successfully',
    defaultmessages: 'Mortgage registration application has been rejected successfully',
  },
  mortgage_registration_application_returned_to_owner: {
    id: 'mortgage_registration_application_returned_to_owner',
    defaultmessages: 'Mortgage registration application has been returned to the owner',
  },
  mortgage_registration_application_returned_to_the_bank_maker: {
    id: 'mortgage_registration_application_returned_to_the_bank_maker',
    defaultmessages: 'Mortgage registration application has been returned to the bank maker',
  },
  mortgage_registration_application_sent_to_bank_approval: {
    id: 'mortgage_registration_application_sent_to_bank_approval',
    defaultmessages: 'Mortgage registration application sent to bank approval',
  },
  mortgage_registration_application_sent_to_bank_checker_for_approval: {
    id: 'mortgage_registration_application_sent_to_bank_checker_for_approval',
    defaultmessages: 'Mortgage registration application sent to bank checker for approval',
  },
  mortgage_registration_application_sent_to_municipality: {
    id: 'mortgage_registration_application_sent_to_municipality',
    defaultmessages: 'The mortgage registration application has been sent to the back office for approval.',
  },
  mortgage_registration_certificate: {
    id: 'mortgage_registration_certificate',
    defaultmessages: 'Mortgage Registration Certificate',
  },
  mortgage_registration_certificate_successfully_issues: {
    id: 'mortgage_registration_certificate_successfully_issues',
    defaultmessages: 'Mortgage registration certificate has been successfully issued',
  },
  mortgage_registration_fee: {
    id: 'mortgage_registration_fee',
    defaultmessages: 'Mortgage registration fee is',
  },
  mortgage_registration_fee_0_1_no_maximum_cap: {
    id: 'mortgage_registration_fee_0_1_no_maximum_cap',
    defaultmessages: 'Mortgage Registration Fee: 0.1% of the mortgage amount (no maximum cap applies)',
  },
  mortgage_registration_fee_470_5_percent: {
    id: 'mortgage_registration_fee_470_5_percent',
    defaultmessages: 'Mortgage Registration Fee: 470 AED + 5% VAT',
  },
  mortgage_registration_fee_hint: {
    id: 'mortgage_registration_fee_hint',
    defaultmessages: '(0.1% from the mortgage amount)',
  },
  mortgage_registration_fee_paid_by_bank: {
    id: 'mortgage_registration_fee_paid_by_bank',
    defaultmessages: 'The mortgage registration fees to be paid by',
  },
  mortgage_registration_fees: {
    id: 'mortgage_registration_fees',
    defaultmessages: 'Mortgage Registration Fees',
  },
  mortgage_registration_is_completed: {
    id: 'mortgage_registration_is_completed',
    defaultmessages: 'Mortgage registration is completed.',
  },
  mortgage_registration_land_description: {
    id: 'mortgage_registration_land_description',
    defaultmessages:
      'Through this service, you can register a mortgage on a plot so that you can later transfer, substitute, add, extend or modify the terms of the mortgage agreement.',
  },
  mortgage_registration_plot_unit: {
    id: 'mortgage_registration_plot_unit',
    defaultmessages: 'Mortgage Registration (Plot/Unit)',
  },
  mortgage_registration_unit_description: {
    id: 'mortgage_registration_unit_description',
    defaultmessages:
      'Through this service, you can register a mortgage on a unit so that you can later transfer, substitute, add, extend or modify the terms of the mortgage agreement.',
  },
  mortgage_release: {
    id: 'mortgage_release',
    defaultmessages: 'Mortgage Release',
  },
  mortgage_release_application_rejected_successfully: {
    id: 'mortgage_release_application_rejected_successfully',
    defaultmessages: 'Mortgage Release application has been rejected successfully.',
  },
  mortgage_release_application_sent_to_bank_for_approval: {
    id: 'mortgage_release_application_sent_to_bank_for_approval',
    defaultmessages: 'Mortgage Release application has been forwarded to the bank for approval.',
  },
  mortgage_release_application_sent_to_other_owners_for_approval: {
    id: 'mortgage_release_application_sent_to_other_owners_for_approval',
    defaultmessages: 'Mortgage Release application has been forwarded to the other owners for approval.',
  },
  mortgage_release_certificate_successfully_issues: {
    id: 'mortgage_release_certificate_successfully_issues',
    defaultmessages: 'Mortgage Release Certificate has been issued successfully.',
  },
  mortgage_release_description: {
    id: 'mortgage_release_description',
    defaultmessages:
      'Through this service, the property owner or mortgage bank can discharge the mortgage of a mortgaged property.',
  },
  mortgage_release_fee_AED: {
    id: 'mortgage_release_fee_AED',
    defaultmessages: 'Mortgage Release fees: (AED 900 Per property)',
  },
  mortgage_release_fee_AED_VAT: {
    id: 'mortgage_release_fee_AED_VAT',
    defaultmessages: 'Mortgage Discharge Fee: 65 AED + VAT.',
  },
  mortgage_release_fee_developer_will_pay_the_registration_fee: {
    id: 'mortgage_release_fee_developer_will_pay_the_registration_fee',
    defaultmessages: 'Mortgage Discharge Fee',
  },
  mortgage_release_fee_if_released_while_modification: {
    id: 'mortgage_release_fee_if_released_while_modification',
    defaultmessages: 'Mortgage Discharge Fees (if discharged during modification): 65 AED + VAT.',
  },
  mortgage_release_fee_per_property: {
    id: 'mortgage_release_fee_per_property',
    defaultmessages: 'Mortgage Discharge Fee: 1,000 AED per property (if applicable)',
  },
  mortgage_release_fee_title: {
    id: 'mortgage_release_fee_title',
    defaultmessages: 'Mortgage Release fee',
  },
  mortgage_release_fees: {
    id: 'mortgage_release_fees',
    defaultmessages: 'Mortgage Discharge Fees',
  },
  'mortgage_release_letter_mandatory_if_applicable:': {
    id: 'mortgage_release_letter_mandatory_if_applicable:',
    defaultmessages: 'Mortgage Release Letter (Mandatory, if applicable)',
  },
  mortgage_release_sent_to_checker_for_approval: {
    id: 'mortgage_release_sent_to_checker_for_approval',
    defaultmessages: 'Mortgage Release application has been forwarded to the bank checker for approval.',
  },
  mortgage_release_sent_to_municipality_for_approval: {
    id: 'mortgage_release_sent_to_municipality_for_approval',
    defaultmessages: 'Mortgage Discharge application has been forwarded to ADGM Admin for approval',
  },
  mortgage_services_adgm_fees: {
    id: 'mortgage_services_adgm_fees',
    defaultmessages: 'Mortgage Service ADGM Fees',
  },
  mortgage_share_is_full_precentage: {
    id: 'mortgage_share_is_full_precentage',
    defaultmessages: 'The 100% mortgage share is {s}% of the total buyer’s share on this property.',
  },
  mortgage_share_is_specific_precentage: {
    id: 'mortgage_share_is_specific_precentage',
    defaultmessages: 'The {p}% mortgage share is {s}% of the total buyer’s share on this property.',
  },
  mortgage_shares: {
    id: 'mortgage_shares',
    defaultmessages: 'Mortgage shares',
  },
  mortgage_specific_shares: {
    id: 'mortgage_specific_shares',
    defaultmessages: 'Mortgage specific shares',
  },
  mortgage_start_date: {
    id: 'mortgage_start_date',
    defaultmessages: 'Mortgage start date',
  },
  mortgage_status: {
    id: 'mortgage_status',
    defaultmessages: 'Mortgage status',
  },
  mortgage_type: {
    id: 'mortgage_type',
    defaultmessages: 'Mortgage Type',
  },
  mortgage_value: {
    id: 'mortgage_value',
    defaultmessages: 'Mortgage value',
  },
  mortgage_variation_fee_AED_VAT: {
    id: 'mortgage_variation_fee_AED_VAT',
    defaultmessages: 'AED {num} + {per}% VAT',
  },
  mortgage_variation_is_completed: {
    id: 'mortgage_variation_is_completed',
    defaultmessages: 'Mortgage Variation is completed.',
  },
  mortgage_verification_instrument_mandatory: {
    id: 'mortgage_verification_instrument_mandatory',
    defaultmessages: 'Mortgage Verification Instrument (Mandatory)',
  },
  mortgage_volume: {
    id: 'mortgage_volume',
    defaultmessages: 'Mortgage volume',
  },
  mortgaged: {
    id: 'mortgaged',
    defaultmessages: 'Mortgaged',
  },
  mortgaged_title_deed: {
    id: 'mortgaged_title_deed',
    defaultmessages: 'Mortgaged Title Deed',
  },
  multiple: {
    id: 'multiple',
    defaultmessages: 'Multiple',
  },
  multiple_license_allowed: {
    id: 'multiple_license_allowed',
    defaultmessages: 'Multiple licenses allowed',
  },
  multiple_license_allowed_hint: {
    id: 'multiple_license_allowed_hint',
    defaultmessages: 'This allows you to add multiple trade licenses on the same property',
  },
  multiple_units: {
    id: 'multiple_units',
    defaultmessages: 'Multiple units',
  },
  multiusage: {
    id: 'multiusage',
    defaultmessages: 'Multi Usage',
  },
  municipality: {
    id: 'municipality',
    defaultmessages: 'Municipality',
  },
  municipality_fee: {
    id: 'municipality_fee',
    defaultmessages: 'Municipality fee',
  },
  municipality_returned_the_contract_with_feedback: {
    id: 'municipality_returned_the_contract_with_feedback',
    defaultmessages: 'Municipality returned the agreement with feedback',
  },
  musataha: {
    id: 'musataha',
    defaultmessages: 'Musataha',
  },
  musataha_contract: {
    id: 'musataha_contract',
    defaultmessages: '',
  },
  musataha_contract_agreement_has_been_successfully_issued: {
    id: 'musataha_contract_agreement_has_been_successfully_issued',
    defaultmessages: 'Musataha agreement agreement has been issued successfully',
  },
  musataha_contract_being_generated: {
    id: 'musataha_contract_being_generated',
    defaultmessages: 'Payment received successfully, your agreement is generated',
  },
  musataha_contract_details: {
    id: 'musataha_contract_details',
    defaultmessages: 'Musataha Agreement Details',
  },
  musataha_contract_rejection: {
    id: 'musataha_contract_rejection',
    defaultmessages: 'Musataha agreement rejection was successfully sent',
  },
  musataha_contract_rejection_forwarded_to_initiator: {
    id: 'musataha_contract_rejection_forwarded_to_initiator',
    defaultmessages: 'Your rejection of musataha agreement has been successfully forwarded to the initiator',
  },
  musataha_contract_success: {
    id: 'musataha_contract_success',
    defaultmessages: 'Your musataha agreement has been successfully issued',
  },
  musataha_contract_terminated: {
    id: 'musataha_contract_terminated',
    defaultmessages: 'Your musataha agreement application has been terminated',
  },
  musataha_registration_fee_hint: {
    id: 'musataha_registration_fee_hint',
    defaultmessages: '1% for industrial land with a maximum of one million dirhams (AED 1,000,000).',
  },
  musataha_registration_success_title: {
    id: 'musataha_registration_success_title',
    defaultmessages: 'Musataha agreement registration application has been sent successfully',
  },
  musataha_type: {
    id: 'musataha_type',
    defaultmessages: 'Musataha Type',
  },
  musateh: {
    id: 'musateh',
    defaultmessages: 'Current Musateh #{s}',
  },
  musateh_detail: {
    id: 'musateh_detail',
    defaultmessages: 'Musateh details',
  },
  musateh_documents: {
    id: 'musateh_documents',
    defaultmessages: 'New Musateh Documents',
  },
  musateh_name: {
    id: 'musateh_name',
    defaultmessages: 'Musateh name',
  },
  musateh_num_documents: {
    id: 'musateh_num_documents',
    defaultmessages: 'New Musateh #{s} documents',
  },
  musateh_type: {
    id: 'musateh_type',
    defaultmessages: 'Musateh Type',
  },
  mutual_agreement: {
    id: 'mutual_agreement',
    defaultmessages: 'Mutual Agreement',
  },
  mutual_agreement_mandatory_if_applicable: {
    id: 'mutual_agreement_mandatory_if_applicable',
    defaultmessages: 'Mutual Agreement (Mandatory) (if applicable)',
  },
  mutual_greement_or_court_letter_optional: {
    id: 'mutual_greement_or_court_letter_optional',
    defaultmessages: 'Mutual Agreement or Court Letter (Optional)',
  },
  my_cards: {
    id: 'my_cards',
    defaultmessages: 'My cards',
  },
  my_company: {
    id: 'my_company',
    defaultmessages: 'Company Management',
  },
  my_documents: {
    id: 'my_documents',
    defaultmessages: 'My documents',
  },
  my_profile: {
    id: 'my_profile',
    defaultmessages: 'My Profile',
  },
  my_projects: {
    id: 'my_projects',
    defaultmessages: 'My projects',
  },
  my_properties: {
    id: 'my_properties',
    defaultmessages: 'My properties',
  },
  my_wallets_payments: {
    id: 'my_wallets_payments',
    defaultmessages: 'My wallets and payments',
  },
  'n/a_label': {
    id: 'n/a_label',
    defaultmessages: 'N/A',
  },
  name_cannot_be_empty: {
    id: 'name_cannot_be_empty',
    defaultmessages: 'Name required',
  },
  name_is_invalid: {
    id: 'name_is_invalid',
    defaultmessages: 'Name is invalid',
  },
  nationality: {
    id: 'nationality',
    defaultmessages: 'Nationality',
  },
  nationality_source: {
    id: 'nationality_source',
    defaultmessages: 'Nationality/Source',
  },
  need_help_contact_us: {
    id: 'need_help_contact_us',
    defaultmessages: 'Need help? Contact us.',
  },
  neutral: {
    id: 'neutral',
    defaultmessages: 'Neutral',
  },
  new: {
    id: 'new',
    defaultmessages: 'New',
  },
  new_construction_cost: {
    id: 'new_construction_cost',
    defaultmessages: 'New Construction Cost',
  },
  new_contact_details: {
    id: 'new_contact_details',
    defaultmessages: 'New contact details',
  },
  new_mortgage_certificate_mandatory: {
    id: 'new_mortgage_certificate_mandatory',
    defaultmessages: 'New Mortgage Certificate (Mandatory)',
  },
  new_musatah_list: {
    id: 'new_musatah_list',
    defaultmessages: 'New Musateh List',
  },
  new_musatah_num_document_name: {
    id: 'new_musatah_num_document_name',
    defaultmessages: 'New Musateh #{num} documents ({name})',
  },
  new_musataha_contract_details: {
    id: 'new_musataha_contract_details',
    defaultmessages: 'New Musataha Agreement Details',
  },
  new_musateh: {
    id: 'new_musateh',
    defaultmessages: 'New Musateh',
  },
  new_musateh_details: {
    id: 'new_musateh_details',
    defaultmessages: 'New Musateh Details',
  },
  new_musateh_num: {
    id: 'new_musateh_num',
    defaultmessages: 'New Musateh #{num}',
  },
  new_offers: {
    id: 'new_offers',
    defaultmessages: 'New offers',
  },
  new_password: {
    id: 'new_password',
    defaultmessages: 'New password',
  },
  new_project: {
    id: 'new_project',
    defaultmessages: 'New project',
  },
  new_terminated_sent_title: {
    id: 'new_terminated_sent_title',
    defaultmessages: 'PMA agreement will be successfully sent',
  },
  new_terminated_title: {
    id: 'new_terminated_title',
    defaultmessages: 'PMA agreement will be cancelled successfully  ',
  },
  next: {
    id: 'next',
    defaultmessages: 'Next',
  },
  next_of_kin_transfer_of_ownership_offplan_unit_plot: {
    id: 'next_of_kin_transfer_of_ownership_offplan_unit_plot',
    defaultmessages: 'Next of Kin Transfer of Ownership – Off Plan (Unit/ Plot)',
  },
  next_of_kin_transfer_of_ownership_unit_plot: {
    id: 'next_of_kin_transfer_of_ownership_unit_plot',
    defaultmessages: 'Next of Kin Transfer of Ownership (Unit/ Plot)',
  },
  no: {
    id: 'no',
    defaultmessages: 'No',
  },
  no_active_agreements: {
    id: 'no_active_agreements',
    defaultmessages: 'There are no active agreements on this property.',
  },
  no_buyer_added_message: {
    id: 'no_buyer_added_message',
    defaultmessages: 'You haven’t added any buyer yet',
  },
  no_construction_on_land: {
    id: 'no_construction_on_land',
    defaultmessages: 'No construction on land',
  },
  no_contract_available_to_download: {
    id: 'no_contract_available_to_download',
    defaultmessages:
      'Due to an ownership change, you don’t have the right to perform this action.\nPlease contact our customer support for further assistance.',
  },
  no_contract_selected_message_title: {
    id: 'no_contract_selected_message_title',
    defaultmessages: '',
  },
  no_contract_selected_title: {
    id: 'no_contract_selected_title',
    defaultmessages: 'You have not selected any agreement yet',
  },
  no_escrow_account_for_this_project: {
    id: 'no_escrow_account_for_this_project',
    defaultmessages: 'No escrow account for this project',
  },
  no_existing_representative_found_message: {
    id: 'no_existing_representative_found_message',
    defaultmessages: 'Seems there is no existing Representative, You can add new',
  },
  no_keep: {
    id: 'no_keep',
    defaultmessages: 'No, keep',
  },
  no_liability_letter_from_the_bank_mandatory: {
    id: 'no_liability_letter_from_the_bank_mandatory',
    defaultmessages: 'No Liability Letter from the Bank (Mandatory)',
  },
  no_minimum_cap_point_1_percent: {
    id: 'no_minimum_cap_point_1_percent',
    defaultmessages: 'ADGM Fees: 0.1% (no maximum cap)',
  },
  no_objection_certificate: {
    id: 'no_objection_certificate',
    defaultmessages: 'No Objection Certificate',
  },
  no_objection_certificate_and_undertaking_letter: {
    id: 'no_objection_certificate_and_undertaking_letter',
    defaultmessages: 'No Objection Certificate and Undertaking Letter',
  },
  no_objection_letters_if_applicable: {
    id: 'no_objection_letters_if_applicable',
    defaultmessages: 'No-Objection Letter (if applicable)',
  },
  no_occupants_added_for_this_unit: {
    id: 'no_occupants_added_for_this_unit',
    defaultmessages: 'No occupants added for this unit',
  },
  no_outstanding_claims_declaration: {
    id: 'no_outstanding_claims_declaration',
    defaultmessages: 'No Outstanding Claims Declaration',
  },
  no_projects_subtitle: {
    id: 'no_projects_subtitle',
    defaultmessages: "You still don't have any projects registered in your name",
  },
  no_projects_title: {
    id: 'no_projects_title',
    defaultmessages: "You don't have any projects",
  },
  no_projects_yet: {
    id: 'no_projects_yet',
    defaultmessages: 'Do you have projects that are still not appearing here?',
  },
  no_properties_yet: {
    id: 'no_properties_yet',
    defaultmessages: 'You do not have any properties',
  },
  no_properties_yet_desc: {
    id: 'no_properties_yet_desc',
    defaultmessages: 'You still do not have any properties registered in your name',
  },
  no_representative_found_message: {
    id: 'no_representative_found_message',
    defaultmessages: 'Seems there is no existing representative',
  },
  no_results_found: {
    id: 'no_results_found',
    defaultmessages: 'No results have been found',
  },
  no_terms_add: {
    id: 'no_terms_add',
    defaultmessages: 'You haven’t added any terms yet',
  },
  no_transactions_yet: {
    id: 'no_transactions_yet',
    defaultmessages: 'You have not completed any transactions yet',
  },
  no_transactions_yet_desc: {
    id: 'no_transactions_yet_desc',
    defaultmessages: 'Your transactions will appear here once you have made a payment',
  },
  noc_court_letter_document: {
    id: 'noc_court_letter_document',
    defaultmessages: 'NOC Court Letter Document',
  },
  noc_document: {
    id: 'noc_document',
    defaultmessages: 'NOC Document',
  },
  noc_from_developer: {
    id: 'noc_from_developer',
    defaultmessages: 'NOC from developer',
  },
  noc_from_developer_to_transfer_property_to_completed: {
    id: 'noc_from_developer_to_transfer_property_to_completed',
    defaultmessages: 'NOC from Developer to Transfer Property to Completed',
  },
  noc_from_developer_to_transfer_property_to_completed_mandatory: {
    id: 'noc_from_developer_to_transfer_property_to_completed_mandatory',
    defaultmessages: 'NOC from the developer to transfer property to completed (Mandatory)',
  },
  noc_from_master_developer: {
    id: 'noc_from_master_developer',
    defaultmessages: 'NOC from Master Developer',
  },
  noc_from_master_developer_optional: {
    id: 'noc_from_master_developer_optional',
    defaultmessages: 'NOC from Master Developer (Optional, If Applicable)',
  },
  noc_from_mortgage_banks: {
    id: 'noc_from_mortgage_banks',
    defaultmessages: 'NOC from the mortgage banks',
  },
  noc_from_the_bank: {
    id: 'noc_from_the_bank',
    defaultmessages: 'NOC from the bank',
  },
  noc_from_the_master_developer: {
    id: 'noc_from_the_master_developer',
    defaultmessages: 'NOC from the master developer',
  },
  noc_from_the_mortgage_banks_mandatory_mortgaged: {
    id: 'noc_from_the_mortgage_banks_mandatory_mortgaged',
    defaultmessages:
      'NOC from the mortgage bank — First Insurance Degree (Mandatory if the property was already mortgaged)',
  },
  noc_of_mortgage_release: {
    id: 'noc_of_mortgage_release',
    defaultmessages: 'Mortgage Release Letter',
  },
  non_UAE_resident_login: {
    id: 'non_UAE_resident_login',
    defaultmessages: 'Non-UAE Resident Login',
  },
  non_industrial_land_percent: {
    id: 'non_industrial_land_percent',
    defaultmessages: '2% for non-industrial land',
  },
  non_payment: {
    id: 'non_payment',
    defaultmessages: 'Non-payment',
  },
  non_payment_proof_mandatory_if_applicable: {
    id: 'non_payment_proof_mandatory_if_applicable',
    defaultmessages: 'Non-payment Notice Proof (Mandatory) (if applicable)',
  },
  non_payment_transfer_proof: {
    id: 'non_payment_transfer_proof',
    defaultmessages: 'Non-payment Notice Proof',
  },
  non_resident: {
    id: 'non_resident',
    defaultmessages: 'Non-resident',
  },
  non_uae_residents: {
    id: 'non_uae_residents',
    defaultmessages: 'Non-UAE Residents',
  },
  not_available: {
    id: 'not_available',
    defaultmessages: 'Not Available',
  },
  not_available_have_construction_NOC: {
    id: 'not_available_have_construction_NOC',
    defaultmessages: 'Not Available Have Construction NOC',
  },
  not_eligible_for_service_error_message: {
    id: 'not_eligible_for_service_error_message',
    defaultmessages: 'You are not eligible for this service',
  },
  not_eligible_for_service_error_message_desc: {
    id: 'not_eligible_for_service_error_message_desc',
    defaultmessages:
      'This service is only for owners who are 21 and above. Please inform your assigned representative to apply on your behalf with their account.',
  },
  not_verified: {
    id: 'not_verified',
    defaultmessages: 'not verified',
  },
  notes: {
    id: 'notes',
    defaultmessages: 'Notes',
  },
  nothing_found: {
    id: 'nothing_found',
    defaultmessages: "Sorry! We couldn't find anything.",
  },
  nothing_found_helperText: {
    id: 'nothing_found_helperText',
    defaultmessages: 'Please make sure to input correct information, Or get in touch with {s} to add buyer',
  },
  notice_notification_date: {
    id: 'notice_notification_date',
    defaultmessages: 'Notice Notification Date',
  },
  notice_reason: {
    id: 'notice_reason',
    defaultmessages: 'Notice Reason',
  },
  notification: {
    id: 'notification',
    defaultmessages: 'Notifications',
  },
  notification_details: {
    id: 'notification_details',
    defaultmessages: 'Legal Notice Details',
  },
  notification_notice_issued_successfully_to_Buyer: {
    id: 'notification_notice_issued_successfully_to_Buyer',
    defaultmessages: 'The notification notice issued successfully to Buyer',
  },
  notification_once_registration_is_completed: {
    id: 'notification_once_registration_is_completed',
    defaultmessages: 'We will send you a notification once the registration is completed',
  },
  notified_once_approved_by_parties_dmt: {
    id: 'notified_once_approved_by_parties_dmt',
    defaultmessages: 'You will be notified once the application is reviewed and approved by ADGM and other parties',
  },
  num_BR: {
    id: 'num_BR',
    defaultmessages: '{num} BR',
  },
  num_day: {
    id: 'num_day',
    defaultmessages: '{day} day',
  },
  num_month: {
    id: 'num_month',
    defaultmessages: '{month} month',
  },
  num_month_day: {
    id: 'num_month_day',
    defaultmessages: '{month} month {day} day',
  },
  num_months: {
    id: 'num_months',
    defaultmessages: '{num} months',
  },
  num_of_installments: {
    id: 'num_of_installments',
    defaultmessages: 'No. of Installments.',
  },
  num_year: {
    id: 'num_year',
    defaultmessages: '{year} year',
  },
  num_year_day: {
    id: 'num_year_day',
    defaultmessages: '{year} year {day} day',
  },
  num_year_month: {
    id: 'num_year_month',
    defaultmessages: '{year} year {month} month',
  },
  num_year_month_day: {
    id: 'num_year_month_day',
    defaultmessages: '{year} year {month} month {day} day',
  },
  number_of_floors: {
    id: 'number_of_floors',
    defaultmessages: 'Number of Floors',
  },
  number_of_installment: {
    id: 'number_of_installment',
    defaultmessages: 'Number of Installments',
  },
  number_of_installments: {
    id: 'number_of_installments',
    defaultmessages: 'Number of Installments',
  },
  number_of_installments_hint: {
    id: 'number_of_installments_hint',
    defaultmessages: 'No. of Installments.',
  },
  number_of_plots_doesnt_match: {
    id: 'number_of_plots_doesnt_match',
    defaultmessages: 'The number of plots in the inventory sheet doesn’t match with the project plots',
  },
  number_of_rooms: {
    id: 'number_of_rooms',
    defaultmessages: 'Number of Rooms',
  },
  number_of_units: {
    id: 'number_of_units',
    defaultmessages: '',
  },
  occupancy_units: {
    id: 'occupancy_units',
    defaultmessages: 'Occupancy Units',
  },
  occupant_details: {
    id: 'occupant_details',
    defaultmessages: 'Occupant Details',
  },
  occupant_information: {
    id: 'occupant_information',
    defaultmessages: 'Occupant Information',
  },
  occupant_numb: {
    id: 'occupant_numb',
    defaultmessages: 'Occupant #{s}',
  },
  occupant_relationship: {
    id: 'occupant_relationship',
    defaultmessages: 'Occupant Relationship',
  },
  occupant_salary: {
    id: 'occupant_salary',
    defaultmessages: 'Occupant’s Salary',
  },
  occupants_details: {
    id: 'occupants_details',
    defaultmessages: 'Occupant’s Details',
  },
  'off-plan-termination': {
    id: 'off-plan-termination',
    defaultmessages: 'Off-Plan Buy & Sell Termination',
  },
  offPlan: {
    id: 'offPlan',
    defaultmessages: 'Off Plan',
  },
  off_plan: {
    id: 'off_plan',
    defaultmessages: 'Off Plan',
  },
  off_plan_agreement_subject_termination: {
    id: 'off_plan_agreement_subject_termination',
    defaultmessages:
      'The off-plan agreement is subject to cancellation in accordance with the applicable laws and regulations.',
  },
  off_plan_contract_details: {
    id: 'off_plan_contract_details',
    defaultmessages: 'Off Plan Agreement Details',
  },
  off_plan_first_sell: {
    id: 'off_plan_first_sell',
    defaultmessages: 'Off Plan First Sell',
  },
  off_plan_first_sell_unit: {
    id: 'off_plan_first_sell_unit',
    defaultmessages: 'Off Plan First Sell — Unit',
  },
  off_plan_issued: {
    id: 'off_plan_issued',
    defaultmessages: 'Off Plan certificate is issued successfully',
  },
  off_plan_out_of_percentage_share: {
    id: 'off_plan_out_of_percentage_share',
    defaultmessages: 'Out of {num1} of property share',
  },
  off_plan_owners: {
    id: 'off_plan_owners',
    defaultmessages: 'Off-Plan Owners',
  },
  off_plan_plot_agreement: {
    id: 'off_plan_plot_agreement',
    defaultmessages: 'Off-plan Plot Agreement',
  },
  off_plan_plot_buy_sell_registration: {
    id: 'off_plan_plot_buy_sell_registration',
    defaultmessages: 'Off Plan Plot Buy & Sell Registration',
  },
  off_plan_plot_unit_buy_and_sell_registration_is_completed: {
    id: 'off_plan_plot_unit_buy_and_sell_registration_is_completed',
    defaultmessages: 'Off plan plot/unit buy & sell registration is completed',
  },
  off_plan_projects: {
    id: 'off_plan_projects',
    defaultmessages: 'Off-Plan Projects',
  },
  off_plan_registration_fees: {
    id: 'off_plan_registration_fees',
    defaultmessages: 'Off Plan Registration Fees',
  },
  off_plan_sale_purchase_agreement_mandatory: {
    id: 'off_plan_sale_purchase_agreement_mandatory',
    defaultmessages: 'Off-plan Sale & Purchase Agreement (Mandatory)',
  },
  off_plan_sale_purchase_agreement_optional: {
    id: 'off_plan_sale_purchase_agreement_optional',
    defaultmessages: 'Off-plan Sale & Purchase Agreement (Optional)',
  },
  off_plan_selling_date_of_sale_note: {
    id: 'off_plan_selling_date_of_sale_note',
    defaultmessages:
      'AED 10,000 will be charged to the developer if the registration date exceeds 30 days after actual date of sale',
  },
  off_plan_termination_description: {
    id: 'off_plan_termination_description',
    defaultmessages:
      'This service facilitates the cancellation of off-plan agreements between the developer and the buyer. Cancellation may result from a mutual agreement or by a court order. Upon cancellation, the property is returned to the developer’s custody, and the financial outcome may include a refunded amount to the buyer and/or a forfeited amount retained by the developer.',
  },
  off_plan_unit_agreement: {
    id: 'off_plan_unit_agreement',
    defaultmessages: 'Off-plan Unit Agreement',
  },
  officeUnits: {
    id: 'officeUnits',
    defaultmessages: 'Office Area',
  },
  offplan: {
    id: 'offplan',
    defaultmessages: 'Off Plan',
  },
  'offplan-termination': {
    id: 'offplan-termination',
    defaultmessages: 'Off-plan Agreement Termination',
  },
  offplan_First_sell_Unit: {
    id: 'offplan_First_sell_Unit',
    defaultmessages: 'Off-Plan First Sell',
  },
  offplan_agreement: {
    id: 'offplan_agreement',
    defaultmessages: 'Off-Plan Agreement',
  },
  offplan_agreement_mandatory: {
    id: 'offplan_agreement_mandatory',
    defaultmessages: 'Off-plan Agreement (Mandatory)',
  },
  offplan_buy_and_sell_registration_plot: {
    id: 'offplan_buy_and_sell_registration_plot',
    defaultmessages: 'Off Plan Buy and Sell Registration — Plot',
  },
  offplan_buy_and_sell_registration_unit: {
    id: 'offplan_buy_and_sell_registration_unit',
    defaultmessages: 'Off Plan Buy and Sell Registration — Unit',
  },
  offplan_buy_sell_calculate_fee_tool_tip: {
    id: 'offplan_buy_sell_calculate_fee_tool_tip',
    defaultmessages: 'It is mandatory to calculate fees in order to proceed.',
  },
  offplan_buy_sell_payment_canceled_title: {
    id: 'offplan_buy_sell_payment_canceled_title',
    defaultmessages: 'Off plan first sell application has been successfully canceled',
  },
  offplan_buy_sell_payment_success_title: {
    id: 'offplan_buy_sell_payment_success_title',
    defaultmessages: 'Your off plan sell certificate has been successfully issued',
  },
  offplan_buy_sell_payment_success_unit_musataha_title: {
    id: 'offplan_buy_sell_payment_success_unit_musataha_title',
    defaultmessages: 'Your off plan preregistration certificate has been successfully issued',
  },
  offplan_buy_sell_registration: {
    id: 'offplan_buy_sell_registration',
    defaultmessages: 'Off-Plan Plot/Unit Buy & Sell Registration',
  },
  'offplan_first_sell application_rejected': {
    id: 'offplan_first_sell application_rejected',
    defaultmessages: 'Off plan first sell application has been rejected',
  },
  offplan_first_sell_application_returned_successfully: {
    id: 'offplan_first_sell_application_returned_successfully',
    defaultmessages: 'Off plan sale application has been successfully returned',
  },
  offplan_marketing_request: {
    id: 'offplan_marketing_request',
    defaultmessages: 'Permit for Marketing of Off-Plan Projects',
  },
  offplan_marketing_request_description: {
    id: 'offplan_marketing_request_description',
    defaultmessages:
      'This service enables developers to obtain a permit to conduct marketing activities for Off-Plan Projects, including direct or live marketing efforts such as hosting events, participating in fairs, and engaging brand representatives.',
  },
  offplan_plot_buy_sell_registration: {
    id: 'offplan_plot_buy_sell_registration',
    defaultmessages: 'Off Plan Plot Buy & Sell Registration',
  },
  offplan_project_registration: {
    id: 'offplan_project_registration',
    defaultmessages: 'Register Real Estate Development Projects',
  },
  offplan_project_registration_reject_application_success: {
    id: 'offplan_project_registration_reject_application_success',
    defaultmessages: 'You have rejected the off plan project registration application',
  },
  offplan_project_registration_return_application_success: {
    id: 'offplan_project_registration_return_application_success',
    defaultmessages: 'You have successfully returned the off plan project registration application',
  },
  offplan_project_registration_submit_application_success: {
    id: 'offplan_project_registration_submit_application_success',
    defaultmessages: 'You have successfully submitted the off plan project registration application',
  },
  offplan_registration_fee: {
    id: 'offplan_registration_fee',
    defaultmessages: 'Off Plan Registration Fees',
  },
  offplan_registration_fee_amount: {
    id: 'offplan_registration_fee_amount',
    defaultmessages: 'Off Plan Registration Fee ({s}%)',
  },
  offplan_registration_fee_hint: {
    id: 'offplan_registration_fee_hint',
    defaultmessages: 'Registration fee calculated based on the agreement remaining amount',
  },
  offplan_registration_is_going_to_be_cancelled_because_developer_payment_not_received: {
    id: 'offplan_registration_is_going_to_be_cancelled_because_developer_payment_not_received',
    defaultmessages:
      "Your off-plan agreement is going to be cancelled because developer haven't received payment. Please respond to your application within 10 days to avoid this. If we don't hear from you, we will automatically proceed with the cancellation.",
  },
  offplan_sale_registration_unit_plot: {
    id: 'offplan_sale_registration_unit_plot',
    defaultmessages: 'Off Plan Sale Registration (Unit/ Plot)',
  },
  offplan_saleprice_placeholder: {
    id: 'offplan_saleprice_placeholder',
    defaultmessages: 'e.g. AED 2,000,000',
  },
  offplan_sell: {
    id: 'offplan_sell',
    defaultmessages: 'Off Plan Sell',
  },
  offplan_termination_description: {
    id: 'offplan_termination_description',
    defaultmessages: 'This service is for terminating an off-plan sales and purchase agreement',
  },
  offplan_transaction_fee_paid_by: {
    id: 'offplan_transaction_fee_paid_by',
    defaultmessages: 'Transaction fee paid by',
  },
  offplan_unit_buy_sell_registration: {
    id: 'offplan_unit_buy_sell_registration',
    defaultmessages: 'Off Plan Unit Buy & Sell Registration',
  },
  okay: {
    id: 'okay',
    defaultmessages: 'Okay',
  },
  on_approval_complete_the_payment: {
    id: 'on_approval_complete_the_payment',
    defaultmessages: 'Upon approval complete the payment',
  },
  on_approval_the_application_will_sent_for_the_payment: {
    id: 'on_approval_the_application_will_sent_for_the_payment',
    defaultmessages: 'Upon approval, the application will be sent for payment.',
  },
  on_approval_the_application_will_sent_to_the_bank_for_the_payment: {
    id: 'on_approval_the_application_will_sent_to_the_bank_for_the_payment',
    defaultmessages: 'Upon approval, the application will be sent for payment.',
  },
  on_behalf_of: {
    id: 'on_behalf_of',
    defaultmessages: 'On behalf of',
  },
  on_site_fees: {
    id: 'on_site_fees',
    defaultmessages: 'On-Site Fees',
  },
  one_installment_paid_by_lessor: {
    id: 'one_installment_paid_by_lessor',
    defaultmessages: 'One installment during the application — Paid by lessor',
  },
  one_month: {
    id: 'one_month',
    defaultmessages: '1 month',
  },
  only_arabic_characters_are_allowed: {
    id: 'only_arabic_characters_are_allowed',
    defaultmessages: 'only Arabic characters are allowed',
  },
  only_english_characters_are_allowed: {
    id: 'only_english_characters_are_allowed',
    defaultmessages: 'Only English characters are allowed',
  },
  only_pdf_file_is_supported: {
    id: 'only_pdf_file_is_supported',
    defaultmessages: 'Only PDF file is supported',
  },
  only_pdf_jpg_or_png_files_are_supported: {
    id: 'only_pdf_jpg_or_png_files_are_supported',
    defaultmessages: 'Only PDF, JPG or PNG files are supported',
  },
  only_xls_or_xlsx_files_are_supported: {
    id: 'only_xls_or_xlsx_files_are_supported',
    defaultmessages: 'Only XLS or XLSX files are supported.',
  },
  only_xls_xlsx_files_are_supported: {
    id: 'only_xls_xlsx_files_are_supported',
    defaultmessages: 'Only XLS/XLSX files are supported',
  },
  only_zip_RAR_or_dwf_files_are_supported_you_can_upload_multiple_documents: {
    id: 'only_zip_RAR_or_dwf_files_are_supported_you_can_upload_multiple_documents',
    defaultmessages: 'Only ZIP, RAR or dwf files are supported. You can upload multiple documents.',
  },
  onwani_address: {
    id: 'onwani_address',
    defaultmessages: 'Onwani Address',
  },
  oops: {
    id: 'oops',
    defaultmessages: 'Oops!',
  },
  oops_something_went_wrong: {
    id: 'oops_something_went_wrong',
    defaultmessages: 'Something Went Wrong',
  },
  open_date: {
    id: 'open_date',
    defaultmessages: 'Open Date',
  },
  open_employee_account: {
    id: 'open_employee_account',
    defaultmessages: 'Open employee account',
  },
  option_not_available_active_future_contract: {
    id: 'option_not_available_active_future_contract',
    defaultmessages: 'This option is not available; there is an active future interest agreement.',
  },
  option_not_available_active_lease_hold: {
    id: 'option_not_available_active_lease_hold',
    defaultmessages: 'This option is not available; there is an active leasehold agreement.',
  },
  optional: {
    id: 'optional',
    defaultmessages: 'Optional',
  },
  or: {
    id: 'or',
    defaultmessages: 'Or',
  },
  or_: {
    id: 'or_',
    defaultmessages: 'or',
  },
  other_bank_maker: {
    id: 'other_bank_maker',
    defaultmessages: 'Other "Bank Maker"',
  },
  other_documents: {
    id: 'other_documents',
    defaultmessages: 'Other Documents',
  },
  other_documents_optional: {
    id: 'other_documents_optional',
    defaultmessages: 'Other Documents (Optional)',
  },
  other_fees: {
    id: 'other_fees',
    defaultmessages: 'Other Fees',
  },
  other_profiles: {
    id: 'other_profiles',
    defaultmessages: 'Other Profiles',
  },
  other_rents_after: {
    id: 'other_rents_after',
    defaultmessages: 'Other rents after {s}',
  },
  other_spaces: {
    id: 'other_spaces',
    defaultmessages: 'Other Spaces',
  },
  others: {
    id: 'others',
    defaultmessages: 'Others',
  },
  others_mandatory: {
    id: 'others_mandatory',
    defaultmessages: 'Others (Mandatory)',
  },
  otp_info_title: {
    id: 'otp_info_title',
    defaultmessages: 'Do not have access to this number?',
  },
  otp_non_resident_message: {
    id: 'otp_non_resident_message',
    defaultmessages: 'A one-time verification code has been sent to your associated email address',
  },
  otp_screen_message: {
    id: 'otp_screen_message',
    defaultmessages: 'We have sent you a verification code on your associated mobile number',
  },
  out_of: {
    id: 'out_of',
    defaultmessages: 'out of {s}',
  },
  out_of_musataha_share: {
    id: 'out_of_musataha_share',
    defaultmessages: '{s} out of Musataha share',
  },
  out_of_percentage_musataha_share: {
    id: 'out_of_percentage_musataha_share',
    defaultmessages: '{s}% out of {s2}% Musataha share',
  },
  out_of_percentage_share: {
    id: 'out_of_percentage_share',
    defaultmessages: '{num1} out of {num2} property share',
  },
  out_of_selling_share: {
    id: 'out_of_selling_share',
    defaultmessages: 'Out of {num} of selling share',
  },
  out_of_total_sold_percentage: {
    id: 'out_of_total_sold_percentage',
    defaultmessages: 'Out of the total sold percentage {s}',
  },
  outside_uae: {
    id: 'outside_uae',
    defaultmessages: 'Outside UAE',
  },
  overall_error: {
    id: 'overall_error',
    defaultmessages: 'Overall Error',
  },
  owned_properties: {
    id: 'owned_properties',
    defaultmessages: 'Owned Properties',
  },
  owner: {
    id: 'owner',
    defaultmessages: 'Owner',
  },
  owner_count: {
    id: 'owner_count',
    defaultmessages: 'Owner {s}',
  },
  owner_documents: {
    id: 'owner_documents',
    defaultmessages: 'Owner Documents',
  },
  owner_has_returned_the_contract: {
    id: 'owner_has_returned_the_contract',
    defaultmessages: 'Owner has returned the application',
  },
  owner_name: {
    id: 'owner_name',
    defaultmessages: 'Owner Name',
  },
  owner_name_you: {
    id: 'owner_name_you',
    defaultmessages: 'Owner Name (you)',
  },
  owner_num: {
    id: 'owner_num',
    defaultmessages: 'Owner #{s}',
  },
  owner_return_with_feedback: {
    id: 'owner_return_with_feedback',
    defaultmessages: 'Owner returned the application with feedback',
  },
  owner_submit_the_application: {
    id: 'owner_submit_the_application',
    defaultmessages: 'Owner submits the application',
  },
  owner_termination_text: {
    id: 'owner_termination_text',
    defaultmessages: 'We will send your response to the seller',
  },
  owner_termination_title: {
    id: 'owner_termination_title',
    defaultmessages: 'Your sale and purchase application has been terminated!',
  },
  owner_type: {
    id: 'owner_type',
    defaultmessages: 'Right Hold Type',
  },
  owners: {
    id: 'owners',
    defaultmessages: 'Owners',
  },
  owners_approval: {
    id: 'owners_approval',
    defaultmessages: '',
  },
  ownership_certificate: {
    id: 'ownership_certificate',
    defaultmessages: '',
  },
  ownership_certificate_optional: {
    id: 'ownership_certificate_optional',
    defaultmessages: 'Ownership Certificate (Optional)',
  },
  ownership_status: {
    id: 'ownership_status',
    defaultmessages: 'Ownership Status',
  },
  ownership_type: {
    id: 'ownership_type',
    defaultmessages: 'Ownership Type',
  },
  paid: {
    id: 'paid',
    defaultmessages: 'Paid',
  },
  paid_in_advance: {
    id: 'paid_in_advance',
    defaultmessages: 'Paid in Advance',
  },
  paid_in_advance_years: {
    id: 'paid_in_advance_years',
    defaultmessages: 'Paid in advance/years',
  },
  paid_until: {
    id: 'paid_until',
    defaultmessages: 'Paid Until',
  },
  parking: {
    id: 'parking',
    defaultmessages: 'Parking',
  },
  partial_text: {
    id: 'partial_text',
    defaultmessages: 'Partial ({num}%)',
  },
  parties_details: {
    id: 'parties_details',
    defaultmessages: "Parties' Details",
  },
  partnership_agreement: {
    id: 'partnership_agreement',
    defaultmessages: 'Partnership Agreement',
  },
  partnership_contract_po_a_number_error_msg: {
    id: 'partnership_contract_po_a_number_error_msg',
    defaultmessages: 'Partnership agreement/POA number is 10 digits',
  },
  party_details: {
    id: 'party_details',
    defaultmessages: 'Party Details',
  },
  party_type: {
    id: 'party_type',
    defaultmessages: 'Party Type',
  },
  passport: {
    id: 'passport',
    defaultmessages: 'Passport',
  },
  passport_country: {
    id: 'passport_country',
    defaultmessages: 'Passport Country',
  },
  passport_details: {
    id: 'passport_details',
    defaultmessages: 'Passport Details',
  },
  passport_document: {
    id: 'passport_document',
    defaultmessages: 'Passport Document',
  },
  passport_expiry_date: {
    id: 'passport_expiry_date',
    defaultmessages: 'Passport Expiry Date',
  },
  passport_hint: {
    id: 'passport_hint',
    defaultmessages: 'Ex: 12346576',
  },
  passport_information: {
    id: 'passport_information',
    defaultmessages: 'Passport Information',
  },
  passport_issue_date: {
    id: 'passport_issue_date',
    defaultmessages: 'Passport Issue Date',
  },
  passport_number: {
    id: 'passport_number',
    defaultmessages: 'Passport Number',
  },
  passport_verification: {
    id: 'passport_verification',
    defaultmessages: 'Passport Verification',
  },
  password: {
    id: 'password',
    defaultmessages: 'Password',
  },
  password_change_succ: {
    id: 'password_change_succ',
    defaultmessages: 'Your password has been changed successfully. Use your new password to log in.',
  },
  password_reset: {
    id: 'password_reset',
    defaultmessages: 'Password reset link has been sent successfully',
  },
  password_reset_msg: {
    id: 'password_reset_msg',
    defaultmessages: 'Please check your email inbox for password reset link and follow instruction',
  },
  password_set_successfully: {
    id: 'password_set_successfully',
    defaultmessages: 'Your password has been set successfully. Use your email and password to log in.',
  },
  password_update: {
    id: 'password_update',
    defaultmessages: 'Your password has been successfully updated.',
  },
  pay: {
    id: 'pay',
    defaultmessages: 'Pay',
  },
  pay_in_advance: {
    id: 'pay_in_advance',
    defaultmessages: 'Pay in advance/years',
  },
  pay_liability: {
    id: 'pay_liability',
    defaultmessages: 'Pay Liability',
  },
  pay_now: {
    id: 'pay_now',
    defaultmessages: 'Pay Now',
  },
  pay_rent_in_advance: {
    id: 'pay_rent_in_advance',
    defaultmessages: 'Pay rent in advance',
  },
  pay_the_applicable_fees: {
    id: 'pay_the_applicable_fees',
    defaultmessages: 'Pay the applicable fees',
  },
  pay_with: {
    id: 'pay_with',
    defaultmessages: 'Pay with',
  },
  payable_liability_amount: {
    id: 'payable_liability_amount',
    defaultmessages: 'Payable Liability Amount',
  },
  payment: {
    id: 'payment',
    defaultmessages: 'Payment',
  },
  paymentStatus: {
    id: 'paymentStatus',
    defaultmessages: 'Payment Status',
  },
  payment_card_last_digits: {
    id: 'payment_card_last_digits',
    defaultmessages: 'Ends with ****{s}',
  },
  payment_card_last_digits_expiry: {
    id: 'payment_card_last_digits_expiry',
    defaultmessages: 'Ends with **** {s1} | Expiry date: {s2}',
  },
  payment_completed: {
    id: 'payment_completed',
    defaultmessages: 'Payment Completed',
  },
  payment_date: {
    id: 'payment_date',
    defaultmessages: 'Payment Date',
  },
  payment_detail: {
    id: 'payment_detail',
    defaultmessages: 'Payment Detail',
  },
  payment_details: {
    id: 'payment_details',
    defaultmessages: 'Payment Details',
  },
  payment_failed: {
    id: 'payment_failed',
    defaultmessages: 'Payment Failed',
  },
  payment_has_been_done_successfully: {
    id: 'payment_has_been_done_successfully',
    defaultmessages: 'Payment has been successfully completed.',
  },
  payment_method: {
    id: 'payment_method',
    defaultmessages: 'Payment Method',
  },
  payment_plan: {
    id: 'payment_plan',
    defaultmessages: 'Payment Plan',
  },
  payment_plans: {
    id: 'payment_plans',
    defaultmessages: 'Payment Plans',
  },
  payment_processed_bank_generate_title_deed: {
    id: 'payment_processed_bank_generate_title_deed',
    defaultmessages:
      'Your payment has been successfully processed, we notified the bank to complete the application in order to generate the title deed',
  },
  payment_processed_owner_generate_title_deed: {
    id: 'payment_processed_owner_generate_title_deed',
    defaultmessages:
      'Your payment has been successfully processed, we notified the owner to complete the application in order to generate the title deed',
  },
  payment_required_to_download_permit: {
    id: 'payment_required_to_download_permit',
    defaultmessages: 'Payment is required to download the permit.',
  },
  payment_required_to_download_permit_certificate: {
    id: 'payment_required_to_download_permit_certificate',
    defaultmessages: 'Payment is required to download the permit.',
  },
  payment_successfully_processed: {
    id: 'payment_successfully_processed',
    defaultmessages: 'Your payment has been successfully processed',
  },
  payment_summary: {
    id: 'payment_summary',
    defaultmessages: 'Payment Summary',
  },
  payment_type: {
    id: 'payment_type',
    defaultmessages: 'Payment Type',
  },
  payment_with: {
    id: 'payment_with',
    defaultmessages: 'Payment Method',
  },
  pending_action: {
    id: 'pending_action',
    defaultmessages: 'Pending Action',
  },
  pending_actions: {
    id: 'pending_actions',
    defaultmessages: 'Pending Actions ({count})',
  },
  pending_for_payment: {
    id: 'pending_for_payment',
    defaultmessages: 'Pending for Payment',
  },
  pending_items: {
    id: 'pending_items',
    defaultmessages: 'Pending Items',
  },
  per_of_mortgage_value: {
    id: 'per_of_mortgage_value',
    defaultmessages: '0.1% of the mortgage amount',
  },
  per_of_the_agreement_value: {
    id: 'per_of_the_agreement_value',
    defaultmessages: '2% of agreement value',
  },
  per_of_the_property_value: {
    id: 'per_of_the_property_value',
    defaultmessages: '2% of the property value',
  },
  percent_of_property_value_or_evaluation_whichever_is_higher: {
    id: 'percent_of_property_value_or_evaluation_whichever_is_higher',
    defaultmessages: '2% of the property value or the property evaluation, whichever is higher.',
  },
  percentage: {
    id: 'percentage',
    defaultmessages: 'Percentage',
  },
  percentage_fixed: {
    id: 'percentage_fixed',
    defaultmessages: 'Installment Method',
  },
  percentage_modal_title: {
    id: 'percentage_modal_title',
    defaultmessages: 'Completion percentage is 20% or less',
  },
  percentage_of_total_agreement_amount: {
    id: 'percentage_of_total_agreement_amount',
    defaultmessages: '( {s}% of total agreement amount)',
  },
  percentage_of_total_property: {
    id: 'percentage_of_total_property',
    defaultmessages: '{s}% of total property',
  },
  percentage_or_fixed: {
    id: 'percentage_or_fixed',
    defaultmessages: 'Percentage/Fixed',
  },
  percentage_share: {
    id: 'percentage_share',
    defaultmessages: '{s} of property share',
  },
  period_approval_date: {
    id: 'period_approval_date',
    defaultmessages: 'Period Approval Date',
  },
  permissions: {
    id: 'permissions',
    defaultmessages: 'Permissions',
  },
  permit_details: {
    id: 'permit_details',
    defaultmessages: 'Permit Details',
  },
  permit_exclusive_to_selected_broker: {
    id: 'permit_exclusive_to_selected_broker',
    defaultmessages: 'Will the permit be exclusive to the selected broker?',
  },
  permit_propert_duration: {
    id: 'permit_propert_duration',
    defaultmessages: '{amount} ({duration} months plan) X {total}',
  },
  person: {
    id: 'person',
    defaultmessages: 'Person',
  },
  person_details: {
    id: 'person_details',
    defaultmessages: "Person's Details",
  },
  personal_details: {
    id: 'personal_details',
    defaultmessages: 'Personal Details',
  },
  personal_information: {
    id: 'personal_information',
    defaultmessages: 'Personal Information',
  },
  pets_allowed: {
    id: 'pets_allowed',
    defaultmessages: 'Pets Allowed',
  },
  phone: {
    id: 'phone',
    defaultmessages: 'Phone',
  },
  phone_cannot_be_empty: {
    id: 'phone_cannot_be_empty',
    defaultmessages: 'Phone number required',
  },
  phone_length_should_be_9_or_less_then_16: {
    id: 'phone_length_should_be_9_or_less_then_16',
    defaultmessages: 'Phone number should be more than 9 characters or fewer than 16 characters',
  },
  phone_number: {
    id: 'phone_number',
    defaultmessages: 'Phone Number',
  },
  phone_number_val: {
    id: 'phone_number_val',
    defaultmessages: '+{s}',
  },
  photo_validation_msg: {
    id: 'photo_validation_msg',
    defaultmessages: 'Maximum file size: 20 MB. Allowed file types: PNG, JPEG.',
  },
  photos: {
    id: 'photos',
    defaultmessages: 'Photos',
  },
  photos_added_successfully: {
    id: 'photos_added_successfully',
    defaultmessages: '{s} photos added successfully',
  },
  physical: {
    id: 'physical',
    defaultmessages: 'Physical',
  },
  place_of_birth: {
    id: 'place_of_birth',
    defaultmessages: 'Place of Birth',
  },
  place_your_comments: {
    id: 'place_your_comments',
    defaultmessages: 'Comments',
  },
  plaintiff: {
    id: 'plaintiff',
    defaultmessages: 'Plaintiff',
  },
  plaintiff_documents_title: {
    id: 'plaintiff_documents_title',
    defaultmessages: 'Plaintiff Documents',
  },
  plaintiff_law_info_title: {
    id: 'plaintiff_law_info_title',
    defaultmessages: 'Plaintiff law firm information',
  },
  plaintiff_submit_approval_title: {
    id: 'plaintiff_submit_approval_title',
    defaultmessages: 'You have successfully approved the dispute',
  },
  plaintiffs: {
    id: 'plaintiffs',
    defaultmessages: 'Plaintiffs',
  },
  planning_approval_DMP_approval: {
    id: 'planning_approval_DMP_approval',
    defaultmessages: 'Planning Approval / DMP Approval',
  },
  planning_approval_dmp_approval_mandatory: {
    id: 'planning_approval_dmp_approval_mandatory',
    defaultmessages: 'Planning Approval / DMP Approval (Mandatory)',
  },
  please_add_all_the_application_documents: {
    id: 'please_add_all_the_application_documents',
    defaultmessages: 'Please add all application documents',
  },
  please_add_all_the_required_documents: {
    id: 'please_add_all_the_required_documents',
    defaultmessages: 'Please add all the required documents',
  },
  please_add_all_the_seller_documents: {
    id: 'please_add_all_the_seller_documents',
    defaultmessages: "Please add all the seller's documents",
  },
  please_add_at_least_one_buyer: {
    id: 'please_add_at_least_one_buyer',
    defaultmessages: 'Please add at least one buyer',
  },
  please_add_at_least_one_party_for_each_side: {
    id: 'please_add_at_least_one_party_for_each_side',
    defaultmessages: 'Please add at least one party for each side',
  },
  please_add_diplomat_document: {
    id: 'please_add_diplomat_document',
    defaultmessages: 'Please add the diplomatic document',
  },
  please_contact_help_center_to_verify_your_identity: {
    id: 'please_contact_help_center_to_verify_your_identity',
    defaultmessages: 'Please contact help center to verify your identity & update your information',
  },
  please_dont_exit_this_page: {
    id: 'please_dont_exit_this_page',
    defaultmessages: 'Please do not exit this page',
  },
  please_enter_ADGM_court_poa_details: {
    id: 'please_enter_ADGM_court_poa_details',
    defaultmessages: 'Please enter ADGM court POA details',
  },
  please_enter_your_reason_for_return_off_plan_project_registration: {
    id: 'please_enter_your_reason_for_return_off_plan_project_registration',
    defaultmessages: 'Please enter your reason for return off plan project registration',
  },
  please_read_the_terms_and_conditions: {
    id: 'please_read_the_terms_and_conditions',
    defaultmessages: 'Please read the terms and conditions.',
  },
  please_select_a_surveyor_to_continue: {
    id: 'please_select_a_surveyor_to_continue',
    defaultmessages: 'Please select a surveyor to continue',
  },
  please_select_cancelation_date: {
    id: 'please_select_cancelation_date',
    defaultmessages: 'Please select cancellation date',
  },
  please_select_contract_termination_date: {
    id: 'please_select_contract_termination_date',
    defaultmessages: 'Please select agreement termination date',
  },
  please_select_primary_buyer: {
    id: 'please_select_primary_buyer',
    defaultmessages: 'Please select a primary buyer',
  },
  please_try_removing_some_of_the_filters_and_try_again: {
    id: 'please_try_removing_some_of_the_filters_and_try_again',
    defaultmessages: 'Please adjust or remove some filters and try again.',
  },
  please_upload_required_document: {
    id: 'please_upload_required_document',
    defaultmessages: 'Please upload required document',
  },
  please_upload_the_following_documents_for_tenant_contract_termination: {
    id: 'please_upload_the_following_documents_for_tenant_contract_termination',
    defaultmessages: 'Please upload the following documents for lease agreement termination',
  },
  please_use_arabic_characters_only: {
    id: 'please_use_arabic_characters_only',
    defaultmessages: 'Please use Arabic characters only',
  },
  please_use_english_characters_only: {
    id: 'please_use_english_characters_only',
    defaultmessages: 'Please use English characters only',
  },
  plot_address: {
    id: 'plot_address',
    defaultmessages: 'Plot Address',
  },
  plot_breakdown: {
    id: 'plot_breakdown',
    defaultmessages: 'Plot Breakdown',
  },
  plot_details: {
    id: 'plot_details',
    defaultmessages: 'Plot Details',
  },
  plot_issues: {
    id: 'plot_issues',
    defaultmessages: 'Plot Issues ({s})',
  },
  plot_number: {
    id: 'plot_number',
    defaultmessages: 'Plot Number',
  },
  plot_number_title: {
    id: 'plot_number_title',
    defaultmessages: 'Plot Number {s}',
  },
  plots: {
    id: 'plots',
    defaultmessages: 'Plots',
  },
  plots_breakdown: {
    id: 'plots_breakdown',
    defaultmessages: 'Plots Breakdown',
  },
  plots_have_issues_count: {
    id: 'plots_have_issues_count',
    defaultmessages: '{s} plots have issues',
  },
  plots_icon: {
    id: 'plots_icon',
    defaultmessages: '{s} Plots Area',
  },
  plots_selection: {
    id: 'plots_selection',
    defaultmessages: 'Plots Selection',
  },
  plus_num_photo: {
    id: 'plus_num_photo',
    defaultmessages: '+{num} photo',
  },
  plus_num_photos: {
    id: 'plus_num_photos',
    defaultmessages: '+ {num} photos',
  },
  pma: {
    id: 'pma',
    defaultmessages: 'PMA',
  },
  pma_agreement_application_has_been_returned_successfully: {
    id: 'pma_agreement_application_has_been_returned_successfully',
    defaultmessages: 'The PMA application has been successfully returned',
  },
  pma_agreement_approval: {
    id: 'pma_agreement_approval',
    defaultmessages: 'You have approved the PMA agreement',
  },
  pma_agreement_has_been_successfully_issued: {
    id: 'pma_agreement_has_been_successfully_issued',
    defaultmessages: 'PMA has been successfully issued',
  },
  pma_agreement_success: {
    id: 'pma_agreement_success',
    defaultmessages: 'PMA has been successfully modified',
  },
  pma_bank_init_payment: {
    id: 'pma_bank_init_payment',
    defaultmessages: 'The application will be sent to the bank to proceed with the payment',
  },
  pma_bank_search_subTitle: {
    id: 'pma_bank_search_subTitle',
    defaultmessages:
      'To search for properties by location, please specify the municipality, district, and community. You can also use other search parameters to find the desired property.',
  },
  pma_bank_title: {
    id: 'pma_bank_title',
    defaultmessages: 'You have not selected any property yet',
  },
  pma_classification: {
    id: 'pma_classification',
    defaultmessages: 'PMA Classification',
  },
  pma_contract_completed: {
    id: 'pma_contract_completed',
    defaultmessages: 'PMA is successfully completed',
  },
  pma_issuance_has_been_successfully_rejected: {
    id: 'pma_issuance_has_been_successfully_rejected',
    defaultmessages: 'PMA application has been successfully rejected',
  },
  pma_issuance_has_been_successfully_returned: {
    id: 'pma_issuance_has_been_successfully_returned',
    defaultmessages: 'PMA application has been successfully returned',
  },
  pma_issuance_has_been_successfully_sent: {
    id: 'pma_issuance_has_been_successfully_sent',
    defaultmessages: 'You have successfully approved the PMA application',
  },
  pma_issuance_has_been_successfully_sent_content: {
    id: 'pma_issuance_has_been_successfully_sent_content',
    defaultmessages: 'You will be notified of their response once they have checked it.',
  },
  pma_issuance_has_been_successfully_terminate: {
    id: 'pma_issuance_has_been_successfully_terminate',
    defaultmessages: 'Property Management Agreement has been successfully cancelled.',
  },
  pma_issuance_has_been_successfully_terminated: {
    id: 'pma_issuance_has_been_successfully_terminated',
    defaultmessages: 'PMA application has been successfully cancelled',
  },
  pma_issuance_sent_successfully: {
    id: 'pma_issuance_sent_successfully',
    defaultmessages: "PMA's registration has been successfully sent for approval",
  },
  pma_issuance_sent_successfully_subText: {
    id: 'pma_issuance_sent_successfully_subText',
    defaultmessages: 'Your application will be sent to the second party to get the required approvals',
  },
  pma_modification_has_been_successfully_accepted: {
    id: 'pma_modification_has_been_successfully_accepted',
    defaultmessages: 'PMA modification request has been successfully accepted',
  },
  pma_modification_has_been_successfully_rejected: {
    id: 'pma_modification_has_been_successfully_rejected',
    defaultmessages: 'PMA modification request has been successfully rejected',
  },
  pma_modification_has_been_successfully_returned: {
    id: 'pma_modification_has_been_successfully_returned',
    defaultmessages: 'PMA modification request has been successfully returned',
  },
  pma_modification_successfully_sent: {
    id: 'pma_modification_successfully_sent',
    defaultmessages: 'PMA modification request has been successfully sent for approval',
  },
  pma_more_properties: {
    id: 'pma_more_properties',
    defaultmessages: 'You can add more properties.',
  },
  pma_name: {
    id: 'pma_name',
    defaultmessages: 'Second Party Details',
  },
  pma_other_party_approval: {
    id: 'pma_other_party_approval',
    defaultmessages: 'Your application will be sent to the other party to get the required approvals.',
  },
  pma_payment_modified: {
    id: 'pma_payment_modified',
    defaultmessages: 'PMA has been successfully modified',
  },
  pma_payment_renewed: {
    id: 'pma_payment_renewed',
    defaultmessages: 'PMA agreement has been successfully renewed',
  },
  pma_pending_payment: {
    id: 'pma_pending_payment',
    defaultmessages: 'The application will be sent to the concerned parties to proceed with the payment.',
  },
  pma_registration_after_pmc_approval: {
    id: 'pma_registration_after_pmc_approval',
    defaultmessages: 'PMA has been successfully approved',
  },
  pma_reject_agreement_generic: {
    id: 'pma_reject_agreement_generic',
    defaultmessages: 'PMA application has been successfully rejected.',
  },
  pma_renewal_has_been_successfully_rejected: {
    id: 'pma_renewal_has_been_successfully_rejected',
    defaultmessages: 'PMA renewal request has been successfully rejected',
  },
  pma_renewal_has_been_successfully_returned: {
    id: 'pma_renewal_has_been_successfully_returned',
    defaultmessages: 'PMA renewal request has been successfully returned',
  },
  pma_renewal_has_been_successfully_terminated: {
    id: 'pma_renewal_has_been_successfully_terminated',
    defaultmessages: 'PMA renewal application has been successfully terminated',
  },
  pma_renewal_successfully_sent: {
    id: 'pma_renewal_successfully_sent',
    defaultmessages: 'PMA renewal request has been successfully sent for approval.',
  },
  pma_termination_accepted_successfully: {
    id: 'pma_termination_accepted_successfully',
    defaultmessages: 'PMA cancellation is successfully accepted',
  },
  pma_termination_has_been_successfully_accepted: {
    id: 'pma_termination_has_been_successfully_accepted',
    defaultmessages: 'PMA cancellation has been successfully submitted',
  },
  pma_termination_has_been_successfully_rejected: {
    id: 'pma_termination_has_been_successfully_rejected',
    defaultmessages: 'PMA cancellation request has been successfully rejected',
  },
  pma_termination_has_been_successfully_returned: {
    id: 'pma_termination_has_been_successfully_returned',
    defaultmessages: 'PMA cancellation request has been successfully returned',
  },
  pma_termination_has_been_successfully_sent: {
    id: 'pma_termination_has_been_successfully_sent',
    defaultmessages: 'PMA cancellation request has been successfully sent for approval',
  },
  pma_termination_reject: {
    id: 'pma_termination_reject',
    defaultmessages: 'PMA cancellation application has been successfully rejected',
  },
  pma_termination_request_successfully_sent: {
    id: 'pma_termination_request_successfully_sent',
    defaultmessages: 'PMA cancellation request has been successfully sent for approval',
  },
  pma_termination_return_subTitle: {
    id: 'pma_termination_return_subTitle',
    defaultmessages: 'Your application will be returned to the initiator to fix the issues and submit it again.',
  },
  pma_termination_return_title: {
    id: 'pma_termination_return_title',
    defaultmessages: 'PMA cancellation application has been successfully returned',
  },
  pma_termination_subTitle: {
    id: 'pma_termination_subTitle',
    defaultmessages: 'The application will be forwarded to the bank signatory for approval',
  },
  pma_termination_success_message: {
    id: 'pma_termination_success_message',
    defaultmessages: 'PMA cancellation is successfully accepted',
  },
  pma_type: {
    id: 'pma_type',
    defaultmessages: 'Property Management Agreement Type',
  },
  pma_type_filter: {
    id: 'pma_type_filter',
    defaultmessages: 'PMA Type',
  },
  pmc_approval_for_pma: {
    id: 'pmc_approval_for_pma',
    defaultmessages: 'You will be notified once PMA agreement is reviewed and approved.',
  },
  pmc_no_properties_desc: {
    id: 'pmc_no_properties_desc',
    defaultmessages: 'To search for properties you can use any of the certificate search parameters',
  },
  pmc_return_title_main: {
    id: 'pmc_return_title_main',
    defaultmessages: 'PMA application has been successfully returned',
  },
  poa: {
    id: 'poa',
    defaultmessages: 'POA',
  },
  poa_agreement_mandatory: {
    id: 'poa_agreement_mandatory',
    defaultmessages: 'POA Agreement (Mandatory)',
  },
  poa_details: {
    id: 'poa_details',
    defaultmessages: 'POA Details',
  },
  poa_document: {
    id: 'poa_document',
    defaultmessages: 'Power of Attorney Document',
  },
  poa_expiry_date: {
    id: 'poa_expiry_date',
    defaultmessages: 'POA Expiry Date',
  },
  poa_issuance_date: {
    id: 'poa_issuance_date',
    defaultmessages: 'POA Issuance Date',
  },
  poa_number: {
    id: 'poa_number',
    defaultmessages: 'POA Number',
  },
  poa_sent_for_adgm_approval: {
    id: 'poa_sent_for_adgm_approval',
    defaultmessages: 'Your POA application has been sent to ADGM for approval',
  },
  poa_sent_for_other_owners_approval: {
    id: 'poa_sent_for_other_owners_approval',
    defaultmessages: 'Register Power of Attorney application is sent for other owners approval',
  },
  poa_source: {
    id: 'poa_source',
    defaultmessages: 'POA Source',
  },
  poa_source_of_authorization: {
    id: 'poa_source_of_authorization',
    defaultmessages: 'POA Source of Authorization',
  },
  poa_terminate_success_screen_label: {
    id: 'poa_terminate_success_screen_label',
    defaultmessages: 'Terminate Power of Attorney application sent for ADGM approval',
  },
  poa_type: {
    id: 'poa_type',
    defaultmessages: 'POA Type',
  },
  point_1_of_mortgage_value: {
    id: 'point_1_of_mortgage_value',
    defaultmessages: '0.1% of Mortgage Amount',
  },
  possesive_mortgage_details: {
    id: 'possesive_mortgage_details',
    defaultmessages: 'Possessive Mortgage Details',
  },
  possessory_mortgage: {
    id: 'possessory_mortgage',
    defaultmessages: 'Possessory Mortgage',
  },
  power_of_attorney: {
    id: 'power_of_attorney',
    defaultmessages: 'Power of Attorney',
  },
  powered_by: {
    id: 'powered_by',
    defaultmessages: 'Powered by',
  },
  preliminary_architecture_approval: {
    id: 'preliminary_architecture_approval',
    defaultmessages: 'Preliminary Architecture Approval',
  },
  premise_address: {
    id: 'premise_address',
    defaultmessages: 'Premise Address',
  },
  premise_id: {
    id: 'premise_id',
    defaultmessages: 'Premise ID',
  },
  premise_id_is_not_correct: {
    id: 'premise_id_is_not_correct',
    defaultmessages: 'Premise ID is incorrect',
  },
  premise_number: {
    id: 'premise_number',
    defaultmessages: 'Premise Number',
  },
  premise_number_plc: {
    id: 'premise_number_plc',
    defaultmessages: 'Enter Premise Number',
  },
  preventing_you_from_continuing_on_this_application: {
    id: 'preventing_you_from_continuing_on_this_application',
    defaultmessages:
      'These properties have a block on them that’s preventing you from continuing on this application. You can cancel the application or save it as a draft for later.',
  },
  preview: {
    id: 'preview',
    defaultmessages: 'Preview',
  },
  preview_contract: {
    id: 'preview_contract',
    defaultmessages: '',
  },
  preview_lease_contract_pdf: {
    id: 'preview_lease_contract_pdf',
    defaultmessages: 'Preview Lease Agreement PDF',
  },
  previous: {
    id: 'previous',
    defaultmessages: 'Previous',
  },
  previous_mortgage_certificate_mandatory: {
    id: 'previous_mortgage_certificate_mandatory',
    defaultmessages: 'Previous Mortgage Certificate (Mandatory)',
  },
  previous_progress_reports: {
    id: 'previous_progress_reports',
    defaultmessages: 'Previous Progress Reports',
  },
  previous_service_charges: {
    id: 'previous_service_charges',
    defaultmessages: 'Previous Service Charges',
  },
  previously_owned_land: {
    id: 'previously_owned_land',
    defaultmessages: 'Previously Owned Land/s',
  },
  previously_owned_unit: {
    id: 'previously_owned_unit',
    defaultmessages: 'Previously Owned Unit/s',
  },
  previously_this_owner_does_not_own_any_land: {
    id: 'previously_this_owner_does_not_own_any_land',
    defaultmessages: 'Oops! Previously this owner does not own any land/s.',
  },
  previously_this_owner_does_not_own_any_units: {
    id: 'previously_this_owner_does_not_own_any_units',
    defaultmessages: 'Oops! Previously this owner does not own any unit/s',
  },
  price_index_methodology_statement: {
    id: 'price_index_methodology_statement',
    defaultmessages:
      'Abu Dhabi’s real estate price indices follow a four-step process: data collection and consolidation, data cleansing, methodology selection, and calculation.\nIn emerging real estate markets such as Abu Dhabi, where many variables affect data quality, maximizing transactional records and relevant property characteristics allows for the deployment of the hedonic method.\nThe hedonic method conveys the impact of qualitative and quantitative property characteristics on the attractiveness of individual properties, and – by extrapolation – the attractiveness of individual sub-markets, this serves to relay market sentiment in a discretized manner, allowing stakeholders more granular insights.\nFor details on hedonic price indexing, ',
  },
  price_index_methodology_statement_title: {
    id: 'price_index_methodology_statement_title',
    defaultmessages: 'Real Estate Price Indices Calculation Methodology',
  },
  price_indices: {
    id: 'price_indices',
    defaultmessages: 'Price Indices',
  },
  price_indices_emirate_title: {
    id: 'price_indices_emirate_title',
    defaultmessages: 'Price indices in emirate of Abu Dhabi',
  },
  price_indices_in_abu_dhabi: {
    id: 'price_indices_in_abu_dhabi',
    defaultmessages: 'Sale price indices in Abu Dhabi city',
  },
  price_is_based_on_the_evaluation_certificate: {
    id: 'price_is_based_on_the_evaluation_certificate',
    defaultmessages: 'Price is based on the evaluation certificate',
  },
  pricing_rent_unit_per_month_vat_2_and_3_month_permit: {
    id: 'pricing_rent_unit_per_month_vat_2_and_3_month_permit',
    defaultmessages:
      'Advertisement Permit for rent purpose (per unit): \nAED 50 + 5% VAT for 1 month.\nAED 100 +5% VAT for 2 months .\nAED 115 + 5% VAT for 3 months.',
  },
  pricing_sell_unit_per_month_vat_2_and_3_month_permit: {
    id: 'pricing_sell_unit_per_month_vat_2_and_3_month_permit',
    defaultmessages:
      'Advertisement Permit for selling purposes (per unit): \nAED 125 + 5% VAT for 1 month.\nAED 250 + 5% VAT for 2 months.\nAED 250 + 5% VAT for 3 months.',
  },
  'primary-developer': {
    id: 'primary-developer',
    defaultmessages: 'Primary Developer',
  },
  primary_buyer: {
    id: 'primary_buyer',
    defaultmessages: 'Primary Buyer',
  },
  primary_buyer_documents: {
    id: 'primary_buyer_documents',
    defaultmessages: 'Primary Buyer Documents',
  },
  primary_contact: {
    id: 'primary_contact',
    defaultmessages: 'Primary Contact',
  },
  primary_contact_details: {
    id: 'primary_contact_details',
    defaultmessages: 'Primary Contact Details',
  },
  primary_contact_made_default_successfully: {
    id: 'primary_contact_made_default_successfully',
    defaultmessages: 'Primary contact {s} have been made default successfully, list is up to date',
  },
  primary_contact_removed_successfully: {
    id: 'primary_contact_removed_successfully',
    defaultmessages: 'Primary contact {s} have been removed successfully, list is up to date',
  },
  primary_developer: {
    id: 'primary_developer',
    defaultmessages: 'Primary Developer',
  },
  primary_lessor_is_mandatory: {
    id: 'primary_lessor_is_mandatory',
    defaultmessages: 'Primary lessor is mandatory',
  },
  primary_lessor_is_same_primary_contact: {
    id: 'primary_lessor_is_same_primary_contact',
    defaultmessages: 'Primary contact is the same as primary lessor',
  },
  primary_lessor_same_as_primary_contact: {
    id: 'primary_lessor_same_as_primary_contact',
    defaultmessages: 'Primary lessor is the same primary contact',
  },
  primary_musateh_details: {
    id: 'primary_musateh_details',
    defaultmessages: 'Primary Musateh Details',
  },
  proceed: {
    id: 'proceed',
    defaultmessages: 'Proceed',
  },
  proceed_secured_checkout: {
    id: 'proceed_secured_checkout',
    defaultmessages: 'Proceed to secured checkout',
  },
  proceed_to_closure: {
    id: 'proceed_to_closure',
    defaultmessages: 'Proceed to Expiry',
  },
  proceed_to_payment: {
    id: 'proceed_to_payment',
    defaultmessages: 'Proceed to Payment',
  },
  profession_license_end_date: {
    id: 'profession_license_end_date',
    defaultmessages: 'Profession License Expiry Date',
  },
  profession_license_start_date: {
    id: 'profession_license_start_date',
    defaultmessages: 'Profession License Issue Date',
  },
  profession_type: {
    id: 'profession_type',
    defaultmessages: 'Profession Type',
  },
  professional: {
    id: 'professional',
    defaultmessages: 'Professional',
  },
  professional_details: {
    id: 'professional_details',
    defaultmessages: 'Professional Details',
  },
  professional_info: {
    id: 'professional_info',
    defaultmessages: 'Professional Info',
  },
  professional_license: {
    id: 'professional_license',
    defaultmessages: 'Professional License',
  },
  professions: {
    id: 'professions',
    defaultmessages: 'Professions',
  },
  profileSwitcher: {
    id: 'profileSwitcher',
    defaultmessages: 'Personal Account',
  },
  profileSwitcherCompany: {
    id: 'profileSwitcherCompany',
    defaultmessages: 'Company Account',
  },
  profile_details: {
    id: 'profile_details',
    defaultmessages: 'Profile Details',
  },
  profile_message_eid: {
    id: 'profile_message_eid',
    defaultmessages: 'This information is retrieved from your UAE PASS and cannot be edited',
  },
  profile_message_eid_new: {
    id: 'profile_message_eid_new',
    defaultmessages: 'This information is retrieved cannot be edited',
  },
  profile_message_unified: {
    id: 'profile_message_unified',
    defaultmessages: 'This information has been retrieved from your passport and only some sections can be edited',
  },
  profile_settings: {
    id: 'profile_settings',
    defaultmessages: 'Profile Settings',
  },
  profile_type: {
    id: 'profile_type',
    defaultmessages: 'Profile Type',
  },
  profit_distribution_plan_if_applicable: {
    id: 'profit_distribution_plan_if_applicable',
    defaultmessages: 'Profit Distribution Plan (if applicable)',
  },
  progress_report: {
    id: 'progress_report',
    defaultmessages: 'Progress Report',
  },
  project: {
    id: 'project',
    defaultmessages: 'Project',
  },
  project_account_agreement_mandatory: {
    id: 'project_account_agreement_mandatory',
    defaultmessages: 'Project Account Agreement (Mandatory)',
  },
  project_account_agreement_registration: {
    id: 'project_account_agreement_registration',
    defaultmessages: 'Project Account Agreement Registration',
  },
  project_account_agreement_registration_description: {
    id: 'project_account_agreement_registration_description',
    defaultmessages:
      'This service involves documenting and linking a real estate development project to a Project Account, allowing the developer to start selling properties off-plan.',
  },
  project_account_bank_registration: {
    id: 'project_account_bank_registration',
    defaultmessages: 'Registration of a Bank Account',
  },
  project_account_bank_registration_description: {
    id: 'project_account_bank_registration_description',
    defaultmessages:
      'This service registers the bank as the trustee of the project account, allowing it to establish a project account agreement with the real estate developer.',
  },
  project_boundary: {
    id: 'project_boundary',
    defaultmessages: 'Project Boundary',
  },
  project_breakdown: {
    id: 'project_breakdown',
    defaultmessages: 'Project Breakdown',
  },
  project_category: {
    id: 'project_category',
    defaultmessages: 'Project Category',
  },
  project_completion_date: {
    id: 'project_completion_date',
    defaultmessages: 'Project Completion Date',
  },
  project_construction_cost: {
    id: 'project_construction_cost',
    defaultmessages: 'Project Construction Cost',
  },
  project_construction_cost_in_aed: {
    id: 'project_construction_cost_in_aed',
    defaultmessages: 'Project Construction Cost in AED',
  },
  project_cost_hint: {
    id: 'project_cost_hint',
    defaultmessages: 'e.g. AED 1,200,000',
  },
  project_description: {
    id: 'project_description',
    defaultmessages: '',
  },
  project_description_arabic: {
    id: 'project_description_arabic',
    defaultmessages: 'Project Description (AR)',
  },
  project_description_en: {
    id: 'project_description_en',
    defaultmessages: 'Project Description (EN)',
  },
  project_description_hint_ar: {
    id: 'project_description_hint_ar',
    defaultmessages: 'وصف المشروع بالعربية',
  },
  project_description_in_english: {
    id: 'project_description_in_english',
    defaultmessages: 'Project Description in English',
  },
  project_details: {
    id: 'project_details',
    defaultmessages: 'Project Details',
  },
  project_id: {
    id: 'project_id',
    defaultmessages: 'Project ID',
  },
  project_information: {
    id: 'project_information',
    defaultmessages: 'Project Information',
  },
  project_inventory_sheet: {
    id: 'project_inventory_sheet',
    defaultmessages: 'Project Inventory Sheet',
  },
  project_location: {
    id: 'project_location',
    defaultmessages: 'Project Location',
  },
  project_name: {
    id: 'project_name',
    defaultmessages: 'Project Name',
  },
  project_name_ar: {
    id: 'project_name_ar',
    defaultmessages: 'Project Name (AR)',
  },
  project_name_arabic_hint: {
    id: 'project_name_arabic_hint',
    defaultmessages: 'اسم المشروع بالعربية',
  },
  project_name_en: {
    id: 'project_name_en',
    defaultmessages: 'Project Name (EN)',
  },
  project_name_in_english: {
    id: 'project_name_in_english',
    defaultmessages: 'Project Name in English',
  },
  project_number: {
    id: 'project_number',
    defaultmessages: 'Project Number',
  },
  project_photos: {
    id: 'project_photos',
    defaultmessages: 'Project Photos',
  },
  project_plot: {
    id: 'project_plot',
    defaultmessages: 'Project Plots',
  },
  project_plots: {
    id: 'project_plots',
    defaultmessages: 'Project Plots',
  },
  project_progress_report: {
    id: 'project_progress_report',
    defaultmessages: 'Project Progress Report',
  },
  project_reg_certificate: {
    id: 'project_reg_certificate',
    defaultmessages: 'Project Reg. Certificate',
  },
  project_registration: {
    id: 'project_registration',
    defaultmessages: 'Project Registration',
  },
  project_registration_certificate: {
    id: 'project_registration_certificate',
    defaultmessages: 'Project Registration Certificate',
  },
  project_registration_certificate_marketing_materials_new_offers_and_payment_plans: {
    id: 'project_registration_certificate_marketing_materials_new_offers_and_payment_plans',
    defaultmessages: 'Project registration certificate, Marketing materials, new offers and payment plans',
  },
  project_registration_description: {
    id: 'project_registration_description',
    defaultmessages:
      "This service allows developers to register their real estate development projects. It includes specifying the project type, naming the project, and detailing the project's inventory.",
  },
  project_registration_letter_mandatory: {
    id: 'project_registration_letter_mandatory',
    defaultmessages: 'Project Registration Letter (Mandatory)',
  },
  project_registration_success_message: {
    id: 'project_registration_success_message',
    defaultmessages: 'Project has been successfully registered',
  },
  project_required_information_mandatory: {
    id: 'project_required_information_mandatory',
    defaultmessages: 'Project Required Information (Mandatory)',
  },
  project_status: {
    id: 'project_status',
    defaultmessages: 'Project Status',
  },
  project_type: {
    id: 'project_type',
    defaultmessages: 'Project Type',
  },
  project_value: {
    id: 'project_value',
    defaultmessages: 'Project Value',
  },
  project_value_in_aed: {
    id: 'project_value_in_aed',
    defaultmessages: 'Project Value in AED',
  },
  proof_of_non_payment: {
    id: 'proof_of_non_payment',
    defaultmessages: 'Proof of Non-payment',
  },
  proof_of_non_payment_mandatory: {
    id: 'proof_of_non_payment_mandatory',
    defaultmessages: 'Proof of Non-payment (Mandatory)',
  },
  proof_of_non_payment_notice_mandatory: {
    id: 'proof_of_non_payment_notice_mandatory',
    defaultmessages: 'Proof of non-payment notice (Mandatory)',
  },
  proof_of_ownership: {
    id: 'proof_of_ownership',
    defaultmessages: 'Proof of Ownership',
  },
  proof_of_ownership_or_equivalent: {
    id: 'proof_of_ownership_or_equivalent',
    defaultmessages: 'Proof of Ownership (Title Deed or equivalent document)',
  },
  proof_of_payment: {
    id: 'proof_of_payment',
    defaultmessages: 'Proof of payment',
  },
  proof_the_bank_has_been_registered_before_as_project_account_mandatory: {
    id: 'proof_the_bank_has_been_registered_before_as_project_account_mandatory',
    defaultmessages: 'Proof that the bank has been previously registered as a Project Account (Mandatory)',
  },
  properties_information: {
    id: 'properties_information',
    defaultmessages: 'Properties Information ({s} units)',
  },
  properties_selected: {
    id: 'properties_selected',
    defaultmessages: 'Properties Selected',
  },
  property: {
    id: 'property',
    defaultmessages: 'Property',
  },
  property_certificate_no: {
    id: 'property_certificate_no',
    defaultmessages: 'Property Certificate No.',
  },
  property_details: {
    id: 'property_details',
    defaultmessages: 'Property Details',
  },
  property_information: {
    id: 'property_information',
    defaultmessages: 'Property Information',
  },
  property_information_count: {
    id: 'property_information_count',
    defaultmessages: 'Property Information ( {count} )',
  },
  property_lessors: {
    id: 'property_lessors',
    defaultmessages: 'Property Lessors',
  },
  property_management: {
    id: 'property_management',
    defaultmessages: '',
  },
  property_name: {
    id: 'property_name',
    defaultmessages: 'Property Name',
  },
  property_num: {
    id: 'property_num',
    defaultmessages: 'Property #{num}',
  },
  property_owner: {
    id: 'property_owner',
    defaultmessages: 'Property Owner',
  },
  property_owners: {
    id: 'property_owners',
    defaultmessages: 'Property Owners',
  },
  property_owners_num: {
    id: 'property_owners_num',
    defaultmessages: 'Property Owners ({num})',
  },
  property_reg_no_text: {
    id: 'property_reg_no_text',
    defaultmessages: 'Building Registration No.',
  },
  property_reg_no_text_hint: {
    id: 'property_reg_no_text_hint',
    defaultmessages: 'e.g., 8287636',
  },
  property_selling_details: {
    id: 'property_selling_details',
    defaultmessages: 'Property Selling Details',
  },
  property_share: {
    id: 'property_share',
    defaultmessages: 'Property Share',
  },
  property_summary: {
    id: 'property_summary',
    defaultmessages: 'Property Summary',
  },
  property_type: {
    id: 'property_type',
    defaultmessages: 'Property Type',
  },
  property_usage: {
    id: 'property_usage',
    defaultmessages: 'Property Usage',
  },
  property_use: {
    id: 'property_use',
    defaultmessages: 'Property Usage',
  },
  property_validation_details_title: {
    id: 'property_validation_details_title',
    defaultmessages: 'The following properties have pending items preventing you from initiating a service on them:',
  },
  provide_detailed_description: {
    id: 'provide_detailed_description',
    defaultmessages:
      'Please provide a detailed description of your feedback, include any relevant date, reference number or circumstances',
  },
  prp_number: {
    id: 'prp_number',
    defaultmessages: 'PRP Number',
  },
  public_benefit_association: {
    id: 'public_benefit_association',
    defaultmessages: 'Public Benefit Association',
  },
  qa_qc_certificate: {
    id: 'qa_qc_certificate',
    defaultmessages: '',
  },
  qa_qc_check: {
    id: 'qa_qc_check',
    defaultmessages: 'QA/QC Check',
  },
  qa_qc_code: {
    id: 'qa_qc_code',
    defaultmessages: 'QA/QC Code',
  },
  rating: {
    id: 'rating',
    defaultmessages: 'Rating',
  },
  rating_service_flow: {
    id: 'rating_service_flow',
    defaultmessages: 'How would you rate {s} service flow?',
  },
  rational_desc: {
    id: 'rational_desc',
    defaultmessages: 'Document cannot be uploaded without this permission',
  },
  rational_title: {
    id: 'rational_title',
    defaultmessages: 'Permission not granted',
  },
  're-upload': {
    id: 're-upload',
    defaultmessages: 'Re-Upload',
  },
  reactivate: {
    id: 'reactivate',
    defaultmessages: 'Reactivate',
  },
  reactivate_employee: {
    id: 'reactivate_employee',
    defaultmessages: 'Reactivate employee account',
  },
  reactivate_employee_pop_up: {
    id: 'reactivate_employee_pop_up',
    defaultmessages: 'Reactivate an employee account',
  },
  reactivate_employee_pop_up_desc: {
    id: 'reactivate_employee_pop_up_desc',
    defaultmessages: 'This will grant the employee immediate access to the properties again.',
  },
  reactivate_employee_popup_description: {
    id: 'reactivate_employee_popup_description',
    defaultmessages: 'This will give the employee access to the properties again immediately',
  },
  reactivate_employee_popup_title: {
    id: 'reactivate_employee_popup_title',
    defaultmessages: 'Reactivate employee account?',
  },
  reactivate_now: {
    id: 'reactivate_now',
    defaultmessages: 'Reactivate Account Now',
  },
  read: {
    id: 'read',
    defaultmessages: '',
  },
  read_more: {
    id: 'read_more',
    defaultmessages: 'Read More',
  },
  ready: {
    id: 'ready',
    defaultmessages: 'Ready',
  },
  ready_for_download_subtitle: {
    id: 'ready_for_download_subtitle',
    defaultmessages: 'You will be notified once the certificate is ready to download.',
  },
  ready_project_status_tooltip_message: {
    id: 'ready_project_status_tooltip_message',
    defaultmessages: 'Projects registered without an escrow account',
  },
  real_estate_disclaimer_title: {
    id: 'real_estate_disclaimer_title',
    defaultmessages: 'Real Estate Price Indices Calculation Methodology',
  },
  real_estate_local_exhibition_participation_success: {
    id: 'real_estate_local_exhibition_participation_success',
    defaultmessages: 'The Permit to Participate in a Real Estate Local Exhibition has been successfully issued.',
  },
  real_estate_project_registration: {
    id: 'real_estate_project_registration',
    defaultmessages: 'Real estate Project Registration',
  },
  real_estate_projects: {
    id: 'real_estate_projects',
    defaultmessages: 'Real Estate Projects',
  },
  reason_for_blocking: {
    id: 'reason_for_blocking',
    defaultmessages: 'Reason for blocking',
  },
  recaptcha_text: {
    id: 'recaptcha_text',
    defaultmessages: 'Please check the box below to proceed',
  },
  receipt: {
    id: 'receipt',
    defaultmessages: 'Payment Receipt',
  },
  recent_broker_subtitle: {
    id: 'recent_broker_subtitle',
    defaultmessages: 'Check out all registered brokerage companies',
  },
  recent_project_subtitle: {
    id: 'recent_project_subtitle',
    defaultmessages: 'Check out all recent Abu Dhabi projects and their statuses',
  },
  recent_surveyor_subtitle: {
    id: 'recent_surveyor_subtitle',
    defaultmessages: 'Check out registered surveyors in the city',
  },
  ref: {
    id: 'ref',
    defaultmessages: 'Reference ID',
  },
  reference_ID: {
    id: 'reference_ID',
    defaultmessages: 'Application ID',
  },
  reference_number: {
    id: 'reference_number',
    defaultmessages: 'Reference Number',
  },
  refund_of_ninty_percent_of_buyer_paid_amount_is_mandatory_with_applicable_terms: {
    id: 'refund_of_ninty_percent_of_buyer_paid_amount_is_mandatory_with_applicable_terms',
    defaultmessages:
      'A refund of 90% of the Buyer’s paid amount is mandatory in accordance with applicable terms and conditions.',
  },
  refunded_amount: {
    id: 'refunded_amount',
    defaultmessages: 'Refunded Amount',
  },
  refunded_amount_will_be_transferred_to_this_bank_account: {
    id: 'refunded_amount_will_be_transferred_to_this_bank_account',
    defaultmessages: 'The refunded amount will be transferred to this bank account',
  },
  refunded_to_buyer: {
    id: 'refunded_to_buyer',
    defaultmessages: 'Refunded to Buyer',
  },
  reg_num: {
    id: 'reg_num',
    defaultmessages: 'Registration Number',
  },
  'register-long-lease-plot': {
    id: 'register-long-lease-plot',
    defaultmessages: 'Registration of Long Lease on Plot',
  },
  'register-renew-developer': {
    id: 'register-renew-developer',
    defaultmessages: 'Register/Renew Developer',
  },
  register_a_mortgage: {
    id: 'register_a_mortgage',
    defaultmessages: 'Register a Mortgage',
  },
  register_caveat: {
    id: 'register_caveat',
    defaultmessages: 'Register Caveat',
  },
  register_caveat_description: {
    id: 'register_caveat_description',
    defaultmessages:
      'A caveat can be lodged by either the registered owner of the real property or another individual claiming an interest in the property.',
  },
  register_company_account: {
    id: 'register_company_account',
    defaultmessages: 'Open Company Account',
  },
  register_covenant: {
    id: 'register_covenant',
    defaultmessages: 'Register Covenant',
  },
  register_covenant_description: {
    id: 'register_covenant_description',
    defaultmessages:
      'Identify the lot to be burdened by the covenant and/or the lot to be benefited by the covenant, including the persons having the benefit of the covenant.',
  },
  register_covenant_release: {
    id: 'register_covenant_release',
    defaultmessages: 'Register Covenant Release',
  },
  register_covenant_release_description: {
    id: 'register_covenant_release_description',
    defaultmessages: 'Executed by the registered owner of the plot that is burdened and/or benefited by the covenant.',
  },
  register_discharge_mortgage: {
    id: 'register_discharge_mortgage',
    defaultmessages: 'Register a Discharge Mortgage',
  },
  register_discharge_mortgage_description: {
    id: 'register_discharge_mortgage_description',
    defaultmessages:
      '1. A registered mortgage can be discharged by registering a discharge of mortgage.\n2. A discharge of mortgage may release the debt or liability secured for:\n— All or part of the mortgage\n— One or more of the mortgagors.',
  },
  register_dispute: {
    id: 'register_dispute',
    defaultmessages: 'Register a Dispute',
  },
  register_easement: {
    id: 'register_easement',
    defaultmessages: 'Register Easement',
  },
  register_easement_description: {
    id: 'register_easement_description',
    defaultmessages: 'To be registered, an instrument creating an easement must:',
  },
  register_easement_description_a: {
    id: 'register_easement_description_a',
    defaultmessages:
      '(a) Clearly specify the nature of the easement, the rights granted or reserved under it, and the extent of the real property burdened by the easement.',
  },
  register_easement_description_b: {
    id: 'register_easement_description_b',
    defaultmessages:
      '(b) If required by the Registrar, include a survey plan that identifies the lot or portion of the lot burdened by the easement, and, unless the easement is an easement in gross, the lot that benefits from the easement.',
  },
  register_easement_description_c: {
    id: 'register_easement_description_c',
    defaultmessages:
      '(c) In the case of an easement in gross, specify the individuals or entities who hold the benefit of the easement.',
  },
  register_escrow_account: {
    id: 'register_escrow_account',
    defaultmessages: 'Register Escrow Account',
  },
  register_long_lease_plot_description: {
    id: 'register_long_lease_plot_description',
    defaultmessages:
      'This service allows property owners or lessees to register a long lease agreement on a plot. Registration ensures the legal validity of the leasehold interest and updates the property records accordingly.',
  },
  register_mortgage: {
    id: 'register_mortgage',
    defaultmessages: 'Register Mortgage',
  },
  register_mortgage_description: {
    id: 'register_mortgage_description',
    defaultmessages:
      'Real property or a registered interest in real property (including a registered lease) can be mortgaged by registering a mortgage. Additionally, a portion of a lot cannot be mortgaged separately from the rest of the lot.',
  },
  register_new_developer: {
    id: 'register_new_developer',
    defaultmessages: 'Register/Renew Developer',
  },
  register_new_developer_description: {
    id: 'register_new_developer_description',
    defaultmessages:
      'This service allows developers or sub-developers to register or renew their status as an Off-Plan Developer within ADGM jurisdiction.',
  },
  register_now: {
    id: 'register_now',
    defaultmessages: 'Register Now',
  },
  register_power_of_attorney: {
    id: 'register_power_of_attorney',
    defaultmessages: 'Register Power of Attorney',
  },
  register_property_management_agreement: {
    id: 'register_property_management_agreement',
    defaultmessages: 'Register Property Management Agreement',
  },
  register_property_mortgage_contract: {
    id: 'register_property_mortgage_contract',
    defaultmessages: 'Register a Property Mortgage Agreement',
  },
  register_sub_pma_contract_title: {
    id: 'register_sub_pma_contract_title',
    defaultmessages: '',
  },
  register_tenancy_contract: {
    id: 'register_tenancy_contract',
    defaultmessages: 'Register Lease Agreement',
  },
  register_variation_mortgage: {
    id: 'register_variation_mortgage',
    defaultmessages: 'Register Variation Mortgage',
  },
  register_variation_mortgage_description: {
    id: 'register_variation_mortgage_description',
    defaultmessages:
      'A registered mortgage can be varied by registering an instrument that outlines the changes to the mortgage.',
  },
  register_villa_fee_paid_by_owner: {
    id: 'register_villa_fee_paid_by_owner',
    defaultmessages: 'Registering a Villa fee AED 905 paid by the owner',
  },
  register_withdrawal_of_caveat: {
    id: 'register_withdrawal_of_caveat',
    defaultmessages: 'Register Withdrawal of Caveat',
  },
  register_withdrawal_of_caveat_description: {
    id: 'register_withdrawal_of_caveat_description',
    defaultmessages:
      'A caveat restricts the registration of any instrument that would affect the real property or interest specified in the caveat.',
  },
  registered_caveat_instrument_mandatory: {
    id: 'registered_caveat_instrument_mandatory',
    defaultmessages: 'Registered Caveat Instrument (Mandatory)',
  },
  registered_covenant_instrument_mandatory: {
    id: 'registered_covenant_instrument_mandatory',
    defaultmessages: 'Registered Covenant Instrument (Mandatory)',
  },
  registered_easement_instrument_mandatory: {
    id: 'registered_easement_instrument_mandatory',
    defaultmessages: 'Registered Easement Instrument (Mandatory)',
  },
  registered_on: {
    id: 'registered_on',
    defaultmessages: 'Registered On',
  },
  registered_units: {
    id: 'registered_units',
    defaultmessages: 'Registered Units',
  },
  'registration-of-reservation-agreement': {
    id: 'registration-of-reservation-agreement',
    defaultmessages: 'Registration of Reservation Agreement',
  },
  'registration-of-reservation-agreement-description': {
    id: 'registration-of-reservation-agreement-description',
    defaultmessages:
      'This service allows property owners to register a reservation agreement on a plot. Registration ensures the legal validity of the leasehold interest and updates the property records accordingly.',
  },
  registration_date: {
    id: 'registration_date',
    defaultmessages: 'Registration Date',
  },
  registration_easement: {
    id: 'registration_easement',
    defaultmessages: 'Registration Easement',
  },
  registration_fe: {
    id: 'registration_fe',
    defaultmessages: 'Registration Fee',
  },
  registration_fee: {
    id: 'registration_fee',
    defaultmessages: 'Registration Fees',
  },
  registration_fee_amount: {
    id: 'registration_fee_amount',
    defaultmessages: 'Registration Fee ({s}%)',
  },
  registration_fee_calculated: {
    id: 'registration_fee_calculated',
    defaultmessages: 'Registration fee is calculated based on the agreement remaining amount',
  },
  registration_fee_hint: {
    id: 'registration_fee_hint',
    defaultmessages: 'Registration fee 0.09% of the mortgage amount with maximum of AED 1,000,000',
  },
  registration_fee_is_max: {
    id: 'registration_fee_is_max',
    defaultmessages: 'Registration fee is 15% of the valuation price and paid by the seller only',
  },
  registration_fee_is_of_the_valuation_or_selling_price_whichever_is_higher: {
    id: 'registration_fee_is_of_the_valuation_or_selling_price_whichever_is_higher',
    defaultmessages: 'Registration fee is 2% of the valuation or selling price, whichever is higher.',
  },
  registration_fee_is_paid_by: {
    id: 'registration_fee_is_paid_by',
    defaultmessages: 'Registration fee is paid by',
  },
  registration_fee_paid_by_buyer: {
    id: 'registration_fee_paid_by_buyer',
    defaultmessages: 'Registration fees are paid by buyer',
  },
  registration_fees_of_property_details: {
    id: 'registration_fees_of_property_details',
    defaultmessages: 'Registration Fees of Property Details',
  },
  registration_fees_of_rental_unit_details: {
    id: 'registration_fees_of_rental_unit_details',
    defaultmessages: 'Registration Fees of Rental Unit Details',
  },
  registration_fees_paid_by: {
    id: 'registration_fees_paid_by',
    defaultmessages: 'Registration Fees Paid by',
  },
  registration_license_no: {
    id: 'registration_license_no',
    defaultmessages: 'Registration License No',
  },
  registration_license_num: {
    id: 'registration_license_num',
    defaultmessages: 'Registration License No.: %s',
  },
  registration_license_number: {
    id: 'registration_license_number',
    defaultmessages: 'Registration License Number',
  },
  registration_no: {
    id: 'registration_no',
    defaultmessages: '',
  },
  registration_of_easement_instrument_mandatory: {
    id: 'registration_of_easement_instrument_mandatory',
    defaultmessages: 'Registration of Easement Instrument (Mandatory)',
  },
  registration_sub_pma_title: {
    id: 'registration_sub_pma_title',
    defaultmessages: '',
  },
  registration_type: {
    id: 'registration_type',
    defaultmessages: 'Registration Type',
  },
  reject: {
    id: 'reject',
    defaultmessages: 'Reject',
  },
  reject_application: {
    id: 'reject_application',
    defaultmessages: 'Reject Application',
  },
  reject_cancallation_title: {
    id: 'reject_cancallation_title',
    defaultmessages: 'Reject Agreement Surrender?',
  },
  reject_cancellation: {
    id: 'reject_cancellation',
    defaultmessages: 'Reject Surrender?',
  },
  reject_cancellation_text: {
    id: 'reject_cancellation_text',
    defaultmessages: 'We will send you a notification once the application is completed and signed.',
  },
  reject_cancellation_title: {
    id: 'reject_cancellation_title',
    defaultmessages: 'Your agreement is successfully cancelled',
  },
  reject_case_title: {
    id: 'reject_case_title',
    defaultmessages: 'Reject Dispute Title',
  },
  reject_reason: {
    id: 'reject_reason',
    defaultmessages: 'Reject Reason',
  },
  reject_reason_title: {
    id: 'reject_reason_title',
    defaultmessages: 'Please enter the reason for rejection',
  },
  reject_with_feedback: {
    id: 'reject_with_feedback',
    defaultmessages: 'Reject with Feedback',
  },
  rejected_musataha_contract_title: {
    id: 'rejected_musataha_contract_title',
    defaultmessages: 'Musataha agreement registration application has been successfully rejected',
  },
  rejection_feedback: {
    id: 'rejection_feedback',
    defaultmessages: 'Rejection Reason(s):',
  },
  rejection_feedback_text: {
    id: 'rejection_feedback_text',
    defaultmessages: 'Your feedback will be shared with the owner of the property, The maximum character count is 500.',
  },
  rejection_text: {
    id: 'rejection_text',
    defaultmessages: 'Are you sure you want to reject the application?',
  },
  rejection_title: {
    id: 'rejection_title',
    defaultmessages: 'Please enter your return reason',
  },
  rejection_title_v2: {
    id: 'rejection_title_v2',
    defaultmessages: 'Please enter the application rejection reason',
  },
  release: {
    id: 'release',
    defaultmessages: 'Release',
  },
  'release-funds-for-developer-costs': {
    id: 'release-funds-for-developer-costs',
    defaultmessages: 'Request to Release Funds for Development Costs',
  },
  'release-funds-for-development-costs': {
    id: 'release-funds-for-development-costs',
    defaultmessages: 'Request to Release Funds for Development Costs',
  },
  'release-profits-after-building-completion': {
    id: 'release-profits-after-building-completion',
    defaultmessages: 'Request to Release Profits (Post-Building Completion)',
  },
  'release-profits-before-building-completion': {
    id: 'release-profits-before-building-completion',
    defaultmessages: 'Request to Release Profits (Pre-Building Completion)',
  },
  release_easement_instrument_mandatory: {
    id: 'release_easement_instrument_mandatory',
    defaultmessages: 'Release Easement Instrument (Mandatory)',
  },
  release_funds_for_development_costs: {
    id: 'release_funds_for_development_costs',
    defaultmessages: 'Release Funds for Development Costs',
  },
  release_funds_for_development_costs_description: {
    id: 'release_funds_for_development_costs_description',
    defaultmessages:
      'This service allows developers to request the release of funds from a designated Project Account to cover development costs for an Off-Plan Project.',
  },
  release_mortgage: {
    id: 'release_mortgage',
    defaultmessages: 'Release Mortgage',
  },
  release_mortgage_and_transfer_of_ownership_with_mortgage_buyout: {
    id: 'release_mortgage_and_transfer_of_ownership_with_mortgage_buyout',
    defaultmessages: 'Release mortgage and transfer of ownership with mortgage (buyout)',
  },
  release_profits_after_building_completion_description: {
    id: 'release_profits_after_building_completion_description',
    defaultmessages:
      'This service allows developers to request the release of profits from the Project Account after the Off-Plan Project achieves Building Completion.',
  },
  release_profits_before_building_completion_description: {
    id: 'release_profits_before_building_completion_description',
    defaultmessages:
      'This service allows developers to request the release of profits from the Project Account prior to the Building Completion of an Off-Plan Project.',
  },
  released_amount_receipt: {
    id: 'released_amount_receipt',
    defaultmessages: 'Released Amount Receipt',
  },
  remaining_precentage: {
    id: 'remaining_precentage',
    defaultmessages: 'Remaining: {s} %',
  },
  'remaining_share_out _of_total': {
    id: 'remaining_share_out _of_total',
    defaultmessages: '(Out of {s}) Remaining Share {s1}',
  },
  remove: {
    id: 'remove',
    defaultmessages: 'Remove',
  },
  remove_all: {
    id: 'remove_all',
    defaultmessages: 'Remove All',
  },
  remove_contact_details: {
    id: 'remove_contact_details',
    defaultmessages: 'Remove Contact Details',
  },
  remove_invalid_plot_description: {
    id: 'remove_invalid_plot_description',
    defaultmessages:
      'In order to proceed with your application, plots with issues will be removed. Are you sure you want to continue?',
  },
  remove_invalid_plot_text: {
    id: 'remove_invalid_plot_text',
    defaultmessages: 'Plots with issues are going to be removed',
  },
  remove_permissions_confirmation_text: {
    id: 'remove_permissions_confirmation_text',
    defaultmessages: 'You have to add again once the user group is removed',
  },
  remove_permissions_confirmation_title: {
    id: 'remove_permissions_confirmation_title',
    defaultmessages: 'Are you sure about removing it?',
  },
  remove_plot: {
    id: 'remove_plot',
    defaultmessages: 'Remove Plot',
  },
  remove_property: {
    id: 'remove_property',
    defaultmessages: 'Remove Property',
  },
  remove_sure: {
    id: 'remove_sure',
    defaultmessages: 'Are you sure you want to remove the condition? It will be removed permanently.',
  },
  remove_sure_term: {
    id: 'remove_sure_term',
    defaultmessages: 'It can not be retrieved once removed. Are you sure you want to proceed with the removal?',
  },
  remove_term: {
    id: 'remove_term',
    defaultmessages: 'Are you sure about removing Term {s} ?',
  },
  remove_unit: {
    id: 'remove_unit',
    defaultmessages: 'Are you sure you want to remove unit(s) from the selected property %@?',
  },
  remove_unitsV2: {
    id: 'remove_unitsV2',
    defaultmessages: 'Are you sure you want to remove unit(s) from the selected property {s}?',
  },
  'removing_cost_per property': {
    id: 'removing_cost_per property',
    defaultmessages: 'Removing property from the agreement will cost you AED 1000 per property.',
  },
  renew: {
    id: 'renew',
    defaultmessages: 'Renew',
  },
  renewal_tenancy_title: {
    id: 'renewal_tenancy_title',
    defaultmessages: 'Your lease agreement renewal application has been successfully submitted for approval',
  },
  rent: {
    id: 'rent',
    defaultmessages: 'Rent',
  },
  rent_amount: {
    id: 'rent_amount',
    defaultmessages: 'Rent Amount',
  },
  rent_collection: {
    id: 'rent_collection',
    defaultmessages: 'Rent collection on behalf of owner',
  },
  rent_contract_type: {
    id: 'rent_contract_type',
    defaultmessages: 'Rent Agreement Type',
  },
  rent_details: {
    id: 'rent_details',
    defaultmessages: 'Rent Details',
  },
  rent_free_grace_period_days: {
    id: 'rent_free_grace_period_days',
    defaultmessages: 'Rent-free Grace Period (days)',
  },
  rent_free_grace_period_days_desc: {
    id: 'rent_free_grace_period_days_desc',
    defaultmessages:
      'These are EXTRA days not affecting the end of the agreement date and not calculated as part of rent',
  },
  rent_free_grace_period_days_hint: {
    id: 'rent_free_grace_period_days_hint',
    defaultmessages: '0-90 days',
  },
  rent_free_grace_period_desc: {
    id: 'rent_free_grace_period_desc',
    defaultmessages:
      'These are EXTRA days not affecting the end of the agreement date and not calculated as part of rent',
  },
  rent_free_grace_period_error: {
    id: 'rent_free_grace_period_error',
    defaultmessages: 'Grace period cannot be more than 90 days',
  },
  rent_payment: {
    id: 'rent_payment',
    defaultmessages: 'Rent Payment',
  },
  rent_payment_details: {
    id: 'rent_payment_details',
    defaultmessages: 'Rent Payment Details',
  },
  rent_payment_sent_for_municipality: {
    id: 'rent_payment_sent_for_municipality',
    defaultmessages: 'Your rent payment application sent for Municipality review',
  },
  rent_payment_successfully_processed: {
    id: 'rent_payment_successfully_processed',
    defaultmessages: 'Your rent payment has been successfully processed',
  },
  rent_satus: {
    id: 'rent_satus',
    defaultmessages: 'Rent Status',
  },
  rental_to_musataha_sent_for_approval: {
    id: 'rental_to_musataha_sent_for_approval',
    defaultmessages: 'You have successfully sent the application for approval.',
  },
  report: {
    id: 'report',
    defaultmessages: 'Report',
  },
  representative: {
    id: 'representative',
    defaultmessages: 'Representative',
  },
  representative_detail_you: {
    id: 'representative_detail_you',
    defaultmessages: 'Representative Details',
  },
  representative_details: {
    id: 'representative_details',
    defaultmessages: 'Representative Details',
  },
  representative_documents: {
    id: 'representative_documents',
    defaultmessages: 'Representative Documents',
  },
  representative_id: {
    id: 'representative_id',
    defaultmessages: 'Representative ID',
  },
  representative_of: {
    id: 'representative_of',
    defaultmessages: 'Representative of {s}',
  },
  representative_poa: {
    id: 'representative_poa',
    defaultmessages: 'POA',
  },
  representative_second_party: {
    id: 'representative_second_party',
    defaultmessages: 'Representative (Second party)',
  },
  representative_type: {
    id: 'representative_type',
    defaultmessages: 'Representative Type',
  },
  represented_by: {
    id: 'represented_by',
    defaultmessages: 'Represented By',
  },
  representor_Id: {
    id: 'representor_Id',
    defaultmessages: 'Representative ID',
  },
  representor_name: {
    id: 'representor_name',
    defaultmessages: 'Representative Name',
  },
  'request-permit-advertisement-broker-land': {
    id: 'request-permit-advertisement-broker-land',
    defaultmessages: 'Request a Permit to Advertise on Website (Land)',
  },
  'request-permit-advertisement-broker-unit': {
    id: 'request-permit-advertisement-broker-unit',
    defaultmessages: 'Request a Permit to Advertise on Website (Unit)',
  },
  'request-valuation-certificate-land': {
    id: 'request-valuation-certificate-land',
    defaultmessages: 'Land Evaluation Certificate Issuance',
  },
  'request-valuation-certificate-unit': {
    id: 'request-valuation-certificate-unit',
    defaultmessages: 'Unit Evaluation Certificate Issuance',
  },
  request_form_completed_and_signed: {
    id: 'request_form_completed_and_signed',
    defaultmessages: 'Request Form (completed and signed)',
  },
  request_permit_advertisement_broker_land_description: {
    id: 'request_permit_advertisement_broker_land_description',
    defaultmessages:
      'This service allows licensed brokers to request a permit to advertise a land for sale on the property listing website. To ensure compliance with real estate advertising regulations and verifies the broker’s eligibility and the property’s status. Upon approval, the broker may proceed with publishing the property details online for the selected duration.',
  },
  request_permit_advertisement_broker_unit_description: {
    id: 'request_permit_advertisement_broker_unit_description',
    defaultmessages:
      'This service allows licensed brokers to request a permit to advertise a unit for sale or rent on property listing websites. To ensure compliance with real estate advertising regulations and verifies the broker’s eligibility and the property’s status. Upon approval, the broker may proceed with publishing the property details online for the selected duration.',
  },
  request_valuation_certificate_land_description: {
    id: 'request_valuation_certificate_land_description',
    defaultmessages:
      'Through this service, you can request a certificate to be issued stating the approximate value of the land for any of the following purposes: to show restrictions such as registered mortgage or investment, show the approximate value of a land, or act as an identification of the method of land acquisition.If you have a representative with a power of attorney, they can also request the same on your behalf.',
  },
  request_valuation_certificate_unit_description: {
    id: 'request_valuation_certificate_unit_description',
    defaultmessages:
      'This service allows you to request a certificate stating the approximate value of a unit. It can be used to indicate restrictions such as a registered mortgage or investment, demonstrate the unit’s approximate value, or identify the method of unit acquisition. A representative holding a valid power of attorney may also submit the request on your behalf.',
  },
  requested_by: {
    id: 'requested_by',
    defaultmessages: 'Requested by',
  },
  required_documents: {
    id: 'required_documents',
    defaultmessages: 'Required Documents',
  },
  requires_owner_approval_on_sub_lease: {
    id: 'requires_owner_approval_on_sub_lease',
    defaultmessages: "Owner's approval is required on sub-lease",
  },
  reservation_agreement: {
    id: 'reservation_agreement',
    defaultmessages: 'Reservation Agreement',
  },
  reserved_company_name: {
    id: 'reserved_company_name',
    defaultmessages: 'Reserved Trade Number',
  },
  reserved_name_placeholder: {
    id: 'reserved_name_placeholder',
    defaultmessages: 'TN-xxxxxxx',
  },
  reset_filters: {
    id: 'reset_filters',
    defaultmessages: 'Clear All',
  },
  reset_password: {
    id: 'reset_password',
    defaultmessages: 'Reset Password',
  },
  reset_password_msg: {
    id: 'reset_password_msg',
    defaultmessages: 'Enter the email address and submit the request to reset password',
  },
  residency_country: {
    id: 'residency_country',
    defaultmessages: 'Residency Country',
  },
  residency_document: {
    id: 'residency_document',
    defaultmessages: 'Residency Document',
  },
  residency_mandatory: {
    id: 'residency_mandatory',
    defaultmessages: 'Residency (Mandatory)',
  },
  residential: {
    id: 'residential',
    defaultmessages: 'Residential',
  },
  residential_AED_amount: {
    id: 'residential_AED_amount',
    defaultmessages: 'Residential: AED 1,000',
  },
  residential_breakdown: {
    id: 'residential_breakdown',
    defaultmessages: 'Residential Units Breakdown',
  },
  residential_commercial: {
    id: 'residential_commercial',
    defaultmessages: 'Residential / Commercial',
  },
  residential_units: {
    id: 'residential_units',
    defaultmessages: 'Residential Units',
  },
  resolved_case_approval_title: {
    id: 'resolved_case_approval_title',
    defaultmessages: 'You have successfully accepted the settlement terms',
  },
  resolved_case_return_title: {
    id: 'resolved_case_return_title',
    defaultmessages: 'You have successfully returned the settlement back to the mediator',
  },
  resolved_case_success_body: {
    id: 'resolved_case_success_body',
    defaultmessages: 'You can download the settlement agreed on by clicking the download button below',
  },
  resolved_case_success_title: {
    id: 'resolved_case_success_title',
    defaultmessages: 'Congratulations! The registered dispute was successfully resolved.',
  },
  resource_planning_for_managing_the_account: {
    id: 'resource_planning_for_managing_the_account',
    defaultmessages: 'Resource Planning for Managing the Account',
  },
  resubmit: {
    id: 'resubmit',
    defaultmessages: '‏Resubmit',
  },
  resubmit_for_termination: {
    id: 'resubmit_for_termination',
    defaultmessages: 'Resubmit for Termination',
  },
  resubmitted_case_approval_title: {
    id: 'resubmitted_case_approval_title',
    defaultmessages: 'You have successfully resubmitted the dispute',
  },
  results: {
    id: 'results',
    defaultmessages: '{s} Results Found',
  },
  retailUnits: {
    id: 'retailUnits',
    defaultmessages: 'Retail Units',
  },
  retention_balance: {
    id: 'retention_balance',
    defaultmessages: 'Retention Balance',
  },
  retention_balance_exclamation: {
    id: 'retention_balance_exclamation',
    defaultmessages: 'Total credited in retention account — Total debited in retention account',
  },
  retention_number: {
    id: 'retention_number',
    defaultmessages: 'Retention Number',
  },
  return: {
    id: 'return',
    defaultmessages: 'Return',
  },
  return_reason: {
    id: 'return_reason',
    defaultmessages: 'Return Reason',
  },
  return_reason_title: {
    id: 'return_reason_title',
    defaultmessages: 'Please enter your reason for returning property sales agreement',
  },
  return_reject: {
    id: 'return_reject',
    defaultmessages: 'Return / Reject',
  },
  return_to_developer: {
    id: 'return_to_developer',
    defaultmessages: 'Return to Developer',
  },
  return_waiver_musataha_title: {
    id: 'return_waiver_musataha_title',
    defaultmessages: 'Return waiver of musataha',
  },
  return_with_feedback: {
    id: 'return_with_feedback',
    defaultmessages: 'Return with Feedback',
  },
  returned_musataha_contract_title: {
    id: 'returned_musataha_contract_title',
    defaultmessages: 'Leasehold agreement registration application has been successfully returned',
  },
  reupload_sheet: {
    id: 'reupload_sheet',
    defaultmessages: 'Re-upload Sheet',
  },
  reupload_sheet_text: {
    id: 'reupload_sheet_text',
    defaultmessages: 'You can’t add plots with issues to your project, re-upload the sheet after resolving the issues',
  },
  review_Initiated_by: {
    id: 'review_Initiated_by',
    defaultmessages: 'Initiated by',
  },
  review_and_submit_the_application_to_the_designated_party_for_approval: {
    id: 'review_and_submit_the_application_to_the_designated_party_for_approval',
    defaultmessages: 'Review and submit the application to the designated party for approval',
  },
  review_contract: {
    id: 'review_contract',
    defaultmessages: 'Review Application',
  },
  revoke_authority: {
    id: 'revoke_authority',
    defaultmessages: 'Revoke Authority',
  },
  revoke_authority_description: {
    id: 'revoke_authority_description',
    defaultmessages:
      'This service is for revoking the authority of an existing Power of Attorney (POA) for a property owner.',
  },
  right_hold_type: {
    id: 'right_hold_type',
    defaultmessages: 'Right Hold Type',
  },
  right_holder_name: {
    id: 'right_holder_name',
    defaultmessages: 'Right Holder Name',
  },
  road: {
    id: 'road',
    defaultmessages: 'Road',
  },
  road_no: {
    id: 'road_no',
    defaultmessages: 'Road Number',
  },
  room: {
    id: 'room',
    defaultmessages: 'Room',
  },
  rooms: {
    id: 'rooms',
    defaultmessages: 'Rooms',
  },
  sad: {
    id: 'sad',
    defaultmessages: 'Sad',
  },
  sale: {
    id: 'sale',
    defaultmessages: 'Sale',
  },
  sale_agreement_fee: {
    id: 'sale_agreement_fee',
    defaultmessages: 'Sale Agreement Fees',
  },
  sale_agreement_fee_dmt: {
    id: 'sale_agreement_fee_dmt',
    defaultmessages: 'These are agreement charges that can be paid at the DMT appointment day.',
  },
  sale_agreement_successfully_sent_for_buyers_approval: {
    id: 'sale_agreement_successfully_sent_for_buyers_approval',
    defaultmessages:
      'You have successfully sent the sale agreement for buyers approval. You will be notified with their response.',
  },
  sale_agreement_successfully_sent_for_municipality_approval: {
    id: 'sale_agreement_successfully_sent_for_municipality_approval',
    defaultmessages:
      'You have successfully sent the sale agreement for Municipality approval. You will be notified with their response.',
  },
  sale_amount: {
    id: 'sale_amount',
    defaultmessages: 'Sale Amount',
  },
  sale_and_purchase: {
    id: 'sale_and_purchase',
    defaultmessages: 'Sale and Purchase',
  },
  sale_desc: {
    id: 'sale_desc',
    defaultmessages: 'Sell and Purchase Property in Abu Dhabi',
  },
  sale_market_data: {
    id: 'sale_market_data',
    defaultmessages: 'Sale',
  },
  sale_price: {
    id: 'sale_price',
    defaultmessages: 'Sale Price',
  },
  sale_purchase_application_completed_successfully: {
    id: 'sale_purchase_application_completed_successfully',
    defaultmessages: 'Sale and purchase application completed successfully',
  },
  sale_purchase_application_submitted: {
    id: 'sale_purchase_application_submitted',
    defaultmessages: 'Sale and purchase application submitted successfully',
  },
  sale_purchase_application_submitted_desc: {
    id: 'sale_purchase_application_submitted_desc',
    defaultmessages:
      "You have successfully sent the application for other owners' approval. You will be notified with their response.",
  },
  sale_purchase_contract_will_be_issued_after_virtual_call: {
    id: 'sale_purchase_contract_will_be_issued_after_virtual_call',
    defaultmessages: 'The sale and purchase agreement will be issued at the end of the virtual call appointments',
  },
  sale_value: {
    id: 'sale_value',
    defaultmessages: 'Sale Value',
  },
  sale_volume: {
    id: 'sale_volume',
    defaultmessages: 'Sale Volume',
  },
  sales_data: {
    id: 'sales_data',
    defaultmessages: 'Sales Data',
  },
  sales_emirate_title: {
    id: 'sales_emirate_title',
    defaultmessages: 'Sales in Emirate of Abu Dhabi',
  },
  save: {
    id: 'save',
    defaultmessages: 'Save',
  },
  save_and_continue_next_unit: {
    id: 'save_and_continue_next_unit',
    defaultmessages: 'Save & Continue to Next Unit',
  },
  save_as_pdf: {
    id: 'save_as_pdf',
    defaultmessages: 'Save as PDF',
  },
  save_changes: {
    id: 'save_changes',
    defaultmessages: 'Save Changes',
  },
  schedule_appointment: {
    id: 'schedule_appointment',
    defaultmessages: ' Schedule Appointment',
  },
  schedule_deactivate: {
    id: 'schedule_deactivate',
    defaultmessages: 'Schedule Account Deactivation',
  },
  scheduled_meeting_link: {
    id: 'scheduled_meeting_link',
    defaultmessages: 'Scheduled Meeting Link',
  },
  search: {
    id: 'search',
    defaultmessages: 'Show Results',
  },
  search_and_agreement_start_service: {
    id: 'search_and_agreement_start_service',
    defaultmessages: 'Search and select an agreement to start the service',
  },
  search_and_select_property_to_start_the_service: {
    id: 'search_and_select_property_to_start_the_service',
    defaultmessages: 'Search and select a property to start the service',
  },
  search_and_select_sroperty_to_start_the_service: {
    id: 'search_and_select_sroperty_to_start_the_service',
    defaultmessages: 'Search and Select a Property to Initiate the Service',
  },
  search_buyer_by_passport_number_info: {
    id: 'search_buyer_by_passport_number_info',
    defaultmessages:
      'To search for a specific buyer, please specify the passport number.\nMoreover, you can use any of the other search parameters to find the desired buyer.',
  },
  search_by: {
    id: 'search_by',
    defaultmessages: 'Search by',
  },
  search_by_employee_name: {
    id: 'search_by_employee_name',
    defaultmessages: 'Search by employee name',
  },
  search_by_name: {
    id: 'search_by_name',
    defaultmessages: 'Search by Name',
  },
  search_by_name_or_number: {
    id: 'search_by_name_or_number',
    defaultmessages: 'Search by name or number',
  },
  search_for_a_profession_by_name: {
    id: 'search_for_a_profession_by_name',
    defaultmessages: 'Search for a profession by name',
  },
  search_for_a_project_by_name: {
    id: 'search_for_a_project_by_name',
    defaultmessages: 'Search by project name/number',
  },
  search_for_a_project_byname: {
    id: 'search_for_a_project_byname',
    defaultmessages: 'Search for a project by name',
  },
  search_for_location_by_name: {
    id: 'search_for_location_by_name',
    defaultmessages: 'Search for location by name',
  },
  search_for_non_UAE_resident_buyer: {
    id: 'search_for_non_UAE_resident_buyer',
    defaultmessages: 'Search for non-UAE resident buyer',
  },
  search_project_number: {
    id: 'search_project_number',
    defaultmessages: 'Search Project Number',
  },
  search_property: {
    id: 'search_property',
    defaultmessages: 'Search Property',
  },
  search_service: {
    id: 'search_service',
    defaultmessages: 'Search Service',
  },
  search_service_provider_card_title: {
    id: 'search_service_provider_card_title',
    defaultmessages: 'Enter the trade license number or the name of the service provider',
  },
  search_text: {
    id: 'search_text',
    defaultmessages: 'Search',
  },
  second_party: {
    id: 'second_party',
    defaultmessages: 'Second Party',
  },
  second_party_type: {
    id: 'second_party_type',
    defaultmessages: 'Second Party Type',
  },
  'secondary-developer': {
    id: 'secondary-developer',
    defaultmessages: 'Secondary Developer',
  },
  secondary_musateh_details: {
    id: 'secondary_musateh_details',
    defaultmessages: 'Secondary Musateh Details',
  },
  sector: {
    id: 'sector',
    defaultmessages: 'Sector',
  },
  see_all_demands: {
    id: 'see_all_demands',
    defaultmessages: 'See All Demands',
  },
  see_all_tasks: {
    id: 'see_all_tasks',
    defaultmessages: 'See All Tasks',
  },
  see_all_terms: {
    id: 'see_all_terms',
    defaultmessages: 'See All Terms',
  },
  see_less: {
    id: 'see_less',
    defaultmessages: 'See Less',
  },
  see_less_demands: {
    id: 'see_less_demands',
    defaultmessages: 'See Fewer Demands',
  },
  see_less_terms: {
    id: 'see_less_terms',
    defaultmessages: 'See Fewer Terms',
  },
  sel_appoinemt_location_map: {
    id: 'sel_appoinemt_location_map',
    defaultmessages: 'Select appointment location on map',
  },
  select: {
    id: 'select',
    defaultmessages: 'Select',
  },
  select_a_project: {
    id: 'select_a_project',
    defaultmessages: 'Select a Project',
  },
  select_a_surveyor: {
    id: 'select_a_surveyor',
    defaultmessages: 'Select a Surveyor',
  },
  select_all: {
    id: 'select_all',
    defaultmessages: 'Select All',
  },
  select_all_on_page: {
    id: 'select_all_on_page',
    defaultmessages: 'Select all on page',
  },
  select_all_units_under_this_building: {
    id: 'select_all_units_under_this_building',
    defaultmessages: 'Select all units under this building',
  },
  select_an_option: {
    id: 'select_an_option',
    defaultmessages: 'Select an Option',
  },
  select_applicaiton_type: {
    id: 'select_applicaiton_type',
    defaultmessages: 'Select Application Type',
  },
  select_appoiment_location: {
    id: 'select_appoiment_location',
    defaultmessages: 'Select Appointment Location',
  },
  select_appoinment_option: {
    id: 'select_appoinment_option',
    defaultmessages: 'Select one of the options to complete the sale transaction in the municipality records',
  },
  select_appointment_slot_info: {
    id: 'select_appointment_slot_info',
    defaultmessages: 'The application has been approved by Municipality, please choose your preferred appointment slot',
  },
  select_bank: {
    id: 'select_bank',
    defaultmessages: 'Select Bank',
  },
  select_certificate_date: {
    id: 'select_certificate_date',
    defaultmessages: 'Select Certificate Date',
  },
  select_contract: {
    id: 'select_contract',
    defaultmessages: 'Select Agreement',
  },
  select_dari_office: {
    id: 'select_dari_office',
    defaultmessages: 'Select AccessRP Office',
  },
  select_date: {
    id: 'select_date',
    defaultmessages: 'Select Date',
  },
  select_if_elife: {
    id: 'select_if_elife',
    defaultmessages: 'Select if you would like new eLife or support',
  },
  select_installment: {
    id: 'select_installment',
    defaultmessages: 'Select Installments',
  },
  select_issue: {
    id: 'select_issue',
    defaultmessages: 'Select Issue',
  },
  select_lease_properties: {
    id: 'select_lease_properties',
    defaultmessages: 'Select Lease Properties',
  },
  select_method: {
    id: 'select_method',
    defaultmessages: 'Select Method',
  },
  select_mortgage_shares: {
    id: 'select_mortgage_shares',
    defaultmessages: 'Select Mortgage Shares',
  },
  select_musataha_property: {
    id: 'select_musataha_property',
    defaultmessages: 'Select Musataha Property',
  },
  select_notice_reason: {
    id: 'select_notice_reason',
    defaultmessages: 'Select notice reason',
  },
  select_occupant_to_proceed: {
    id: 'select_occupant_to_proceed',
    defaultmessages: 'Please add at least one occupant to proceed',
  },
  select_owners: {
    id: 'select_owners',
    defaultmessages: 'Select Owners',
  },
  select_ownership_property: {
    id: 'select_ownership_property',
    defaultmessages: 'Select the property ownership type',
  },
  select_parties: {
    id: 'select_parties',
    defaultmessages: 'Select the involved parties to proceed with the application',
  },
  select_permissions: {
    id: 'select_permissions',
    defaultmessages: 'Select Permissions',
  },
  select_plots_manually: {
    id: 'select_plots_manually',
    defaultmessages: 'Select plots manually',
  },
  select_primary_contact_popup_title: {
    id: 'select_primary_contact_popup_title',
    defaultmessages: 'Select primary contact you want to use',
  },
  select_project: {
    id: 'select_project',
    defaultmessages: 'Select Project',
  },
  select_project_before_proceeding: {
    id: 'select_project_before_proceeding',
    defaultmessages: 'Project selection is required. Please choose a project before continuing.',
  },
  select_properties: {
    id: 'select_properties',
    defaultmessages: 'Select Properties',
  },
  select_property: {
    id: 'select_property',
    defaultmessages: 'Select Property',
  },
  select_property_before_proceeding: {
    id: 'select_property_before_proceeding',
    defaultmessages: 'Property selection is required. Please choose one before continuing.',
  },
  select_representative_poa: {
    id: 'select_representative_poa',
    defaultmessages: 'Select Representative (Power of attorney)',
  },
  select_selling_shares: {
    id: 'select_selling_shares',
    defaultmessages: 'Select selling shares',
  },
  select_the_approval_process: {
    id: 'select_the_approval_process',
    defaultmessages: 'Select the approval process',
  },
  select_the_broker_if_the_initiator_is_not_the_broker: {
    id: 'select_the_broker_if_the_initiator_is_not_the_broker',
    defaultmessages: 'Select the broker (if the initiator is not the broker)',
  },
  select_the_initiator_type_and_choose_the_permit_type_and_duration: {
    id: 'select_the_initiator_type_and_choose_the_permit_type_and_duration',
    defaultmessages: 'Select the initiator type and Choose the permit type and duration',
  },
  select_the_project_registration_status: {
    id: 'select_the_project_registration_status',
    defaultmessages: 'Select the project registration status',
  },
  select_the_property: {
    id: 'select_the_property',
    defaultmessages: 'Select the property',
  },
  select_the_property_type: {
    id: 'select_the_property_type',
    defaultmessages: 'Select the property type',
  },
  selected: {
    id: 'selected',
    defaultmessages: 'Selected',
  },
  selected_S_provider_title: {
    id: 'selected_S_provider_title',
    defaultmessages: 'Selected Service Provider',
  },
  selected_appointment_type_for_verification_attendance: {
    id: 'selected_appointment_type_for_verification_attendance',
    defaultmessages: 'Selected appointment type for verification attendance.',
  },
  selected_bank: {
    id: 'selected_bank',
    defaultmessages: 'Mortgagor Bank',
  },
  selected_plots: {
    id: 'selected_plots',
    defaultmessages: 'Selected Plots ({s})',
  },
  selected_properties: {
    id: 'selected_properties',
    defaultmessages: 'Selected Properties',
  },
  selected_properties_count: {
    id: 'selected_properties_count',
    defaultmessages: 'Next {count} Selected',
  },
  selected_property: {
    id: 'selected_property',
    defaultmessages: 'Selected Property',
  },
  selected_units: {
    id: 'selected_units',
    defaultmessages: '{s} unit(s) selected',
  },
  sell_all_shares: {
    id: 'sell_all_shares',
    defaultmessages: 'Sell all shares',
  },
  sell_and_mortgage: {
    id: 'sell_and_mortgage',
    defaultmessages: 'Sell and Mortgage',
  },
  sell_and_release_mortgage: {
    id: 'sell_and_release_mortgage',
    defaultmessages: 'Sell and Release Mortgage',
  },
  sell_approve_text: {
    id: 'sell_approve_text',
    defaultmessages: 'We will send your response to the seller',
  },
  sell_approve_title: {
    id: 'sell_approve_title',
    defaultmessages: 'You approved the property sale agreement!',
  },
  sell_mortgaged_property_with_new_mortgage_registration: {
    id: 'sell_mortgaged_property_with_new_mortgage_registration',
    defaultmessages: 'Sell Mortgaged Property with New Mortgage Registration',
  },
  sell_percentage: {
    id: 'sell_percentage',
    defaultmessages: 'Selling Percentage',
  },
  sell_purchase: {
    id: 'sell_purchase',
    defaultmessages: 'Sell and Purchase',
  },
  sell_purchase_breadcrumbs: {
    id: 'sell_purchase_breadcrumbs',
    defaultmessages: 'Sell',
  },
  sell_rejection_text: {
    id: 'sell_rejection_text',
    defaultmessages: 'Your sale agreement edit has been forwarded to the initiator with feedback',
  },
  sell_rejection_title: {
    id: 'sell_rejection_title',
    defaultmessages: 'Agreement edit successfully sent',
  },
  sell_specific_shares: {
    id: 'sell_specific_shares',
    defaultmessages: 'Sell specific shares',
  },
  seller: {
    id: 'seller',
    defaultmessages: 'Seller',
  },
  'seller_#num': {
    id: 'seller_#num',
    defaultmessages: 'Seller #{num}',
  },
  seller_approval: {
    id: 'seller_approval',
    defaultmessages: 'Seller Approval',
  },
  seller_attende_list: {
    id: 'seller_attende_list',
    defaultmessages: 'Seller’s Attendees List',
  },
  seller_documents: {
    id: 'seller_documents',
    defaultmessages: "Seller's Documents",
  },
  seller_num: {
    id: 'seller_num',
    defaultmessages: 'Seller #',
  },
  seller_payment_completed: {
    id: 'seller_payment_completed',
    defaultmessages: 'You have successfully completed the seller payment.',
  },
  seller_reject: {
    id: 'seller_reject',
    defaultmessages: 'Seller Rejection',
  },
  sellers: {
    id: 'sellers',
    defaultmessages: 'Sellers',
  },
  selling_agreement_mandatory: {
    id: 'selling_agreement_mandatory',
    defaultmessages: 'Signed Buy and Sell Agreement (Mandatory)',
  },
  selling_and_buying_percentage_should_be_greater_than_0: {
    id: 'selling_and_buying_percentage_should_be_greater_than_0',
    defaultmessages: 'Selling and buying percentage should be greater than 0',
  },
  selling_and_buying_percentage_should_equal: {
    id: 'selling_and_buying_percentage_should_equal',
    defaultmessages: 'Selling and buying percentage should be equal',
  },
  selling_detail: {
    id: 'selling_detail',
    defaultmessages: 'Selling Details',
  },
  selling_details: {
    id: 'selling_details',
    defaultmessages: 'Sale Details',
  },
  selling_percentage: {
    id: 'selling_percentage',
    defaultmessages: 'Sale Percentage',
  },
  selling_price: {
    id: 'selling_price',
    defaultmessages: 'Selling Price',
  },
  selling_price_must_greater_than_zero: {
    id: 'selling_price_must_greater_than_zero',
    defaultmessages: 'Selling price must be greater than 0',
  },
  selling_price_warning_to_developer: {
    id: 'selling_price_warning_to_developer',
    defaultmessages:
      'A late filing fee of AED 10,000 will be charged to the developer if the registration date exceeds 30 days from the actual date of sale.',
  },
  selling_share_is_required: {
    id: 'selling_share_is_required',
    defaultmessages: 'Selling share is required',
  },
  selling_share_should_be_less_than_property_share: {
    id: 'selling_share_should_be_less_than_property_share',
    defaultmessages: 'Selling shares should be equal to or less than property shares.',
  },
  selling_shares: {
    id: 'selling_shares',
    defaultmessages: 'Selling Shares',
  },
  selling_shares_guideline: {
    id: 'selling_shares_guideline',
    defaultmessages:
      'To sell 100% of your shares, please select this checkbox or enter a specific percentage in the field below if you are selling \nless than 100% of your shares',
  },
  selling_value: {
    id: 'selling_value',
    defaultmessages: 'Selling Value',
  },
  sellpurchase_success_payment_text: {
    id: 'sellpurchase_success_payment_text',
    defaultmessages: 'The buyer has also been notified and will meet you there at the same time',
  },
  sellpurchase_success_payment_title: {
    id: 'sellpurchase_success_payment_title',
    defaultmessages: 'Your appointment has been successfully booked',
  },
  sent_the_application_for_buyer_approval: {
    id: 'sent_the_application_for_buyer_approval',
    defaultmessages:
      'You have successfully sent the application for buyer’s approval. Please check the application later on to check their response.',
  },
  service: {
    id: 'service',
    defaultmessages: 'Service',
  },
  service_charge: {
    id: 'service_charge',
    defaultmessages: 'Service Charges',
  },
  service_charges_sqft: {
    id: 'service_charges_sqft',
    defaultmessages: 'Service Charges (per sq. ft.)',
  },
  service_description: {
    id: 'service_description',
    defaultmessages: 'Service Description',
  },
  service_fee: {
    id: 'service_fee',
    defaultmessages: 'Service Fee',
  },
  service_fee_aed: {
    id: 'service_fee_aed',
    defaultmessages: 'Service Fee: AED {p}',
  },
  service_inquiry: {
    id: 'service_inquiry',
    defaultmessages: 'Service Inquiry',
  },
  service_provider_approval_title: {
    id: 'service_provider_approval_title',
    defaultmessages:
      'You have approved the Request Payment Approval from Real Estate Project Escrow Account application successfully.',
  },
  service_provider_paid_title: {
    id: 'service_provider_paid_title',
    defaultmessages: 'You have successfully paid for the service providers',
  },
  service_provider_return_subtitle: {
    id: 'service_provider_return_subtitle',
    defaultmessages: 'Your application will be forwarded to the initiator to take the necessary action.',
  },
  service_provider_return_title: {
    id: 'service_provider_return_title',
    defaultmessages:
      'You have returned the Request Payment Approval from Real Estate Project Escrow Account application successfully.',
  },
  service_providers: {
    id: 'service_providers',
    defaultmessages: 'Service Providers',
  },
  service_providers_payment_approval: {
    id: 'service_providers_payment_approval',
    defaultmessages: 'Request Payment Approval from Real Estate Project Escrow Account',
  },
  service_status: {
    id: 'service_status',
    defaultmessages: 'Service Status',
  },
  service_unavailable: {
    id: 'service_unavailable',
    defaultmessages:
      'This service is coming soon. If you want to sell a property to a buyer paying via mortgage, please visit your nearest DMT service center.',
  },
  service_unavailable_for_non_resident: {
    id: 'service_unavailable_for_non_resident',
    defaultmessages: 'This service is currently unavailable for non-UAE residents, it will be enabled soon',
  },
  service_unavailable_title: {
    id: 'service_unavailable_title',
    defaultmessages: 'Service Unavailable',
  },
  session_info_title: {
    id: 'session_info_title',
    defaultmessages: 'Session Information',
  },
  set_password: {
    id: 'set_password',
    defaultmessages: 'Set Password',
  },
  settled: {
    id: 'settled',
    defaultmessages: 'Settled',
  },
  settlement: {
    id: 'settlement',
    defaultmessages: 'Settlement',
  },
  share_for_each_buyer: {
    id: 'share_for_each_buyer',
    defaultmessages: 'Please add mortgage share for each buyer!',
  },
  share_percent: {
    id: 'share_percent',
    defaultmessages: 'Share %',
  },
  share_percentage: {
    id: 'share_percentage',
    defaultmessages: 'Share Percentage',
  },
  shared_premise_id: {
    id: 'shared_premise_id',
    defaultmessages: 'Shared Premise ID',
  },
  shares_restriction: {
    id: 'shares_restriction',
    defaultmessages: 'Please select between {min} and {max}',
  },
  short_term: {
    id: 'short_term',
    defaultmessages: 'Short Term',
  },
  short_term_helper: {
    id: 'short_term_helper',
    defaultmessages: 'An agreement of 0 to 4 years is considered short-term.',
  },
  show_less: {
    id: 'show_less',
    defaultmessages: 'Show Less',
  },
  show_less_filter: {
    id: 'show_less_filter',
    defaultmessages: 'Fewer Filters',
  },
  show_more: {
    id: 'show_more',
    defaultmessages: 'Show More',
  },
  show_more_filter: {
    id: 'show_more_filter',
    defaultmessages: 'All Filters',
  },
  sign_in: {
    id: 'sign_in',
    defaultmessages: 'Sign In',
  },
  sign_in_dari_message: {
    id: 'sign_in_dari_message',
    defaultmessages: 'Log In/Sign Up',
  },
  sign_up: {
    id: 'sign_up',
    defaultmessages: 'Sign Up',
  },
  sign_with_UAE_pass: {
    id: 'sign_with_UAE_pass',
    defaultmessages: 'Sign in with the UAE PASS',
  },
  sign_with_eid_error_msg: {
    id: 'sign_with_eid_error_msg',
    defaultmessages: 'This ID number is incorrect',
  },
  sign_with_eid_number: {
    id: 'sign_with_eid_number',
    defaultmessages: 'Login using your EID number',
  },
  sign_with_uae_pass: {
    id: 'sign_with_uae_pass',
    defaultmessages: 'Sign with the UAE PASS',
  },
  sign_with_unified_number: {
    id: 'sign_with_unified_number',
    defaultmessages: 'Continue using your Unified Number',
  },
  signatory_role: {
    id: 'signatory_role',
    defaultmessages: 'Signatory Role',
  },
  signin_emirates_label: {
    id: 'signin_emirates_label',
    defaultmessages: 'EID Number',
  },
  signin_emirates_title: {
    id: 'signin_emirates_title',
    defaultmessages: 'Sign in with your EID number',
  },
  signin_unified_title: {
    id: 'signin_unified_title',
    defaultmessages: 'Sign in with your Unified Number',
  },
  single_unit: {
    id: 'single_unit',
    defaultmessages: 'Single Unit',
  },
  slot: {
    id: 'slot',
    defaultmessages: 'Slot',
  },
  soft_update_title: {
    id: 'soft_update_title',
    defaultmessages: 'A newer version is here',
  },
  sold: {
    id: 'sold',
    defaultmessages: 'Sold',
  },
  sold_units: {
    id: 'sold_units',
    defaultmessages: 'Sold Units',
  },
  some_items_not_editable_due_to_Terms_conditions: {
    id: 'some_items_not_editable_due_to_Terms_conditions',
    defaultmessages: 'Some items are not editable due to the agreement terms & conditions.',
  },
  some_plots_are_listed_in_another_project_only_pdf_file_is_supported: {
    id: 'some_plots_are_listed_in_another_project_only_pdf_file_is_supported',
    defaultmessages: 'Some plots are listed in another project. Only PDF file is supported.',
  },
  source_emirate: {
    id: 'source_emirate',
    defaultmessages: 'Source Emirate',
  },
  source_hint: {
    id: 'source_hint',
    defaultmessages: 'Ex. Abu Dhabi',
  },
  specific_percentage: {
    id: 'specific_percentage',
    defaultmessages: 'Specific Percentage',
  },
  specific_shares: {
    id: 'specific_shares',
    defaultmessages: 'Specific Shares',
  },
  start_a_service_now: {
    id: 'start_a_service_now',
    defaultmessages: 'Start a Service Now',
  },
  start_application: {
    id: 'start_application',
    defaultmessages: 'Start Application',
  },
  start_date: {
    id: 'start_date',
    defaultmessages: 'Start Date',
  },
  start_date_is_required: {
    id: 'start_date_is_required',
    defaultmessages: 'Start date is required',
  },
  start_the_application: {
    id: 'start_the_application',
    defaultmessages: 'Start the Application',
  },
  status: {
    id: 'status',
    defaultmessages: 'Status',
  },
  statutory_charges: {
    id: 'statutory_charges',
    defaultmessages: 'Statutory Charges',
  },
  striked_case_approved_title: {
    id: 'striked_case_approved_title',
    defaultmessages: 'This case was striked by the mediator',
  },
  striked_case_completed_body: {
    id: 'striked_case_completed_body',
    defaultmessages: 'You can download the striked dispute letter using the button below',
  },
  striked_case_completed_title: {
    id: 'striked_case_completed_title',
    defaultmessages: 'As no action was taken, the center has decided to strike the dispute',
  },
  striked_case_rejected_title: {
    id: 'striked_case_rejected_title',
    defaultmessages: 'You have successfully returned the strike decision',
  },
  studio: {
    id: 'studio',
    defaultmessages: 'Studio',
  },
  subPma_agreement_title: {
    id: 'subPma_agreement_title',
    defaultmessages: '',
  },
  sub_lease: {
    id: 'sub_lease',
    defaultmessages: 'Sub-Lease',
  },
  sub_lease_only_commercial: {
    id: 'sub_lease_only_commercial',
    defaultmessages: 'Sub-lease (Commercial Use Only)',
  },
  sub_lease_permissions: {
    id: 'sub_lease_permissions',
    defaultmessages: 'Sub-lease Permissions',
  },
  sub_pma: {
    id: 'sub_pma',
    defaultmessages: 'Sub PMA',
  },
  sub_pma_contract_no: {
    id: 'sub_pma_contract_no',
    defaultmessages: '',
  },
  sub_pma_post_approve_title: {
    id: 'sub_pma_post_approve_title',
    defaultmessages: '',
  },
  sub_pma_post_reject_title: {
    id: 'sub_pma_post_reject_title',
    defaultmessages: '',
  },
  sub_pma_post_return_title: {
    id: 'sub_pma_post_return_title',
    defaultmessages: '',
  },
  sub_pma_sub_title: {
    id: 'sub_pma_sub_title',
    defaultmessages: '',
  },
  sub_pma_success_title: {
    id: 'sub_pma_success_title',
    defaultmessages: '',
  },
  sub_project_name: {
    id: 'sub_project_name',
    defaultmessages: 'Sub-Project Name',
  },
  subject: {
    id: 'subject',
    defaultmessages: 'Subject',
  },
  subject_cannot_be_empty: {
    id: 'subject_cannot_be_empty',
    defaultmessages: 'Subject Required',
  },
  submit: {
    id: 'submit',
    defaultmessages: 'Submit',
  },
  submit_agreement: {
    id: 'submit_agreement',
    defaultmessages: 'Submit Agreement',
  },
  submit_application: {
    id: 'submit_application',
    defaultmessages: 'Submit Application',
  },
  submit_application_for_developer_approval: {
    id: 'submit_application_for_developer_approval',
    defaultmessages: 'Submit application for developer approval',
  },
  submit_application_for_other_owner_and_other_partys_approval: {
    id: 'submit_application_for_other_owner_and_other_partys_approval',
    defaultmessages: 'Submit the application for approval by the other owner and involved parties',
  },
  submit_changes: {
    id: 'submit_changes',
    defaultmessages: 'Submit Changes',
  },
  submit_edit: {
    id: 'submit_edit',
    defaultmessages: 'Submit with Edit',
  },
  submit_for_approval: {
    id: 'submit_for_approval',
    defaultmessages: 'Submit for Approval',
  },
  submit_form_warning: {
    id: 'submit_form_warning',
    defaultmessages: 'After submitting this form, data cannot be edited. Are you sure you want to proceed?',
  },
  submit_form_warning_title: {
    id: 'submit_form_warning_title',
    defaultmessages: 'Are you sure you want to proceed?',
  },
  submit_reject: {
    id: 'submit_reject',
    defaultmessages: 'Submit Rejection',
  },
  submit_reject_V2: {
    id: 'submit_reject_V2',
    defaultmessages: 'Submit Reject',
  },
  submit_rejection: {
    id: 'submit_rejection',
    defaultmessages: 'Submit Feedback',
  },
  submit_return: {
    id: 'submit_return',
    defaultmessages: 'Submit Return',
  },
  submit_terminate: {
    id: 'submit_terminate',
    defaultmessages: 'Submit Termination',
  },
  submit_the_application: {
    id: 'submit_the_application',
    defaultmessages: 'Submit',
  },
  submits_the_application_for_admin__approval: {
    id: 'submits_the_application_for_admin__approval',
    defaultmessages: 'Submit the application for ADGM Admin approval',
  },
  submits_the_application_for_verification_and_ADGM_approval: {
    id: 'submits_the_application_for_verification_and_ADGM_approval',
    defaultmessages: 'Submit the Application for Verification and ADGM Approval (first time only)',
  },
  success: {
    id: 'success',
    defaultmessages: 'Success',
  },
  suggested_appointment_slots: {
    id: 'suggested_appointment_slots',
    defaultmessages: '',
  },
  supervisor_court_letter: {
    id: 'supervisor_court_letter',
    defaultmessages: 'Supervisor Court Letter',
  },
  supporting_documents_if_applicable: {
    id: 'supporting_documents_if_applicable',
    defaultmessages: 'Supporting Documents (if applicable)',
  },
  sure_remove_this_property: {
    id: 'sure_remove_this_property',
    defaultmessages: 'Are you sure want to remove this property?',
  },
  surrender: {
    id: 'surrender',
    defaultmessages: 'Surrender',
  },
  surrender_agreement_signed_by_both_parties: {
    id: 'surrender_agreement_signed_by_both_parties',
    defaultmessages: 'Surrender Agreement (signed by both parties)',
  },
  survey_status: {
    id: 'survey_status',
    defaultmessages: 'Survey Status',
  },
  surveying_company: {
    id: 'surveying_company',
    defaultmessages: 'Surveying Company',
  },
  surveying_consultant_documents: {
    id: 'surveying_consultant_documents',
    defaultmessages: 'Surveying Consultant Documents',
  },
  surveyor_company: {
    id: 'surveyor_company',
    defaultmessages: 'Surveyor Company',
  },
  surveyor_employee: {
    id: 'surveyor_employee',
    defaultmessages: 'Surveyor Employee',
  },
  surveyor_filters: {
    id: 'surveyor_filters',
    defaultmessages: 'Surveyor Filters',
  },
  surveyor_name: {
    id: 'surveyor_name',
    defaultmessages: 'Surveyor Name',
  },
  surveyors: {
    id: 'surveyors',
    defaultmessages: 'Surveyors',
  },
  switch_to_Professional: {
    id: 'switch_to_Professional',
    defaultmessages: 'Switch Account',
  },
  switch_to_personal_profile_content: {
    id: 'switch_to_personal_profile_content',
    defaultmessages:
      'To update your information, you will be switched to your personal profile. Would you like to proceed?',
  },
  switch_to_personal_profile_title: {
    id: 'switch_to_personal_profile_title',
    defaultmessages: 'Switch to your personal profile',
  },
  switch_to_professional_title: {
    id: 'switch_to_professional_title',
    defaultmessages: 'Switch profile to professional',
  },
  t_added_any_service_provider: {
    id: 't_added_any_service_provider',
    defaultmessages: 'You have not added any service provider',
  },
  t_min: {
    id: 't_min',
    defaultmessages: '{m} min',
  },
  tab_all: {
    id: 'tab_all',
    defaultmessages: 'All',
  },
  tab_credit: {
    id: 'tab_credit',
    defaultmessages: 'Credit/Debit Card',
  },
  tab_wallet: {
    id: 'tab_wallet',
    defaultmessages: 'Wallet',
  },
  table_of_contents: {
    id: 'table_of_contents',
    defaultmessages: 'Table of Contents',
  },
  task_notification: {
    id: 'task_notification',
    defaultmessages: 'You have ({s}) new tasks',
  },
  task_status: {
    id: 'task_status',
    defaultmessages: 'Task Status',
  },
  tasks: {
    id: 'tasks',
    defaultmessages: 'Tasks',
  },
  tawtheeq_enrolment: {
    id: 'tawtheeq_enrolment',
    defaultmessages: 'Tawtheeq Registration',
  },
  tawtheeq_registration_fees: {
    id: 'tawtheeq_registration_fees',
    defaultmessages: 'Tawtheeq Registration Fees',
  },
  tawtheeq_registration_fees_property_hint: {
    id: 'tawtheeq_registration_fees_property_hint',
    defaultmessages: 'Registration fee of building (AED 900) has been paid by the developer',
  },
  tawtheeq_registration_fees_unit_hint: {
    id: 'tawtheeq_registration_fees_unit_hint',
    defaultmessages: 'Registration fee of unit (AED 5) has been paid by the owner',
  },
  team_investigate: {
    id: 'team_investigate',
    defaultmessages: 'Our team will investigate your concern thoroughly',
  },
  technical: {
    id: 'technical',
    defaultmessages: 'Technical',
  },
  technical_issue: {
    id: 'technical_issue',
    defaultmessages: 'Technical Issue',
  },
  technical_issue_title: {
    id: 'technical_issue_title',
    defaultmessages: 'Something went wrong',
  },
  templates: {
    id: 'templates',
    defaultmessages: 'Templates',
  },
  ten_name: {
    id: 'ten_name',
    defaultmessages: 'Name',
  },
  ten_name_hint: {
    id: 'ten_name_hint',
    defaultmessages: 'First + Last Name',
  },
  tenancy_contract: {
    id: 'tenancy_contract',
    defaultmessages: 'Lease AgreementS',
  },
  tenancy_contract_button_text: {
    id: 'tenancy_contract_button_text',
    defaultmessages: 'Verify',
  },
  tenancy_contract_format: {
    id: 'tenancy_contract_format',
    defaultmessages: '000000000',
  },
  tenancy_contract_has_been_successfully_closed: {
    id: 'tenancy_contract_has_been_successfully_closed',
    defaultmessages: 'Your lease agreement has been successfully closed',
  },
  tenancy_contract_modification_within_seven_days_note: {
    id: 'tenancy_contract_modification_within_seven_days_note',
    defaultmessages:
      'Kindly note that you can variate your lease agreement within 7 days from its start date, noting that after the 7 days, you can only variate the premise ID and adding/removing occupants.',
  },
  tenancy_placeholder: {
    id: 'tenancy_placeholder',
    defaultmessages: 'Please enter lease agreement number',
  },
  tenant: {
    id: 'tenant',
    defaultmessages: 'Lessee',
  },
  tenant_acceptance_information: {
    id: 'tenant_acceptance_information',
    defaultmessages: 'Lessee has accepted the agreement. Sign and pay the fee to formally register the agreement.',
  },
  tenant_contract_submitted_success_DMT: {
    id: 'tenant_contract_submitted_success_DMT',
    defaultmessages: 'Your expiry of Lease agreement has been forwarded successfully to ADGM for approval',
  },
  tenant_details: {
    id: 'tenant_details',
    defaultmessages: 'Lessee Details',
  },
  tenant_has_returned_the_contract: {
    id: 'tenant_has_returned_the_contract',
    defaultmessages: 'Lessee has returned the application',
  },
  tenant_id_license_number: {
    id: 'tenant_id_license_number',
    defaultmessages: 'Lessee ID/License Number',
  },
  tenant_id_liscence_number: {
    id: 'tenant_id_liscence_number',
    defaultmessages: 'Lessee ID/License Number',
  },
  tenant_id_liscence_number_eg: {
    id: 'tenant_id_liscence_number_eg',
    defaultmessages: 'Any UAE license issued number goes here (e.g. 123456 or CN-12345)',
  },
  tenant_is_the_occupant: {
    id: 'tenant_is_the_occupant',
    defaultmessages: 'Lessee is the occupant',
  },
  tenant_lease_success_text: {
    id: 'tenant_lease_success_text',
    defaultmessages: 'We will send you a notification once the registration is completed and signed.',
  },
  tenant_lease_success_title: {
    id: 'tenant_lease_success_title',
    defaultmessages: 'You signed your agreement successfully',
  },
  tenant_name: {
    id: 'tenant_name',
    defaultmessages: 'Lessee Name',
  },
  tenant_num: {
    id: 'tenant_num',
    defaultmessages: 'Lessee #{s}',
  },
  tenant_phone_number: {
    id: 'tenant_phone_number',
    defaultmessages: 'Lessee Phone Number',
  },
  tenant_rejection_title: {
    id: 'tenant_rejection_title',
    defaultmessages: 'The application has been successfully returned',
  },
  tenant_review_title: {
    id: 'tenant_review_title',
    defaultmessages: 'Agreement returned successfully.',
  },
  tenant_type: {
    id: 'tenant_type',
    defaultmessages: 'Lessee Type',
  },
  tennacy_owner_reject_title: {
    id: 'tennacy_owner_reject_title',
    defaultmessages: 'Agreement rejected successfully',
  },
  term: {
    id: 'term',
    defaultmessages: 'Term',
  },
  term_ar_web: {
    id: 'term_ar_web',
    defaultmessages: 'الشرط رقم {s} ( بالعربي)',
  },
  term_en_web: {
    id: 'term_en_web',
    defaultmessages: 'Term {s} (English)',
  },
  term_index: {
    id: 'term_index',
    defaultmessages: 'Term {i}',
  },
  terminate: {
    id: 'terminate',
    defaultmessages: 'Terminate',
  },
  terminate_a_lease_agreement_by_court_order: {
    id: 'terminate_a_lease_agreement_by_court_order',
    defaultmessages: 'Terminate Lease Agreement by Court Order',
  },
  terminate_application: {
    id: 'terminate_application',
    defaultmessages: 'Terminate Application',
  },
  terminate_application_title: {
    id: 'terminate_application_title',
    defaultmessages: 'Terminate Application?',
  },
  terminate_by_court_order: {
    id: 'terminate_by_court_order',
    defaultmessages: 'Terminate by Court Order',
  },
  terminate_case_title: {
    id: 'terminate_case_title',
    defaultmessages: 'Terminate Case',
  },
  terminate_contract: {
    id: 'terminate_contract',
    defaultmessages: 'Terminate Agreement',
  },
  terminate_contract_popup_alert_message: {
    id: 'terminate_contract_popup_alert_message',
    defaultmessages: 'The next agreement you would like to issue should be on the same day of termination or after.',
  },
  terminate_contract_title: {
    id: 'terminate_contract_title',
    defaultmessages: 'Cancel Agreement?',
  },
  terminate_pma_contract: {
    id: 'terminate_pma_contract',
    defaultmessages: 'Cancel PMA',
  },
  terminate_pma_name: {
    id: 'terminate_pma_name',
    defaultmessages: 'Property Management Agreement Cancellation',
  },
  terminated: {
    id: 'terminated',
    defaultmessages: 'Terminated',
  },
  termination_acknowledgment_and_pledge: {
    id: 'termination_acknowledgment_and_pledge',
    defaultmessages:
      'I acknowledge the validity of the entered data and the attached documents, and I bear the responsibility for their correctness in relation to the rights of third parties, in accordance with the applicable legislation.',
  },
  termination_application_Mandatory: {
    id: 'termination_application_Mandatory',
    defaultmessages: 'Termination Application (Mandatory)',
  },
  termination_approval_bank_subTitle: {
    id: 'termination_approval_bank_subTitle',
    defaultmessages: 'You will be notified once PMA agreement is reviewed and approved by PMC signatory',
  },
  termination_approval_pmc_subTitle: {
    id: 'termination_approval_pmc_subTitle',
    defaultmessages: 'You will be notified once PMA agreement is reviewed and approved by Bank signatory.',
  },
  termination_details: {
    id: 'termination_details',
    defaultmessages: 'Termination Details',
  },
  termination_payment_confirm: {
    id: 'termination_payment_confirm',
    defaultmessages: "Payment Confirmed: The funds have been transferred to the recipient's account",
  },
  termination_pma_bank_signatory_initiator: {
    id: 'termination_pma_bank_signatory_initiator',
    defaultmessages: 'The application will be sent to the PMC signatory for approval.',
  },
  termination_text: {
    id: 'termination_text',
    defaultmessages: 'Are you sure you want to cancel the application?',
  },
  termination_title: {
    id: 'termination_title',
    defaultmessages: 'Cancel Application?',
  },
  termination_type: {
    id: 'termination_type',
    defaultmessages: 'Termination Type',
  },
  terms: {
    id: 'terms',
    defaultmessages: 'Terms',
  },
  'terms_&_conditions': {
    id: 'terms_&_conditions',
    defaultmessages: 'Terms & Conditions',
  },
  terms_and_condition_modified: {
    id: 'terms_and_condition_modified',
    defaultmessages: 'Terms and Conditions Modified',
  },
  terms_and_conditions_hint: {
    id: 'terms_and_conditions_hint',
    defaultmessages: 'Terms & Conditions should not contradict the ADGM regulations.',
  },
  terms_conditions: {
    id: 'terms_conditions',
    defaultmessages: 'Terms and Conditions',
  },
  the_above_mentioned_fees_do_not_include_vat: {
    id: 'the_above_mentioned_fees_do_not_include_vat',
    defaultmessages: '*The above mentioned fees are inclusive of VAT.',
  },
  the_accepted_format: {
    id: 'the_accepted_format',
    defaultmessages: 'The accepted format is (+971XXXXXXXXX)',
  },
  the_accepted_format_is: {
    id: 'the_accepted_format_is',
    defaultmessages: 'The accepted format is',
  },
  'the_application_has_been returned': {
    id: 'the_application_has_been returned',
    defaultmessages:
      'The application has been returned, for more details please check the feedback notes section for more details.',
  },
  the_application_has_been_approved: {
    id: 'the_application_has_been_approved',
    defaultmessages: 'The application has been approved',
  },
  the_application_has_been_canceled_successfully: {
    id: 'the_application_has_been_canceled_successfully',
    defaultmessages: 'The application has been successfully canceled',
  },
  the_application_has_been_rejected: {
    id: 'the_application_has_been_rejected',
    defaultmessages: 'The application has been rejected',
  },
  the_application_has_been_returned: {
    id: 'the_application_has_been_returned',
    defaultmessages: 'The application has been returned, for more details please check the feedback notes section',
  },
  the_application_has_been_returned_successfully: {
    id: 'the_application_has_been_returned_successfully',
    defaultmessages: 'The application has been successfully returned',
  },
  the_application_submitted_successfully: {
    id: 'the_application_submitted_successfully',
    defaultmessages: 'The application has been submitted successfully',
  },
  the_application_successfully_completed: {
    id: 'the_application_successfully_completed',
    defaultmessages: 'The application is successfully completed',
  },
  the_application_will_be_sent_to_dari_gis_team_for_the_approval: {
    id: 'the_application_will_be_sent_to_dari_gis_team_for_the_approval',
    defaultmessages: 'The application will be sent to AccessRP GIS team for the approval',
  },
  the_application_will_be_sent_to_the_municipality_to_get_the_required_approvals: {
    id: 'the_application_will_be_sent_to_the_municipality_to_get_the_required_approvals',
    defaultmessages: 'The application will be sent to the municipality to get the required approvals',
  },
  the_decision_to_declare_the_public_benefit_association: {
    id: 'the_decision_to_declare_the_public_benefit_association',
    defaultmessages: 'The decision to declare the Public Benefit Association',
  },
  the_developer: {
    id: 'the_developer',
    defaultmessages: 'The Developer',
  },
  the_following_properties_have_pending_items_preventing_you_from_inititating: {
    id: 'the_following_properties_have_pending_items_preventing_you_from_inititating',
    defaultmessages: 'The following properties have pending items preventing you from initiating a service on them:',
  },
  the_following_sub_pma_needs_to_be_terminated: {
    id: 'the_following_sub_pma_needs_to_be_terminated',
    defaultmessages: 'The following Sub PMA agreements need to be terminated to continue the application',
  },
  the_maximum_character_count_is: {
    id: 'the_maximum_character_count_is',
    defaultmessages: 'The maximum character count is {s}.',
  },
  the_message_goes_here: {
    id: 'the_message_goes_here',
    defaultmessages: 'You have pending tasks!',
  },
  the_refunded_amount_will_be_transferred_to_this_bank_account: {
    id: 'the_refunded_amount_will_be_transferred_to_this_bank_account',
    defaultmessages: 'The refunded amount will be transferred to this bank account',
  },
  the_second_party_has_returned_the_pma_agreement: {
    id: 'the_second_party_has_returned_the_pma_agreement',
    defaultmessages: 'The second party has returned the PMA agreement with feedback',
  },
  there_are_no_professions_with_your_filters: {
    id: 'there_are_no_professions_with_your_filters',
    defaultmessages: 'There are no professions with your filters',
  },
  there_are_no_projects_with_your_filters: {
    id: 'there_are_no_projects_with_your_filters',
    defaultmessages: 'No search results were found for projects using the entered details',
  },
  these_units_have_a_block_on_them: {
    id: 'these_units_have_a_block_on_them',
    defaultmessages: 'These units have a block on them, preventing you from continuing with the application.',
  },
  third_party: {
    id: 'third_party',
    defaultmessages: 'Third Party',
  },
  this_application_will_be_sent_to_other_buyers_to_get_the_required_approvals: {
    id: 'this_application_will_be_sent_to_other_buyers_to_get_the_required_approvals',
    defaultmessages: "This application will be sent to other buyer's to get the required approvals",
  },
  this_application_will_be_sent_to_the_developer_to_get_the_required_approvals: {
    id: 'this_application_will_be_sent_to_the_developer_to_get_the_required_approvals',
    defaultmessages: 'This application will be sent to the developer to get the required approvals',
  },
  this_buyer_is_already_added: {
    id: 'this_buyer_is_already_added',
    defaultmessages: 'This buyer is already added',
  },
  this_information_won_t_be_shown_on_the_final_contract: {
    id: 'this_information_won_t_be_shown_on_the_final_contract',
    defaultmessages: 'This information will not be shown on the final agreement',
  },
  this_is_mandatory: {
    id: 'this_is_mandatory',
    defaultmessages: 'This is mandatory',
  },
  this_is_where_applications_contracts_show: {
    id: 'this_is_where_applications_contracts_show',
    defaultmessages: 'This is where all your applications will appear',
  },
  this_is_where_tasks_will_appear: {
    id: 'this_is_where_tasks_will_appear',
    defaultmessages: 'This is where all the tasks requiring your action will appear.',
  },
  this_property_has_an_existing_mortgage: {
    id: 'this_property_has_an_existing_mortgage',
    defaultmessages: 'This property has an existing mortgage.',
  },
  this_property_is_blocked: {
    id: 'this_property_is_blocked',
    defaultmessages: 'This property is blocked',
  },
  this_unit_has_multiple_blocks_on_it: {
    id: 'this_unit_has_multiple_blocks_on_it',
    defaultmessages: 'This unit has multiple blocks on it',
  },
  this_will_terminate_the_application: {
    id: 'this_will_terminate_the_application',
    defaultmessages: 'This will terminate the application and you will have to start a new one',
  },
  time: {
    id: 'time',
    defaultmessages: 'Time',
  },
  time_and_date: {
    id: 'time_and_date',
    defaultmessages: 'Time & Date',
  },
  title404: {
    id: 'title404',
    defaultmessages: 'Page not found',
  },
  title_deed: {
    id: 'title_deed',
    defaultmessages: 'Title Deed',
  },
  title_deed_document: {
    id: 'title_deed_document',
    defaultmessages: 'Title Deed Document',
  },
  title_deed_mandatory: {
    id: 'title_deed_mandatory',
    defaultmessages: 'Title Deed (Mandatory)',
  },
  title_deed_optional: {
    id: 'title_deed_optional',
    defaultmessages: 'Title Deed (Optional)',
  },
  to: {
    id: 'to',
    defaultmessages: 'To',
  },
  to_be_paid_dmt: {
    id: 'to_be_paid_dmt',
    defaultmessages: 'To be paid in person at the DMT',
  },
  to_validate_the_added_completion_percentage_only_pdf_file_is_supported: {
    id: 'to_validate_the_added_completion_percentage_only_pdf_file_is_supported',
    defaultmessages: 'To validate the added completion percentage, only PDF files are supported.',
  },
  'too-many-files': {
    id: 'too-many-files',
    defaultmessages: "You can't upload more than 6 photos",
  },
  'top-up-my-wallet': {
    id: 'top-up-my-wallet',
    defaultmessages: 'Top Up My Wallet',
  },
  top_up: {
    id: 'top_up',
    defaultmessages: 'Top-Up',
  },
  top_up_wallet: {
    id: 'top_up_wallet',
    defaultmessages: 'Top Up Wallet',
  },
  total_acquiring_percentage_should_be_equal_to_total_waiving_percentage: {
    id: 'total_acquiring_percentage_should_be_equal_to_total_waiving_percentage',
    defaultmessages: 'Total acquiring percentage should be equal to total waiving percentage',
  },
  total_addc_aadc_current_liability: {
    id: 'total_addc_aadc_current_liability',
    defaultmessages: 'Total ADDC/AADC Current Liability',
  },
  total_amount: {
    id: 'total_amount',
    defaultmessages: 'Total Amount',
  },
  total_amount_for_whole_rent_duration: {
    id: 'total_amount_for_whole_rent_duration',
    defaultmessages: 'Total Amount for Entire Rent Duration',
  },
  total_area: {
    id: 'total_area',
    defaultmessages: 'Total Area',
  },
  total_buying_percentage_should_be_equal_to_total_selling_percentage: {
    id: 'total_buying_percentage_should_be_equal_to_total_selling_percentage',
    defaultmessages: 'Total buying percentage should be equal to total selling percentage',
  },
  total_claim_value: {
    id: 'total_claim_value',
    defaultmessages: 'Total Claim Value: {number}',
  },
  total_contract_amount: {
    id: 'total_contract_amount',
    defaultmessages: 'Total Agreement Amount',
  },
  total_count: {
    id: 'total_count',
    defaultmessages: 'Total Count',
  },
  total_credited: {
    id: 'total_credited',
    defaultmessages: 'Total Credited',
  },
  total_credited_exclamation: {
    id: 'total_credited_exclamation',
    defaultmessages: 'Total credited in main escrow account',
  },
  total_debited: {
    id: 'total_debited',
    defaultmessages: 'Total Debited',
  },
  total_due_rent: {
    id: 'total_due_rent',
    defaultmessages: 'Total Due Rent',
  },
  total_due_rent_amount_for_the_period: {
    id: 'total_due_rent_amount_for_the_period',
    defaultmessages: 'Total due rent amount for the period {s}',
  },
  total_fee_to_be_paid: {
    id: 'total_fee_to_be_paid',
    defaultmessages: 'Total Fees to be paid',
  },
  total_mortgage_value: {
    id: 'total_mortgage_value',
    defaultmessages: 'Total Mortgage Value',
  },
  total_mortgage_volume: {
    id: 'total_mortgage_volume',
    defaultmessages: 'Total Mortgage Volume',
  },
  total_paid_amount: {
    id: 'total_paid_amount',
    defaultmessages: 'Total Paid Amount',
  },
  total_payment: {
    id: 'total_payment',
    defaultmessages: 'Total Payment',
  },
  total_payment_amount_can_not_be: {
    id: 'total_payment_amount_can_not_be',
    defaultmessages: 'Total payment amount can not be {s} than the sale price',
  },
  total_payment_amount_can_not_be_less: {
    id: 'total_payment_amount_can_not_be_less',
    defaultmessages: 'Total payment amount can not be less than the sale price',
  },
  total_payment_amount_can_not_be_more: {
    id: 'total_payment_amount_can_not_be_more',
    defaultmessages: 'Total payment amount can not be more than the sale price',
  },
  total_percentage: {
    id: 'total_percentage',
    defaultmessages: 'Total: {s}%',
  },
  total_registration_fee: {
    id: 'total_registration_fee',
    defaultmessages: 'Total Registration Fees',
  },
  total_registration_fee_to_be_paid: {
    id: 'total_registration_fee_to_be_paid',
    defaultmessages: 'Total Registration Fees to be Paid',
  },
  total_rent_amount: {
    id: 'total_rent_amount',
    defaultmessages: 'Total Rent Amount',
  },
  total_rent_to_be_paid: {
    id: 'total_rent_to_be_paid',
    defaultmessages: 'Total Rent to be Paid',
  },
  total_sale_value: {
    id: 'total_sale_value',
    defaultmessages: 'Total Sale Value',
  },
  total_sale_volume: {
    id: 'total_sale_volume',
    defaultmessages: 'Total Sale Volume',
  },
  total_sales_transactions_title: {
    id: 'total_sales_transactions_title',
    defaultmessages: 'Total sales transactions last week In emirate of Abu Dhabi',
  },
  total_selling_percentage: {
    id: 'total_selling_percentage',
    defaultmessages: 'Total Sale Percentage',
  },
  total_shares_100: {
    id: 'total_shares_100',
    defaultmessages: 'Total shares percentage should be equal to 100%',
  },
  total_to_be_paid: {
    id: 'total_to_be_paid',
    defaultmessages: 'Total to be Paid',
  },
  total_transaction_fee_field_title: {
    id: 'total_transaction_fee_field_title',
    defaultmessages: 'Total Transaction Fee',
  },
  total_unit_count: {
    id: 'total_unit_count',
    defaultmessages: 'Total Unit Count',
  },
  total_value: {
    id: 'total_value',
    defaultmessages: 'Total Value',
  },
  total_volume: {
    id: 'total_volume',
    defaultmessages: 'Total Volume',
  },
  total_waiving_percentage: {
    id: 'total_waiving_percentage',
    defaultmessages: 'Total Waiving Percentage',
  },
  townhouse: {
    id: 'townhouse',
    defaultmessages: 'Townhouse',
  },
  tradeName: {
    id: 'tradeName',
    defaultmessages: 'Trade Name',
  },
  trade_license: {
    id: 'trade_license',
    defaultmessages: 'Trade License',
  },
  trade_license_document: {
    id: 'trade_license_document',
    defaultmessages: 'Commercial License',
  },
  trade_license_end_date: {
    id: 'trade_license_end_date',
    defaultmessages: 'Trade License Expiry Date',
  },
  trade_license_hint: {
    id: 'trade_license_hint',
    defaultmessages: '99384823746',
  },
  trade_license_num: {
    id: 'trade_license_num',
    defaultmessages: '',
  },
  trade_license_number: {
    id: 'trade_license_number',
    defaultmessages: 'Commercial License Number',
  },
  trade_license_number_error_msg: {
    id: 'trade_license_number_error_msg',
    defaultmessages: 'License number should be 6 digits only',
  },
  trade_license_placeholder: {
    id: 'trade_license_placeholder',
    defaultmessages: 'Ex. C01R1234',
  },
  trade_license_start_date: {
    id: 'trade_license_start_date',
    defaultmessages: 'Trade License Issue Date',
  },
  transaction: {
    id: 'transaction',
    defaultmessages: 'Transactions',
  },
  transaction_details: {
    id: 'transaction_details',
    defaultmessages: 'Transaction Details',
  },
  transaction_failure_msg: {
    id: 'transaction_failure_msg',
    defaultmessages: 'If your credit/debit card was charged, the transaction will be reversed.',
  },
  transaction_fee: {
    id: 'transaction_fee',
    defaultmessages: 'Transaction Fee',
  },
  transaction_fee_field_desc: {
    id: 'transaction_fee_field_desc',
    defaultmessages:
      'Transaction fee is calculated as 2% of the evaluation price or the selling price, whichever is higher.',
  },
  transaction_fee_field_desc_web: {
    id: 'transaction_fee_field_desc_web',
    defaultmessages: 'The transaction fee is {s}% of the valuation or selling price, whichever is higher.',
  },
  transaction_fee_field_title: {
    id: 'transaction_fee_field_title',
    defaultmessages: 'Municipality Transaction Fees (2%)',
  },
  transaction_fee_field_title_web: {
    id: 'transaction_fee_field_title_web',
    defaultmessages: 'Transaction fee ({s}%)',
  },
  transaction_helper: {
    id: 'transaction_helper',
    defaultmessages: 'View the latest transactions on your account',
  },
  transaction_id: {
    id: 'transaction_id',
    defaultmessages: 'Transaction ID: {s}',
  },
  transaction_id_label: {
    id: 'transaction_id_label',
    defaultmessages: 'Transaction ID',
  },
  transactions: {
    id: 'transactions',
    defaultmessages: 'Transactions',
  },
  transactions_in_abu_dhabi: {
    id: 'transactions_in_abu_dhabi',
    defaultmessages: 'Transactions in Abu Dhabi Emirate',
  },
  transction_fee_paid_by: {
    id: 'transction_fee_paid_by',
    defaultmessages: 'Transaction fee paid by',
  },
  transfee_text2: {
    id: 'transfee_text2',
    defaultmessages: '{s}% of sale price',
  },
  'transfer-of-interest-land': {
    id: 'transfer-of-interest-land',
    defaultmessages: 'Transfer of Interest — Land',
  },
  'transfer-of-interest-unit': {
    id: 'transfer-of-interest-unit',
    defaultmessages: 'Transfer of Interest — Unit',
  },
  transfer_bank_approval_success_message: {
    id: 'transfer_bank_approval_success_message',
    defaultmessages:
      'Your application to transfer the registered lands from an initial register to the real estate register has been sent to the bank for approval',
  },
  transfer_bank_approval_success_message_unit: {
    id: 'transfer_bank_approval_success_message_unit',
    defaultmessages:
      'Your application to transfer the registered units from an initial register to the real estate register has been sent to the bank for approval',
  },
  transfer_fee: {
    id: 'transfer_fee',
    defaultmessages:
      'Registration fee to transfer registered lands from an initial register to the real estate register',
  },
  transfer_fee_hint: {
    id: 'transfer_fee_hint',
    defaultmessages:
      'Registration fee to transfer registered lands from an initial register to the real estate register (AED 900) to be paid',
  },
  transfer_fee_hint_web: {
    id: 'transfer_fee_hint_web',
    defaultmessages:
      'Registration fee to transfer registered lands from an initial register to the real estate register (AED 900) to be paid by',
  },
  transfer_fee_hint_web_unit: {
    id: 'transfer_fee_hint_web_unit',
    defaultmessages:
      'Registration fee to transfer registered units from an initial register to the real estate register (AED 900) to be paid by',
  },
  transfer_fee_paid_by_owner: {
    id: 'transfer_fee_paid_by_owner',
    defaultmessages: 'Transfer Registered Lands from Initial Register to Real Estate Register fee paid by the',
  },
  transfer_fee_paid_by_owner_unit: {
    id: 'transfer_fee_paid_by_owner_unit',
    defaultmessages: 'Transfer Registered Units from Initial Register to Real Estate Register fee paid by the',
  },
  transfer_fee_unit: {
    id: 'transfer_fee_unit',
    defaultmessages:
      'Registration fee to transfer registered units from an initial register to the real estate register',
  },
  transfer_final_approval_success_screen: {
    id: 'transfer_final_approval_success_screen',
    defaultmessages:
      'Your application to transfer registered lands from an initial register to the real estate register is approved',
  },
  transfer_final_approval_success_screen_unit: {
    id: 'transfer_final_approval_success_screen_unit',
    defaultmessages:
      'Your application to transfer registered units from an initial register to the real estate register is approved',
  },
  transfer_land_to_real_estate: {
    id: 'transfer_land_to_real_estate',
    defaultmessages: 'Transfer Registered Lands from Initial Register to Real Estate Register',
  },
  transfer_land_to_real_estate_unit: {
    id: 'transfer_land_to_real_estate_unit',
    defaultmessages: 'Transfer Registered Units from Initial Register to Real Estate Register',
  },
  transfer_of_interest_adgm_fees: {
    id: 'transfer_of_interest_adgm_fees',
    defaultmessages: 'Transfer of interest ADGM Fees',
  },
  transfer_of_interest_application_rejected: {
    id: 'transfer_of_interest_application_rejected',
    defaultmessages: 'Transfer of interest application has been rejected',
  },
  transfer_of_interest_application_returned: {
    id: 'transfer_of_interest_application_returned',
    defaultmessages: 'Transfer of interest application has been returned',
  },
  transfer_of_interest_fees: {
    id: 'transfer_of_interest_fees',
    defaultmessages: 'Transfer of Interest Fees',
  },
  transfer_of_interest_land_description: {
    id: 'transfer_of_interest_land_description',
    defaultmessages:
      'This service allows the registration of a title deed transfer, enabling the transfer of land ownership from one entity or individual to another and allow owner to discharge mortgage if applicable.',
  },
  transfer_of_interest_land_description_withMortgage: {
    id: 'transfer_of_interest_land_description_withMortgage',
    defaultmessages:
      'This service allows the registration of a title deed transfer, enabling the transfer of land ownership from one entity or individual to another. It also allows the owner to register and discharge a mortgage, if applicable.',
  },
  transfer_of_interest_percent_of_property_value_or_evaluation_whichever_is_higher: {
    id: 'transfer_of_interest_percent_of_property_value_or_evaluation_whichever_is_higher',
    defaultmessages:
      'Transfer of Interest Fee: 2% of the property value or the property evaluation, whichever is higher',
  },
  transfer_of_interest_registration_is_completed: {
    id: 'transfer_of_interest_registration_is_completed',
    defaultmessages: 'Transfer of interest registration is completed',
  },
  transfer_of_interest_subtitle_buyer_approval: {
    id: 'transfer_of_interest_subtitle_buyer_approval',
    defaultmessages: 'You have successfully sent the application for buyer’s approval.',
  },
  transfer_of_interest_subtitle_other_owners_approval: {
    id: 'transfer_of_interest_subtitle_other_owners_approval',
    defaultmessages: "You have successfully sent the application for other owner's approval.",
  },
  transfer_of_interest_unit_description: {
    id: 'transfer_of_interest_unit_description',
    defaultmessages:
      'This service allows the registration of a title deed transfer, enabling the transfer of unit ownership from one entity or individual to another and allow owner to discharge mortgage if applicable.',
  },
  transfer_of_interest_unit_description_withMortgage: {
    id: 'transfer_of_interest_unit_description_withMortgage',
    defaultmessages:
      'This service allows the registration of a title deed transfer, enabling the transfer of unit ownership from one entity or individual to another. It also allows the owner to register and discharge a mortgage, if applicable.',
  },
  transfer_of_ownership_with_mortgages: {
    id: 'transfer_of_ownership_with_mortgages',
    defaultmessages: 'Transfer of Ownership with Mortgages',
  },
  transfer_off_plan_aknowledgment: {
    id: 'transfer_off_plan_aknowledgment',
    defaultmessages:
      'The developer hereby confirms that they do not have any pending liabilities on the owner, and have no objection for moving this property to the owner',
  },
  transfer_off_plan_complete_success_message: {
    id: 'transfer_off_plan_complete_success_message',
    defaultmessages:
      'Application to transfer registered lands from an initial register to the real estate register has been successfully sent for approval',
  },
  transfer_off_plan_complete_success_message_unit: {
    id: 'transfer_off_plan_complete_success_message_unit',
    defaultmessages:
      'Application to transfer registered units from an initial register to the real estate register has been successfully sent for approval',
  },
  transfer_property: {
    id: 'transfer_property',
    defaultmessages: 'Transfer Real Property Interest',
  },
  transfer_property_description: {
    id: 'transfer_property_description',
    defaultmessages:
      'This service handles recording buy and sell transactions and transferring property ownership to new owners.',
  },
  transfer_property_from_off_plan_to_completed: {
    id: 'transfer_property_from_off_plan_to_completed',
    defaultmessages: 'Transfer Property from Off-Plan to Completed',
  },
  transfer_property_from_off_plan_to_completed_description: {
    id: 'transfer_property_from_off_plan_to_completed_description',
    defaultmessages:
      'This service facilitates the transfer of property ownership from the developer to the buyer upon project completion.',
  },
  transfer_registration_fees: {
    id: 'transfer_registration_fees',
    defaultmessages: 'Transfer Registration Fees',
  },
  transfer_rent_contract_to_musataha_sent_for_approval: {
    id: 'transfer_rent_contract_to_musataha_sent_for_approval',
    defaultmessages: 'Transfer Rental Agreement to Musataha was successfully sent for approval',
  },
  transfer_return_success_message: {
    id: 'transfer_return_success_message',
    defaultmessages:
      'Your application to transfer the registered lands from an initial register to the real estate register has been returned',
  },
  transfer_return_success_message_unit: {
    id: 'transfer_return_success_message_unit',
    defaultmessages:
      'Your application to transfer the registered units from an initial register to the real estate register has been returned',
  },
  translation: {
    id: 'translation',
    defaultmessages: 'Translation',
  },
  try_again: {
    id: 'try_again',
    defaultmessages: 'Try Again',
  },
  try_again_in_secs: {
    id: 'try_again_in_secs',
    defaultmessages: 'Try again in {message} seconds',
  },
  type: {
    id: 'type',
    defaultmessages: 'Type',
  },
  type_of_agreement: {
    id: 'type_of_agreement',
    defaultmessages: 'Type of Agreement',
  },
  uae_pass_login_exception: {
    id: 'uae_pass_login_exception',
    defaultmessages: 'Something went wrong during the login, please try again later!',
  },
  uae_pass_reject_access_title: {
    id: 'uae_pass_reject_access_title',
    defaultmessages: 'UAE Pass access denied',
  },
  uae_resident_party: {
    id: 'uae_resident_party',
    defaultmessages: 'UAE Resident Party',
  },
  uae_residents: {
    id: 'uae_residents',
    defaultmessages: 'UAE Residents',
  },
  un_eid_number: {
    id: 'un_eid_number',
    defaultmessages: 'UN/EID Number',
  },
  unable_to_fetch_contracts: {
    id: 'unable_to_fetch_contracts',
    defaultmessages: 'Unable to fetch agreement',
  },
  unable_to_fetch_fees: {
    id: 'unable_to_fetch_fees',
    defaultmessages: 'Unable to fetch fees',
  },
  unable_to_fetch_properties: {
    id: 'unable_to_fetch_properties',
    defaultmessages: 'Unable to fetch properties',
  },
  unable_to_initiate_the_application: {
    id: 'unable_to_initiate_the_application',
    defaultmessages: 'Unable to initiate the application',
  },
  unable_to_upload_the_document: {
    id: 'unable_to_upload_the_document',
    defaultmessages: 'Unable to upload the document',
  },
  under_age_buyer_info: {
    id: 'under_age_buyer_info',
    defaultmessages: "The buyer's age is below 21 years, please add the representative to proceed",
  },
  under_age_seller_info: {
    id: 'under_age_seller_info',
    defaultmessages: "The seller's age is below 21 years, please add the representative to proceed",
  },
  under_construction: {
    id: 'under_construction',
    defaultmessages: 'Under Construction',
  },
  under_construction_project_status_tooltip_message: {
    id: 'under_construction_project_status_tooltip_message',
    defaultmessages: 'The projects with progress report and an escrow account for sale as off-plan',
  },
  undertaking_letter: {
    id: 'undertaking_letter',
    defaultmessages: 'Undertaking Letter',
  },
  undertaking_letter_: {
    id: 'undertaking_letter_',
    defaultmessages: 'Undertaking letter the validity and accuracy of the information provided',
  },
  unified_greater_than_6_character: {
    id: 'unified_greater_than_6_character',
    defaultmessages: 'Unified number should be greater than 5 characters',
  },
  unified_number: {
    id: 'unified_number',
    defaultmessages: 'Unified Number',
  },
  unified_number_hint: {
    id: 'unified_number_hint',
    defaultmessages: '12345',
  },
  unified_number_incorrect: {
    id: 'unified_number_incorrect',
    defaultmessages: 'This unified number is incorrect',
  },
  unified_number_title: {
    id: 'unified_number_title',
    defaultmessages:
      'Your unified number is a number that can be found on your entry stamp or on the last page of your passport.',
  },
  unified_should_be_not_empty: {
    id: 'unified_should_be_not_empty',
    defaultmessages: 'Unified number required',
  },
  unit_area: {
    id: 'unit_area',
    defaultmessages: 'Unit Area',
  },
  unit_building: {
    id: 'unit_building',
    defaultmessages: 'Unit {u}, Building {b}',
  },
  unit_classification: {
    id: 'unit_classification',
    defaultmessages: 'Unit Classification',
  },
  unit_count: {
    id: 'unit_count',
    defaultmessages: 'Unit Count',
  },
  unit_details: {
    id: 'unit_details',
    defaultmessages: 'Unit Details',
  },
  unit_hash: {
    id: 'unit_hash',
    defaultmessages: 'Unit #',
  },
  unit_name_number: {
    id: 'unit_name_number',
    defaultmessages: 'Unit Number',
  },
  unit_no: {
    id: 'unit_no',
    defaultmessages: 'Unit Reg #',
  },
  unit_num: {
    id: 'unit_num',
    defaultmessages: 'Unit no.',
  },
  unit_num_hint: {
    id: 'unit_num_hint',
    defaultmessages: 'e.g., 221 or GO1',
  },
  unit_number: {
    id: 'unit_number',
    defaultmessages: 'Unit Number',
  },
  unit_number_title: {
    id: 'unit_number_title',
    defaultmessages: 'Unit Number {s}',
  },
  unit_reg_no_text: {
    id: 'unit_reg_no_text',
    defaultmessages: 'Unit registration no.',
  },
  unit_reg_number: {
    id: 'unit_reg_number',
    defaultmessages: 'Unit reg. number',
  },
  unit_reg_number_eg: {
    id: 'unit_reg_number_eg',
    defaultmessages: 'e.g., UNT00000',
  },
  unit_registration_fee_paid_by_owner: {
    id: 'unit_registration_fee_paid_by_owner',
    defaultmessages: 'Unit registration fees paid by the owner',
  },
  unit_registration_number_is_required: {
    id: 'unit_registration_number_is_required',
    defaultmessages: 'Unit registration number is required',
  },
  unit_size: {
    id: 'unit_size',
    defaultmessages: 'Unit Size',
  },
  unit_type: {
    id: 'unit_type',
    defaultmessages: 'Unit Type',
  },
  unit_use: {
    id: 'unit_use',
    defaultmessages: 'Unit Use',
  },
  unit_verification: {
    id: 'unit_verification',
    defaultmessages: 'Unit Verification',
  },
  units: {
    id: 'units',
    defaultmessages: 'Units',
  },
  units_are_no_longer_under_the_same_owner: {
    id: 'units_are_no_longer_under_the_same_owner',
    defaultmessages: 'These units are no longer under the same owner.',
  },
  units_registered_number: {
    id: 'units_registered_number',
    defaultmessages: 'Units Registration Number',
  },
  unresolved_case_success_screen_body: {
    id: 'unresolved_case_success_screen_body',
    defaultmessages: 'You can download the referral decision document by clicking the download button below',
  },
  unresolved_case_success_screen_title: {
    id: 'unresolved_case_success_screen_title',
    defaultmessages: 'The Center has decided to refer the dispute to the court of law',
  },
  unt_number: {
    id: 'unt_number',
    defaultmessages: 'UNT Number',
  },
  unt_reg_number: {
    id: 'unt_reg_number',
    defaultmessages: 'Unit Registration Number',
  },
  unwaive_shares: {
    id: 'unwaive_shares',
    defaultmessages: 'Acquire Shares',
  },
  update: {
    id: 'update',
    defaultmessages: 'Update',
  },
  update_company: {
    id: 'update_company',
    defaultmessages: 'Update Company Details',
  },
  update_company_info: {
    id: 'update_company_info',
    defaultmessages: 'Update company information',
  },
  update_company_submit_success: {
    id: 'update_company_submit_success',
    defaultmessages: 'Your company Information update has been successfully submitted',
  },
  update_information: {
    id: 'update_information',
    defaultmessages: 'Update Information',
  },
  update_occupant_details: {
    id: 'update_occupant_details',
    defaultmessages: 'Update Occupant Details',
  },
  update_phone_number: {
    id: 'update_phone_number',
    defaultmessages: 'Update phone number\n ',
  },
  update_professional_details: {
    id: 'update_professional_details',
    defaultmessages: 'Update Professional Details',
  },
  update_your_profile_title: {
    id: 'update_your_profile_title',
    defaultmessages: '',
  },
  updated_financial_plan: {
    id: 'updated_financial_plan',
    defaultmessages: 'Updated Financial Plan',
  },
  updated_lease_agreement: {
    id: 'updated_lease_agreement',
    defaultmessages: 'Updated Lease Agreement',
  },
  updated_lease_agreement_mandatory: {
    id: 'updated_lease_agreement_mandatory',
    defaultmessages: 'Updated Lease Agreement (Mandatory)',
  },
  upload: {
    id: 'upload',
    defaultmessages: 'Upload',
  },
  upload_again: {
    id: 'upload_again',
    defaultmessages: 'Upload Again',
  },
  upload_document: {
    id: 'upload_document',
    defaultmessages: 'Upload Documents',
  },
  upload_photos: {
    id: 'upload_photos',
    defaultmessages: 'Upload Photos',
  },
  upload_plots_sheet: {
    id: 'upload_plots_sheet',
    defaultmessages: 'Upload Plots Sheet',
  },
  upload_project_photos: {
    id: 'upload_project_photos',
    defaultmessages: 'Upload Project Photos',
  },
  upload_required_document_notification: {
    id: 'upload_required_document_notification',
    defaultmessages: 'Please make sure all required documents are uploaded before moving forward',
  },
  upload_required_documents: {
    id: 'upload_required_documents',
    defaultmessages: 'Upload Required Documents',
  },
  upload_the_required_documents: {
    id: 'upload_the_required_documents',
    defaultmessages: 'Upload the Required Documents',
  },
  uploaded_documents: {
    id: 'uploaded_documents',
    defaultmessages: 'Uploaded Documents',
  },
  usage: {
    id: 'usage',
    defaultmessages: '',
  },
  usageType: {
    id: 'usageType',
    defaultmessages: 'Usage Type',
  },
  usage_type: {
    id: 'usage_type',
    defaultmessages: 'Usage Type',
  },
  use_type: {
    id: 'use_type',
    defaultmessages: 'Use Type',
  },
  user_acknowledgement_letter: {
    id: 'user_acknowledgement_letter',
    defaultmessages: 'User Acknowledgment Letter',
  },
  user_full_name: {
    id: 'user_full_name',
    defaultmessages: 'User Full Name',
  },
  user_inputs_verification_hint: {
    id: 'user_inputs_verification_hint',
    defaultmessages: 'Please make sure the inputs are correct',
  },
  user_name: {
    id: 'user_name',
    defaultmessages: 'User Name',
  },
  user_role: {
    id: 'user_role',
    defaultmessages: 'User Role',
  },
  user_type: {
    id: 'user_type',
    defaultmessages: 'User Type',
  },
  usufruct: {
    id: 'usufruct',
    defaultmessages: 'Usufruct',
  },
  usufruct_contract_details: {
    id: 'usufruct_contract_details',
    defaultmessages: 'Usufruct Agreement Details',
  },
  utility_bills_paid_by: {
    id: 'utility_bills_paid_by',
    defaultmessages: 'Utility bills paid by',
  },
  utility_bills_paid_by_with_reg_fees: {
    id: 'utility_bills_paid_by_with_reg_fees',
    defaultmessages: 'Utility bills paid by + 5% ADGM Authority Fees',
  },
  val001_content: {
    id: 'val001_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val001_title: {
    id: 'val001_title',
    defaultmessages: 'Active application failed',
  },
  val002_content: {
    id: 'val002_content',
    defaultmessages: 'There is an active application on the same property',
  },
  val002_title: {
    id: 'val002_title',
    defaultmessages: 'There is an active application on the same property',
  },
  val003_content: {
    id: 'val003_content',
    defaultmessages: 'Ownership type is not allowed',
  },
  val003_title: {
    id: 'val003_title',
    defaultmessages: 'Ownership type is not allowed',
  },
  val004_content: {
    id: 'val004_content',
    defaultmessages:
      'Owner is blocked in the system and cannot proceed to complete the transaction, please contact customer support for any issue',
  },
  val004_title: {
    id: 'val004_title',
    defaultmessages: 'Owner is blocked',
  },
  val005_content: {
    id: 'val005_content',
    defaultmessages: 'Blocked property must be identified, please contact customer support.',
  },
  val005_title: {
    id: 'val005_title',
    defaultmessages: 'Blocked property not found',
  },
  val006_content: {
    id: 'val006_content',
    defaultmessages:
      'Property is blocked in the system and you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val006_title: {
    id: 'val006_title',
    defaultmessages: 'Property is blocked',
  },
  val007_content: {
    id: 'val007_content',
    defaultmessages:
      'A Valuation Certificate is required to continue your application, please contact customer support.',
  },
  val007_title: {
    id: 'val007_title',
    defaultmessages: 'Valuation Certificate not found',
  },
  val008_content: {
    id: 'val008_content',
    defaultmessages:
      'Valuation certificates are only valid for 30 days. If your certificate is expired, please issue a new valuation certificate.',
  },
  val008_title: {
    id: 'val008_title',
    defaultmessages: 'Valuation certificate is older than %s days',
  },
  val009_content: {
    id: 'val009_content',
    defaultmessages: 'Ownership status is needed to complete your application, please contact customer support.',
  },
  val009_title: {
    id: 'val009_title',
    defaultmessages: 'Ownership status not found',
  },
  val010_content: {
    id: 'val010_content',
    defaultmessages: 'You cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val010_title: {
    id: 'val010_title',
    defaultmessages: 'Ownership type is not allowed',
  },
  val011_content: {
    id: 'val011_content',
    defaultmessages: 'Title deed is needed to proceed with your application, please contact customer support.',
  },
  val011_title: {
    id: 'val011_title',
    defaultmessages: 'Title deed not found',
  },
  val012_content: {
    id: 'val012_content',
    defaultmessages:
      'Title deeds expire after a certain amount of time. If your title deed is expired, please initiate a new deed.',
  },
  val012_title: {
    id: 'val012_title',
    defaultmessages: 'Title deed is greater than %s days',
  },
  val013_content: {
    id: 'val013_content',
    defaultmessages: 'You cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val013_title: {
    id: 'val013_title',
    defaultmessages: "Initiator's ownership type is not allowed",
  },
  val014_content: {
    id: 'val014_content',
    defaultmessages: 'This is not an active agreement',
  },
  val014_title: {
    id: 'val014_title',
    defaultmessages: 'This is not an active agreement',
  },
  val015_content: {
    id: 'val015_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val015_title: {
    id: 'val015_title',
    defaultmessages: 'Active agreement not found',
  },
  val016_content: {
    id: 'val016_content',
    defaultmessages: 'This is not an expired agreement',
  },
  val016_title: {
    id: 'val016_title',
    defaultmessages: 'This is not an expired agreement',
  },
  val017_content: {
    id: 'val017_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val017_title: {
    id: 'val017_title',
    defaultmessages: 'Expired agreement not found',
  },
  val018_content: {
    id: 'val018_content',
    defaultmessages: 'This is not active/expired agreement',
  },
  val018_title: {
    id: 'val018_title',
    defaultmessages: 'This is not active/expired agreement',
  },
  val019_content: {
    id: 'val019_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val019_title: {
    id: 'val019_title',
    defaultmessages: 'Active/Expired agreement not found',
  },
  val020_content: {
    id: 'val020_content',
    defaultmessages: 'You cannot complete this transaction as there is an active agreement on this property',
  },
  val020_title: {
    id: 'val020_title',
    defaultmessages: 'There is an active agreement',
  },
  val021_content: {
    id: 'val021_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val021_title: {
    id: 'val021_title',
    defaultmessages: 'Agreement not found',
  },
  val022_content: {
    id: 'val022_content',
    defaultmessages:
      'Property is blocked in Tawtheeq system, you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val022_title: {
    id: 'val022_title',
    defaultmessages: 'Property is blocked',
  },
  val023_content: {
    id: 'val023_content',
    defaultmessages: 'Plot acquisition type is allotment without right access',
  },
  val023_title: {
    id: 'val023_title',
    defaultmessages: 'Plot acquisition type is allotment without right access',
  },
  val025_content: {
    id: 'val025_content',
    defaultmessages:
      'Owner is blocked in the system and cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val025_title: {
    id: 'val025_title',
    defaultmessages: 'Owner is blocked',
  },
  'val026 _content': {
    id: 'val026 _content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  'val026 _title': {
    id: 'val026 _title',
    defaultmessages: 'Owner not found. Completely blocked.',
  },
  val026_content: {
    id: 'val026_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val027_content: {
    id: 'val027_content',
    defaultmessages:
      'Owner is blocked from this service and cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val027_title: {
    id: 'val027_title',
    defaultmessages: 'Owner is blocked for this service',
  },
  val028_content: {
    id: 'val028_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val028_title: {
    id: 'val028_title',
    defaultmessages: 'Blocked owner not found',
  },
  val029_content: {
    id: 'val029_content',
    defaultmessages:
      'Property is blocked for this service, you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val029_title: {
    id: 'val029_title',
    defaultmessages: 'Property is blocked for this service',
  },
  val030_content: {
    id: 'val030_content',
    defaultmessages:
      'Blocked property needs to be identified to proceed with your application, please contact customer support.',
  },
  val030_title: {
    id: 'val030_title',
    defaultmessages: 'Blocked property not found',
  },
  val031_content: {
    id: 'val031_content',
    defaultmessages:
      "Service is not allowed for this property's right hold type, you cannot complete the transaction, please contact customer support if you have any inquiries.",
  },
  val031_title: {
    id: 'val031_title',
    defaultmessages: 'Service is not allowed for this right hold type',
  },
  val032_content: {
    id: 'val032_content',
    defaultmessages:
      'Type of ownership rights hold is needed to proceed with your application, please contact customer support.',
  },
  val032_title: {
    id: 'val032_title',
    defaultmessages: 'Type of ownership rights hold not found',
  },
  val033_content: {
    id: 'val033_content',
    defaultmessages: 'The owner does not exist',
  },
  val033_title: {
    id: 'val033_title',
    defaultmessages: 'Could not find the owner details',
  },
  val034_content: {
    id: 'val034_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val034_title: {
    id: 'val034_title',
    defaultmessages: 'Existing ownership not found',
  },
  val035_content: {
    id: 'val035_content',
    defaultmessages: 'Selected Property is off plan, it should be completed.',
  },
  val035_title: {
    id: 'val035_title',
    defaultmessages: 'The selected property is not compatible with this service.',
  },
  val036_title: {
    id: 'val036_title',
    defaultmessages: 'Off-plan property not found',
  },
  val036_title_content: {
    id: 'val036_title_content',
    defaultmessages: 'Off-plan property is needed to proceed with your application, please contact customer support.',
  },
  val037_content: {
    id: 'val037_content',
    defaultmessages: 'Property type is invalid',
  },
  val037_title: {
    id: 'val037_title',
    defaultmessages: 'Property type is invalid',
  },
  val038_content: {
    id: 'val038_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val038_title: {
    id: 'val038_title',
    defaultmessages: 'Property type not found',
  },
  val039_content: {
    id: 'val039_content',
    defaultmessages:
      'The transaction cannot be completed as the property is only for lease services. Please contact customer support if you have any questions.',
  },
  val039_title: {
    id: 'val039_title',
    defaultmessages: 'Property is registered for leasing only',
  },
  val040_content: {
    id: 'val040_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val040_title: {
    id: 'val040_title',
    defaultmessages: 'Could not find Tawtheeq lease only',
  },
  val041_content: {
    id: 'val041_content',
    defaultmessages: 'One or more owners of this property has 0% of the ownership',
  },
  val041_title: {
    id: 'val041_title',
    defaultmessages: 'One or more owners of this property has 0% of the ownership',
  },
  val042_content: {
    id: 'val042_content',
    defaultmessages:
      'The sale transaction cannot be completed due to missing ownership percentage. Please contact customer support if you have any inquiries.',
  },
  val042_title: {
    id: 'val042_title',
    defaultmessages: 'Owner share is empty',
  },
  val043_content: {
    id: 'val043_content',
    defaultmessages: "Can't sell this property, land use and ownership types are not allowed",
  },
  val043_title: {
    id: 'val043_title',
    defaultmessages: 'Service is not allowed for ownership type and land use',
  },
  val044_content: {
    id: 'val044_content',
    defaultmessages:
      'Owner has financial obligations to the DMT, you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val044_title: {
    id: 'val044_title',
    defaultmessages: 'Owner is financially blocked',
  },
  val045_content: {
    id: 'val045_content',
    defaultmessages:
      'The selected property has an active mortgage agreement # ({s}). Please discharge the mortgage of this property and try again, or contact our customer support for further assistance',
  },
  val045_title: {
    id: 'val045_title',
    defaultmessages: 'Property is mortgaged',
  },
  val046_content: {
    id: 'val046_content',
    defaultmessages: 'Owner share is needed to complete your application, please contact customer support.',
  },
  val046_title: {
    id: 'val046_title',
    defaultmessages: 'Owner share not found',
  },
  val047_content: {
    id: 'val047_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val047_title: {
    id: 'val047_title',
    defaultmessages: 'Land acquisition not found',
  },
  val048_content: {
    id: 'val048_content',
    defaultmessages:
      'Financial block on owner; you cannot proceed with the application. Please contact customer support.',
  },
  val048_title: {
    id: 'val048_title',
    defaultmessages: 'Owner financial block found',
  },
  val049_content: {
    id: 'val049_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val049_title: {
    id: 'val049_title',
    defaultmessages: 'Mortgaged property not found',
  },
  val050_content: {
    id: 'val050_content',
    defaultmessages:
      'The sale transaction cannot be completed due to active endowment on property. Please contact customer support if you have any inquiries.',
  },
  val050_title: {
    id: 'val050_title',
    defaultmessages: 'This property has an active endowment',
  },
  val051_content: {
    id: 'val051_content',
    defaultmessages:
      'The sale transaction cannot be completed due to incorrect land use. Please contact customer support if you have any inquiries.',
  },
  val051_title: {
    id: 'val051_title',
    defaultmessages: 'Service is not allowed for property land use',
  },
  val052_content: {
    id: 'val052_content',
    defaultmessages:
      'The transaction cannot be completed due to ineligible nationality. Please contact customer support if you have any inquiries.',
  },
  val052_title: {
    id: 'val052_title',
    defaultmessages: 'User nationality is ineligible for this transaction',
  },
  val053_content: {
    id: 'val053_content',
    defaultmessages: 'The transaction cannot be completed. If the issue persists, please contact customer support.',
  },
  val053_title: {
    id: 'val053_title',
    defaultmessages: 'Could not fetch property details',
  },
  val054_content: {
    id: 'val054_content',
    defaultmessages:
      'The transaction cannot be completed. No owner found for this property. Please contact customer support if you have any inquiries.',
  },
  val054_title: {
    id: 'val054_title',
    defaultmessages: 'No owner found for this property',
  },
  val055_content: {
    id: 'val055_content',
    defaultmessages:
      'The transaction cannot be completed. Plot ID is empty. Please contact customer support if you have any inquiries.',
  },
  val055_title: {
    id: 'val055_title',
    defaultmessages: 'Plot ID is empty',
  },
  val056_content: {
    id: 'val056_content',
    defaultmessages: 'Owner ID is empty',
  },
  val056_title: {
    id: 'val056_title',
    defaultmessages: 'Something went wrong',
  },
  val057_content: {
    id: 'val057_content',
    defaultmessages:
      'The transaction cannot be completed. Application could not be fetched for the selected owner. Please contact customer support if you have any inquiries.',
  },
  val057_title: {
    id: 'val057_title',
    defaultmessages: 'Could not fetch active application for selected owner',
  },
  val058_content: {
    id: 'val058_content',
    defaultmessages:
      'The transaction cannot be completed due to incomplete ownership shares. Please contact customer support if you have any inquiries.',
  },
  val058_title: {
    id: 'val058_title',
    defaultmessages: 'Total ownership shares do not add up to 100%',
  },
  val059_content: {
    id: 'val059_content',
    defaultmessages:
      'The transaction cannot be completed as there is an active application. Please contact customer support if you have any inquiries.',
  },
  val059_title: {
    id: 'val059_title',
    defaultmessages: 'There is an active application for the owner(s)',
  },
  val061_content: {
    id: 'val061_content',
    defaultmessages:
      'The transaction cannot be completed as application number {s} is still active. Please contact customer support if you have any inquiries.',
  },
  val061_title: {
    id: 'val061_title',
    defaultmessages: 'Another application of the same type is active',
  },
  val062_content: {
    id: 'val062_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val062_title: {
    id: 'val062_title',
    defaultmessages: 'Concurrent application not found',
  },
  val063_content: {
    id: 'val063_content',
    defaultmessages:
      'The transaction cannot be completed as we are currently not supporting multiple property agreements. Please contact customer support if you have any inquiries.',
  },
  val063_title: {
    id: 'val063_title',
    defaultmessages: 'Service currently unavailable',
  },
  val064_content: {
    id: 'val064_content',
    defaultmessages: 'Lease agreement needed to proceed with the application, please contact customer support.',
  },
  val064_title: {
    id: 'val064_title',
    defaultmessages: 'Lease multiple property not found',
  },
  val065_content: {
    id: 'val065_content',
    defaultmessages: 'Land use is needed to proceed with your application, please contact customer support.',
  },
  val065_title: {
    id: 'val065_title',
    defaultmessages: 'Land use not found',
  },
  val066_content: {
    id: 'val066_content',
    defaultmessages:
      'Land endowment needed to proceed with your application. If the issue persists, please contact customer support.',
  },
  val066_title: {
    id: 'val066_title',
    defaultmessages: 'Land endowment not found',
  },
  val067_content: {
    id: 'val067_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val067_title: {
    id: 'val067_title',
    defaultmessages: 'Investment area nationality check not found',
  },
  val068_content: {
    id: 'val068_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val068_title: {
    id: 'val068_title',
    defaultmessages: 'Allotment property not found',
  },
  val069_content: {
    id: 'val069_content',
    defaultmessages: '',
  },
  val069_title: {
    id: 'val069_title',
    defaultmessages: 'There is an active application on this property',
  },
  val071_content: {
    id: 'val071_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val071_title: {
    id: 'val071_title',
    defaultmessages: "Initiator's ownership not found",
  },
  val072_content: {
    id: 'val072_content',
    defaultmessages:
      'The transaction cannot be completed as it is an ineligible area. Please contact customer support if you have any inquiries.',
  },
  val072_title: {
    id: 'val072_title',
    defaultmessages: 'This unit is in a non-investment area',
  },
  val073_content: {
    id: 'val073_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val073_title: {
    id: 'val073_title',
    defaultmessages: 'Non-investment area not found',
  },
  val074_content: {
    id: 'val074_content',
    defaultmessages: 'Unable to proceed with application. Please contact customer support if you have any inquiries.',
  },
  val074_title: {
    id: 'val074_title',
    defaultmessages: 'Could not fetch active applications',
  },
  val075_content: {
    id: 'val075_content',
    defaultmessages:
      'The transaction cannot be completed as the property has not been uploaded to ADGM. Please contact customer support if you have any questions.',
  },
  val075_title: {
    id: 'val075_title',
    defaultmessages: 'Property is not enabled on ADGM system',
  },
  val076_content: {
    id: 'val076_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val076_title: {
    id: 'val076_title',
    defaultmessages: 'DARI property not found',
  },
  val077: {
    id: 'val077',
    defaultmessages: 'To proceed, a valid valuation certificate for this property is required.',
  },
  val077_title: {
    id: 'val077_title',
    defaultmessages: "You don't have a valid valuation certificate for this property",
  },
  val078_content: {
    id: 'val078_content',
    defaultmessages: 'In order to proceed you have to have a valid title deed for this property',
  },
  val078_title: {
    id: 'val078_title',
    defaultmessages: "You don't have a valid title deed for this property",
  },
  val079_content: {
    id: 'val079_content',
    defaultmessages:
      "Owners' parallel application is needed to proceed with your application, please contact customer support.",
  },
  val079_title: {
    id: 'val079_title',
    defaultmessages: "Owners' parallel application not found",
  },
  val080_content: {
    id: 'val080_content',
    defaultmessages: 'Please try again later. If the issue persists, please contact customer support.',
  },
  val080_title: {
    id: 'val080_title',
    defaultmessages: 'Total owner share not found',
  },
  val081_content: {
    id: 'val081_content',
    defaultmessages:
      'The property is blocked in the system, and the transaction cannot be completed. Please contact customer support for further assistance.',
  },
  val081_title: {
    id: 'val081_title',
    defaultmessages: 'Blocked Property',
  },
  val082_content: {
    id: 'val082_content',
    defaultmessages:
      'There is an active investment agreement on this plot, and the transaction cannot be completed. Please contact customer support for further assistance.',
  },
  val082_title: {
    id: 'val082_title',
    defaultmessages: 'Active investment agreement on this plot',
  },
  val083_content: {
    id: 'val083_content',
    defaultmessages:
      'There is an active possessory mortgage on the property, and the transaction cannot be completed. Please contact customer support for further assistance.',
  },
  val083_title: {
    id: 'val083_title',
    defaultmessages: 'Active possessive mortgage',
  },
  val084_content: {
    id: 'val084_content',
    defaultmessages:
      'The plot is currently blocked in the system, and the transaction cannot be completed. Please contact customer support for further assistance.',
  },
  val084_title: {
    id: 'val084_title',
    defaultmessages: 'Blocked plot',
  },
  val085_content: {
    id: 'val085_content',
    defaultmessages:
      'Units do not share the same ownership, you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val085_title: {
    id: 'val085_title',
    defaultmessages: 'Units do not share the same ownership',
  },
  val086_content: {
    id: 'val086_content',
    defaultmessages:
      'You do not have permission to access this property and cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val086_title: {
    id: 'val086_title',
    defaultmessages: 'You do not have permission to access this property',
  },
  val087_content: {
    id: 'val087_content',
    defaultmessages:
      'There is an active Property Management Agreement, you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val087_title: {
    id: 'val087_title',
    defaultmessages: 'Active PMA agreement on property',
  },
  val088_content: {
    id: 'val088_content',
    defaultmessages:
      'The agreement classification you have selected is not supported , you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val088_title: {
    id: 'val088_title',
    defaultmessages: "PMA's classification type not supported",
  },
  val089_content: {
    id: 'val089_content',
    defaultmessages:
      'The agreement type you have selected is invalid , you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val089_title: {
    id: 'val089_title',
    defaultmessages: 'Invalid Agreement Type',
  },
  val090_content: {
    id: 'val090_content',
    defaultmessages:
      'There is an active Sub PMA agreement under this PMA , you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val090_title: {
    id: 'val090_title',
    defaultmessages: 'Sub PMA agreements found ',
  },
  val091_content: {
    id: 'val091_content',
    defaultmessages:
      'Agreement renewal request cannot be processed. Agreement renewal requests can only be made one year after the agreement start date. Please contact customer support if you have any further inquiries, initiate the service one-year prior to the expiry date.',
  },
  val091_title: {
    id: 'val091_title',
    defaultmessages: 'Agreement renewal cannot be done',
  },
  val092_content: {
    id: 'val092_content',
    defaultmessages:
      'All units you have selected are now owned by a different party, preventing the completion of this action. Please either proceed with the currently active PMA or cancel it and initiate a separate PMA for each owner. Please contact customer support if you have any inquiries.',
  },
  val092_title: {
    id: 'val092_title',
    defaultmessages: 'All units ownership changed',
  },
  val093_content: {
    id: 'val093_content',
    defaultmessages:
      'Property management company license was not found  , you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val093_title: {
    id: 'val093_title',
    defaultmessages: 'PMC license is not found',
  },
  val094_content: {
    id: 'val094_content',
    defaultmessages:
      'Property management company license is expired  , you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val094_title: {
    id: 'val094_title',
    defaultmessages: 'PMC Company license expired',
  },
  val095_content: {
    id: 'val095_content',
    defaultmessages:
      'Property management company license is cancelled  , you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val095_title: {
    id: 'val095_title',
    defaultmessages: 'PMC Company license cancelled ',
  },
  val096_content: {
    id: 'val096_content',
    defaultmessages:
      ' Some of the units you have selected are now owned by a different party, preventing the completion of this action. Please either proceed with the currently active PMA or cancel it and initiate a separate PMA for each owner.”',
  },
  val096_title: {
    id: 'val096_title',
    defaultmessages: 'Properties Ownership change of some of the properties (Not All)',
  },
  val097_content: {
    id: 'val097_content',
    defaultmessages:
      'Freehold PMA only allows residential units. Please contact customer support if you have any inquiries.',
  },
  val097_title: {
    id: 'val097_title',
    defaultmessages: 'Freehold PMA allows Residential Units only',
  },
  val098_content: {
    id: 'val098_content',
    defaultmessages:
      'Property Ownership has changed and Properties cannot be removed as they exist in a Sub PMA. Please contact customer support if you have any inquiries.',
  },
  val098_title: {
    id: 'val098_title',
    defaultmessages: 'Property Ownership has changed and Properties cannot be removed as they exist in a Sub PMA.',
  },
  val099_content: {
    id: 'val099_content',
    defaultmessages:
      "Owner's Mobile No. is empty or invalid ,you cannot complete this transaction. Please contact customer support if you have any inquiries.",
  },
  val099_title: {
    id: 'val099_title',
    defaultmessages: 'Owner/s mobile no is empty or invalid',
  },
  val100000_content: {
    id: 'val100000_content',
    defaultmessages: 'The system is unable to locate any properties that match your search criteria.',
  },
  val100000_title: {
    id: 'val100000_title',
    defaultmessages: 'Unable to find properties',
  },
  val100001_content: {
    id: 'val100001_content',
    defaultmessages: 'Off-Plan property found in the agreement',
  },
  val100001_title: {
    id: 'val100001_title',
    defaultmessages: 'Off-plan property found in the agreement',
  },
  val100002_content: {
    id: 'val100002_content',
    defaultmessages: 'The mortgage bank found is different from the one mentioned in the original agreement.',
  },
  val100002_title: {
    id: 'val100002_title',
    defaultmessages: 'The mortgage bank found is different from the one mentioned in the original agreement.',
  },
  val100003_content: {
    id: 'val100003_content',
    defaultmessages: 'The new agreement start date does not have a three-month buffer from the mortgage end date.',
  },
  val100003_title: {
    id: 'val100003_title',
    defaultmessages: 'The new agreement start date does not have the buffer of 3 months before the mortgage end date.',
  },
  val100004_content: {
    id: 'val100004_content',
    defaultmessages: 'Mortgage does not belong to a registered bank.',
  },
  val100004_content_mortgage: {
    id: 'val100004_content_mortgage',
    defaultmessages: 'The mortgage does not belong to a registered bank on DARI.',
  },
  val100004_title: {
    id: 'val100004_title',
    defaultmessages: 'The mortgage does not belong to a registered bank on DARI.',
  },
  val100005_content: {
    id: 'val100005_content',
    defaultmessages: 'Does not have the permission to initiate the application',
  },
  val100005_title: {
    id: 'val100005_title',
    defaultmessages: 'Does not have the permission to initiate the application',
  },
  val100007_content: {
    id: 'val100007_content',
    defaultmessages: 'Please make sure that the developer property ownership type is "Musataha"',
  },
  val100007_title: {
    id: 'val100007_title',
    defaultmessages: 'The developer property ownership type is not "Musataha"',
  },
  val100008_content: {
    id: 'val100008_content',
    defaultmessages:
      'We regret to inform you that we were unable to locate any project details for the property you have selected.',
  },
  val100008_title: {
    id: 'val100008_title',
    defaultmessages: 'Unable to find the project details for the selected property',
  },
  val100010_content: {
    id: 'val100010_content',
    defaultmessages: 'The investment agreement for this property not found',
  },
  val100010_title: {
    id: 'val100010_title',
    defaultmessages: 'The investment agreement for this property not found',
  },
  val100011_content: {
    id: 'val100011_content',
    defaultmessages: 'Multiple investment agreements found',
  },
  val100011_title: {
    id: 'val100011_title',
    defaultmessages: 'Multiple investment agreements found',
  },
  val100012_content: {
    id: 'val100012_content',
    defaultmessages: 'The selected unit owner differs from the landowner',
  },
  val100012_title: {
    id: 'val100012_title',
    defaultmessages: 'The selected unit owner differs from the landowner',
  },
  val100013_content: {
    id: 'val100013_content',
    defaultmessages: 'The new agreement start date does not have a 3-month buffer before the investment end date.',
  },
  val100013_title: {
    id: 'val100013_title',
    defaultmessages: 'The new agreement start date does not have 3-month buffer before the investment end date.',
  },
  val100014_content: {
    id: 'val100014_content',
    defaultmessages: 'Investment agreement details cannot be found',
  },
  val100014_title: {
    id: 'val100014_title',
    defaultmessages: 'Could not find the investment agreement details',
  },
  val100015_content: {
    id: 'val100015_content',
    defaultmessages: 'There are no valid agreements (Investment, Musataha, Usufruct, Long lease) on this property.',
  },
  val100015_title: {
    id: 'val100015_title',
    defaultmessages: 'Property does not have an active (Investment, Musataha, Usufruct, Long lease) agreements',
  },
  val100016_content: {
    id: 'val100016_content',
    defaultmessages: 'There is an active application on SmartHub for this property',
  },
  val100016_title: {
    id: 'val100016_title',
    defaultmessages: 'There is an active application on SmartHub for this property',
  },
  val100_content: {
    id: 'val100_content',
    defaultmessages: 'No Site Plan Image for this Property',
  },
  val100_title: {
    id: 'val100_title',
    defaultmessages: 'No Site Plan Image for this Property',
  },
  val101_content: {
    id: 'val101_content',
    defaultmessages:
      'Owner EID is empty or invalid ,you cannot complete this transaction. Please contact customer support if you have any inquiries.',
  },
  val101_title: {
    id: 'val101_title',
    defaultmessages: "Owner's EID is empty or invalid",
  },
  val102_content: {
    id: 'val102_content',
    defaultmessages:
      'Acquisition and right hold type are not allowed for this service. Please contact customer support if you have any inquiries.',
  },
  val102_title: {
    id: 'val102_title',
    defaultmessages: 'Right hold type and acquisition combination is not allowed',
  },
  val103_content: {
    id: 'val103_content',
    defaultmessages: 'The selected properties must be on the same land',
  },
  val103_title: {
    id: 'val103_title',
    defaultmessages: 'Properties are not on the same land',
  },
  val104_content: {
    id: 'val104_content',
    defaultmessages: 'Property owner company does not exist in our system , you cannot complete this transaction ',
  },
  val104_title: {
    id: 'val104_title',
    defaultmessages: 'Property owner does not exist in our system',
  },
  val106_content: {
    id: 'val106_content',
    defaultmessages: 'You cannot complete this transaction',
  },
  val106_title: {
    id: 'val106_title',
    defaultmessages: 'There is an active application on the selected property',
  },
  val107_content: {
    id: 'val107_content',
    defaultmessages: 'Freehold property management agreement can only be initiated by a developer.',
  },
  val107_title: {
    id: 'val107_title',
    defaultmessages: 'This service is only eligible for developers',
  },
  val108_content: {
    id: 'val108_content',
    defaultmessages:
      'The transaction cannot be completed. The system has failed to retrieve the site plan, please contact customer support.',
  },
  val108_title: {
    id: 'val108_title',
    defaultmessages: 'Could not fetch site plan',
  },
  val109_content: {
    id: 'val109_content',
    defaultmessages: 'This is not a valid agreement as per the agreement end date',
  },
  val109_title: {
    id: 'val109_title',
    defaultmessages: 'The agreement end date is not valid',
  },
  val110_content: {
    id: 'val110_content',
    defaultmessages:
      'The transaction cannot be completed. Kindly renew your trade license to proceed with the application, for any inquiries contact customer support.',
  },
  val110_title: {
    id: 'val110_title',
    defaultmessages: 'Trade license is expired',
  },
  val111_content: {
    id: 'val111_content',
    defaultmessages:
      'The transaction cannot be completed. The company is not registered in the system, please contact customer support.',
  },
  val111_title: {
    id: 'val111_title',
    defaultmessages: 'Company not found',
  },
  val112_content: {
    id: 'val112_content',
    defaultmessages:
      'The transaction cannot be completed. The lessee is blocked. please contact customer support for assistance.',
  },
  val112_title: {
    id: 'val112_title',
    defaultmessages: 'Lessee is blocked',
  },
  val113_content: {
    id: 'val113_content',
    defaultmessages:
      'The transaction cannot be completed. The owner/lessee is not an Emirate national, please contact customer support.',
  },
  val113_title: {
    id: 'val113_title',
    defaultmessages: 'Owner/Lessee is not local',
  },
  val114_content: {
    id: 'val114_content',
    defaultmessages:
      'The transaction cannot be completed as the Musataha agreement is not active. Please contact customer support for assistance.',
  },
  val114_title: {
    id: 'val114_title',
    defaultmessages: 'Musataha agreement not active',
  },
  val115_content: {
    id: 'val115_content',
    defaultmessages:
      'The transaction cannot be completed as the Musataha agreement was not found. Please contact customer support for assistance.',
  },
  val115_title: {
    id: 'val115_title',
    defaultmessages: 'Musataha agreement not found',
  },
  val116_content: {
    id: 'val116_content',
    defaultmessages:
      'The transaction cannot be completed. The company (owner/lessee) does not exist in the system, please contact customer support.',
  },
  val116_title: {
    id: 'val116_title',
    defaultmessages: 'Company (Owner/Lessee) does not exist in system',
  },
  val117_content: {
    id: 'val117_content',
    defaultmessages:
      'The transaction cannot be completed. The company (owner/lessee) users does not exist in the system, please contact customer support.',
  },
  val117_title: {
    id: 'val117_title',
    defaultmessages: 'Company (Owner/Lessee) users does not exist in system',
  },
  val118_content: {
    id: 'val118_content',
    defaultmessages:
      'The transaction cannot be completed as the Musataha agreement must include a start date. Please contact customer support for assistance.',
  },
  val118_title: {
    id: 'val118_title',
    defaultmessages: 'Musataha agreement start date is invalid',
  },
  val119_content: {
    id: 'val119_content',
    defaultmessages:
      'The transaction cannot be completed as the Musataha agreement must include an annual amount. Please contact customer support for assistance.',
  },
  val119_title: {
    id: 'val119_title',
    defaultmessages: 'Musataha agreement annual amount is invalid',
  },
  val120_content: {
    id: 'val120_content',
    defaultmessages:
      'The transaction cannot be completed. Long lease agreement was not found, please contact customer support.',
  },
  val120_title: {
    id: 'val120_title',
    defaultmessages: 'Long lease agreement not found',
  },
  val121_content: {
    id: 'val121_content',
    defaultmessages:
      'The transaction cannot be completed. There is no owner for this property, please contact customer support.',
  },
  val121_title: {
    id: 'val121_title',
    defaultmessages: "There's no owner in this property",
  },
  val122_content: {
    id: 'val122_content',
    defaultmessages:
      'The transaction cannot be completed. There is no lessee in this property, please contact customer support.',
  },
  val122_title: {
    id: 'val122_title',
    defaultmessages: 'There is no lessee in this property',
  },
  val123_content: {
    id: 'val123_content',
    defaultmessages:
      'The transaction cannot be completed. This property is not listed under any development project. Please contact customer support.',
  },
  val123_title: {
    id: 'val123_title',
    defaultmessages: 'Property is not under a development project',
  },
  val124_content: {
    id: 'val124_content',
    defaultmessages:
      'The transaction cannot be completed. This property is not an off-plan property. Please contact customer support.',
  },
  val124_title: {
    id: 'val124_title',
    defaultmessages: 'Property is not off plan',
  },
  val125_content: {
    id: 'val125_content',
    defaultmessages:
      'The transaction cannot be completed as the project status  for this property is Offplan while it should be completed to proceed with this service. Please contact customer support for assistance.',
  },
  val125_title: {
    id: 'val125_title',
    defaultmessages: 'This property status not completed !',
  },
  val126_content: {
    id: 'val126_content',
    defaultmessages:
      'The transaction cannot be completed. The property owners for the developer were not found. Please contact customer support.',
  },
  val126_title: {
    id: 'val126_title',
    defaultmessages: 'Property owners for developer not found',
  },
  val127_content: {
    id: 'val127_content',
    defaultmessages:
      'The transaction cannot be completed. The property owner for the developer has no details. Please contact customer support.',
  },
  val127_title: {
    id: 'val127_title',
    defaultmessages: 'Property Owner for developer has no details',
  },
  val128_content: {
    id: 'val128_content',
    defaultmessages:
      'The transaction cannot be completed. The owner does not have a developer license. Please contact customer support.',
  },
  val128_title: {
    id: 'val128_title',
    defaultmessages: 'Owner license is invalid',
  },
  val129_content: {
    id: 'val129_content',
    defaultmessages:
      'The transaction cannot be completed. The developer has an expired license. Please contact customer support.',
  },
  val129_title: {
    id: 'val129_title',
    defaultmessages: 'Developer license expired',
  },
  val130_content: {
    id: 'val130_content',
    defaultmessages:
      'The transaction cannot be completed. There is an active PMA termination application, please contact customer support.',
  },
  val130_title: {
    id: 'val130_title',
    defaultmessages: 'PMA Surrender Application Active',
  },
  val131_content: {
    id: 'val131_content',
    defaultmessages:
      'Property is not off-plan, you cannot complete the transaction. Please contact customer support if you have any inquiries.',
  },
  val131_title: {
    id: 'val131_title',
    defaultmessages: 'Property is not off plan',
  },
  val132_content: {
    id: 'val132_content',
    defaultmessages:
      'Mortgage registration is not possible if a Musataha agreement exists. For any inquiries, please contact customer support.',
  },
  val132_title: {
    id: 'val132_title',
    defaultmessages: 'Musataha agreement exists',
  },
  val133_content: {
    id: 'val133_content',
    defaultmessages:
      'A title deed cannot be issued for a plot with a Musataha agreement. For any inquiries, please contact customer support.',
  },
  val133_title: {
    id: 'val133_title',
    defaultmessages: 'Plot has Musataha Agreement',
  },
  val134_content: {
    id: 'val134_content',
    defaultmessages:
      'The Project status of the property selected is incomplete, please contact your project developer.',
  },
  val134_title: {
    id: 'val134_title',
    defaultmessages: 'The Project status of this property is incomplete',
  },
  val135_content: {
    id: 'val135_content',
    defaultmessages: 'User was not found on AccessRP , Please contact customer support if you have any inquiries.',
  },
  val135_title: {
    id: 'val135_title',
    defaultmessages: 'User does not exist in the system',
  },
  val136_content: {
    id: 'val136_content',
    defaultmessages: 'This property must not have multiple units to proceed with the application',
  },
  val136_title: {
    id: 'val136_title',
    defaultmessages: 'This land has multiple units',
  },
  val137_content: {
    id: 'val137_content',
    defaultmessages: 'Villas are considered a part of plot services, please select the plot services to continue',
  },
  val137_title: {
    id: 'val137_title',
    defaultmessages: 'The selected unit is a villa',
  },
  val138_content: {
    id: 'val138_content',
    defaultmessages: 'The transaction cannot be completed as the selected property has been previously sold',
  },
  val138_title: {
    id: 'val138_title',
    defaultmessages: 'This property has been previously sold',
  },
  val139_content: {
    id: 'val139_content',
    defaultmessages:
      'The transaction cannot be completed as there is an existing first degree mortgage registered on the selected property',
  },
  val139_title: {
    id: 'val139_title',
    defaultmessages: 'There is an existing first degree insurance mortgage registered on this property',
  },
  val140_content: {
    id: 'val140_content',
    defaultmessages: 'Lease and PMA agreements cannot be issued for plots that are for personal use',
  },
  val140_title: {
    id: 'val140_title',
    defaultmessages: 'This plot is for personal use and not tradable.',
  },
  val141_content: {
    id: 'val141_content',
    defaultmessages: 'This property is for social cases and lease services cannot be issued on this plot',
  },
  val141_title: {
    id: 'val141_title',
    defaultmessages: 'Lease agreement registration cannot be issued to social cases properties',
  },
  val142_content: {
    id: 'val142_content',
    defaultmessages: 'You cannot add properties from different municipalities under the same PMA',
  },
  val142_title: {
    id: 'val142_title',
    defaultmessages: 'Properties selected are in more than one municipality',
  },
  val143_content: {
    id: 'val143_content',
    defaultmessages: 'You are not eligible to lease this property in musaffah zone',
  },
  val143_title: {
    id: 'val143_title',
    defaultmessages: 'Musaffah zone lease restriction',
  },
  val144_content: {
    id: 'val144_content',
    defaultmessages: 'You are not eligible for this service Plot needs to be owned by government',
  },
  val144_title: {
    id: 'val144_title',
    defaultmessages: 'Plot not owned by government',
  },
  val145_content: {
    id: 'val145_content',
    defaultmessages: 'You do not have any due rent amounts for this agreement',
  },
  val145_title: {
    id: 'val145_title',
    defaultmessages: 'Agreement amount is fully paid',
  },
  val146_content: {
    id: 'val146_content',
    defaultmessages: 'An active musataha agreement is needed to complete this transaction',
  },
  val146_title: {
    id: 'val146_title',
    defaultmessages: 'Musataha agreement was not found or is expired',
  },
  val147_content: {
    id: 'val147_content',
    defaultmessages:
      "The National Housing Mortgage application does not accept this property's land use, as it only supports Residential land uses. For any inquiries, please contact customer support.",
  },
  val147_title: {
    id: 'val147_title',
    defaultmessages: "Selected property's land use is not allowed for this service.",
  },
  val148_content: {
    id: 'val148_content',
    defaultmessages:
      'The correct hold type for this property is not Ownership. Please contact customer support for any inquiries.',
  },
  val148_title: {
    id: 'val148_title',
    defaultmessages: 'Right hold type is not allowed',
  },
  val149_content: {
    id: 'val149_content',
    defaultmessages:
      'Transaction cannot be completed due to property restriction , please contact customer support for any inquiries',
  },
  val149_title: {
    id: 'val149_title',
    defaultmessages: 'This property is restricted',
  },
  val150_content: {
    id: 'val150_content',
    defaultmessages:
      'Please ensure you cancel application {s} on either platforms in order to proceed with the transaction',
  },
  val150_title: {
    id: 'val150_title',
    defaultmessages: 'There is active application on smarthub for this property',
  },
  val151_content: {
    id: 'val151_content',
    defaultmessages: 'The transaction cannot be completed as the selected property parent building is blocked',
  },
  val151_title: {
    id: 'val151_title',
    defaultmessages: 'Hassntuk blocked',
  },
  val152_content: {
    id: 'val152_content',
    defaultmessages: 'You are not eligible for this service. The property selected has an off plan agreement.',
  },
  val152_title: {
    id: 'val152_title',
    defaultmessages: 'You cannot start this service on an off plan property',
  },
  val153_content: {
    id: 'val153_content',
    defaultmessages: "You can't complete this transaction in temporary ranch properties",
  },
  val153_title: {
    id: 'val153_title',
    defaultmessages: 'There is no rent payment for temporary ranch',
  },
  val154_content: {
    id: 'val154_content',
    defaultmessages:
      'The selected user is a non-UAE resident. Please register them before proceeding with the transaction.',
  },
  val154_title: {
    id: 'val154_title',
    defaultmessages: 'Non-UAE resident is not registered in AccessRP',
  },
  val155_content: {
    id: 'val155_content',
    defaultmessages: 'Passport number is mandatory in order to proceed with the transaction',
  },
  val155_title: {
    id: 'val155_title',
    defaultmessages: "Non-UAE resident doesn't have a passport number",
  },
  val156_content: {
    id: 'val156_content',
    defaultmessages: 'Email address is mandatory in order to proceed with the transaction',
  },
  val156_title: {
    id: 'val156_title',
    defaultmessages: "Non-UAE resident doesn't have an email address.",
  },
  val157_content: {
    id: 'val157_content',
    defaultmessages: 'This service is only applicable on properties with the same owner',
  },
  val157_title: {
    id: 'val157_title',
    defaultmessages: 'Units selected do not have the same owner',
  },
  val158_content: {
    id: 'val158_content',
    defaultmessages: 'All units should be under one building in order to proceed with the service',
  },
  val158_title: {
    id: 'val158_title',
    defaultmessages: 'Units are not under the same building',
  },
  val159_content: {
    id: 'val159_content',
    defaultmessages: 'All units must have the same unit usage type in order to proceed with the service',
  },
  val159_title: {
    id: 'val159_title',
    defaultmessages: 'Unit usage for the units selected are not the same',
  },
  val160_content: {
    id: 'val160_content',
    defaultmessages:
      'Selected units are classified as villas and hence must be under the same land in order to proceed',
  },
  val160_title: {
    id: 'val160_title',
    defaultmessages: 'All villas selected should be under the same land',
  },
  val162_content: {
    id: 'val162_content',
    defaultmessages:
      'The transaction cannot be completed as there is an active application {s}. Please contact customer support if you have any inquiries.',
  },
  val162_title: {
    id: 'val162_title',
    defaultmessages: 'There is an active application for this project',
  },
  val163_content: {
    id: 'val163_content',
    defaultmessages: 'Developer should have a trading license in order to proceed',
  },
  val163_title: {
    id: 'val163_title',
    defaultmessages: 'Developer trading license not found',
  },
  val164_content: {
    id: 'val164_content',
    defaultmessages:
      'In order to proceed with any transaction, you must have an escrow account opened for this project',
  },
  val164_title: {
    id: 'val164_title',
    defaultmessages: 'Escrow account does not exist',
  },
  val165_content: {
    id: 'val165_content',
    defaultmessages: "Register an escrow account for this project, we can't find registered escrow account on AccessRP",
  },
  val165_title: {
    id: 'val165_title',
    defaultmessages: 'Escrow account is not registered in AccessRP',
  },
  val166_content: {
    id: 'val166_content',
    defaultmessages: 'The property selected is not eligible for multiple unit lease agreement',
  },
  val166_title: {
    id: 'val166_title',
    defaultmessages: 'Cannot register Multiple unit lease agreement',
  },
  val167_content: {
    id: 'val167_content',
    defaultmessages:
      'The transaction cannot be completed as the dispute selected is of civil type. This transaction is allowed only for disputes of commercial type.',
  },
  val167_title: {
    id: 'val167_title',
    defaultmessages: 'Dispute is not commercial',
  },
  val168_content: {
    id: 'val168_content',
    defaultmessages:
      "The transaction cannot be completed, as the developer's contact information is needed. Please contact customer support.",
  },
  val168_title: {
    id: 'val168_title',
    defaultmessages: 'Developer has no contact information',
  },
  val169_content: {
    id: 'val169_content',
    defaultmessages: "The transaction can't be completed. The developer should have a signatory in order to proceed.",
  },
  val169_title: {
    id: 'val169_title',
    defaultmessages: 'Developer has no signatory',
  },
  val170_content: {
    id: 'val170_content',
    defaultmessages: 'The transaction cannot be completed as the selected project has an existing escrow account.',
  },
  val170_title: {
    id: 'val170_title',
    defaultmessages: 'Escrow account already exists',
  },
  val171_content: {
    id: 'val171_content',
    defaultmessages:
      'The transaction cannot be completed as the progress percentage for the selected project must be less than 100% to proceed.',
  },
  val171_title: {
    id: 'val171_title',
    defaultmessages: 'Progress percentage not less than 100',
  },
  val172_content: {
    id: 'val172_content',
    defaultmessages:
      'The transaction cannot be completed as the selected project must be an off-plan project to proceed.',
  },
  val172_title: {
    id: 'val172_title',
    defaultmessages: 'The project is not an off-plan project',
  },
  val173_content: {
    id: 'val173_content',
    defaultmessages: 'The transaction cannot be completed as there is another active application',
  },
  val173_title: {
    id: 'val173_title',
    defaultmessages: 'There is an active application for this user.',
  },
  val174_content: {
    id: 'val174_content',
    defaultmessages: 'You must have at least one of the following trade license activities to apply for this service',
  },
  val174_title: {
    id: 'val174_title',
    defaultmessages: 'Company activity license is required',
  },
  val175_content: {
    id: 'val175_content',
    defaultmessages: 'Units found are from multiple plots',
  },
  val175_title: {
    id: 'val175_title',
    defaultmessages: 'Units found are from multiple plots',
  },
  val176_content: {
    id: 'val176_content',
    defaultmessages: 'Real Estate Category: Land',
  },
  val176_title: {
    id: 'val176_title',
    defaultmessages: 'Property Type: Land',
  },
  val177_content: {
    id: 'val177_content',
    defaultmessages:
      'You cannot complete this transaction as the selected property mortgage could not be found. Please contact our customer service for further assistance.',
  },
  val177_title: {
    id: 'val177_title',
    defaultmessages: 'Property mortgage not found',
  },
  val178_content: {
    id: 'val178_content',
    defaultmessages: 'Unfortunately, we were unable to locate any activity records for the selected company.',
  },
  val178_title: {
    id: 'val178_title',
    defaultmessages: 'Company activity not found',
  },
  val179_content: {
    id: 'val179_content',
    defaultmessages:
      'The transaction cannot be completed as multiple possessory mortgages were found on the selected property.',
  },
  val179_title: {
    id: 'val179_title',
    defaultmessages: 'Multiple possessory mortgages found',
  },
  val180_content: {
    id: 'val180_content',
    defaultmessages: 'The transaction cannot be completed. The selected property should be "Ready", not "Off-Plan".',
  },
  val180_title: {
    id: 'val180_title',
    defaultmessages: 'The selected property is "Off-Plan"',
  },
  val181_content: {
    id: 'val181_content',
    defaultmessages: 'You cannot complete the transaction because the property is not registered on Tawtheeq',
  },
  val181_title: {
    id: 'val181_title',
    defaultmessages: 'The property is not registered on Tawtheeq',
  },
  val182_content: {
    id: 'val182_content',
    defaultmessages:
      'You cannot complete this transaction, the bank is not found in our system. please contact our customer service for further assistance.',
  },
  val182_title: {
    id: 'val182_title',
    defaultmessages: 'Bank is not found in our system',
  },
  val183_content: {
    id: 'val183_content',
    defaultmessages: 'It seems that Mortgage Bank is not currently registered in AccessRP.',
  },
  val183_title: {
    id: 'val183_title',
    defaultmessages: 'Mortgage Bank is not registered in AccessRP',
  },
  val184_content: {
    id: 'val184_content',
    defaultmessages:
      "You cannot complete your transaction because the bank doesn't have an active possessive mortgage agreement",
  },
  val184_title: {
    id: 'val184_title',
    defaultmessages: "The bank doesn't have an active possessive mortgage agreement",
  },
  val185_content: {
    id: 'val185_content',
    defaultmessages: 'In order to proceed with this application, the chosen units need to be within the same building',
  },
  val185_title: {
    id: 'val185_title',
    defaultmessages: 'Units under different building numbers are not allowed',
  },
  val186_content: {
    id: 'val186_content',
    defaultmessages: 'Agreement has more than 90 days to expire',
  },
  val186_title: {
    id: 'val186_title',
    defaultmessages: 'Ninety days before expiration',
  },
  val187_content: {
    id: 'val187_content',
    defaultmessages: 'Company does not have an ADGM commercial license',
  },
  val187_title: {
    id: 'val187_title',
    defaultmessages: 'Company does not have an ADGM commercial license',
  },
  val188_content: {
    id: 'val188_content',
    defaultmessages: 'Company commercial license is expired',
  },
  val188_title: {
    id: 'val188_title',
    defaultmessages: 'Company commercial license is expired',
  },
  val189_content: {
    id: 'val189_content',
    defaultmessages: '',
  },
  val189_title: {
    id: 'val189_title',
    defaultmessages: 'Agreement type is not valid',
  },
  val190_content: {
    id: 'val190_content',
    defaultmessages: 'The leaseholder customer is the initiator.',
  },
  val190_title: {
    id: 'val190_title',
    defaultmessages: 'The leaseholder customer is the initiator.',
  },
  val191_content: {
    id: 'val191_content',
    defaultmessages: 'An escrow account is not registered for this project. You cannot proceed with the application.',
  },
  val191_title: {
    id: 'val191_title',
    defaultmessages: 'The escrow account is not registered for this project.',
  },
  val200000_content: {
    id: 'val200000_content',
    defaultmessages: 'You need to select a mortgaged property to proceed with this transaction',
  },
  val200000_title: {
    id: 'val200000_title',
    defaultmessages: 'Property is not mortgaged',
  },
  val200001_content: {
    id: 'val200001_content',
    defaultmessages: 'The passport is expired. Please renew the passport or reach out to our support team.',
  },
  val200001_title: {
    id: 'val200001_title',
    defaultmessages: 'User passport is expired',
  },
  val200002_content: {
    id: 'val200002_content',
    defaultmessages: "Please complete the user's information to continue.",
  },
  val200002_title: {
    id: 'val200002_title',
    defaultmessages: "User's info is incomplete",
  },
  val200003_content: {
    id: 'val200003_content',
    defaultmessages:
      'The selected property must have available at least one slot to add mortgages (Insurance Degrees 1, 2, 3, or Possessive Mortgage). Please ensure the property meets the slot availability criteria before proceeding.',
  },
  val200003_title: {
    id: 'val200003_title',
    defaultmessages: 'No available mortgage slots!',
  },
  val200004_content: {
    id: 'val200004_content',
    defaultmessages: "Possessory Mortgages exist on selected property owner can't initiate lease services",
  },
  val200004_title: {
    id: 'val200004_title',
    defaultmessages: 'Lease Services are not allowed this property',
  },
  val200005_content: {
    id: 'val200005_content',
    defaultmessages: "Possessory Mortgages exist on selected property owner can't initiate",
  },
  val200005_title: {
    id: 'val200005_title',
    defaultmessages: 'Possessive Mortgage exist on unit',
  },
  val200006_content: {
    id: 'val200006_content',
    defaultmessages: "PMA's services are not allowed on possessive mortgage properties",
  },
  val200006_title: {
    id: 'val200006_title',
    defaultmessages: 'Possessive Mortgage exists on this property !',
  },
  val200007_content: {
    id: 'val200007_content',
    defaultmessages:
      'The selected property must be associated with a project to proceed. Please contact customer support for assistance.',
  },
  val200007_title: {
    id: 'val200007_title',
    defaultmessages: 'The Property not associated with any project',
  },
  val200008_content: {
    id: 'val200008_content',
    defaultmessages:
      'Application cannot be completed as the property has a block. For assistance, please contact our customer support.',
  },
  val200008_title: {
    id: 'val200008_title',
    defaultmessages: 'The selected property is blocked',
  },
  val200009_content: {
    id: 'val200009_content',
    defaultmessages:
      'Transaction cannot be completed as the owner has a block. For assistance, please contact our customer support.',
  },
  val200009_title: {
    id: 'val200009_title',
    defaultmessages: 'The customer is blocked',
  },
  val200010_content: {
    id: 'val200010_content',
    defaultmessages:
      'A valid Emirates ID or Unified Number is required for individuals, or a valid License Number is required for companies. Please contact customer support for further assistance.',
  },
  val200010_title: {
    id: 'val200010_title',
    defaultmessages: 'No valid identification document or license exists.',
  },
  val200011_content: {
    id: 'val200011_content',
    defaultmessages:
      'There are active multiple mortgages on the selected property, and the application cannot be completed. Please arrange to discharge all mortgages first, then proceed with the application. Alternatively, contact customer support for further assistance.',
  },
  val200011_title: {
    id: 'val200011_title',
    defaultmessages: 'Multiple mortgages exist!',
  },
  val200013_content: {
    id: 'val200013_content',
    defaultmessages:
      'There is an active possessory mortgage on the property, and the application cannot be completed. Please contact customer support for further assistance.',
  },
  val200013_title: {
    id: 'val200013_title',
    defaultmessages: 'Possessory Mortgage exists !',
  },
  val200014_content: {
    id: 'val200014_content',
    defaultmessages: 'Subleasing is not allowed under this agreement',
  },
  val200014_title: {
    id: 'val200014_title',
    defaultmessages: 'Subleasing is not allowed',
  },
  val200015_content: {
    id: 'val200015_content',
    defaultmessages: 'This unit is not listed in the parent agreement',
  },
  val200015_title: {
    id: 'val200015_title',
    defaultmessages: 'Unit does not exist',
  },
  val200016_content: {
    id: 'val200016_content',
    defaultmessages:
      "The action cannot be completed due to master lease existence, You can't surrender, close or terminate a master lease agreement. Please contact our customer support for assistance.",
  },
  val200016_title: {
    id: 'val200016_title',
    defaultmessages: 'This is a master lease agreement!',
  },
  val200017_content: {
    id: 'val200017_content',
    defaultmessages:
      'The action cannot be completed due to an active child sub lease agreement already exists, please cancel them first and proceed or contact our customer support for assistance.',
  },
  val200017_title: {
    id: 'val200017_title',
    defaultmessages: 'Active child sublease agreement exists!',
  },
  val200018_content: {
    id: 'val200018_content',
    defaultmessages: 'The action is not allowed on subunits, please contact our customer support for assistance.',
  },
  val200018_message: {
    id: 'val200018_message',
    defaultmessages: 'This service is not allowed for subunit',
  },
  val200018_title: {
    id: 'val200018_title',
    defaultmessages: 'This service is not allowed for subunit!',
  },
  val200019_content: {
    id: 'val200019_content',
    defaultmessages:
      'The action cannot be completed due to an active parent sub lease agreement already exists, please select another or contact our customer support for assistance.',
  },
  val200019_title: {
    id: 'val200019_title',
    defaultmessages: 'Active parent sublease agreement exists!',
  },
  val200020_content: {
    id: 'val200020_content',
    defaultmessages:
      'This action cannot be completed as you are not authorized to perform it. Please contact customer support for assistance.',
  },
  val200020_title: {
    id: 'val200020_title',
    defaultmessages: 'You have no right to perform this action',
  },
  val200021_content: {
    id: 'val200021_content',
    defaultmessages:
      'The action is not allowed since the master lease agreement is expired, please contact our customer support for assistance.',
  },
  val200021_title: {
    id: 'val200021_title',
    defaultmessages: 'Master lesae is expired !',
  },
  val200023_content: {
    id: 'val200023_content',
    defaultmessages: 'Sublease within the same application is only allowed for the units under the same parent unit.',
  },
  val200023_title: {
    id: 'val200023_title',
    defaultmessages: 'Multiple units out of different parent properties were selected !',
  },
  val200024_content: {
    id: 'val200024_content',
    defaultmessages:
      'The action is not allowed lessee must have an alternative address to rent this property, please contact our customer support for assistance.',
  },
  val200024_title: {
    id: 'val200024_title',
    defaultmessages: 'You have no right to perform this action!',
  },
  val200025_content: {
    id: 'val200025_content',
    defaultmessages:
      'A maximum of two legal notices is allowed per agreement. You cannot submit an additional notice for this agreement.',
  },
  val200025_title: {
    id: 'val200025_title',
    defaultmessages: "You can't proceed with this action!",
  },
  val200026_content: {
    id: 'val200026_content',
    defaultmessages:
      'Application cannot be completed as the developer has a block. For assistance, please contact our customer support.',
  },
  val200026_title: {
    id: 'val200026_title',
    defaultmessages: "You can't proceed with this action!",
  },
  val200027_content: {
    id: 'val200027_content',
    defaultmessages:
      'The first legal notice has not yet fulfilled the required 14-day period. Please wait until the 14-day duration has passed before proceeding.',
  },
  val200027_title: {
    id: 'val200027_title',
    defaultmessages: "You can't proceed with this action!",
  },
  val200027_title_copy: {
    id: 'val200027_title_copy',
    defaultmessages: "You can't proceed with this action!",
  },
  val200028_content: {
    id: 'val200028_content',
    defaultmessages: 'Second Legal Notice must be registered before proceeding with termination due to non-payment.',
  },
  val200028_title: {
    id: 'val200028_title',
    defaultmessages: "You can't proceed with this action!",
  },
  val200029_content: {
    id: 'val200029_content',
    defaultmessages: 'Leasehold agreement exists on Unit. You can only initiate at the unit level.',
  },
  val200029_title: {
    id: 'val200029_title',
    defaultmessages: 'Leasehold agreement  already exist!',
  },
  val200030_content: {
    id: 'val200030_content',
    defaultmessages: "Multiple units exists on land. You can't initiate on a land level.",
  },
  val200030_title: {
    id: 'val200030_title',
    defaultmessages: 'Multiple units already exist!',
  },
  val200031_content: {
    id: 'val200031_content',
    defaultmessages: 'Single unit exists on land. You can only initiate at the land level.',
  },
  val200031_title: {
    id: 'val200031_title',
    defaultmessages: 'Single unit already exist!',
  },
  val203_content: {
    id: 'val203_content',
    defaultmessages: 'Company license has expired',
  },
  val203_title: {
    id: 'val203_title',
    defaultmessages: 'Company license expired',
  },
  val208_content: {
    id: 'val208_content',
    defaultmessages:
      'Cannot proceed with the application as some company details cannot be found on the Department of Economic Development database. Please update the company details before registering on AccessRP or contact support for further assistance.',
  },
  val208_title: {
    id: 'val208_title',
    defaultmessages: 'Some mandatory fields not found on AccessRP',
  },
  val400000_content: {
    id: 'val400000_content',
    defaultmessages: 'You must be logged in with a developer account in order to proceed with this transaction',
  },
  val400000_title: {
    id: 'val400000_title',
    defaultmessages: 'This is not a developer account',
  },
  val400002_content: {
    id: 'val400002_content',
    defaultmessages:
      'Transaction cannot be completed as the owner has a partial block. For assistance, please contact our customer support.',
  },
  val400002_title: {
    id: 'val400002_title',
    defaultmessages: 'Owner is partially blocked',
  },
  val400004_content: {
    id: 'val400004_content',
    defaultmessages:
      'Transaction cannot be completed as the property has a partial block. For assistance, please contact our customer support.',
  },
  val400004_title: {
    id: 'val400004_title',
    defaultmessages: 'Property is partially blocked',
  },
  val500001_content: {
    id: 'val500001_content',
    defaultmessages: 'Please enter a valid agreement date for the industrial agreement',
  },
  val500001_title: {
    id: 'val500001_title',
    defaultmessages: 'The start date of Industrial agreement is invalid',
  },
  val50000235_content: {
    id: 'val50000235_content',
    defaultmessages: 'You have no rights to perform this action',
  },
  val50000235_title: {
    id: 'val50000235_title',
    defaultmessages: 'You have no rights to perform this action',
  },
  val500002_content: {
    id: 'val500002_content',
    defaultmessages: 'Please make sure that the industrial agreement is active',
  },
  val500002_title: {
    id: 'val500002_title',
    defaultmessages: 'Industrial agreement was not active',
  },
  val500003_content: {
    id: 'val500003_content',
    defaultmessages:
      'Agreement amount should not exceed more than 5% of the previous agreement amount and the entered rent amount for the selected period.',
  },
  val500003_title: {
    id: 'val500003_title',
    defaultmessages: 'Industrial agreement annual amount invalid',
  },
  val500004_content: {
    id: 'val500004_content',
    defaultmessages: 'The industrial agreement either could not be found or has expired.',
  },
  val500004_title: {
    id: 'val500004_title',
    defaultmessages: 'Industrial agreement was not found or expired',
  },
  val500006_content: {
    id: 'val500006_content',
    defaultmessages: '',
  },
  val500006_title: {
    id: 'val500006_title',
    defaultmessages: '',
  },
  val500008_title: {
    id: 'val500008_title',
    defaultmessages: 'The original agreement does not have a temporary store for three months',
  },
  val500009_content: {
    id: 'val500009_content',
    defaultmessages:
      'This Property Management Agreement exceeds the limit for creating a Sub-Property Management Transfer Agreement. You cannot create more than two Sub-Agreements.',
  },
  val500009_title: {
    id: 'val500009_title',
    defaultmessages:
      'This Property Management Agreement exceeds the limit for creating a Sub-Property Management Transfer Agreement.',
  },
  val500010_content: {
    id: 'val500010_content',
    defaultmessages:
      'The transaction cannot be completed as application number {s} is still active. Please contact customer support if you have any inquiries.',
  },
  val500010_title: {
    id: 'val500010_title',
    defaultmessages: 'There is another active application of a different type that conflicts with this application.',
  },
  val500012_content: {
    id: 'val500012_content',
    defaultmessages:
      'The selected mortgage includes multiple properties that are not under the same owner. Please contact customer support for further assistance.',
  },
  val500012_title: {
    id: 'val500012_title',
    defaultmessages: 'Mortgage Multiple Properties are not under the same Owner',
  },
  val500013_content: {
    id: 'val500013_content',
    defaultmessages:
      'The selected property acquisition type (allotment) is not eligible for sale. Please review the acquisition details and ensure compliance with the applicable requirements before proceeding, or contact customer support for assistance.',
  },
  val500013_title: {
    id: 'val500013_title',
    defaultmessages: 'Invalid Acquisition Type for Sale (allotment)',
  },
  val700001_content: {
    id: 'val700001_content',
    defaultmessages: 'The property is not found',
  },
  val700001_title: {
    id: 'val700001_title',
    defaultmessages: 'The property is not found',
  },
  val700002_content: {
    id: 'val700002_content',
    defaultmessages:
      'The transaction cannot be completed as there is an active application {s}. Please contact customer support if you have any inquiries.',
  },
  val700002_title: {
    id: 'val700002_title',
    defaultmessages: "There's an existing request active for this property",
  },
  val920023_content: {
    id: 'val920023_content',
    defaultmessages:
      'Your Emirates ID card has expired, you cannot complete the transaction. Please contact customer support if you have any questions.',
  },
  val920023_title: {
    id: 'val920023_title',
    defaultmessages: 'The Emirates ID card has expired',
  },
  valid_plots: {
    id: 'valid_plots',
    defaultmessages: 'Valid Plots ({s})',
  },
  valid_until: {
    id: 'valid_until',
    defaultmessages: 'Valid Until',
  },
  validate: {
    id: 'validate',
    defaultmessages: 'Validate',
  },
  validating_unit: {
    id: 'validating_unit',
    defaultmessages: 'Validating Unit',
  },
  validation_title_message: {
    id: 'validation_title_message',
    defaultmessages: 'There are few pending items that is preventing you from initiating the service',
  },
  validation_title_message_2: {
    id: 'validation_title_message_2',
    defaultmessages: 'There are pending items that are preventing you from initiating the service',
  },
  validation_warning_message: {
    id: 'validation_warning_message',
    defaultmessages: 'The application cannot be submitted for the following reasons:',
  },
  validation_warning_message_2: {
    id: 'validation_warning_message_2',
    defaultmessages: 'You can’t start the application due the following reasons',
  },
  valuation_certificate_land: {
    id: 'valuation_certificate_land',
    defaultmessages: 'Valuation Certificate (Land)',
  },
  valuation_certificate_payment_instruction: {
    id: 'valuation_certificate_payment_instruction',
    defaultmessages: 'The application has been approved. Please proceed to finalize the payment.',
  },
  valuation_company: {
    id: 'valuation_company',
    defaultmessages: 'Valuation company',
  },
  valuator: {
    id: 'valuator',
    defaultmessages: 'Valuator',
  },
  variate: {
    id: 'variate',
    defaultmessages: 'Variate',
  },
  variation_or_extinguishing_of_covenants: {
    id: 'variation_or_extinguishing_of_covenants',
    defaultmessages: 'Register Covenant Extinguishing/Variation',
  },
  variation_or_extinguishing_of_covenants_description: {
    id: 'variation_or_extinguishing_of_covenants_description',
    defaultmessages:
      'Upon receiving an application from an interested party, the Court may issue an order to fully or partially vary or extinguish a covenant affecting real property',
  },
  variation_or_extinguishing_of_covenants_doc_1: {
    id: 'variation_or_extinguishing_of_covenants_doc_1',
    defaultmessages: 'Court Order (Optional)',
  },
  variation_or_extinguishing_of_covenants_doc_2: {
    id: 'variation_or_extinguishing_of_covenants_doc_2',
    defaultmessages: 'Registered Covenant Instrument (Mandatory)',
  },
  variation_or_extinguishing_of_covenants_doc_3: {
    id: 'variation_or_extinguishing_of_covenants_doc_3',
    defaultmessages: 'Updated Lease Agreement (Mandatory)',
  },
  variation_or_extinguishing_of_covenants_doc_4: {
    id: 'variation_or_extinguishing_of_covenants_doc_4',
    defaultmessages: 'Title Deed (Mandatory)',
  },
  vat: {
    id: 'vat',
    defaultmessages: 'VAT 5%',
  },
  vat_aed_: {
    id: 'vat_aed_',
    defaultmessages: 'VAT (AED {num})',
  },
  vat_charges: {
    id: 'vat_charges',
    defaultmessages: 'VAT Charges (5%)',
  },
  verification_attendance_type: {
    id: 'verification_attendance_type',
    defaultmessages: 'Verification attendance type',
  },
  verification_certificate_optional: {
    id: 'verification_certificate_optional',
    defaultmessages: 'Search Certificate (Optional)',
  },
  verified: {
    id: 'verified',
    defaultmessages: 'verified',
  },
  verify: {
    id: 'verify',
    defaultmessages: 'Verify',
  },
  verify_another_document: {
    id: 'verify_another_document',
    defaultmessages: 'Verify Another Document',
  },
  verify_another_tenany: {
    id: 'verify_another_tenany',
    defaultmessages: 'Verify Another Lease Agreement',
  },
  verify_documents: {
    id: 'verify_documents',
    defaultmessages: 'Verify Documents',
  },
  verify_email: {
    id: 'verify_email',
    defaultmessages: 'Verify Email',
  },
  verify_email_msg: {
    id: 'verify_email_msg',
    defaultmessages: 'Hang on a moment while we verify your email address.',
  },
  verify_lease_agreement: {
    id: 'verify_lease_agreement',
    defaultmessages: 'Verify Lease Agreement',
  },
  verify_tenancy_contract: {
    id: 'verify_tenancy_contract',
    defaultmessages: 'Verify lease agreement',
  },
  view: {
    id: 'view',
    defaultmessages: 'View',
  },
  view_all: {
    id: 'view_all',
    defaultmessages: 'View All',
  },
  view_all_details: {
    id: 'view_all_details',
    defaultmessages: 'View all details',
  },
  view_all_occupants: {
    id: 'view_all_occupants',
    defaultmessages: 'View All Occupants',
  },
  view_all_services: {
    id: 'view_all_services',
    defaultmessages: 'View All Services',
  },
  view_all_tenants: {
    id: 'view_all_tenants',
    defaultmessages: 'View All Lessees',
  },
  view_all_unit: {
    id: 'view_all_unit',
    defaultmessages: 'View All Units',
  },
  view_all_units: {
    id: 'view_all_units',
    defaultmessages: 'View All ({s}) Units',
  },
  view_app: {
    id: 'view_app',
    defaultmessages: 'View App',
  },
  view_application: {
    id: 'view_application',
    defaultmessages: 'View Application',
  },
  view_building_table: {
    id: 'view_building_table',
    defaultmessages: 'View Building Table',
  },
  view_contract: {
    id: 'view_contract',
    defaultmessages: 'View Agreement',
  },
  view_details: {
    id: 'view_details',
    defaultmessages: 'View Details',
  },
  view_history: {
    id: 'view_history',
    defaultmessages: 'View History',
  },
  view_less_owner: {
    id: 'view_less_owner',
    defaultmessages: 'View Fewer Owners',
  },
  view_less_reasons: {
    id: 'view_less_reasons',
    defaultmessages: 'View Less',
  },
  view_less_service_charges: {
    id: 'view_less_service_charges',
    defaultmessages: 'View Less',
  },
  view_less_tenants: {
    id: 'view_less_tenants',
    defaultmessages: 'View Fewer Lessees',
  },
  view_more: {
    id: 'view_more',
    defaultmessages: 'View More',
  },
  view_more_contacts: {
    id: 'view_more_contacts',
    defaultmessages: 'View {s} more contacts',
  },
  view_more_owner: {
    id: 'view_more_owner',
    defaultmessages: 'View {s} More Owners',
  },
  view_more_owners: {
    id: 'view_more_owners',
    defaultmessages: 'View {s} More Owners',
  },
  view_more_properties: {
    id: 'view_more_properties',
    defaultmessages: 'View ({s}) More Properties',
  },
  view_more_reasons: {
    id: 'view_more_reasons',
    defaultmessages: 'View {s} More Reasons',
  },
  view_more_service_charges: {
    id: 'view_more_service_charges',
    defaultmessages: 'View {s} More',
  },
  view_on_map: {
    id: 'view_on_map',
    defaultmessages: 'View on Map',
  },
  view_plot_table: {
    id: 'view_plot_table',
    defaultmessages: 'View Plot Table',
  },
  view_properties: {
    id: 'view_properties',
    defaultmessages: 'View Properties',
  },
  view_selected_plots: {
    id: 'view_selected_plots',
    defaultmessages: 'View ({s}) selected plots',
  },
  view_units: {
    id: 'view_units',
    defaultmessages: 'View All Units',
  },
  villa: {
    id: 'villa',
    defaultmessages: 'Villas',
  },
  villa_registration_fees_paid_by_the_owner: {
    id: 'villa_registration_fees_paid_by_the_owner',
    defaultmessages: 'Villa registration fees paid by the owner',
  },
  villas: {
    id: 'villas',
    defaultmessages: 'Villas',
  },
  virtual: {
    id: 'virtual',
    defaultmessages: 'Virtual',
  },
  virtual_appointment_scheduled_for_signature_date_time: {
    id: 'virtual_appointment_scheduled_for_signature_date_time',
    defaultmessages:
      'Your virtual verification appointment has been successfully scheduled for {date} at {time} and shared on your official email address and contact number. Please ensure that you have your original Emirates ID or passport ready for identity verification during the meeting.',
  },
  visitor: {
    id: 'visitor',
    defaultmessages: 'Visitor',
  },
  waive_shares: {
    id: 'waive_shares',
    defaultmessages: 'Waive Shares',
  },
  waive_whole_share: {
    id: 'waive_whole_share',
    defaultmessages: 'Waive Whole Share (100%)',
  },
  waived_shares: {
    id: 'waived_shares',
    defaultmessages: 'Waived shares',
  },
  waiver_musataha_approval: {
    id: 'waiver_musataha_approval',
    defaultmessages: 'Waiver of Musataha agreement sent for approval',
  },
  waiver_musataha_approval_sub: {
    id: 'waiver_musataha_approval_sub',
    defaultmessages: 'You have successfully sent the Waiver of musataha agreement application for approval.',
  },
  waiver_musataha_generation: {
    id: 'waiver_musataha_generation',
    defaultmessages:
      'Your Waiver of Musataha agreement is now being generated, please allow up to 10 minutes for the agreement to be generated',
  },
  waiver_musataha_generation_progress: {
    id: 'waiver_musataha_generation_progress',
    defaultmessages: 'Your Waiver of Musataha agreement will be issued shortly',
  },
  waiver_musataha_rejection: {
    id: 'waiver_musataha_rejection',
    defaultmessages: 'Waiver of Musataha agreement has been successfully rejected',
  },
  waiver_musataha_rejection_forwarded: {
    id: 'waiver_musataha_rejection_forwarded',
    defaultmessages: 'Your rejection of Waiver of Musataha agreement has been forwarded to the initiator',
  },
  waiver_of_musataha_feedback: {
    id: 'waiver_of_musataha_feedback',
    defaultmessages: 'Waiver of Musataha agreement edit has been forwarded to the owner with feedback.',
  },
  waiver_of_musataha_issued: {
    id: 'waiver_of_musataha_issued',
    defaultmessages: 'Waiver of Musataha agreement has been successfully issued',
  },
  waiving_properties: {
    id: 'waiving_properties',
    defaultmessages: 'Waiving Properties',
  },
  wallet: {
    id: 'wallet',
    defaultmessages: 'Wallet',
  },
  wallet_empty_message: {
    id: 'wallet_empty_message',
    defaultmessages: 'Your balance is insufficient for the transaction. Please top up your wallet.',
  },
  wallet_permission_subTitle: {
    id: 'wallet_permission_subTitle',
    defaultmessages: 'Only authorized wallet users (XYZ) can view the transaction details',
  },
  wallet_permission_title: {
    id: 'wallet_permission_title',
    defaultmessages: 'You do not have permission to view the wallet transactions',
  },
  wallet_subTitle: {
    id: 'wallet_subTitle',
    defaultmessages: 'Your transaction will appear here once you have made a payment',
  },
  wallet_title: {
    id: 'wallet_title',
    defaultmessages: 'You have not completed any transaction yet',
  },
  wallet_top_up_loading_desc: {
    id: 'wallet_top_up_loading_desc',
    defaultmessages: 'Your request is being processed through our secure servers',
  },
  wallet_top_up_success_title: {
    id: 'wallet_top_up_success_title',
    defaultmessages: '%1$s %2$s successfully added',
  },
  wallets_and_payments: {
    id: 'wallets_and_payments',
    defaultmessages: 'My wallet & payments',
  },
  we_have_removed_blocked_units_for_you: {
    id: 'we_have_removed_blocked_units_for_you',
    defaultmessages:
      'We have removed the unavailable units for you. You may now proceed with the selected {s} available unit(s).',
  },
  we_seem_to_be_experiencing_issues_with_UAE_pass: {
    id: 'we_seem_to_be_experiencing_issues_with_UAE_pass',
    defaultmessages: 'We seem to be experiencing issues with the UAE PASS',
  },
  we_sent_your_application_for_municipality_approval: {
    id: 'we_sent_your_application_for_municipality_approval',
    defaultmessages: 'We sent your application for ADGM for approval, you will be notified once approved',
  },
  web_remaining_percentage: {
    id: 'web_remaining_percentage',
    defaultmessages: 'Remaining Percentage',
  },
  website: {
    id: 'website',
    defaultmessages: 'Website',
  },
  weekly: {
    id: 'weekly',
    defaultmessages: 'Last 7 days',
  },
  weekly_transactions: {
    id: 'weekly_transactions',
    defaultmessages: 'Transactions in the last 7 days',
  },
  welcomeSubtitle: {
    id: 'welcomeSubtitle',
    defaultmessages: 'Manage your properties and agreements digitally',
  },
  welcome_to_dari: {
    id: 'welcome_to_dari',
    defaultmessages: 'Welcome to AccessRP',
  },
  welcome_to_dari_ar: {
    id: 'welcome_to_dari_ar',
    defaultmessages: 'أهلاً بكم في داري',
  },
  what_are_you_looking_for: {
    id: 'what_are_you_looking_for',
    defaultmessages: 'What Are You Looking For?',
  },
  what_happend_next: {
    id: 'what_happend_next',
    defaultmessages: 'What happens next?',
  },
  whatsapp_chat: {
    id: 'whatsapp_chat',
    defaultmessages: 'WhatsApp chat',
  },
  who_is_applying: {
    id: 'who_is_applying',
    defaultmessages: 'Who is applying?',
  },
  who_is_the_primary_lessor: {
    id: 'who_is_the_primary_lessor',
    defaultmessages: 'Who is the primary lessor?',
  },
  will_be_notified_once_valuation_done: {
    id: 'will_be_notified_once_valuation_done',
    defaultmessages: 'You will be notified once the valuation is done by ADGM Value.',
  },
  with: {
    id: 'with',
    defaultmessages: 'with',
  },
  with_refund: {
    id: 'with_refund',
    defaultmessages: 'With Refund',
  },
  with_second_party_approval: {
    id: 'with_second_party_approval',
    defaultmessages: 'With second party approval',
  },
  without_refund: {
    id: 'without_refund',
    defaultmessages: 'Without Refund',
  },
  without_second_party_approval: {
    id: 'without_second_party_approval',
    defaultmessages: 'Without second party approval',
  },
  working_hours: {
    id: 'working_hours',
    defaultmessages: 'Working hours',
  },
  wrong_date_format: {
    id: 'wrong_date_format',
    defaultmessages: 'Wrong date format',
  },
  xlx_documents_validation_msg: {
    id: 'xlx_documents_validation_msg',
    defaultmessages: 'Maximum file size: 20 MB. Allowed file types: XLS, XLSX',
  },
  year: {
    id: 'year',
    defaultmessages: '{s} year',
  },
  yearly: {
    id: 'yearly',
    defaultmessages: 'Yearly',
  },
  years_11_more: {
    id: 'years_11_more',
    defaultmessages: '{s} years',
  },
  years_2: {
    id: 'years_2',
    defaultmessages: '{s} years',
  },
  years_3_10: {
    id: 'years_3_10',
    defaultmessages: '{s} years',
  },
  yes: {
    id: 'yes',
    defaultmessages: 'Yes',
  },
  yes_clear_all: {
    id: 'yes_clear_all',
    defaultmessages: 'Yes, clear all',
  },
  yes_continue: {
    id: 'yes_continue',
    defaultmessages: 'Yes, Continue',
  },
  yes_include_mortgage_registration: {
    id: 'yes_include_mortgage_registration',
    defaultmessages: 'Yes, Include Mortgage Registration',
  },
  you: {
    id: 'you',
    defaultmessages: 'You',
  },
  you_accepted_the_agreement_successfully: {
    id: 'you_accepted_the_agreement_successfully',
    defaultmessages: 'You accepted the agreement successfully',
  },
  you_are_blocked_as_owner_error_message: {
    id: 'you_are_blocked_as_owner_error_message',
    defaultmessages: 'You are blocked as an owner',
  },
  you_are_blocked_as_owner_error_message_desc: {
    id: 'you_are_blocked_as_owner_error_message_desc',
    defaultmessages: 'You cannot apply for this service because your status is “blocked”',
  },
  you_can_close_tenancy_contract_with_or_without_second_party: {
    id: 'you_can_close_tenancy_contract_with_or_without_second_party',
    defaultmessages: 'You can expire this lease agreement with or without second party approval',
  },
  you_can_upload_multiple_documents: {
    id: 'you_can_upload_multiple_documents',
    defaultmessages: 'You can upload multiple documents',
  },
  'you_do_not_have_permission_to_view-wallet_transactions': {
    id: 'you_do_not_have_permission_to_view-wallet_transactions',
    defaultmessages: 'You do not have a permission to view the wallet transactions',
  },
  you_dont_have_any_primary_contacts_added: {
    id: 'you_dont_have_any_primary_contacts_added',
    defaultmessages: 'You don’t have any primary contacts added',
  },
  you_dont_have_applications_yet: {
    id: 'you_dont_have_applications_yet',
    defaultmessages: 'You do not have any applications yet',
  },
  you_dont_have_tasks_yet: {
    id: 'you_dont_have_tasks_yet',
    defaultmessages: 'You do not have any tasks yet',
  },
  you_have_a_pending_task: {
    id: 'you_have_a_pending_task',
    defaultmessages: 'You have a pending task',
  },
  you_have_accepted_the_off_plan_unit_termination_application: {
    id: 'you_have_accepted_the_off_plan_unit_termination_application',
    defaultmessages: 'You have accepted the off-plan termination application',
  },
  you_have_approved_PMA_agreement: {
    id: 'you_have_approved_PMA_agreement',
    defaultmessages: 'You have approved the PMA',
  },
  you_have_pending_tasks: {
    id: 'you_have_pending_tasks',
    defaultmessages: 'You have pending tasks',
  },
  you_have_rejected_open_employee_account_application: {
    id: 'you_have_rejected_open_employee_account_application',
    defaultmessages: 'You have rejected an application to open a company employee account.',
  },
  you_have_rejected_the_off_plan_unit_termination_application: {
    id: 'you_have_rejected_the_off_plan_unit_termination_application',
    defaultmessages: 'You have rejected the off-plan termination application',
  },
  you_have_returned_application_successfully: {
    id: 'you_have_returned_application_successfully',
    defaultmessages: 'You have returned application successfully',
  },
  you_have_returned_open_employee_account_application: {
    id: 'you_have_returned_open_employee_account_application',
    defaultmessages: 'You have returned an application to open a company employee account.',
  },
  you_have_returned_the_off_plan_unit_termination_application: {
    id: 'you_have_returned_the_off_plan_unit_termination_application',
    defaultmessages: 'You have returned the off-plan termination application',
  },
  you_have_submitted_the_application_successfully: {
    id: 'you_have_submitted_the_application_successfully',
    defaultmessages: 'You have successfully submitted the application',
  },
  you_have_submitted_the_off_plan_unit_termination_application: {
    id: 'you_have_submitted_the_off_plan_unit_termination_application',
    defaultmessages: 'You have submitted the off-plan termination application',
  },
  you_have_successfully_sent_the_application_to_developer_approver_for_approval: {
    id: 'you_have_successfully_sent_the_application_to_developer_approver_for_approval',
    defaultmessages: 'You have successfully sent the application to Developer Approver for approval',
  },
  you_havent_added_any_first_parties_yet: {
    id: 'you_havent_added_any_first_parties_yet',
    defaultmessages: "You haven't added any first parties yet",
  },
  you_havent_added_any_second_party_yet: {
    id: 'you_havent_added_any_second_party_yet',
    defaultmessages: "You haven't added any second party yet",
  },
  you_successfully_added_an_employee_to_your_company: {
    id: 'you_successfully_added_an_employee_to_your_company',
    defaultmessages: 'You successfully added an employee to your company!',
  },
  you_successfully_made_the_payment: {
    id: 'you_successfully_made_the_payment',
    defaultmessages: 'You have successfully made the payment!',
  },
  you_will_be_notified_after_all_parties_approval: {
    id: 'you_will_be_notified_after_all_parties_approval',
    defaultmessages: "You may check the application status later after all parties' approval is completed.",
  },
  you_will_be_notified_once_PMA_agreement_is_reviewed_and_approved: {
    id: 'you_will_be_notified_once_PMA_agreement_is_reviewed_and_approved',
    defaultmessages: 'Your application will be sent to your signatory to get the required approvals',
  },
  you_will_be_notified_once_approved_and_completed: {
    id: 'you_will_be_notified_once_approved_and_completed',
    defaultmessages: 'You will be notified once it is approved and completed',
  },
  you_will_be_notified_once_the_application_reviewed_by_ADGM: {
    id: 'you_will_be_notified_once_the_application_reviewed_by_ADGM',
    defaultmessages:
      'Please check the application later, to get the status update once the application is reviewed by ADGM',
  },
  your_account_is_currently_not_upgraded_in_UAE_pass: {
    id: 'your_account_is_currently_not_upgraded_in_UAE_pass',
    defaultmessages:
      'You are not eligible to access this service. Your account is either not upgraded or you have a visitor account. Please contact AccessRP support to access the services.',
  },
  your_application_has_been_terminated: {
    id: 'your_application_has_been_terminated',
    defaultmessages: 'Your application has been terminated',
  },
  your_application_will_be_returned_to_the_initiator_to_fix_the_issues_and_submit_it_again: {
    id: 'your_application_will_be_returned_to_the_initiator_to_fix_the_issues_and_submit_it_again',
    defaultmessages:
      'Application will be returned to the initiator to fix the issues. Once done, you can submit it again.',
  },
  your_application_will_be_sent_to_the_developer_approval: {
    id: 'your_application_will_be_sent_to_the_developer_approval',
    defaultmessages: 'Your application will be sent to the developer approval',
  },
  your_application_will_be_sent_to_the_municipality_to_get_the_required_approvals: {
    id: 'your_application_will_be_sent_to_the_municipality_to_get_the_required_approvals',
    defaultmessages: 'Your application will be sent to the municipality to get the required approvals',
  },
  your_application_will_be_sent_to_the_second_party_to_get_the_required_approvals: {
    id: 'your_application_will_be_sent_to_the_second_party_to_get_the_required_approvals',
    defaultmessages: 'Your application will be sent to the second party to get the required approvals',
  },
  your_approved_the_application_successully: {
    id: 'your_approved_the_application_successully',
    defaultmessages: 'You have successfully approved the application',
  },
  your_edit_of_tenancy_contract_has_been_forwarded: {
    id: 'your_edit_of_tenancy_contract_has_been_forwarded',
    defaultmessages: 'Your edit of lease agreement has been forwarded to the owner with feedback',
  },
  your_email_address: {
    id: 'your_email_address',
    defaultmessages: 'Your email address',
  },
  your_emirates_id_seems_to_be_linked_with_another_mobile_number: {
    id: 'your_emirates_id_seems_to_be_linked_with_another_mobile_number',
    defaultmessages: 'Your Emirates ID seems to be linked with another mobile number',
  },
  your_name: {
    id: 'your_name',
    defaultmessages: 'Your name',
  },
  your_off_plan_buy_and_sell_termination_has_been_returned: {
    id: 'your_off_plan_buy_and_sell_termination_has_been_returned',
    defaultmessages: 'Your off-plan buy and sell termination has been returned',
  },
  your_phone: {
    id: 'your_phone',
    defaultmessages: 'Your phone number',
  },
  your_request_has_been_approved_and_your_contract_will_be_sent: {
    id: 'your_request_has_been_approved_and_your_contract_will_be_sent',
    defaultmessages: 'Your request has been approved and your agreement will be generated within 15 minutes',
  },
  your_return_of_the_musataha_contract_has_been_forwarded_to_the_initiator_with_feedback: {
    id: 'your_return_of_the_musataha_contract_has_been_forwarded_to_the_initiator_with_feedback',
    defaultmessages:
      'Your return of Transfer Rental Agreement to Musataha has been forwarded to the initiator with feedback',
  },
  your_tenancy_contract_has_been_issued_successfully: {
    id: 'your_tenancy_contract_has_been_issued_successfully',
    defaultmessages: 'Congratulations! Your lease agreement has been successfully issued.',
  },
  your_tenancy_contract_has_been_sent_to_municipality_for_approval: {
    id: 'your_tenancy_contract_has_been_sent_to_municipality_for_approval',
    defaultmessages: 'Your lease agreement has been sent to ADGM for approval',
  },
  your_title_deed_has_been_successfully_issued: {
    id: 'your_title_deed_has_been_successfully_issued',
    defaultmessages: 'Your title deed certificate has been successfully issued',
  },
  your_transaction_could_not_be_processed: {
    id: 'your_transaction_could_not_be_processed',
    defaultmessages: 'Your transaction could not be processed',
  },
  zone: {
    id: 'zone',
    defaultmessages: 'Zone',
  },
};
export default messages;
